function pS(s, e) {
  for (var t = 0; t < e.length; t++) {
    const r = e[t];
    if (typeof r != "string" && !Array.isArray(r)) {
      for (const u in r)
        if (u !== "default" && !(u in s)) {
          const a = Object.getOwnPropertyDescriptor(r, u);
          a && Object.defineProperty(s, u, a.get ? a : {
            enumerable: !0,
            get: () => r[u]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(s, Symbol.toStringTag, { value: "Module" }));
}
var Er = function(s, e) {
  return Er = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, r) {
    t.__proto__ = r;
  } || function(t, r) {
    for (var u in r) Object.prototype.hasOwnProperty.call(r, u) && (t[u] = r[u]);
  }, Er(s, e);
};
function zs(s, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  Er(s, e);
  function t() {
    this.constructor = s;
  }
  s.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
}
var p = function() {
  return p = Object.assign || function(e) {
    for (var t, r = 1, u = arguments.length; r < u; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, p.apply(this, arguments);
};
function Gs(s, e) {
  var t = {};
  for (var r in s) Object.prototype.hasOwnProperty.call(s, r) && e.indexOf(r) < 0 && (t[r] = s[r]);
  if (s != null && typeof Object.getOwnPropertySymbols == "function")
    for (var u = 0, r = Object.getOwnPropertySymbols(s); u < r.length; u++)
      e.indexOf(r[u]) < 0 && Object.prototype.propertyIsEnumerable.call(s, r[u]) && (t[r[u]] = s[r[u]]);
  return t;
}
function Js(s, e, t, r) {
  function u(a) {
    return a instanceof t ? a : new t(function(i) {
      i(a);
    });
  }
  return new (t || (t = Promise))(function(a, i) {
    function _(A) {
      try {
        f(r.next(A));
      } catch (y) {
        i(y);
      }
    }
    function h(A) {
      try {
        f(r.throw(A));
      } catch (y) {
        i(y);
      }
    }
    function f(A) {
      A.done ? a(A.value) : u(A.value).then(_, h);
    }
    f((r = r.apply(s, e || [])).next());
  });
}
function Hs(s, e) {
  var t = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, r, u, a, i = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return i.next = _(0), i.throw = _(1), i.return = _(2), typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function _(f) {
    return function(A) {
      return h([f, A]);
    };
  }
  function h(f) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; i && (i = 0, f[0] && (t = 0)), t; ) try {
      if (r = 1, u && (a = f[0] & 2 ? u.return : f[0] ? u.throw || ((a = u.return) && a.call(u), 0) : u.next) && !(a = a.call(u, f[1])).done) return a;
      switch (u = 0, a && (f = [f[0] & 2, a.value]), f[0]) {
        case 0:
        case 1:
          a = f;
          break;
        case 4:
          return t.label++, { value: f[1], done: !1 };
        case 5:
          t.label++, u = f[1], f = [0];
          continue;
        case 7:
          f = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (a = t.trys, !(a = a.length > 0 && a[a.length - 1]) && (f[0] === 6 || f[0] === 2)) {
            t = 0;
            continue;
          }
          if (f[0] === 3 && (!a || f[1] > a[0] && f[1] < a[3])) {
            t.label = f[1];
            break;
          }
          if (f[0] === 6 && t.label < a[1]) {
            t.label = a[1], a = f;
            break;
          }
          if (a && t.label < a[2]) {
            t.label = a[2], t.ops.push(f);
            break;
          }
          a[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      f = e.call(s, t);
    } catch (A) {
      f = [6, A], u = 0;
    } finally {
      r = a = 0;
    }
    if (f[0] & 5) throw f[1];
    return { value: f[0] ? f[1] : void 0, done: !0 };
  }
}
function Bs(s, e, t) {
  if (t || arguments.length === 2) for (var r = 0, u = e.length, a; r < u; r++)
    (a || !(r in e)) && (a || (a = Array.prototype.slice.call(e, 0, r)), a[r] = e[r]);
  return s.concat(a || Array.prototype.slice.call(e));
}
var vr = function(s, e) {
  return vr = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, r) {
    t.__proto__ = r;
  } || function(t, r) {
    for (var u in r) Object.prototype.hasOwnProperty.call(r, u) && (t[u] = r[u]);
  }, vr(s, e);
};
function bS(s, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  vr(s, e);
  function t() {
    this.constructor = s;
  }
  s.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
}
var lt = function() {
  return lt = Object.assign || function(e) {
    for (var t, r = 1, u = arguments.length; r < u; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, lt.apply(this, arguments);
};
var ur = "Invariant Violation", Ai = Object.setPrototypeOf, ES = Ai === void 0 ? function(s, e) {
  return s.__proto__ = e, s;
} : Ai, b_ = (
  /** @class */
  function(s) {
    bS(e, s);
    function e(t) {
      t === void 0 && (t = ur);
      var r = s.call(this, typeof t == "number" ? ur + ": " + t + " (see https://github.com/apollographql/invariant-packages)" : t) || this;
      return r.framesToPop = 1, r.name = ur, ES(r, e.prototype), r;
    }
    return e;
  }(Error)
);
function ue(s, e) {
  if (!s)
    throw new b_(e);
}
var E_ = ["debug", "log", "warn", "error", "silent"], vS = E_.indexOf("log");
function At(s) {
  return function() {
    if (E_.indexOf(s) >= vS) {
      var e = console[s] || console.log;
      return e.apply(console, arguments);
    }
  };
}
(function(s) {
  s.debug = At("debug"), s.log = At("log"), s.warn = At("warn"), s.error = At("error");
})(ue || (ue = {}));
var Cr = "3.11.8";
function Qs(s) {
  try {
    return s();
  } catch {
  }
}
const mr = Qs(function() {
  return globalThis;
}) || Qs(function() {
  return window;
}) || Qs(function() {
  return self;
}) || Qs(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
Qs(function() {
  return Qs.constructor("return this")();
});
var yi = /* @__PURE__ */ new Map();
function Vr(s) {
  var e = yi.get(s) || 1;
  return yi.set(s, e + 1), "".concat(s, ":").concat(e, ":").concat(Math.random().toString(36).slice(2));
}
function v_(s, e) {
  e === void 0 && (e = 0);
  var t = Vr("stringifyForDisplay");
  return JSON.stringify(s, function(r, u) {
    return u === void 0 ? t : u;
  }, e).split(JSON.stringify(t)).join("<undefined>");
}
function yt(s) {
  return function(e) {
    for (var t = [], r = 1; r < arguments.length; r++)
      t[r - 1] = arguments[r];
    if (typeof e == "number") {
      var u = e;
      e = gr(u), e || (e = kr(u, t), t = []);
    }
    s.apply(void 0, [e].concat(t));
  };
}
var Q = Object.assign(function(e, t) {
  for (var r = [], u = 2; u < arguments.length; u++)
    r[u - 2] = arguments[u];
  e || ue(e, gr(t, r) || kr(t, r));
}, {
  debug: yt(ue.debug),
  log: yt(ue.log),
  warn: yt(ue.warn),
  error: yt(ue.error)
});
function Ps(s) {
  for (var e = [], t = 1; t < arguments.length; t++)
    e[t - 1] = arguments[t];
  return new b_(gr(s, e) || kr(s, e));
}
var ci = Symbol.for("ApolloErrorMessageHandler_" + Cr);
function m_(s) {
  if (typeof s == "string")
    return s;
  try {
    return v_(s, 2).slice(0, 1e3);
  } catch {
    return "<non-serializable>";
  }
}
function gr(s, e) {
  if (e === void 0 && (e = []), !!s)
    return mr[ci] && mr[ci](s, e.map(m_));
}
function kr(s, e) {
  if (e === void 0 && (e = []), !!s)
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
      version: Cr,
      message: s,
      args: e.map(m_)
    })));
}
function Dt(s, e) {
  if (!!!s)
    throw new Error(e);
}
function mS(s) {
  return typeof s == "object" && s !== null;
}
function VS(s, e) {
  if (!!!s)
    throw new Error(
      "Unexpected invariant triggered."
    );
}
const lS = /\r\n|[\n\r]/g;
function lr(s, e) {
  let t = 0, r = 1;
  for (const u of s.body.matchAll(lS)) {
    if (typeof u.index == "number" || VS(!1), u.index >= e)
      break;
    t = u.index + u[0].length, r += 1;
  }
  return {
    line: r,
    column: e + 1 - t
  };
}
function wS(s) {
  return V_(
    s.source,
    lr(s.source, s.start)
  );
}
function V_(s, e) {
  const t = s.locationOffset.column - 1, r = "".padStart(t) + s.body, u = e.line - 1, a = s.locationOffset.line - 1, i = e.line + a, _ = e.line === 1 ? t : 0, h = e.column + _, f = `${s.name}:${i}:${h}
`, A = r.split(/\r\n|[\n\r]/g), y = A[u];
  if (y.length > 120) {
    const c = Math.floor(h / 80), n = h % 80, d = [];
    for (let E = 0; E < y.length; E += 80)
      d.push(y.slice(E, E + 80));
    return f + ni([
      [`${i} |`, d[0]],
      ...d.slice(1, c + 1).map((E) => ["|", E]),
      ["|", "^".padStart(n)],
      ["|", d[c + 1]]
    ]);
  }
  return f + ni([
    // Lines specified like this: ["prefix", "string"],
    [`${i - 1} |`, A[u - 1]],
    [`${i} |`, y],
    ["|", "^".padStart(h)],
    [`${i + 1} |`, A[u + 1]]
  ]);
}
function ni(s) {
  const e = s.filter(([r, u]) => u !== void 0), t = Math.max(...e.map(([r]) => r.length));
  return e.map(([r, u]) => r.padStart(t) + (u ? " " + u : "")).join(`
`);
}
function FS(s) {
  const e = s[0];
  return e == null || "kind" in e || "length" in e ? {
    nodes: e,
    source: s[1],
    positions: s[2],
    path: s[3],
    originalError: s[4],
    extensions: s[5]
  } : e;
}
class Or extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */
  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */
  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */
  /**
   * The original error thrown from a field resolver during execution.
   */
  /**
   * Extension fields to add to the formatted error.
   */
  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(e, ...t) {
    var r, u, a;
    const { nodes: i, source: _, positions: h, path: f, originalError: A, extensions: y } = FS(t);
    super(e), this.name = "GraphQLError", this.path = f ?? void 0, this.originalError = A ?? void 0, this.nodes = Di(
      Array.isArray(i) ? i : i ? [i] : void 0
    );
    const c = Di(
      (r = this.nodes) === null || r === void 0 ? void 0 : r.map((d) => d.loc).filter((d) => d != null)
    );
    this.source = _ ?? (c == null || (u = c[0]) === null || u === void 0 ? void 0 : u.source), this.positions = h ?? (c == null ? void 0 : c.map((d) => d.start)), this.locations = h && _ ? h.map((d) => lr(_, d)) : c == null ? void 0 : c.map((d) => lr(d.source, d.start));
    const n = mS(
      A == null ? void 0 : A.extensions
    ) ? A == null ? void 0 : A.extensions : void 0;
    this.extensions = (a = y ?? n) !== null && a !== void 0 ? a : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, {
      message: {
        writable: !0,
        enumerable: !0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), A != null && A.stack ? Object.defineProperty(this, "stack", {
      value: A.stack,
      writable: !0,
      configurable: !0
    }) : Error.captureStackTrace ? Error.captureStackTrace(this, Or) : Object.defineProperty(this, "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    });
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
  toString() {
    let e = this.message;
    if (this.nodes)
      for (const t of this.nodes)
        t.loc && (e += `

` + wS(t.loc));
    else if (this.source && this.locations)
      for (const t of this.locations)
        e += `

` + V_(this.source, t);
    return e;
  }
  toJSON() {
    const e = {
      message: this.message
    };
    return this.locations != null && (e.locations = this.locations), this.path != null && (e.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (e.extensions = this.extensions), e;
  }
}
function Di(s) {
  return s === void 0 || s.length === 0 ? void 0 : s;
}
function ms(s, e, t) {
  return new Or(`Syntax Error: ${t}`, {
    source: s,
    positions: [e]
  });
}
class xS {
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The Token at which this Node begins.
   */
  /**
   * The Token at which this Node ends.
   */
  /**
   * The Source document the AST represents.
   */
  constructor(e, t, r) {
    this.start = e.start, this.end = t.end, this.startToken = e, this.endToken = t, this.source = r;
  }
  get [Symbol.toStringTag]() {
    return "Location";
  }
  toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  }
}
class l_ {
  /**
   * The kind of Token.
   */
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The 1-indexed line number on which this Token appears.
   */
  /**
   * The 1-indexed column number at which this Token begins.
   */
  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */
  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(e, t, r, u, a, i) {
    this.kind = e, this.start = t, this.end = r, this.line = u, this.column = a, this.value = i, this.prev = null, this.next = null;
  }
  get [Symbol.toStringTag]() {
    return "Token";
  }
  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }
}
const w_ = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, oS = new Set(Object.keys(w_));
function di(s) {
  const e = s == null ? void 0 : s.kind;
  return typeof e == "string" && oS.has(e);
}
var ce;
(function(s) {
  s.QUERY = "query", s.MUTATION = "mutation", s.SUBSCRIPTION = "subscription";
})(ce || (ce = {}));
var wr;
(function(s) {
  s.QUERY = "QUERY", s.MUTATION = "MUTATION", s.SUBSCRIPTION = "SUBSCRIPTION", s.FIELD = "FIELD", s.FRAGMENT_DEFINITION = "FRAGMENT_DEFINITION", s.FRAGMENT_SPREAD = "FRAGMENT_SPREAD", s.INLINE_FRAGMENT = "INLINE_FRAGMENT", s.VARIABLE_DEFINITION = "VARIABLE_DEFINITION", s.SCHEMA = "SCHEMA", s.SCALAR = "SCALAR", s.OBJECT = "OBJECT", s.FIELD_DEFINITION = "FIELD_DEFINITION", s.ARGUMENT_DEFINITION = "ARGUMENT_DEFINITION", s.INTERFACE = "INTERFACE", s.UNION = "UNION", s.ENUM = "ENUM", s.ENUM_VALUE = "ENUM_VALUE", s.INPUT_OBJECT = "INPUT_OBJECT", s.INPUT_FIELD_DEFINITION = "INPUT_FIELD_DEFINITION";
})(wr || (wr = {}));
var G;
(function(s) {
  s.NAME = "Name", s.DOCUMENT = "Document", s.OPERATION_DEFINITION = "OperationDefinition", s.VARIABLE_DEFINITION = "VariableDefinition", s.SELECTION_SET = "SelectionSet", s.FIELD = "Field", s.ARGUMENT = "Argument", s.FRAGMENT_SPREAD = "FragmentSpread", s.INLINE_FRAGMENT = "InlineFragment", s.FRAGMENT_DEFINITION = "FragmentDefinition", s.VARIABLE = "Variable", s.INT = "IntValue", s.FLOAT = "FloatValue", s.STRING = "StringValue", s.BOOLEAN = "BooleanValue", s.NULL = "NullValue", s.ENUM = "EnumValue", s.LIST = "ListValue", s.OBJECT = "ObjectValue", s.OBJECT_FIELD = "ObjectField", s.DIRECTIVE = "Directive", s.NAMED_TYPE = "NamedType", s.LIST_TYPE = "ListType", s.NON_NULL_TYPE = "NonNullType", s.SCHEMA_DEFINITION = "SchemaDefinition", s.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", s.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", s.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", s.FIELD_DEFINITION = "FieldDefinition", s.INPUT_VALUE_DEFINITION = "InputValueDefinition", s.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", s.UNION_TYPE_DEFINITION = "UnionTypeDefinition", s.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", s.ENUM_VALUE_DEFINITION = "EnumValueDefinition", s.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", s.DIRECTIVE_DEFINITION = "DirectiveDefinition", s.SCHEMA_EXTENSION = "SchemaExtension", s.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", s.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", s.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", s.UNION_TYPE_EXTENSION = "UnionTypeExtension", s.ENUM_TYPE_EXTENSION = "EnumTypeExtension", s.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension";
})(G || (G = {}));
function Fr(s) {
  return s === 9 || s === 32;
}
function Ne(s) {
  return s >= 48 && s <= 57;
}
function F_(s) {
  return s >= 97 && s <= 122 || // A-Z
  s >= 65 && s <= 90;
}
function x_(s) {
  return F_(s) || s === 95;
}
function MS(s) {
  return F_(s) || Ne(s) || s === 95;
}
function $S(s) {
  var e;
  let t = Number.MAX_SAFE_INTEGER, r = null, u = -1;
  for (let i = 0; i < s.length; ++i) {
    var a;
    const _ = s[i], h = TS(_);
    h !== _.length && (r = (a = r) !== null && a !== void 0 ? a : i, u = i, i !== 0 && h < t && (t = h));
  }
  return s.map((i, _) => _ === 0 ? i : i.slice(t)).slice(
    (e = r) !== null && e !== void 0 ? e : 0,
    u + 1
  );
}
function TS(s) {
  let e = 0;
  for (; e < s.length && Fr(s.charCodeAt(e)); )
    ++e;
  return e;
}
function PS(s, e) {
  const t = s.replace(/"""/g, '\\"""'), r = t.split(/\r\n|[\n\r]/g), u = r.length === 1, a = r.length > 1 && r.slice(1).every((n) => n.length === 0 || Fr(n.charCodeAt(0))), i = t.endsWith('\\"""'), _ = s.endsWith('"') && !i, h = s.endsWith("\\"), f = _ || h, A = (
    // add leading and trailing new lines only if it improves readability
    !u || s.length > 70 || f || a || i
  );
  let y = "";
  const c = u && Fr(s.charCodeAt(0));
  return (A && !c || a) && (y += `
`), y += t, (A || f) && (y += `
`), '"""' + y + '"""';
}
var x;
(function(s) {
  s.SOF = "<SOF>", s.EOF = "<EOF>", s.BANG = "!", s.DOLLAR = "$", s.AMP = "&", s.PAREN_L = "(", s.PAREN_R = ")", s.SPREAD = "...", s.COLON = ":", s.EQUALS = "=", s.AT = "@", s.BRACKET_L = "[", s.BRACKET_R = "]", s.BRACE_L = "{", s.PIPE = "|", s.BRACE_R = "}", s.NAME = "Name", s.INT = "Int", s.FLOAT = "Float", s.STRING = "String", s.BLOCK_STRING = "BlockString", s.COMMENT = "Comment";
})(x || (x = {}));
class BS {
  /**
   * The previously focused non-ignored token.
   */
  /**
   * The currently focused non-ignored token.
   */
  /**
   * The (1-indexed) line containing the current token.
   */
  /**
   * The character offset at which the current line begins.
   */
  constructor(e) {
    const t = new l_(x.SOF, 0, 0, 0, 0);
    this.source = e, this.lastToken = t, this.token = t, this.line = 1, this.lineStart = 0;
  }
  get [Symbol.toStringTag]() {
    return "Lexer";
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */
  advance() {
    return this.lastToken = this.token, this.token = this.lookahead();
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  lookahead() {
    let e = this.token;
    if (e.kind !== x.EOF)
      do
        if (e.next)
          e = e.next;
        else {
          const t = GS(this, e.end);
          e.next = t, t.prev = e, e = t;
        }
      while (e.kind === x.COMMENT);
    return e;
  }
}
function qS(s) {
  return s === x.BANG || s === x.DOLLAR || s === x.AMP || s === x.PAREN_L || s === x.PAREN_R || s === x.SPREAD || s === x.COLON || s === x.EQUALS || s === x.AT || s === x.BRACKET_L || s === x.BRACKET_R || s === x.BRACE_L || s === x.PIPE || s === x.BRACE_R;
}
function we(s) {
  return s >= 0 && s <= 55295 || s >= 57344 && s <= 1114111;
}
function Tt(s, e) {
  return o_(s.charCodeAt(e)) && M_(s.charCodeAt(e + 1));
}
function o_(s) {
  return s >= 55296 && s <= 56319;
}
function M_(s) {
  return s >= 56320 && s <= 57343;
}
function ie(s, e) {
  const t = s.source.body.codePointAt(e);
  if (t === void 0)
    return x.EOF;
  if (t >= 32 && t <= 126) {
    const r = String.fromCodePoint(t);
    return r === '"' ? `'"'` : `"${r}"`;
  }
  return "U+" + t.toString(16).toUpperCase().padStart(4, "0");
}
function Es(s, e, t, r, u) {
  const a = s.line, i = 1 + t - s.lineStart;
  return new l_(e, t, r, a, i, u);
}
function GS(s, e) {
  const t = s.source.body, r = t.length;
  let u = e;
  for (; u < r; ) {
    const a = t.charCodeAt(u);
    switch (a) {
      case 65279:
      case 9:
      case 32:
      case 44:
        ++u;
        continue;
      case 10:
        ++u, ++s.line, s.lineStart = u;
        continue;
      case 13:
        t.charCodeAt(u + 1) === 10 ? u += 2 : ++u, ++s.line, s.lineStart = u;
        continue;
      case 35:
        return RS(s, u);
      case 33:
        return Es(s, x.BANG, u, u + 1);
      case 36:
        return Es(s, x.DOLLAR, u, u + 1);
      case 38:
        return Es(s, x.AMP, u, u + 1);
      case 40:
        return Es(s, x.PAREN_L, u, u + 1);
      case 41:
        return Es(s, x.PAREN_R, u, u + 1);
      case 46:
        if (t.charCodeAt(u + 1) === 46 && t.charCodeAt(u + 2) === 46)
          return Es(s, x.SPREAD, u, u + 3);
        break;
      case 58:
        return Es(s, x.COLON, u, u + 1);
      case 61:
        return Es(s, x.EQUALS, u, u + 1);
      case 64:
        return Es(s, x.AT, u, u + 1);
      case 91:
        return Es(s, x.BRACKET_L, u, u + 1);
      case 93:
        return Es(s, x.BRACKET_R, u, u + 1);
      case 123:
        return Es(s, x.BRACE_L, u, u + 1);
      case 124:
        return Es(s, x.PIPE, u, u + 1);
      case 125:
        return Es(s, x.BRACE_R, u, u + 1);
      case 34:
        return t.charCodeAt(u + 1) === 34 && t.charCodeAt(u + 2) === 34 ? NS(s, u) : US(s, u);
    }
    if (Ne(a) || a === 45)
      return jS(s, u, a);
    if (x_(a))
      return IS(s, u);
    throw ms(
      s.source,
      u,
      a === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : we(a) || Tt(t, u) ? `Unexpected character: ${ie(s, u)}.` : `Invalid character: ${ie(s, u)}.`
    );
  }
  return Es(s, x.EOF, r, r);
}
function RS(s, e) {
  const t = s.source.body, r = t.length;
  let u = e + 1;
  for (; u < r; ) {
    const a = t.charCodeAt(u);
    if (a === 10 || a === 13)
      break;
    if (we(a))
      ++u;
    else if (Tt(t, u))
      u += 2;
    else
      break;
  }
  return Es(
    s,
    x.COMMENT,
    e,
    u,
    t.slice(e + 1, u)
  );
}
function jS(s, e, t) {
  const r = s.source.body;
  let u = e, a = t, i = !1;
  if (a === 45 && (a = r.charCodeAt(++u)), a === 48) {
    if (a = r.charCodeAt(++u), Ne(a))
      throw ms(
        s.source,
        u,
        `Invalid number, unexpected digit after 0: ${ie(
          s,
          u
        )}.`
      );
  } else
    u = ar(s, u, a), a = r.charCodeAt(u);
  if (a === 46 && (i = !0, a = r.charCodeAt(++u), u = ar(s, u, a), a = r.charCodeAt(u)), (a === 69 || a === 101) && (i = !0, a = r.charCodeAt(++u), (a === 43 || a === 45) && (a = r.charCodeAt(++u)), u = ar(s, u, a), a = r.charCodeAt(u)), a === 46 || x_(a))
    throw ms(
      s.source,
      u,
      `Invalid number, expected digit but got: ${ie(
        s,
        u
      )}.`
    );
  return Es(
    s,
    i ? x.FLOAT : x.INT,
    e,
    u,
    r.slice(e, u)
  );
}
function ar(s, e, t) {
  if (!Ne(t))
    throw ms(
      s.source,
      e,
      `Invalid number, expected digit but got: ${ie(
        s,
        e
      )}.`
    );
  const r = s.source.body;
  let u = e + 1;
  for (; Ne(r.charCodeAt(u)); )
    ++u;
  return u;
}
function US(s, e) {
  const t = s.source.body, r = t.length;
  let u = e + 1, a = u, i = "";
  for (; u < r; ) {
    const _ = t.charCodeAt(u);
    if (_ === 34)
      return i += t.slice(a, u), Es(s, x.STRING, e, u + 1, i);
    if (_ === 92) {
      i += t.slice(a, u);
      const h = t.charCodeAt(u + 1) === 117 ? t.charCodeAt(u + 2) === 123 ? QS(s, u) : zS(s, u) : WS(s, u);
      i += h.value, u += h.size, a = u;
      continue;
    }
    if (_ === 10 || _ === 13)
      break;
    if (we(_))
      ++u;
    else if (Tt(t, u))
      u += 2;
    else
      throw ms(
        s.source,
        u,
        `Invalid character within String: ${ie(
          s,
          u
        )}.`
      );
  }
  throw ms(s.source, u, "Unterminated string.");
}
function QS(s, e) {
  const t = s.source.body;
  let r = 0, u = 3;
  for (; u < 12; ) {
    const a = t.charCodeAt(e + u++);
    if (a === 125) {
      if (u < 5 || !we(r))
        break;
      return {
        value: String.fromCodePoint(r),
        size: u
      };
    }
    if (r = r << 4 | Re(a), r < 0)
      break;
  }
  throw ms(
    s.source,
    e,
    `Invalid Unicode escape sequence: "${t.slice(
      e,
      e + u
    )}".`
  );
}
function zS(s, e) {
  const t = s.source.body, r = pi(t, e + 2);
  if (we(r))
    return {
      value: String.fromCodePoint(r),
      size: 6
    };
  if (o_(r) && t.charCodeAt(e + 6) === 92 && t.charCodeAt(e + 7) === 117) {
    const u = pi(t, e + 8);
    if (M_(u))
      return {
        value: String.fromCodePoint(r, u),
        size: 12
      };
  }
  throw ms(
    s.source,
    e,
    `Invalid Unicode escape sequence: "${t.slice(e, e + 6)}".`
  );
}
function pi(s, e) {
  return Re(s.charCodeAt(e)) << 12 | Re(s.charCodeAt(e + 1)) << 8 | Re(s.charCodeAt(e + 2)) << 4 | Re(s.charCodeAt(e + 3));
}
function Re(s) {
  return s >= 48 && s <= 57 ? s - 48 : s >= 65 && s <= 70 ? s - 55 : s >= 97 && s <= 102 ? s - 87 : -1;
}
function WS(s, e) {
  const t = s.source.body;
  switch (t.charCodeAt(e + 1)) {
    case 34:
      return {
        value: '"',
        size: 2
      };
    case 92:
      return {
        value: "\\",
        size: 2
      };
    case 47:
      return {
        value: "/",
        size: 2
      };
    case 98:
      return {
        value: "\b",
        size: 2
      };
    case 102:
      return {
        value: "\f",
        size: 2
      };
    case 110:
      return {
        value: `
`,
        size: 2
      };
    case 114:
      return {
        value: "\r",
        size: 2
      };
    case 116:
      return {
        value: "	",
        size: 2
      };
  }
  throw ms(
    s.source,
    e,
    `Invalid character escape sequence: "${t.slice(
      e,
      e + 2
    )}".`
  );
}
function NS(s, e) {
  const t = s.source.body, r = t.length;
  let u = s.lineStart, a = e + 3, i = a, _ = "";
  const h = [];
  for (; a < r; ) {
    const f = t.charCodeAt(a);
    if (f === 34 && t.charCodeAt(a + 1) === 34 && t.charCodeAt(a + 2) === 34) {
      _ += t.slice(i, a), h.push(_);
      const A = Es(
        s,
        x.BLOCK_STRING,
        e,
        a + 3,
        // Return a string of the lines joined with U+000A.
        $S(h).join(`
`)
      );
      return s.line += h.length - 1, s.lineStart = u, A;
    }
    if (f === 92 && t.charCodeAt(a + 1) === 34 && t.charCodeAt(a + 2) === 34 && t.charCodeAt(a + 3) === 34) {
      _ += t.slice(i, a), i = a + 1, a += 4;
      continue;
    }
    if (f === 10 || f === 13) {
      _ += t.slice(i, a), h.push(_), f === 13 && t.charCodeAt(a + 1) === 10 ? a += 2 : ++a, _ = "", i = a, u = a;
      continue;
    }
    if (we(f))
      ++a;
    else if (Tt(t, a))
      a += 2;
    else
      throw ms(
        s.source,
        a,
        `Invalid character within String: ${ie(
          s,
          a
        )}.`
      );
  }
  throw ms(s.source, a, "Unterminated string.");
}
function IS(s, e) {
  const t = s.source.body, r = t.length;
  let u = e + 1;
  for (; u < r; ) {
    const a = t.charCodeAt(u);
    if (MS(a))
      ++u;
    else
      break;
  }
  return Es(
    s,
    x.NAME,
    e,
    u,
    t.slice(e, u)
  );
}
const JS = 10, $_ = 2;
function Lr(s) {
  return Pt(s, []);
}
function Pt(s, e) {
  switch (typeof s) {
    case "string":
      return JSON.stringify(s);
    case "function":
      return s.name ? `[function ${s.name}]` : "[function]";
    case "object":
      return HS(s, e);
    default:
      return String(s);
  }
}
function HS(s, e) {
  if (s === null)
    return "null";
  if (e.includes(s))
    return "[Circular]";
  const t = [...e, s];
  if (YS(s)) {
    const r = s.toJSON();
    if (r !== s)
      return typeof r == "string" ? r : Pt(r, t);
  } else if (Array.isArray(s))
    return XS(s, t);
  return KS(s, t);
}
function YS(s) {
  return typeof s.toJSON == "function";
}
function KS(s, e) {
  const t = Object.entries(s);
  return t.length === 0 ? "{}" : e.length > $_ ? "[" + ZS(s) + "]" : "{ " + t.map(
    ([u, a]) => u + ": " + Pt(a, e)
  ).join(", ") + " }";
}
function XS(s, e) {
  if (s.length === 0)
    return "[]";
  if (e.length > $_)
    return "[Array]";
  const t = Math.min(JS, s.length), r = s.length - t, u = [];
  for (let a = 0; a < t; ++a)
    u.push(Pt(s[a], e));
  return r === 1 ? u.push("... 1 more item") : r > 1 && u.push(`... ${r} more items`), "[" + u.join(", ") + "]";
}
function ZS(s) {
  const e = Object.prototype.toString.call(s).replace(/^\[object /, "").replace(/]$/, "");
  if (e === "Object" && typeof s.constructor == "function") {
    const t = s.constructor.name;
    if (typeof t == "string" && t !== "")
      return t;
  }
  return e;
}
const CS = globalThis.process && // eslint-disable-next-line no-undef
process.env.NODE_ENV === "production", gS = (
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  CS ? function(e, t) {
    return e instanceof t;
  } : function(e, t) {
    if (e instanceof t)
      return !0;
    if (typeof e == "object" && e !== null) {
      var r;
      const u = t.prototype[Symbol.toStringTag], a = (
        // We still need to support constructor's name to detect conflicts with older versions of this library.
        Symbol.toStringTag in e ? e[Symbol.toStringTag] : (r = e.constructor) === null || r === void 0 ? void 0 : r.name
      );
      if (u === a) {
        const i = Lr(e);
        throw new Error(`Cannot use ${u} "${i}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
      }
    }
    return !1;
  }
);
class T_ {
  constructor(e, t = "GraphQL request", r = {
    line: 1,
    column: 1
  }) {
    typeof e == "string" || Dt(!1, `Body must be a string. Received: ${Lr(e)}.`), this.body = e, this.name = t, this.locationOffset = r, this.locationOffset.line > 0 || Dt(
      !1,
      "line in locationOffset is 1-indexed and must be positive."
    ), this.locationOffset.column > 0 || Dt(
      !1,
      "column in locationOffset is 1-indexed and must be positive."
    );
  }
  get [Symbol.toStringTag]() {
    return "Source";
  }
}
function kS(s) {
  return gS(s, T_);
}
function OS(s, e) {
  return new LS(s, e).parseDocument();
}
class LS {
  constructor(e, t = {}) {
    const r = kS(e) ? e : new T_(e);
    this._lexer = new BS(r), this._options = t, this._tokenCounter = 0;
  }
  /**
   * Converts a name lex token into a name parse node.
   */
  parseName() {
    const e = this.expectToken(x.NAME);
    return this.node(e, {
      kind: G.NAME,
      value: e.value
    });
  }
  // Implements the parsing rules in the Document section.
  /**
   * Document : Definition+
   */
  parseDocument() {
    return this.node(this._lexer.token, {
      kind: G.DOCUMENT,
      definitions: this.many(
        x.SOF,
        this.parseDefinition,
        x.EOF
      )
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  parseDefinition() {
    if (this.peek(x.BRACE_L))
      return this.parseOperationDefinition();
    const e = this.peekDescription(), t = e ? this._lexer.lookahead() : this._lexer.token;
    if (t.kind === x.NAME) {
      switch (t.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
      if (e)
        throw ms(
          this._lexer.source,
          this._lexer.token.start,
          "Unexpected description, descriptions are supported only on type definitions."
        );
      switch (t.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
        case "extend":
          return this.parseTypeSystemExtension();
      }
    }
    throw this.unexpected(t);
  }
  // Implements the parsing rules in the Operations section.
  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  parseOperationDefinition() {
    const e = this._lexer.token;
    if (this.peek(x.BRACE_L))
      return this.node(e, {
        kind: G.OPERATION_DEFINITION,
        operation: ce.QUERY,
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet()
      });
    const t = this.parseOperationType();
    let r;
    return this.peek(x.NAME) && (r = this.parseName()), this.node(e, {
      kind: G.OPERATION_DEFINITION,
      operation: t,
      name: r,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */
  parseOperationType() {
    const e = this.expectToken(x.NAME);
    switch (e.value) {
      case "query":
        return ce.QUERY;
      case "mutation":
        return ce.MUTATION;
      case "subscription":
        return ce.SUBSCRIPTION;
    }
    throw this.unexpected(e);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  parseVariableDefinitions() {
    return this.optionalMany(
      x.PAREN_L,
      this.parseVariableDefinition,
      x.PAREN_R
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: G.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(x.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(x.EQUALS) ? this.parseConstValueLiteral() : void 0,
      directives: this.parseConstDirectives()
    });
  }
  /**
   * Variable : $ Name
   */
  parseVariable() {
    const e = this._lexer.token;
    return this.expectToken(x.DOLLAR), this.node(e, {
      kind: G.VARIABLE,
      name: this.parseName()
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */
  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: G.SELECTION_SET,
      selections: this.many(
        x.BRACE_L,
        this.parseSelection,
        x.BRACE_R
      )
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  parseSelection() {
    return this.peek(x.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  parseField() {
    const e = this._lexer.token, t = this.parseName();
    let r, u;
    return this.expectOptionalToken(x.COLON) ? (r = t, u = this.parseName()) : u = t, this.node(e, {
      kind: G.FIELD,
      alias: r,
      name: u,
      arguments: this.parseArguments(!1),
      directives: this.parseDirectives(!1),
      selectionSet: this.peek(x.BRACE_L) ? this.parseSelectionSet() : void 0
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  parseArguments(e) {
    const t = e ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(x.PAREN_L, t, x.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  parseArgument(e = !1) {
    const t = this._lexer.token, r = this.parseName();
    return this.expectToken(x.COLON), this.node(t, {
      kind: G.ARGUMENT,
      name: r,
      value: this.parseValueLiteral(e)
    });
  }
  parseConstArgument() {
    return this.parseArgument(!0);
  }
  // Implements the parsing rules in the Fragments section.
  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  parseFragment() {
    const e = this._lexer.token;
    this.expectToken(x.SPREAD);
    const t = this.expectOptionalKeyword("on");
    return !t && this.peek(x.NAME) ? this.node(e, {
      kind: G.FRAGMENT_SPREAD,
      name: this.parseFragmentName(),
      directives: this.parseDirectives(!1)
    }) : this.node(e, {
      kind: G.INLINE_FRAGMENT,
      typeCondition: t ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  parseFragmentDefinition() {
    const e = this._lexer.token;
    return this.expectKeyword("fragment"), this._options.allowLegacyFragmentVariables === !0 ? this.node(e, {
      kind: G.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      variableDefinitions: this.parseVariableDefinitions(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    }) : this.node(e, {
      kind: G.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentName : Name but not `on`
   */
  parseFragmentName() {
    if (this._lexer.token.value === "on")
      throw this.unexpected();
    return this.parseName();
  }
  // Implements the parsing rules in the Values section.
  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseValueLiteral(e) {
    const t = this._lexer.token;
    switch (t.kind) {
      case x.BRACKET_L:
        return this.parseList(e);
      case x.BRACE_L:
        return this.parseObject(e);
      case x.INT:
        return this.advanceLexer(), this.node(t, {
          kind: G.INT,
          value: t.value
        });
      case x.FLOAT:
        return this.advanceLexer(), this.node(t, {
          kind: G.FLOAT,
          value: t.value
        });
      case x.STRING:
      case x.BLOCK_STRING:
        return this.parseStringLiteral();
      case x.NAME:
        switch (this.advanceLexer(), t.value) {
          case "true":
            return this.node(t, {
              kind: G.BOOLEAN,
              value: !0
            });
          case "false":
            return this.node(t, {
              kind: G.BOOLEAN,
              value: !1
            });
          case "null":
            return this.node(t, {
              kind: G.NULL
            });
          default:
            return this.node(t, {
              kind: G.ENUM,
              value: t.value
            });
        }
      case x.DOLLAR:
        if (e)
          if (this.expectToken(x.DOLLAR), this._lexer.token.kind === x.NAME) {
            const r = this._lexer.token.value;
            throw ms(
              this._lexer.source,
              t.start,
              `Unexpected variable "$${r}" in constant value.`
            );
          } else
            throw this.unexpected(t);
        return this.parseVariable();
      default:
        throw this.unexpected();
    }
  }
  parseConstValueLiteral() {
    return this.parseValueLiteral(!0);
  }
  parseStringLiteral() {
    const e = this._lexer.token;
    return this.advanceLexer(), this.node(e, {
      kind: G.STRING,
      value: e.value,
      block: e.kind === x.BLOCK_STRING
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  parseList(e) {
    const t = () => this.parseValueLiteral(e);
    return this.node(this._lexer.token, {
      kind: G.LIST,
      values: this.any(x.BRACKET_L, t, x.BRACKET_R)
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */
  parseObject(e) {
    const t = () => this.parseObjectField(e);
    return this.node(this._lexer.token, {
      kind: G.OBJECT,
      fields: this.any(x.BRACE_L, t, x.BRACE_R)
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  parseObjectField(e) {
    const t = this._lexer.token, r = this.parseName();
    return this.expectToken(x.COLON), this.node(t, {
      kind: G.OBJECT_FIELD,
      name: r,
      value: this.parseValueLiteral(e)
    });
  }
  // Implements the parsing rules in the Directives section.
  /**
   * Directives[Const] : Directive[?Const]+
   */
  parseDirectives(e) {
    const t = [];
    for (; this.peek(x.AT); )
      t.push(this.parseDirective(e));
    return t;
  }
  parseConstDirectives() {
    return this.parseDirectives(!0);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */
  parseDirective(e) {
    const t = this._lexer.token;
    return this.expectToken(x.AT), this.node(t, {
      kind: G.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(e)
    });
  }
  // Implements the parsing rules in the Types section.
  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  parseTypeReference() {
    const e = this._lexer.token;
    let t;
    if (this.expectOptionalToken(x.BRACKET_L)) {
      const r = this.parseTypeReference();
      this.expectToken(x.BRACKET_R), t = this.node(e, {
        kind: G.LIST_TYPE,
        type: r
      });
    } else
      t = this.parseNamedType();
    return this.expectOptionalToken(x.BANG) ? this.node(e, {
      kind: G.NON_NULL_TYPE,
      type: t
    }) : t;
  }
  /**
   * NamedType : Name
   */
  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: G.NAMED_TYPE,
      name: this.parseName()
    });
  }
  // Implements the parsing rules in the Type Definition section.
  peekDescription() {
    return this.peek(x.STRING) || this.peek(x.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  parseDescription() {
    if (this.peekDescription())
      return this.parseStringLiteral();
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */
  parseSchemaDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("schema");
    const r = this.parseConstDirectives(), u = this.many(
      x.BRACE_L,
      this.parseOperationTypeDefinition,
      x.BRACE_R
    );
    return this.node(e, {
      kind: G.SCHEMA_DEFINITION,
      description: t,
      directives: r,
      operationTypes: u
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  parseOperationTypeDefinition() {
    const e = this._lexer.token, t = this.parseOperationType();
    this.expectToken(x.COLON);
    const r = this.parseNamedType();
    return this.node(e, {
      kind: G.OPERATION_TYPE_DEFINITION,
      operation: t,
      type: r
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  parseScalarTypeDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("scalar");
    const r = this.parseName(), u = this.parseConstDirectives();
    return this.node(e, {
      kind: G.SCALAR_TYPE_DEFINITION,
      description: t,
      name: r,
      directives: u
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  parseObjectTypeDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("type");
    const r = this.parseName(), u = this.parseImplementsInterfaces(), a = this.parseConstDirectives(), i = this.parseFieldsDefinition();
    return this.node(e, {
      kind: G.OBJECT_TYPE_DEFINITION,
      description: t,
      name: r,
      interfaces: u,
      directives: a,
      fields: i
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  parseImplementsInterfaces() {
    return this.expectOptionalKeyword("implements") ? this.delimitedMany(x.AMP, this.parseNamedType) : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */
  parseFieldsDefinition() {
    return this.optionalMany(
      x.BRACE_L,
      this.parseFieldDefinition,
      x.BRACE_R
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  parseFieldDefinition() {
    const e = this._lexer.token, t = this.parseDescription(), r = this.parseName(), u = this.parseArgumentDefs();
    this.expectToken(x.COLON);
    const a = this.parseTypeReference(), i = this.parseConstDirectives();
    return this.node(e, {
      kind: G.FIELD_DEFINITION,
      description: t,
      name: r,
      arguments: u,
      type: a,
      directives: i
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  parseArgumentDefs() {
    return this.optionalMany(
      x.PAREN_L,
      this.parseInputValueDef,
      x.PAREN_R
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  parseInputValueDef() {
    const e = this._lexer.token, t = this.parseDescription(), r = this.parseName();
    this.expectToken(x.COLON);
    const u = this.parseTypeReference();
    let a;
    this.expectOptionalToken(x.EQUALS) && (a = this.parseConstValueLiteral());
    const i = this.parseConstDirectives();
    return this.node(e, {
      kind: G.INPUT_VALUE_DEFINITION,
      description: t,
      name: r,
      type: u,
      defaultValue: a,
      directives: i
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  parseInterfaceTypeDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("interface");
    const r = this.parseName(), u = this.parseImplementsInterfaces(), a = this.parseConstDirectives(), i = this.parseFieldsDefinition();
    return this.node(e, {
      kind: G.INTERFACE_TYPE_DEFINITION,
      description: t,
      name: r,
      interfaces: u,
      directives: a,
      fields: i
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  parseUnionTypeDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("union");
    const r = this.parseName(), u = this.parseConstDirectives(), a = this.parseUnionMemberTypes();
    return this.node(e, {
      kind: G.UNION_TYPE_DEFINITION,
      description: t,
      name: r,
      directives: u,
      types: a
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  parseUnionMemberTypes() {
    return this.expectOptionalToken(x.EQUALS) ? this.delimitedMany(x.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  parseEnumTypeDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("enum");
    const r = this.parseName(), u = this.parseConstDirectives(), a = this.parseEnumValuesDefinition();
    return this.node(e, {
      kind: G.ENUM_TYPE_DEFINITION,
      description: t,
      name: r,
      directives: u,
      values: a
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */
  parseEnumValuesDefinition() {
    return this.optionalMany(
      x.BRACE_L,
      this.parseEnumValueDefinition,
      x.BRACE_R
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */
  parseEnumValueDefinition() {
    const e = this._lexer.token, t = this.parseDescription(), r = this.parseEnumValueName(), u = this.parseConstDirectives();
    return this.node(e, {
      kind: G.ENUM_VALUE_DEFINITION,
      description: t,
      name: r,
      directives: u
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseEnumValueName() {
    if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null")
      throw ms(
        this._lexer.source,
        this._lexer.token.start,
        `${ct(
          this._lexer.token
        )} is reserved and cannot be used for an enum value.`
      );
    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  parseInputObjectTypeDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("input");
    const r = this.parseName(), u = this.parseConstDirectives(), a = this.parseInputFieldsDefinition();
    return this.node(e, {
      kind: G.INPUT_OBJECT_TYPE_DEFINITION,
      description: t,
      name: r,
      directives: u,
      fields: a
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */
  parseInputFieldsDefinition() {
    return this.optionalMany(
      x.BRACE_L,
      this.parseInputValueDef,
      x.BRACE_R
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  parseTypeSystemExtension() {
    const e = this._lexer.lookahead();
    if (e.kind === x.NAME)
      switch (e.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
      }
    throw this.unexpected(e);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */
  parseSchemaExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("schema");
    const t = this.parseConstDirectives(), r = this.optionalMany(
      x.BRACE_L,
      this.parseOperationTypeDefinition,
      x.BRACE_R
    );
    if (t.length === 0 && r.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: G.SCHEMA_EXTENSION,
      directives: t,
      operationTypes: r
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  parseScalarTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("scalar");
    const t = this.parseName(), r = this.parseConstDirectives();
    if (r.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: G.SCALAR_TYPE_EXTENSION,
      name: t,
      directives: r
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  parseObjectTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("type");
    const t = this.parseName(), r = this.parseImplementsInterfaces(), u = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    if (r.length === 0 && u.length === 0 && a.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: G.OBJECT_TYPE_EXTENSION,
      name: t,
      interfaces: r,
      directives: u,
      fields: a
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  parseInterfaceTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("interface");
    const t = this.parseName(), r = this.parseImplementsInterfaces(), u = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    if (r.length === 0 && u.length === 0 && a.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: G.INTERFACE_TYPE_EXTENSION,
      name: t,
      interfaces: r,
      directives: u,
      fields: a
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  parseUnionTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("union");
    const t = this.parseName(), r = this.parseConstDirectives(), u = this.parseUnionMemberTypes();
    if (r.length === 0 && u.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: G.UNION_TYPE_EXTENSION,
      name: t,
      directives: r,
      types: u
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  parseEnumTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("enum");
    const t = this.parseName(), r = this.parseConstDirectives(), u = this.parseEnumValuesDefinition();
    if (r.length === 0 && u.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: G.ENUM_TYPE_EXTENSION,
      name: t,
      directives: r,
      values: u
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  parseInputObjectTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("input");
    const t = this.parseName(), r = this.parseConstDirectives(), u = this.parseInputFieldsDefinition();
    if (r.length === 0 && u.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: G.INPUT_OBJECT_TYPE_EXTENSION,
      name: t,
      directives: r,
      fields: u
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */
  parseDirectiveDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("directive"), this.expectToken(x.AT);
    const r = this.parseName(), u = this.parseArgumentDefs(), a = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    const i = this.parseDirectiveLocations();
    return this.node(e, {
      kind: G.DIRECTIVE_DEFINITION,
      description: t,
      name: r,
      arguments: u,
      repeatable: a,
      locations: i
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  parseDirectiveLocations() {
    return this.delimitedMany(x.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  parseDirectiveLocation() {
    const e = this._lexer.token, t = this.parseName();
    if (Object.prototype.hasOwnProperty.call(wr, t.value))
      return t;
    throw this.unexpected(e);
  }
  // Core parsing utility functions
  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */
  node(e, t) {
    return this._options.noLocation !== !0 && (t.loc = new xS(
      e,
      this._lexer.lastToken,
      this._lexer.source
    )), t;
  }
  /**
   * Determines if the next token is of a given kind
   */
  peek(e) {
    return this._lexer.token.kind === e;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectToken(e) {
    const t = this._lexer.token;
    if (t.kind === e)
      return this.advanceLexer(), t;
    throw ms(
      this._lexer.source,
      t.start,
      `Expected ${P_(e)}, found ${ct(t)}.`
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalToken(e) {
    return this._lexer.token.kind === e ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectKeyword(e) {
    const t = this._lexer.token;
    if (t.kind === x.NAME && t.value === e)
      this.advanceLexer();
    else
      throw ms(
        this._lexer.source,
        t.start,
        `Expected "${e}", found ${ct(t)}.`
      );
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalKeyword(e) {
    const t = this._lexer.token;
    return t.kind === x.NAME && t.value === e ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  unexpected(e) {
    const t = e ?? this._lexer.token;
    return ms(
      this._lexer.source,
      t.start,
      `Unexpected ${ct(t)}.`
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  any(e, t, r) {
    this.expectToken(e);
    const u = [];
    for (; !this.expectOptionalToken(r); )
      u.push(t.call(this));
    return u;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  optionalMany(e, t, r) {
    if (this.expectOptionalToken(e)) {
      const u = [];
      do
        u.push(t.call(this));
      while (!this.expectOptionalToken(r));
      return u;
    }
    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  many(e, t, r) {
    this.expectToken(e);
    const u = [];
    do
      u.push(t.call(this));
    while (!this.expectOptionalToken(r));
    return u;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  delimitedMany(e, t) {
    this.expectOptionalToken(e);
    const r = [];
    do
      r.push(t.call(this));
    while (this.expectOptionalToken(e));
    return r;
  }
  advanceLexer() {
    const { maxTokens: e } = this._options, t = this._lexer.advance();
    if (e !== void 0 && t.kind !== x.EOF && (++this._tokenCounter, this._tokenCounter > e))
      throw ms(
        this._lexer.source,
        t.start,
        `Document contains more that ${e} tokens. Parsing aborted.`
      );
  }
}
function ct(s) {
  const e = s.value;
  return P_(s.kind) + (e != null ? ` "${e}"` : "");
}
function P_(s) {
  return qS(s) ? `"${s}"` : s;
}
function sA(s) {
  return `"${s.replace(eA, tA)}"`;
}
const eA = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function tA(s) {
  return rA[s.charCodeAt(0)];
}
const rA = [
  "\\u0000",
  "\\u0001",
  "\\u0002",
  "\\u0003",
  "\\u0004",
  "\\u0005",
  "\\u0006",
  "\\u0007",
  "\\b",
  "\\t",
  "\\n",
  "\\u000B",
  "\\f",
  "\\r",
  "\\u000E",
  "\\u000F",
  "\\u0010",
  "\\u0011",
  "\\u0012",
  "\\u0013",
  "\\u0014",
  "\\u0015",
  "\\u0016",
  "\\u0017",
  "\\u0018",
  "\\u0019",
  "\\u001A",
  "\\u001B",
  "\\u001C",
  "\\u001D",
  "\\u001E",
  "\\u001F",
  "",
  "",
  '\\"',
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 2F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 3F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 4F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\\\",
  "",
  "",
  "",
  // 5F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 6F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\u007F",
  "\\u0080",
  "\\u0081",
  "\\u0082",
  "\\u0083",
  "\\u0084",
  "\\u0085",
  "\\u0086",
  "\\u0087",
  "\\u0088",
  "\\u0089",
  "\\u008A",
  "\\u008B",
  "\\u008C",
  "\\u008D",
  "\\u008E",
  "\\u008F",
  "\\u0090",
  "\\u0091",
  "\\u0092",
  "\\u0093",
  "\\u0094",
  "\\u0095",
  "\\u0096",
  "\\u0097",
  "\\u0098",
  "\\u0099",
  "\\u009A",
  "\\u009B",
  "\\u009C",
  "\\u009D",
  "\\u009E",
  "\\u009F"
], su = Object.freeze({});
function Xs(s, e, t = w_) {
  const r = /* @__PURE__ */ new Map();
  for (const b of Object.values(G))
    r.set(b, uA(e, b));
  let u, a = Array.isArray(s), i = [s], _ = -1, h = [], f = s, A, y;
  const c = [], n = [];
  do {
    _++;
    const b = _ === i.length, F = b && h.length !== 0;
    if (b) {
      if (A = n.length === 0 ? void 0 : c[c.length - 1], f = y, y = n.pop(), F)
        if (a) {
          f = f.slice();
          let T = 0;
          for (const [$, q] of h) {
            const z = $ - T;
            q === null ? (f.splice(z, 1), T++) : f[z] = q;
          }
        } else {
          f = Object.defineProperties(
            {},
            Object.getOwnPropertyDescriptors(f)
          );
          for (const [T, $] of h)
            f[T] = $;
        }
      _ = u.index, i = u.keys, h = u.edits, a = u.inArray, u = u.prev;
    } else if (y) {
      if (A = a ? _ : i[_], f = y[A], f == null)
        continue;
      c.push(A);
    }
    let l;
    if (!Array.isArray(f)) {
      var d, E;
      di(f) || Dt(!1, `Invalid AST Node: ${Lr(f)}.`);
      const T = b ? (d = r.get(f.kind)) === null || d === void 0 ? void 0 : d.leave : (E = r.get(f.kind)) === null || E === void 0 ? void 0 : E.enter;
      if (l = T == null ? void 0 : T.call(e, f, A, y, c, n), l === su)
        break;
      if (l === !1) {
        if (!b) {
          c.pop();
          continue;
        }
      } else if (l !== void 0 && (h.push([A, l]), !b))
        if (di(l))
          f = l;
        else {
          c.pop();
          continue;
        }
    }
    if (l === void 0 && F && h.push([A, f]), b)
      c.pop();
    else {
      var V;
      u = {
        inArray: a,
        index: _,
        keys: i,
        edits: h,
        prev: u
      }, a = Array.isArray(f), i = a ? f : (V = t[f.kind]) !== null && V !== void 0 ? V : [], _ = -1, h = [], y && n.push(y), y = f;
    }
  } while (u !== void 0);
  return h.length !== 0 ? h[h.length - 1][1] : s;
}
function uA(s, e) {
  const t = s[e];
  return typeof t == "object" ? t : typeof t == "function" ? {
    enter: t,
    leave: void 0
  } : {
    enter: s.enter,
    leave: s.leave
  };
}
function aA(s) {
  return Xs(s, _A);
}
const iA = 80, _A = {
  Name: {
    leave: (s) => s.value
  },
  Variable: {
    leave: (s) => "$" + s.name
  },
  // Document
  Document: {
    leave: (s) => R(s.definitions, `

`)
  },
  OperationDefinition: {
    leave(s) {
      const e = k("(", R(s.variableDefinitions, ", "), ")"), t = R(
        [
          s.operation,
          R([s.name, e]),
          R(s.directives, " ")
        ],
        " "
      );
      return (t === "query" ? "" : t + " ") + s.selectionSet;
    }
  },
  VariableDefinition: {
    leave: ({ variable: s, type: e, defaultValue: t, directives: r }) => s + ": " + e + k(" = ", t) + k(" ", R(r, " "))
  },
  SelectionSet: {
    leave: ({ selections: s }) => Us(s)
  },
  Field: {
    leave({ alias: s, name: e, arguments: t, directives: r, selectionSet: u }) {
      const a = k("", s, ": ") + e;
      let i = a + k("(", R(t, ", "), ")");
      return i.length > iA && (i = a + k(`(
`, dt(R(t, `
`)), `
)`)), R([i, R(r, " "), u], " ");
    }
  },
  Argument: {
    leave: ({ name: s, value: e }) => s + ": " + e
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name: s, directives: e }) => "..." + s + k(" ", R(e, " "))
  },
  InlineFragment: {
    leave: ({ typeCondition: s, directives: e, selectionSet: t }) => R(
      [
        "...",
        k("on ", s),
        R(e, " "),
        t
      ],
      " "
    )
  },
  FragmentDefinition: {
    leave: ({ name: s, typeCondition: e, variableDefinitions: t, directives: r, selectionSet: u }) => (
      // or removed in the future.
      `fragment ${s}${k("(", R(t, ", "), ")")} on ${e} ${k("", R(r, " "), " ")}` + u
    )
  },
  // Value
  IntValue: {
    leave: ({ value: s }) => s
  },
  FloatValue: {
    leave: ({ value: s }) => s
  },
  StringValue: {
    leave: ({ value: s, block: e }) => e ? PS(s) : sA(s)
  },
  BooleanValue: {
    leave: ({ value: s }) => s ? "true" : "false"
  },
  NullValue: {
    leave: () => "null"
  },
  EnumValue: {
    leave: ({ value: s }) => s
  },
  ListValue: {
    leave: ({ values: s }) => "[" + R(s, ", ") + "]"
  },
  ObjectValue: {
    leave: ({ fields: s }) => "{" + R(s, ", ") + "}"
  },
  ObjectField: {
    leave: ({ name: s, value: e }) => s + ": " + e
  },
  // Directive
  Directive: {
    leave: ({ name: s, arguments: e }) => "@" + s + k("(", R(e, ", "), ")")
  },
  // Type
  NamedType: {
    leave: ({ name: s }) => s
  },
  ListType: {
    leave: ({ type: s }) => "[" + s + "]"
  },
  NonNullType: {
    leave: ({ type: s }) => s + "!"
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description: s, directives: e, operationTypes: t }) => k("", s, `
`) + R(["schema", R(e, " "), Us(t)], " ")
  },
  OperationTypeDefinition: {
    leave: ({ operation: s, type: e }) => s + ": " + e
  },
  ScalarTypeDefinition: {
    leave: ({ description: s, name: e, directives: t }) => k("", s, `
`) + R(["scalar", e, R(t, " ")], " ")
  },
  ObjectTypeDefinition: {
    leave: ({ description: s, name: e, interfaces: t, directives: r, fields: u }) => k("", s, `
`) + R(
      [
        "type",
        e,
        k("implements ", R(t, " & ")),
        R(r, " "),
        Us(u)
      ],
      " "
    )
  },
  FieldDefinition: {
    leave: ({ description: s, name: e, arguments: t, type: r, directives: u }) => k("", s, `
`) + e + (bi(t) ? k(`(
`, dt(R(t, `
`)), `
)`) : k("(", R(t, ", "), ")")) + ": " + r + k(" ", R(u, " "))
  },
  InputValueDefinition: {
    leave: ({ description: s, name: e, type: t, defaultValue: r, directives: u }) => k("", s, `
`) + R(
      [e + ": " + t, k("= ", r), R(u, " ")],
      " "
    )
  },
  InterfaceTypeDefinition: {
    leave: ({ description: s, name: e, interfaces: t, directives: r, fields: u }) => k("", s, `
`) + R(
      [
        "interface",
        e,
        k("implements ", R(t, " & ")),
        R(r, " "),
        Us(u)
      ],
      " "
    )
  },
  UnionTypeDefinition: {
    leave: ({ description: s, name: e, directives: t, types: r }) => k("", s, `
`) + R(
      ["union", e, R(t, " "), k("= ", R(r, " | "))],
      " "
    )
  },
  EnumTypeDefinition: {
    leave: ({ description: s, name: e, directives: t, values: r }) => k("", s, `
`) + R(["enum", e, R(t, " "), Us(r)], " ")
  },
  EnumValueDefinition: {
    leave: ({ description: s, name: e, directives: t }) => k("", s, `
`) + R([e, R(t, " ")], " ")
  },
  InputObjectTypeDefinition: {
    leave: ({ description: s, name: e, directives: t, fields: r }) => k("", s, `
`) + R(["input", e, R(t, " "), Us(r)], " ")
  },
  DirectiveDefinition: {
    leave: ({ description: s, name: e, arguments: t, repeatable: r, locations: u }) => k("", s, `
`) + "directive @" + e + (bi(t) ? k(`(
`, dt(R(t, `
`)), `
)`) : k("(", R(t, ", "), ")")) + (r ? " repeatable" : "") + " on " + R(u, " | ")
  },
  SchemaExtension: {
    leave: ({ directives: s, operationTypes: e }) => R(
      ["extend schema", R(s, " "), Us(e)],
      " "
    )
  },
  ScalarTypeExtension: {
    leave: ({ name: s, directives: e }) => R(["extend scalar", s, R(e, " ")], " ")
  },
  ObjectTypeExtension: {
    leave: ({ name: s, interfaces: e, directives: t, fields: r }) => R(
      [
        "extend type",
        s,
        k("implements ", R(e, " & ")),
        R(t, " "),
        Us(r)
      ],
      " "
    )
  },
  InterfaceTypeExtension: {
    leave: ({ name: s, interfaces: e, directives: t, fields: r }) => R(
      [
        "extend interface",
        s,
        k("implements ", R(e, " & ")),
        R(t, " "),
        Us(r)
      ],
      " "
    )
  },
  UnionTypeExtension: {
    leave: ({ name: s, directives: e, types: t }) => R(
      [
        "extend union",
        s,
        R(e, " "),
        k("= ", R(t, " | "))
      ],
      " "
    )
  },
  EnumTypeExtension: {
    leave: ({ name: s, directives: e, values: t }) => R(["extend enum", s, R(e, " "), Us(t)], " ")
  },
  InputObjectTypeExtension: {
    leave: ({ name: s, directives: e, fields: t }) => R(["extend input", s, R(e, " "), Us(t)], " ")
  }
};
function R(s, e = "") {
  var t;
  return (t = s == null ? void 0 : s.filter((r) => r).join(e)) !== null && t !== void 0 ? t : "";
}
function Us(s) {
  return k(`{
`, dt(R(s, `
`)), `
}`);
}
function k(s, e, t = "") {
  return e != null && e !== "" ? s + e + t : "";
}
function dt(s) {
  return k("  ", s.replace(/\n/g, `
  `));
}
function bi(s) {
  var e;
  return (e = s == null ? void 0 : s.some((t) => t.includes(`
`))) !== null && e !== void 0 ? e : !1;
}
function Ei(s) {
  return s.kind === G.FIELD || s.kind === G.FRAGMENT_SPREAD || s.kind === G.INLINE_FRAGMENT;
}
function Ze(s, e) {
  var t = s.directives;
  return !t || !t.length ? !0 : SA(t).every(function(r) {
    var u = r.directive, a = r.ifArgument, i = !1;
    return a.value.kind === "Variable" ? (i = e && e[a.value.name.value], Q(i !== void 0, 70, u.name.value)) : i = a.value.value, u.name.value === "skip" ? !i : i;
  });
}
function Ie(s, e, t) {
  var r = new Set(s), u = r.size;
  return Xs(e, {
    Directive: function(a) {
      if (r.delete(a.name.value) && (!t || !r.size))
        return su;
    }
  }), t ? !r.size : r.size < u;
}
function fA(s) {
  return s && Ie(["client", "export"], s, !0);
}
function hA(s) {
  var e = s.name.value;
  return e === "skip" || e === "include";
}
function SA(s) {
  var e = [];
  return s && s.length && s.forEach(function(t) {
    if (hA(t)) {
      var r = t.arguments, u = t.name.value;
      Q(r && r.length === 1, 71, u);
      var a = r[0];
      Q(a.name && a.name.value === "if", 72, u);
      var i = a.value;
      Q(i && (i.kind === "Variable" || i.kind === "BooleanValue"), 73, u), e.push({ directive: t, ifArgument: a });
    }
  }), e;
}
const AA = () => /* @__PURE__ */ Object.create(null), { forEach: yA, slice: vi } = Array.prototype, { hasOwnProperty: cA } = Object.prototype;
let Fe = class B_ {
  constructor(e = !0, t = AA) {
    this.weakness = e, this.makeData = t;
  }
  lookup() {
    return this.lookupArray(arguments);
  }
  lookupArray(e) {
    let t = this;
    return yA.call(e, (r) => t = t.getChildTrie(r)), cA.call(t, "data") ? t.data : t.data = this.makeData(vi.call(e));
  }
  peek() {
    return this.peekArray(arguments);
  }
  peekArray(e) {
    let t = this;
    for (let r = 0, u = e.length; t && r < u; ++r) {
      const a = t.mapFor(e[r], !1);
      t = a && a.get(e[r]);
    }
    return t && t.data;
  }
  remove() {
    return this.removeArray(arguments);
  }
  removeArray(e) {
    let t;
    if (e.length) {
      const r = e[0], u = this.mapFor(r, !1), a = u && u.get(r);
      a && (t = a.removeArray(vi.call(e, 1)), !a.data && !a.weak && !(a.strong && a.strong.size) && u.delete(r));
    } else
      t = this.data, delete this.data;
    return t;
  }
  getChildTrie(e) {
    const t = this.mapFor(e, !0);
    let r = t.get(e);
    return r || t.set(e, r = new B_(this.weakness, this.makeData)), r;
  }
  mapFor(e, t) {
    return this.weakness && nA(e) ? this.weak || (t ? this.weak = /* @__PURE__ */ new WeakMap() : void 0) : this.strong || (t ? this.strong = /* @__PURE__ */ new Map() : void 0);
  }
};
function nA(s) {
  switch (typeof s) {
    case "object":
      if (s === null)
        break;
    case "function":
      return !0;
  }
  return !1;
}
var q_ = Qs(function() {
  return navigator.product;
}) == "ReactNative", xe = typeof WeakMap == "function" && !(q_ && !global.HermesInternal), G_ = typeof WeakSet == "function", eu = typeof Symbol == "function" && typeof Symbol.for == "function", Bt = eu && Symbol.asyncIterator, R_ = typeof Qs(function() {
  return window.document.createElement;
}) == "function", DA = (
  // Following advice found in this comment from @domenic (maintainer of jsdom):
  // https://github.com/jsdom/jsdom/issues/1537#issuecomment-229405327
  //
  // Since we control the version of Jest and jsdom used when running Apollo
  // Client tests, and that version is recent enought to include " jsdom/x.y.z"
  // at the end of the user agent string, I believe this case is all we need to
  // check. Testing for "Node.js" was recommended for backwards compatibility
  // with older version of jsdom, but we don't have that problem.
  Qs(function() {
    return navigator.userAgent.indexOf("jsdom") >= 0;
  }) || !1
), dA = (R_ || q_) && !DA;
function Ds(s) {
  return s !== null && typeof s == "object";
}
function pA(s, e) {
  var t = e, r = [];
  s.definitions.forEach(function(a) {
    if (a.kind === "OperationDefinition")
      throw Ps(
        74,
        a.operation,
        a.name ? " named '".concat(a.name.value, "'") : ""
      );
    a.kind === "FragmentDefinition" && r.push(a);
  }), typeof t > "u" && (Q(r.length === 1, 75, r.length), t = r[0].name.value);
  var u = p(p({}, s), { definitions: Bs([
    {
      kind: "OperationDefinition",
      // OperationTypeNode is an enum
      operation: "query",
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: t
            }
          }
        ]
      }
    }
  ], s.definitions, !0) });
  return u;
}
function qt(s) {
  s === void 0 && (s = []);
  var e = {};
  return s.forEach(function(t) {
    e[t.name.value] = t;
  }), e;
}
function Gt(s, e) {
  switch (s.kind) {
    case "InlineFragment":
      return s;
    case "FragmentSpread": {
      var t = s.name.value;
      if (typeof e == "function")
        return e(t);
      var r = e && e[t];
      return Q(r, 76, t), r || null;
    }
    default:
      return null;
  }
}
function bA() {
}
class xr {
  constructor(e = 1 / 0, t = bA) {
    this.max = e, this.dispose = t, this.map = /* @__PURE__ */ new Map(), this.newest = null, this.oldest = null;
  }
  has(e) {
    return this.map.has(e);
  }
  get(e) {
    const t = this.getNode(e);
    return t && t.value;
  }
  get size() {
    return this.map.size;
  }
  getNode(e) {
    const t = this.map.get(e);
    if (t && t !== this.newest) {
      const { older: r, newer: u } = t;
      u && (u.older = r), r && (r.newer = u), t.older = this.newest, t.older.newer = t, t.newer = null, this.newest = t, t === this.oldest && (this.oldest = u);
    }
    return t;
  }
  set(e, t) {
    let r = this.getNode(e);
    return r ? r.value = t : (r = {
      key: e,
      value: t,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = r), this.newest = r, this.oldest = this.oldest || r, this.map.set(e, r), r.value);
  }
  clean() {
    for (; this.oldest && this.map.size > this.max; )
      this.delete(this.oldest.key);
  }
  delete(e) {
    const t = this.map.get(e);
    return t ? (t === this.newest && (this.newest = t.older), t === this.oldest && (this.oldest = t.newer), t.newer && (t.newer.older = t.older), t.older && (t.older.newer = t.newer), this.map.delete(e), this.dispose(t.value, e), !0) : !1;
  }
}
function or() {
}
const EA = or, vA = typeof WeakRef < "u" ? WeakRef : function(s) {
  return { deref: () => s };
}, mA = typeof WeakMap < "u" ? WeakMap : Map, VA = typeof FinalizationRegistry < "u" ? FinalizationRegistry : function() {
  return {
    register: or,
    unregister: or
  };
}, lA = 10024;
class wt {
  constructor(e = 1 / 0, t = EA) {
    this.max = e, this.dispose = t, this.map = new mA(), this.newest = null, this.oldest = null, this.unfinalizedNodes = /* @__PURE__ */ new Set(), this.finalizationScheduled = !1, this.size = 0, this.finalize = () => {
      const r = this.unfinalizedNodes.values();
      for (let u = 0; u < lA; u++) {
        const a = r.next().value;
        if (!a)
          break;
        this.unfinalizedNodes.delete(a);
        const i = a.key;
        delete a.key, a.keyRef = new vA(i), this.registry.register(i, a, a);
      }
      this.unfinalizedNodes.size > 0 ? queueMicrotask(this.finalize) : this.finalizationScheduled = !1;
    }, this.registry = new VA(this.deleteNode.bind(this));
  }
  has(e) {
    return this.map.has(e);
  }
  get(e) {
    const t = this.getNode(e);
    return t && t.value;
  }
  getNode(e) {
    const t = this.map.get(e);
    if (t && t !== this.newest) {
      const { older: r, newer: u } = t;
      u && (u.older = r), r && (r.newer = u), t.older = this.newest, t.older.newer = t, t.newer = null, this.newest = t, t === this.oldest && (this.oldest = u);
    }
    return t;
  }
  set(e, t) {
    let r = this.getNode(e);
    return r ? r.value = t : (r = {
      key: e,
      value: t,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = r), this.newest = r, this.oldest = this.oldest || r, this.scheduleFinalization(r), this.map.set(e, r), this.size++, r.value);
  }
  clean() {
    for (; this.oldest && this.size > this.max; )
      this.deleteNode(this.oldest);
  }
  deleteNode(e) {
    e === this.newest && (this.newest = e.older), e === this.oldest && (this.oldest = e.newer), e.newer && (e.newer.older = e.older), e.older && (e.older.newer = e.newer), this.size--;
    const t = e.key || e.keyRef && e.keyRef.deref();
    this.dispose(e.value, t), e.keyRef ? this.registry.unregister(e) : this.unfinalizedNodes.delete(e), t && this.map.delete(t);
  }
  delete(e) {
    const t = this.map.get(e);
    return t ? (this.deleteNode(t), !0) : !1;
  }
  scheduleFinalization(e) {
    this.unfinalizedNodes.add(e), this.finalizationScheduled || (this.finalizationScheduled = !0, queueMicrotask(this.finalize));
  }
}
var ir = /* @__PURE__ */ new WeakSet();
function j_(s) {
  s.size <= (s.max || -1) || ir.has(s) || (ir.add(s), setTimeout(function() {
    s.clean(), ir.delete(s);
  }, 100));
}
var tu = function(s, e) {
  var t = new wt(s, e);
  return t.set = function(r, u) {
    var a = wt.prototype.set.call(this, r, u);
    return j_(this), a;
  }, t;
}, wA = function(s, e) {
  var t = new xr(s, e);
  return t.set = function(r, u) {
    var a = xr.prototype.set.call(this, r, u);
    return j_(this), a;
  }, t;
}, FA = Symbol.for("apollo.cacheSize"), Ns = p({}, mr[FA]), re = {};
function ru(s, e) {
  re[s] = e;
}
var xA = globalThis.__DEV__ !== !1 ? TA : void 0, oA = globalThis.__DEV__ !== !1 ? PA : void 0, MA = globalThis.__DEV__ !== !1 ? U_ : void 0;
function $A() {
  var s = {
    parser: 1e3,
    canonicalStringify: 1e3,
    print: 2e3,
    "documentTransform.cache": 2e3,
    "queryManager.getDocumentInfo": 2e3,
    "PersistedQueryLink.persistedQueryHashes": 2e3,
    "fragmentRegistry.transform": 2e3,
    "fragmentRegistry.lookup": 1e3,
    "fragmentRegistry.findFragmentSpreads": 4e3,
    "cache.fragmentQueryDocuments": 1e3,
    "removeTypenameFromVariables.getVariableDefinitions": 2e3,
    "inMemoryCache.maybeBroadcastWatch": 5e3,
    "inMemoryCache.executeSelectionSet": 5e4,
    "inMemoryCache.executeSubSelectedArray": 1e4
  };
  return Object.fromEntries(Object.entries(s).map(function(e) {
    var t = e[0], r = e[1];
    return [
      t,
      Ns[t] || r
    ];
  }));
}
function TA() {
  var s, e, t, r, u;
  if (globalThis.__DEV__ === !1)
    throw new Error("only supported in development mode");
  return {
    limits: $A(),
    sizes: p({ print: (s = re.print) === null || s === void 0 ? void 0 : s.call(re), parser: (e = re.parser) === null || e === void 0 ? void 0 : e.call(re), canonicalStringify: (t = re.canonicalStringify) === null || t === void 0 ? void 0 : t.call(re), links: $r(this.link), queryManager: {
      getDocumentInfo: this.queryManager.transformCache.size,
      documentTransforms: z_(this.queryManager.documentTransform)
    } }, (u = (r = this.cache).getMemoryInternals) === null || u === void 0 ? void 0 : u.call(r))
  };
}
function U_() {
  return {
    cache: {
      fragmentQueryDocuments: gs(this.getFragmentDoc)
    }
  };
}
function PA() {
  var s = this.config.fragments;
  return p(p({}, U_.apply(this)), { addTypenameDocumentTransform: z_(this.addTypenameTransform), inMemoryCache: {
    executeSelectionSet: gs(this.storeReader.executeSelectionSet),
    executeSubSelectedArray: gs(this.storeReader.executeSubSelectedArray),
    maybeBroadcastWatch: gs(this.maybeBroadcastWatch)
  }, fragmentRegistry: {
    findFragmentSpreads: gs(s == null ? void 0 : s.findFragmentSpreads),
    lookup: gs(s == null ? void 0 : s.lookup),
    transform: gs(s == null ? void 0 : s.transform)
  } });
}
function BA(s) {
  return !!s && "dirtyKey" in s;
}
function gs(s) {
  return BA(s) ? s.size : void 0;
}
function Q_(s) {
  return s != null;
}
function z_(s) {
  return Mr(s).map(function(e) {
    return { cache: e };
  });
}
function Mr(s) {
  return s ? Bs(Bs([
    gs(s == null ? void 0 : s.performWork)
  ], Mr(s == null ? void 0 : s.left), !0), Mr(s == null ? void 0 : s.right), !0).filter(Q_) : [];
}
function $r(s) {
  var e;
  return s ? Bs(Bs([
    (e = s == null ? void 0 : s.getMemoryInternals) === null || e === void 0 ? void 0 : e.call(s)
  ], $r(s == null ? void 0 : s.left), !0), $r(s == null ? void 0 : s.right), !0).filter(Q_) : [];
}
var ks = Object.assign(function(e) {
  return JSON.stringify(e, qA);
}, {
  reset: function() {
    ne = new wA(
      Ns.canonicalStringify || 1e3
      /* defaultCacheSizes.canonicalStringify */
    );
  }
});
globalThis.__DEV__ !== !1 && ru("canonicalStringify", function() {
  return ne.size;
});
var ne;
ks.reset();
function qA(s, e) {
  if (e && typeof e == "object") {
    var t = Object.getPrototypeOf(e);
    if (t === Object.prototype || t === null) {
      var r = Object.keys(e);
      if (r.every(GA))
        return e;
      var u = JSON.stringify(r), a = ne.get(u);
      if (!a) {
        r.sort();
        var i = JSON.stringify(r);
        a = ne.get(i) || r, ne.set(u, a), ne.set(i, a);
      }
      var _ = Object.create(t);
      return a.forEach(function(h) {
        _[h] = e[h];
      }), _;
    }
  }
  return e;
}
function GA(s, e, t) {
  return e === 0 || t[e - 1] <= s;
}
function pe(s) {
  return { __ref: String(s) };
}
function ts(s) {
  return !!(s && typeof s == "object" && typeof s.__ref == "string");
}
function RA(s) {
  return Ds(s) && s.kind === "Document" && Array.isArray(s.definitions);
}
function jA(s) {
  return s.kind === "StringValue";
}
function UA(s) {
  return s.kind === "BooleanValue";
}
function QA(s) {
  return s.kind === "IntValue";
}
function zA(s) {
  return s.kind === "FloatValue";
}
function WA(s) {
  return s.kind === "Variable";
}
function NA(s) {
  return s.kind === "ObjectValue";
}
function IA(s) {
  return s.kind === "ListValue";
}
function JA(s) {
  return s.kind === "EnumValue";
}
function HA(s) {
  return s.kind === "NullValue";
}
function me(s, e, t, r) {
  if (QA(t) || zA(t))
    s[e.value] = Number(t.value);
  else if (UA(t) || jA(t))
    s[e.value] = t.value;
  else if (NA(t)) {
    var u = {};
    t.fields.map(function(i) {
      return me(u, i.name, i.value, r);
    }), s[e.value] = u;
  } else if (WA(t)) {
    var a = (r || {})[t.name.value];
    s[e.value] = a;
  } else if (IA(t))
    s[e.value] = t.values.map(function(i) {
      var _ = {};
      return me(_, e, i, r), _[e.value];
    });
  else if (JA(t))
    s[e.value] = t.value;
  else if (HA(t))
    s[e.value] = null;
  else
    throw Ps(85, e.value, t.kind);
}
function YA(s, e) {
  var t = null;
  s.directives && (t = {}, s.directives.forEach(function(u) {
    t[u.name.value] = {}, u.arguments && u.arguments.forEach(function(a) {
      var i = a.name, _ = a.value;
      return me(t[u.name.value], i, _, e);
    });
  }));
  var r = null;
  return s.arguments && s.arguments.length && (r = {}, s.arguments.forEach(function(u) {
    var a = u.name, i = u.value;
    return me(r, a, i, e);
  })), W_(s.name.value, r, t);
}
var KA = [
  "connection",
  "include",
  "skip",
  "client",
  "rest",
  "export",
  "nonreactive"
], Te = ks, W_ = Object.assign(function(s, e, t) {
  if (e && t && t.connection && t.connection.key)
    if (t.connection.filter && t.connection.filter.length > 0) {
      var r = t.connection.filter ? t.connection.filter : [];
      r.sort();
      var u = {};
      return r.forEach(function(_) {
        u[_] = e[_];
      }), "".concat(t.connection.key, "(").concat(Te(u), ")");
    } else
      return t.connection.key;
  var a = s;
  if (e) {
    var i = Te(e);
    a += "(".concat(i, ")");
  }
  return t && Object.keys(t).forEach(function(_) {
    KA.indexOf(_) === -1 && (t[_] && Object.keys(t[_]).length ? a += "@".concat(_, "(").concat(Te(t[_]), ")") : a += "@".concat(_));
  }), a;
}, {
  setStringify: function(s) {
    var e = Te;
    return Te = s, e;
  }
});
function Rt(s, e) {
  if (s.arguments && s.arguments.length) {
    var t = {};
    return s.arguments.forEach(function(r) {
      var u = r.name, a = r.value;
      return me(t, u, a, e);
    }), t;
  }
  return null;
}
function Os(s) {
  return s.alias ? s.alias.value : s.name.value;
}
function Tr(s, e, t) {
  for (var r, u = 0, a = e.selections; u < a.length; u++) {
    var i = a[u];
    if (Ls(i)) {
      if (i.name.value === "__typename")
        return s[Os(i)];
    } else r ? r.push(i) : r = [i];
  }
  if (typeof s.__typename == "string")
    return s.__typename;
  if (r)
    for (var _ = 0, h = r; _ < h.length; _++) {
      var i = h[_], f = Tr(s, Gt(i, t).selectionSet, t);
      if (typeof f == "string")
        return f;
    }
}
function Ls(s) {
  return s.kind === "Field";
}
function XA(s) {
  return s.kind === "InlineFragment";
}
function Ce(s) {
  Q(s && s.kind === "Document", 77);
  var e = s.definitions.filter(function(t) {
    return t.kind !== "FragmentDefinition";
  }).map(function(t) {
    if (t.kind !== "OperationDefinition")
      throw Ps(78, t.kind);
    return t;
  });
  return Q(e.length <= 1, 79, e.length), s;
}
function ge(s) {
  return Ce(s), s.definitions.filter(function(e) {
    return e.kind === "OperationDefinition";
  })[0];
}
function Pr(s) {
  return s.definitions.filter(function(e) {
    return e.kind === "OperationDefinition" && !!e.name;
  }).map(function(e) {
    return e.name.value;
  })[0] || null;
}
function jt(s) {
  return s.definitions.filter(function(e) {
    return e.kind === "FragmentDefinition";
  });
}
function N_(s) {
  var e = ge(s);
  return Q(e && e.operation === "query", 80), e;
}
function ZA(s) {
  Q(s.kind === "Document", 81), Q(s.definitions.length <= 1, 82);
  var e = s.definitions[0];
  return Q(e.kind === "FragmentDefinition", 83), e;
}
function ke(s) {
  Ce(s);
  for (var e, t = 0, r = s.definitions; t < r.length; t++) {
    var u = r[t];
    if (u.kind === "OperationDefinition") {
      var a = u.operation;
      if (a === "query" || a === "mutation" || a === "subscription")
        return u;
    }
    u.kind === "FragmentDefinition" && !e && (e = u);
  }
  if (e)
    return e;
  throw Ps(84);
}
function uu(s) {
  var e = /* @__PURE__ */ Object.create(null), t = s && s.variableDefinitions;
  return t && t.length && t.forEach(function(r) {
    r.defaultValue && me(e, r.variable.name, r.defaultValue);
  }), e;
}
const CA = () => /* @__PURE__ */ Object.create(null), { forEach: gA, slice: kA } = Array.prototype, { hasOwnProperty: OA } = Object.prototype;
class au {
  constructor(e = !0, t = CA) {
    this.weakness = e, this.makeData = t;
  }
  lookup(...e) {
    return this.lookupArray(e);
  }
  lookupArray(e) {
    let t = this;
    return gA.call(e, (r) => t = t.getChildTrie(r)), OA.call(t, "data") ? t.data : t.data = this.makeData(kA.call(e));
  }
  peek(...e) {
    return this.peekArray(e);
  }
  peekArray(e) {
    let t = this;
    for (let r = 0, u = e.length; t && r < u; ++r) {
      const a = this.weakness && mi(e[r]) ? t.weak : t.strong;
      t = a && a.get(e[r]);
    }
    return t && t.data;
  }
  getChildTrie(e) {
    const t = this.weakness && mi(e) ? this.weak || (this.weak = /* @__PURE__ */ new WeakMap()) : this.strong || (this.strong = /* @__PURE__ */ new Map());
    let r = t.get(e);
    return r || t.set(e, r = new au(this.weakness, this.makeData)), r;
  }
}
function mi(s) {
  switch (typeof s) {
    case "object":
      if (s === null)
        break;
    case "function":
      return !0;
  }
  return !1;
}
let xs = null;
const Vi = {};
let LA = 1;
const sy = () => class {
  constructor() {
    this.id = [
      "slot",
      LA++,
      Date.now(),
      Math.random().toString(36).slice(2)
    ].join(":");
  }
  hasValue() {
    for (let e = xs; e; e = e.parent)
      if (this.id in e.slots) {
        const t = e.slots[this.id];
        if (t === Vi)
          break;
        return e !== xs && (xs.slots[this.id] = t), !0;
      }
    return xs && (xs.slots[this.id] = Vi), !1;
  }
  getValue() {
    if (this.hasValue())
      return xs.slots[this.id];
  }
  withValue(e, t, r, u) {
    const a = {
      __proto__: null,
      [this.id]: e
    }, i = xs;
    xs = { parent: i, slots: a };
    try {
      return t.apply(u, r);
    } finally {
      xs = i;
    }
  }
  // Capture the current context and wrap a callback function so that it
  // reestablishes the captured context when called.
  static bind(e) {
    const t = xs;
    return function() {
      const r = xs;
      try {
        return xs = t, e.apply(this, arguments);
      } finally {
        xs = r;
      }
    };
  }
  // Immediately run a callback function without any captured context.
  static noContext(e, t, r) {
    if (xs) {
      const u = xs;
      try {
        return xs = null, e.apply(r, t);
      } finally {
        xs = u;
      }
    } else
      return e.apply(r, t);
  }
};
function li(s) {
  try {
    return s();
  } catch {
  }
}
const _r = "@wry/context:Slot", ey = (
  // Prefer globalThis when available.
  // https://github.com/benjamn/wryware/issues/347
  li(() => globalThis) || // Fall back to global, which works in Node.js and may be converted by some
  // bundlers to the appropriate identifier (window, self, ...) depending on the
  // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
  li(() => global) || // Otherwise, use a dummy host that's local to this module. We used to fall
  // back to using the Array constructor as a namespace, but that was flagged in
  // https://github.com/benjamn/wryware/issues/347, and can be avoided.
  /* @__PURE__ */ Object.create(null)
), wi = ey, I_ = wi[_r] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[_r] || function(s) {
  try {
    Object.defineProperty(wi, _r, {
      value: s,
      enumerable: !1,
      writable: !1,
      // When it was possible for globalHost to be the Array constructor (a
      // legacy Slot dedup strategy), it was important for the property to be
      // configurable:true so it could be deleted. That does not seem to be as
      // important when globalHost is the global object, but I don't want to
      // cause similar problems again, and configurable:true seems safest.
      // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
      configurable: !0
    });
  } finally {
    return s;
  }
}(sy()), Ut = new I_(), { hasOwnProperty: ty } = Object.prototype, iu = Array.from || function(s) {
  const e = [];
  return s.forEach((t) => e.push(t)), e;
};
function _u(s) {
  const { unsubscribe: e } = s;
  typeof e == "function" && (s.unsubscribe = void 0, e());
}
const Je = [], ry = 100;
function Ve(s, e) {
  if (!s)
    throw new Error(e || "assertion failure");
}
function J_(s, e) {
  const t = s.length;
  return (
    // Unknown values are not equal to each other.
    t > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    t === e.length && // The underlying value or exception must be the same.
    s[t - 1] === e[t - 1]
  );
}
function H_(s) {
  switch (s.length) {
    case 0:
      throw new Error("unknown value");
    case 1:
      return s[0];
    case 2:
      throw s[1];
  }
}
function Y_(s) {
  return s.slice(0);
}
class Qt {
  constructor(e) {
    this.fn = e, this.parents = /* @__PURE__ */ new Set(), this.childValues = /* @__PURE__ */ new Map(), this.dirtyChildren = null, this.dirty = !0, this.recomputing = !1, this.value = [], this.deps = null, ++Qt.count;
  }
  peek() {
    if (this.value.length === 1 && !se(this))
      return Fi(this), this.value[0];
  }
  // This is the most important method of the Entry API, because it
  // determines whether the cached this.value can be returned immediately,
  // or must be recomputed. The overall performance of the caching system
  // depends on the truth of the following observations: (1) this.dirty is
  // usually false, (2) this.dirtyChildren is usually null/empty, and thus
  // (3) valueGet(this.value) is usually returned without recomputation.
  recompute(e) {
    return Ve(!this.recomputing, "already recomputing"), Fi(this), se(this) ? uy(this, e) : H_(this.value);
  }
  setDirty() {
    this.dirty || (this.dirty = !0, K_(this), _u(this));
  }
  dispose() {
    this.setDirty(), k_(this), fu(this, (e, t) => {
      e.setDirty(), O_(e, this);
    });
  }
  forget() {
    this.dispose();
  }
  dependOn(e) {
    e.add(this), this.deps || (this.deps = Je.pop() || /* @__PURE__ */ new Set()), this.deps.add(e);
  }
  forgetDeps() {
    this.deps && (iu(this.deps).forEach((e) => e.delete(this)), this.deps.clear(), Je.push(this.deps), this.deps = null);
  }
}
Qt.count = 0;
function Fi(s) {
  const e = Ut.getValue();
  if (e)
    return s.parents.add(e), e.childValues.has(s) || e.childValues.set(s, []), se(s) ? Z_(e, s) : C_(e, s), e;
}
function uy(s, e) {
  return k_(s), Ut.withValue(s, ay, [s, e]), _y(s, e) && iy(s), H_(s.value);
}
function ay(s, e) {
  s.recomputing = !0;
  const { normalizeResult: t } = s;
  let r;
  t && s.value.length === 1 && (r = Y_(s.value)), s.value.length = 0;
  try {
    if (s.value[0] = s.fn.apply(null, e), t && r && !J_(r, s.value))
      try {
        s.value[0] = t(s.value[0], r[0]);
      } catch {
      }
  } catch (u) {
    s.value[1] = u;
  }
  s.recomputing = !1;
}
function se(s) {
  return s.dirty || !!(s.dirtyChildren && s.dirtyChildren.size);
}
function iy(s) {
  s.dirty = !1, !se(s) && X_(s);
}
function K_(s) {
  fu(s, Z_);
}
function X_(s) {
  fu(s, C_);
}
function fu(s, e) {
  const t = s.parents.size;
  if (t) {
    const r = iu(s.parents);
    for (let u = 0; u < t; ++u)
      e(r[u], s);
  }
}
function Z_(s, e) {
  Ve(s.childValues.has(e)), Ve(se(e));
  const t = !se(s);
  if (!s.dirtyChildren)
    s.dirtyChildren = Je.pop() || /* @__PURE__ */ new Set();
  else if (s.dirtyChildren.has(e))
    return;
  s.dirtyChildren.add(e), t && K_(s);
}
function C_(s, e) {
  Ve(s.childValues.has(e)), Ve(!se(e));
  const t = s.childValues.get(e);
  t.length === 0 ? s.childValues.set(e, Y_(e.value)) : J_(t, e.value) || s.setDirty(), g_(s, e), !se(s) && X_(s);
}
function g_(s, e) {
  const t = s.dirtyChildren;
  t && (t.delete(e), t.size === 0 && (Je.length < ry && Je.push(t), s.dirtyChildren = null));
}
function k_(s) {
  s.childValues.size > 0 && s.childValues.forEach((e, t) => {
    O_(s, t);
  }), s.forgetDeps(), Ve(s.dirtyChildren === null);
}
function O_(s, e) {
  e.parents.delete(s), s.childValues.delete(e), g_(s, e);
}
function _y(s, e) {
  if (typeof s.subscribe == "function")
    try {
      _u(s), s.unsubscribe = s.subscribe.apply(null, e);
    } catch {
      return s.setDirty(), !1;
    }
  return !0;
}
const fy = {
  setDirty: !0,
  dispose: !0,
  forget: !0
  // Fully remove parent Entry from LRU cache and computation graph
};
function L_(s) {
  const e = /* @__PURE__ */ new Map();
  function t(r) {
    const u = Ut.getValue();
    if (u) {
      let a = e.get(r);
      a || e.set(r, a = /* @__PURE__ */ new Set()), u.dependOn(a);
    }
  }
  return t.dirty = function(u, a) {
    const i = e.get(u);
    if (i) {
      const _ = a && ty.call(fy, a) ? a : "setDirty";
      iu(i).forEach((h) => h[_]()), e.delete(u), _u(i);
    }
  }, t;
}
let xi;
function hy(...s) {
  return (xi || (xi = new au(typeof WeakMap == "function"))).lookupArray(s);
}
const fr = /* @__PURE__ */ new Set();
function He(s, { max: e = Math.pow(2, 16), keyArgs: t, makeCacheKey: r = hy, normalizeResult: u, subscribe: a, cache: i = xr } = /* @__PURE__ */ Object.create(null)) {
  const _ = typeof i == "function" ? new i(e, (c) => c.dispose()) : i, h = function() {
    const c = r.apply(null, t ? t.apply(null, arguments) : arguments);
    if (c === void 0)
      return s.apply(null, arguments);
    let n = _.get(c);
    n || (_.set(c, n = new Qt(s)), n.normalizeResult = u, n.subscribe = a, n.forget = () => _.delete(c));
    const d = n.recompute(Array.prototype.slice.call(arguments));
    return _.set(c, n), fr.add(_), Ut.hasValue() || (fr.forEach((E) => E.clean()), fr.clear()), d;
  };
  Object.defineProperty(h, "size", {
    get: () => _.size,
    configurable: !1,
    enumerable: !1
  }), Object.freeze(h.options = {
    max: e,
    keyArgs: t,
    makeCacheKey: r,
    normalizeResult: u,
    subscribe: a,
    cache: _
  });
  function f(c) {
    const n = c && _.get(c);
    n && n.setDirty();
  }
  h.dirtyKey = f, h.dirty = function() {
    f(r.apply(null, arguments));
  };
  function A(c) {
    const n = c && _.get(c);
    if (n)
      return n.peek();
  }
  h.peekKey = A, h.peek = function() {
    return A(r.apply(null, arguments));
  };
  function y(c) {
    return c ? _.delete(c) : !1;
  }
  return h.forgetKey = y, h.forget = function() {
    return y(r.apply(null, arguments));
  }, h.makeCacheKey = r, h.getKey = t ? function() {
    return r.apply(null, t.apply(null, arguments));
  } : r, Object.freeze(h);
}
function Sy(s) {
  return s;
}
var sf = (
  /** @class */
  function() {
    function s(e, t) {
      t === void 0 && (t = /* @__PURE__ */ Object.create(null)), this.resultCache = G_ ? /* @__PURE__ */ new WeakSet() : /* @__PURE__ */ new Set(), this.transform = e, t.getCacheKey && (this.getCacheKey = t.getCacheKey), this.cached = t.cache !== !1, this.resetCache();
    }
    return s.prototype.getCacheKey = function(e) {
      return [e];
    }, s.identity = function() {
      return new s(Sy, { cache: !1 });
    }, s.split = function(e, t, r) {
      return r === void 0 && (r = s.identity()), Object.assign(new s(
        function(u) {
          var a = e(u) ? t : r;
          return a.transformDocument(u);
        },
        // Reasonably assume both `left` and `right` transforms handle their own caching
        { cache: !1 }
      ), { left: t, right: r });
    }, s.prototype.resetCache = function() {
      var e = this;
      if (this.cached) {
        var t = new Fe(xe);
        this.performWork = He(s.prototype.performWork.bind(this), {
          makeCacheKey: function(r) {
            var u = e.getCacheKey(r);
            if (u)
              return Q(Array.isArray(u), 69), t.lookupArray(u);
          },
          max: Ns["documentTransform.cache"],
          cache: wt
        });
      }
    }, s.prototype.performWork = function(e) {
      return Ce(e), this.transform(e);
    }, s.prototype.transformDocument = function(e) {
      if (this.resultCache.has(e))
        return e;
      var t = this.performWork(e);
      return this.resultCache.add(t), t;
    }, s.prototype.concat = function(e) {
      var t = this;
      return Object.assign(new s(
        function(r) {
          return e.transformDocument(t.transformDocument(r));
        },
        // Reasonably assume both transforms handle their own caching
        { cache: !1 }
      ), {
        left: this,
        right: e
      });
    }, s;
  }()
), Ue, zt = Object.assign(function(s) {
  var e = Ue.get(s);
  return e || (e = aA(s), Ue.set(s, e)), e;
}, {
  reset: function() {
    Ue = new tu(
      Ns.print || 2e3
      /* defaultCacheSizes.print */
    );
  }
});
zt.reset();
globalThis.__DEV__ !== !1 && ru("print", function() {
  return Ue ? Ue.size : 0;
});
var ds = Array.isArray;
function Rs(s) {
  return Array.isArray(s) && s.length > 0;
}
var oi = {
  kind: G.FIELD,
  name: {
    kind: G.NAME,
    value: "__typename"
  }
};
function ef(s, e) {
  return !s || s.selectionSet.selections.every(function(t) {
    return t.kind === G.FRAGMENT_SPREAD && ef(e[t.name.value], e);
  });
}
function Ay(s) {
  return ef(ge(s) || ZA(s), qt(jt(s))) ? null : s;
}
function yy(s) {
  var e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
  return s.forEach(function(r) {
    r && (r.name ? e.set(r.name, r) : r.test && t.set(r.test, r));
  }), function(r) {
    var u = e.get(r.name.value);
    return !u && t.size && t.forEach(function(a, i) {
      i(r) && (u = a);
    }), u;
  };
}
function Mi(s) {
  var e = /* @__PURE__ */ new Map();
  return function(r) {
    r === void 0 && (r = s);
    var u = e.get(r);
    return u || e.set(r, u = {
      // Variable and fragment spread names used directly within this
      // operation or fragment definition, as identified by key. These sets
      // will be populated during the first traversal of the document in
      // removeDirectivesFromDocument below.
      variables: /* @__PURE__ */ new Set(),
      fragmentSpreads: /* @__PURE__ */ new Set()
    }), u;
  };
}
function tf(s, e) {
  Ce(e);
  for (var t = Mi(""), r = Mi(""), u = function(b) {
    for (var F = 0, l = void 0; F < b.length && (l = b[F]); ++F)
      if (!ds(l)) {
        if (l.kind === G.OPERATION_DEFINITION)
          return t(l.name && l.name.value);
        if (l.kind === G.FRAGMENT_DEFINITION)
          return r(l.name.value);
      }
    return globalThis.__DEV__ !== !1 && Q.error(86), null;
  }, a = 0, i = e.definitions.length - 1; i >= 0; --i)
    e.definitions[i].kind === G.OPERATION_DEFINITION && ++a;
  var _ = yy(s), h = function(b) {
    return Rs(b) && b.map(_).some(function(F) {
      return F && F.remove;
    });
  }, f = /* @__PURE__ */ new Map(), A = !1, y = {
    enter: function(b) {
      if (h(b.directives))
        return A = !0, null;
    }
  }, c = Xs(e, {
    // These two AST node types share the same implementation, defined above.
    Field: y,
    InlineFragment: y,
    VariableDefinition: {
      enter: function() {
        return !1;
      }
    },
    Variable: {
      enter: function(b, F, l, T, $) {
        var q = u($);
        q && q.variables.add(b.name.value);
      }
    },
    FragmentSpread: {
      enter: function(b, F, l, T, $) {
        if (h(b.directives))
          return A = !0, null;
        var q = u($);
        q && q.fragmentSpreads.add(b.name.value);
      }
    },
    FragmentDefinition: {
      enter: function(b, F, l, T) {
        f.set(JSON.stringify(T), b);
      },
      leave: function(b, F, l, T) {
        var $ = f.get(JSON.stringify(T));
        if (b === $)
          return b;
        if (
          // This logic applies only if the document contains one or more
          // operations, since removing all fragments from a document containing
          // only fragments makes the document useless.
          a > 0 && b.selectionSet.selections.every(function(q) {
            return q.kind === G.FIELD && q.name.value === "__typename";
          })
        )
          return r(b.name.value).removed = !0, A = !0, null;
      }
    },
    Directive: {
      leave: function(b) {
        if (_(b))
          return A = !0, null;
      }
    }
  });
  if (!A)
    return e;
  var n = function(b) {
    return b.transitiveVars || (b.transitiveVars = new Set(b.variables), b.removed || b.fragmentSpreads.forEach(function(F) {
      n(r(F)).transitiveVars.forEach(function(l) {
        b.transitiveVars.add(l);
      });
    })), b;
  }, d = /* @__PURE__ */ new Set();
  c.definitions.forEach(function(b) {
    b.kind === G.OPERATION_DEFINITION ? n(t(b.name && b.name.value)).fragmentSpreads.forEach(function(F) {
      d.add(F);
    }) : b.kind === G.FRAGMENT_DEFINITION && // If there are no operations in the document, then all fragment
    // definitions count as usages of their own fragment names. This heuristic
    // prevents accidentally removing all fragment definitions from the
    // document just because it contains no operations that use the fragments.
    a === 0 && !r(b.name.value).removed && d.add(b.name.value);
  }), d.forEach(function(b) {
    n(r(b)).fragmentSpreads.forEach(function(F) {
      d.add(F);
    });
  });
  var E = function(b) {
    return !!// A fragment definition will be removed if there are no spreads that refer
    // to it, or the fragment was explicitly removed because it had no fields
    // other than __typename.
    (!d.has(b) || r(b).removed);
  }, V = {
    enter: function(b) {
      if (E(b.name.value))
        return null;
    }
  };
  return Ay(Xs(c, {
    // If the fragment is going to be removed, then leaving any dangling
    // FragmentSpread nodes with the same name would be a mistake.
    FragmentSpread: V,
    // This is where the fragment definition is actually removed.
    FragmentDefinition: V,
    OperationDefinition: {
      leave: function(b) {
        if (b.variableDefinitions) {
          var F = n(
            // If an operation is anonymous, we use the empty string as its key.
            t(b.name && b.name.value)
          ).transitiveVars;
          if (F.size < b.variableDefinitions.length)
            return p(p({}, b), { variableDefinitions: b.variableDefinitions.filter(function(l) {
              return F.has(l.variable.name.value);
            }) });
        }
      }
    }
  }));
}
var hu = Object.assign(function(s) {
  return Xs(s, {
    SelectionSet: {
      enter: function(e, t, r) {
        if (!(r && r.kind === G.OPERATION_DEFINITION)) {
          var u = e.selections;
          if (u) {
            var a = u.some(function(_) {
              return Ls(_) && (_.name.value === "__typename" || _.name.value.lastIndexOf("__", 0) === 0);
            });
            if (!a) {
              var i = r;
              if (!(Ls(i) && i.directives && i.directives.some(function(_) {
                return _.name.value === "export";
              })))
                return p(p({}, e), { selections: Bs(Bs([], u, !0), [oi], !1) });
            }
          }
        }
      }
    }
  });
}, {
  added: function(s) {
    return s === oi;
  }
});
function cy(s) {
  var e = ke(s), t = e.operation;
  if (t === "query")
    return s;
  var r = Xs(s, {
    OperationDefinition: {
      enter: function(u) {
        return p(p({}, u), { operation: "query" });
      }
    }
  });
  return r;
}
function rf(s) {
  Ce(s);
  var e = tf([
    {
      test: function(t) {
        return t.name.value === "client";
      },
      remove: !0
    }
  ], s);
  return e;
}
var ny = Object.prototype.hasOwnProperty;
function $i() {
  for (var s = [], e = 0; e < arguments.length; e++)
    s[e] = arguments[e];
  return Wt(s);
}
function Wt(s) {
  var e = s[0] || {}, t = s.length;
  if (t > 1)
    for (var r = new ee(), u = 1; u < t; ++u)
      e = r.merge(e, s[u]);
  return e;
}
var Dy = function(s, e, t) {
  return this.merge(s[t], e[t]);
}, ee = (
  /** @class */
  function() {
    function s(e) {
      e === void 0 && (e = Dy), this.reconciler = e, this.isObject = Ds, this.pastCopies = /* @__PURE__ */ new Set();
    }
    return s.prototype.merge = function(e, t) {
      for (var r = this, u = [], a = 2; a < arguments.length; a++)
        u[a - 2] = arguments[a];
      return Ds(t) && Ds(e) ? (Object.keys(t).forEach(function(i) {
        if (ny.call(e, i)) {
          var _ = e[i];
          if (t[i] !== _) {
            var h = r.reconciler.apply(r, Bs([
              e,
              t,
              i
            ], u, !1));
            h !== _ && (e = r.shallowCopyForMerge(e), e[i] = h);
          }
        } else
          e = r.shallowCopyForMerge(e), e[i] = t[i];
      }), e) : t;
    }, s.prototype.shallowCopyForMerge = function(e) {
      return Ds(e) && (this.pastCopies.has(e) || (Array.isArray(e) ? e = e.slice(0) : e = p({ __proto__: Object.getPrototypeOf(e) }, e), this.pastCopies.add(e))), e;
    }, s;
  }()
);
function dy(s, e) {
  var t = typeof Symbol < "u" && s[Symbol.iterator] || s["@@iterator"];
  if (t) return (t = t.call(s)).next.bind(t);
  if (Array.isArray(s) || (t = py(s)) || e) {
    t && (s = t);
    var r = 0;
    return function() {
      return r >= s.length ? { done: !0 } : { done: !1, value: s[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function py(s, e) {
  if (s) {
    if (typeof s == "string") return Ti(s, e);
    var t = Object.prototype.toString.call(s).slice(8, -1);
    if (t === "Object" && s.constructor && (t = s.constructor.name), t === "Map" || t === "Set") return Array.from(s);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Ti(s, e);
  }
}
function Ti(s, e) {
  (e == null || e > s.length) && (e = s.length);
  for (var t = 0, r = new Array(e); t < e; t++)
    r[t] = s[t];
  return r;
}
function Pi(s, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(s, r.key, r);
  }
}
function Su(s, e, t) {
  return e && Pi(s.prototype, e), t && Pi(s, t), Object.defineProperty(s, "prototype", { writable: !1 }), s;
}
var Au = function() {
  return typeof Symbol == "function";
}, yu = function(s) {
  return Au() && !!Symbol[s];
}, cu = function(s) {
  return yu(s) ? Symbol[s] : "@@" + s;
};
Au() && !yu("observable") && (Symbol.observable = Symbol("observable"));
var by = cu("iterator"), Br = cu("observable"), uf = cu("species");
function Ft(s, e) {
  var t = s[e];
  if (t != null) {
    if (typeof t != "function") throw new TypeError(t + " is not a function");
    return t;
  }
}
function Pe(s) {
  var e = s.constructor;
  return e !== void 0 && (e = e[uf], e === null && (e = void 0)), e !== void 0 ? e : rs;
}
function Ey(s) {
  return s instanceof rs;
}
function le(s) {
  le.log ? le.log(s) : setTimeout(function() {
    throw s;
  });
}
function pt(s) {
  Promise.resolve().then(function() {
    try {
      s();
    } catch (e) {
      le(e);
    }
  });
}
function af(s) {
  var e = s._cleanup;
  if (e !== void 0 && (s._cleanup = void 0, !!e))
    try {
      if (typeof e == "function")
        e();
      else {
        var t = Ft(e, "unsubscribe");
        t && t.call(e);
      }
    } catch (r) {
      le(r);
    }
}
function qr(s) {
  s._observer = void 0, s._queue = void 0, s._state = "closed";
}
function vy(s) {
  var e = s._queue;
  if (e) {
    s._queue = void 0, s._state = "ready";
    for (var t = 0; t < e.length && (_f(s, e[t].type, e[t].value), s._state !== "closed"); ++t)
      ;
  }
}
function _f(s, e, t) {
  s._state = "running";
  var r = s._observer;
  try {
    var u = Ft(r, e);
    switch (e) {
      case "next":
        u && u.call(r, t);
        break;
      case "error":
        if (qr(s), u) u.call(r, t);
        else throw t;
        break;
      case "complete":
        qr(s), u && u.call(r);
        break;
    }
  } catch (a) {
    le(a);
  }
  s._state === "closed" ? af(s) : s._state === "running" && (s._state = "ready");
}
function hr(s, e, t) {
  if (s._state !== "closed") {
    if (s._state === "buffering") {
      s._queue.push({
        type: e,
        value: t
      });
      return;
    }
    if (s._state !== "ready") {
      s._state = "buffering", s._queue = [{
        type: e,
        value: t
      }], pt(function() {
        return vy(s);
      });
      return;
    }
    _f(s, e, t);
  }
}
var my = /* @__PURE__ */ function() {
  function s(t, r) {
    this._cleanup = void 0, this._observer = t, this._queue = void 0, this._state = "initializing";
    var u = new Vy(this);
    try {
      this._cleanup = r.call(void 0, u);
    } catch (a) {
      u.error(a);
    }
    this._state === "initializing" && (this._state = "ready");
  }
  var e = s.prototype;
  return e.unsubscribe = function() {
    this._state !== "closed" && (qr(this), af(this));
  }, Su(s, [{
    key: "closed",
    get: function() {
      return this._state === "closed";
    }
  }]), s;
}(), Vy = /* @__PURE__ */ function() {
  function s(t) {
    this._subscription = t;
  }
  var e = s.prototype;
  return e.next = function(r) {
    hr(this._subscription, "next", r);
  }, e.error = function(r) {
    hr(this._subscription, "error", r);
  }, e.complete = function() {
    hr(this._subscription, "complete");
  }, Su(s, [{
    key: "closed",
    get: function() {
      return this._subscription._state === "closed";
    }
  }]), s;
}(), rs = /* @__PURE__ */ function() {
  function s(t) {
    if (!(this instanceof s)) throw new TypeError("Observable cannot be called as a function");
    if (typeof t != "function") throw new TypeError("Observable initializer must be a function");
    this._subscriber = t;
  }
  var e = s.prototype;
  return e.subscribe = function(r) {
    return (typeof r != "object" || r === null) && (r = {
      next: r,
      error: arguments[1],
      complete: arguments[2]
    }), new my(r, this._subscriber);
  }, e.forEach = function(r) {
    var u = this;
    return new Promise(function(a, i) {
      if (typeof r != "function") {
        i(new TypeError(r + " is not a function"));
        return;
      }
      function _() {
        h.unsubscribe(), a();
      }
      var h = u.subscribe({
        next: function(f) {
          try {
            r(f, _);
          } catch (A) {
            i(A), h.unsubscribe();
          }
        },
        error: i,
        complete: a
      });
    });
  }, e.map = function(r) {
    var u = this;
    if (typeof r != "function") throw new TypeError(r + " is not a function");
    var a = Pe(this);
    return new a(function(i) {
      return u.subscribe({
        next: function(_) {
          try {
            _ = r(_);
          } catch (h) {
            return i.error(h);
          }
          i.next(_);
        },
        error: function(_) {
          i.error(_);
        },
        complete: function() {
          i.complete();
        }
      });
    });
  }, e.filter = function(r) {
    var u = this;
    if (typeof r != "function") throw new TypeError(r + " is not a function");
    var a = Pe(this);
    return new a(function(i) {
      return u.subscribe({
        next: function(_) {
          try {
            if (!r(_)) return;
          } catch (h) {
            return i.error(h);
          }
          i.next(_);
        },
        error: function(_) {
          i.error(_);
        },
        complete: function() {
          i.complete();
        }
      });
    });
  }, e.reduce = function(r) {
    var u = this;
    if (typeof r != "function") throw new TypeError(r + " is not a function");
    var a = Pe(this), i = arguments.length > 1, _ = !1, h = arguments[1], f = h;
    return new a(function(A) {
      return u.subscribe({
        next: function(y) {
          var c = !_;
          if (_ = !0, !c || i)
            try {
              f = r(f, y);
            } catch (n) {
              return A.error(n);
            }
          else
            f = y;
        },
        error: function(y) {
          A.error(y);
        },
        complete: function() {
          if (!_ && !i) return A.error(new TypeError("Cannot reduce an empty sequence"));
          A.next(f), A.complete();
        }
      });
    });
  }, e.concat = function() {
    for (var r = this, u = arguments.length, a = new Array(u), i = 0; i < u; i++)
      a[i] = arguments[i];
    var _ = Pe(this);
    return new _(function(h) {
      var f, A = 0;
      function y(c) {
        f = c.subscribe({
          next: function(n) {
            h.next(n);
          },
          error: function(n) {
            h.error(n);
          },
          complete: function() {
            A === a.length ? (f = void 0, h.complete()) : y(_.from(a[A++]));
          }
        });
      }
      return y(r), function() {
        f && (f.unsubscribe(), f = void 0);
      };
    });
  }, e.flatMap = function(r) {
    var u = this;
    if (typeof r != "function") throw new TypeError(r + " is not a function");
    var a = Pe(this);
    return new a(function(i) {
      var _ = [], h = u.subscribe({
        next: function(A) {
          if (r)
            try {
              A = r(A);
            } catch (c) {
              return i.error(c);
            }
          var y = a.from(A).subscribe({
            next: function(c) {
              i.next(c);
            },
            error: function(c) {
              i.error(c);
            },
            complete: function() {
              var c = _.indexOf(y);
              c >= 0 && _.splice(c, 1), f();
            }
          });
          _.push(y);
        },
        error: function(A) {
          i.error(A);
        },
        complete: function() {
          f();
        }
      });
      function f() {
        h.closed && _.length === 0 && i.complete();
      }
      return function() {
        _.forEach(function(A) {
          return A.unsubscribe();
        }), h.unsubscribe();
      };
    });
  }, e[Br] = function() {
    return this;
  }, s.from = function(r) {
    var u = typeof this == "function" ? this : s;
    if (r == null) throw new TypeError(r + " is not an object");
    var a = Ft(r, Br);
    if (a) {
      var i = a.call(r);
      if (Object(i) !== i) throw new TypeError(i + " is not an object");
      return Ey(i) && i.constructor === u ? i : new u(function(_) {
        return i.subscribe(_);
      });
    }
    if (yu("iterator") && (a = Ft(r, by), a))
      return new u(function(_) {
        pt(function() {
          if (!_.closed) {
            for (var h = dy(a.call(r)), f; !(f = h()).done; ) {
              var A = f.value;
              if (_.next(A), _.closed) return;
            }
            _.complete();
          }
        });
      });
    if (Array.isArray(r))
      return new u(function(_) {
        pt(function() {
          if (!_.closed) {
            for (var h = 0; h < r.length; ++h)
              if (_.next(r[h]), _.closed) return;
            _.complete();
          }
        });
      });
    throw new TypeError(r + " is not observable");
  }, s.of = function() {
    for (var r = arguments.length, u = new Array(r), a = 0; a < r; a++)
      u[a] = arguments[a];
    var i = typeof this == "function" ? this : s;
    return new i(function(_) {
      pt(function() {
        if (!_.closed) {
          for (var h = 0; h < u.length; ++h)
            if (_.next(u[h]), _.closed) return;
          _.complete();
        }
      });
    });
  }, Su(s, null, [{
    key: uf,
    get: function() {
      return this;
    }
  }]), s;
}();
Au() && Object.defineProperty(rs, Symbol("extensions"), {
  value: {
    symbol: Br,
    hostReportError: le
  },
  configurable: !0
});
function ly(s) {
  var e, t = s.Symbol;
  if (typeof t == "function")
    if (t.observable)
      e = t.observable;
    else {
      typeof t.for == "function" ? e = t.for("https://github.com/benlesh/symbol-observable") : e = t("https://github.com/benlesh/symbol-observable");
      try {
        t.observable = e;
      } catch {
      }
    }
  else
    e = "@@observable";
  return e;
}
var Ae;
typeof self < "u" ? Ae = self : typeof window < "u" ? Ae = window : typeof global < "u" ? Ae = global : typeof module < "u" ? Ae = module : Ae = Function("return this")();
ly(Ae);
var Bi = rs.prototype, qi = "@@observable";
Bi[qi] || (Bi[qi] = function() {
  return this;
});
var wy = Object.prototype.toString;
function ff(s) {
  return Gr(s);
}
function Gr(s, e) {
  switch (wy.call(s)) {
    case "[object Array]": {
      if (e = e || /* @__PURE__ */ new Map(), e.has(s))
        return e.get(s);
      var t = s.slice(0);
      return e.set(s, t), t.forEach(function(u, a) {
        t[a] = Gr(u, e);
      }), t;
    }
    case "[object Object]": {
      if (e = e || /* @__PURE__ */ new Map(), e.has(s))
        return e.get(s);
      var r = Object.create(Object.getPrototypeOf(s));
      return e.set(s, r), Object.keys(s).forEach(function(u) {
        r[u] = Gr(s[u], e);
      }), r;
    }
    default:
      return s;
  }
}
function Fy(s) {
  var e = /* @__PURE__ */ new Set([s]);
  return e.forEach(function(t) {
    Ds(t) && xy(t) === t && Object.getOwnPropertyNames(t).forEach(function(r) {
      Ds(t[r]) && e.add(t[r]);
    });
  }), s;
}
function xy(s) {
  if (globalThis.__DEV__ !== !1 && !Object.isFrozen(s))
    try {
      Object.freeze(s);
    } catch (e) {
      if (e instanceof TypeError)
        return null;
      throw e;
    }
  return s;
}
function Ye(s) {
  return globalThis.__DEV__ !== !1 && Fy(s), s;
}
function Qe(s, e, t) {
  var r = [];
  s.forEach(function(u) {
    return u[e] && r.push(u);
  }), r.forEach(function(u) {
    return u[e](t);
  });
}
function Sr(s, e, t) {
  return new rs(function(r) {
    var u = {
      // Normally we would initialize promiseQueue to Promise.resolve(), but
      // in this case, for backwards compatibility, we need to be careful to
      // invoke the first callback synchronously.
      then: function(h) {
        return new Promise(function(f) {
          return f(h());
        });
      }
    };
    function a(h, f) {
      return function(A) {
        if (h) {
          var y = function() {
            return r.closed ? (
              /* will be swallowed */
              0
            ) : h(A);
          };
          u = u.then(y, y).then(function(c) {
            return r.next(c);
          }, function(c) {
            return r.error(c);
          });
        } else
          r[f](A);
      };
    }
    var i = {
      next: a(e, "next"),
      error: a(t, "error"),
      complete: function() {
        u.then(function() {
          return r.complete();
        });
      }
    }, _ = s.subscribe(i);
    return function() {
      return _.unsubscribe();
    };
  });
}
function hf(s) {
  function e(t) {
    Object.defineProperty(s, t, { value: rs });
  }
  return eu && Symbol.species && e(Symbol.species), e("@@species"), s;
}
function Gi(s) {
  return s && typeof s.then == "function";
}
var ye = (
  /** @class */
  function(s) {
    zs(e, s);
    function e(t) {
      var r = s.call(this, function(u) {
        return r.addObserver(u), function() {
          return r.removeObserver(u);
        };
      }) || this;
      return r.observers = /* @__PURE__ */ new Set(), r.promise = new Promise(function(u, a) {
        r.resolve = u, r.reject = a;
      }), r.handlers = {
        next: function(u) {
          r.sub !== null && (r.latest = ["next", u], r.notify("next", u), Qe(r.observers, "next", u));
        },
        error: function(u) {
          var a = r.sub;
          a !== null && (a && setTimeout(function() {
            return a.unsubscribe();
          }), r.sub = null, r.latest = ["error", u], r.reject(u), r.notify("error", u), Qe(r.observers, "error", u));
        },
        complete: function() {
          var u = r, a = u.sub, i = u.sources, _ = i === void 0 ? [] : i;
          if (a !== null) {
            var h = _.shift();
            h ? Gi(h) ? h.then(function(f) {
              return r.sub = f.subscribe(r.handlers);
            }, r.handlers.error) : r.sub = h.subscribe(r.handlers) : (a && setTimeout(function() {
              return a.unsubscribe();
            }), r.sub = null, r.latest && r.latest[0] === "next" ? r.resolve(r.latest[1]) : r.resolve(), r.notify("complete"), Qe(r.observers, "complete"));
          }
        }
      }, r.nextResultListeners = /* @__PURE__ */ new Set(), r.cancel = function(u) {
        r.reject(u), r.sources = [], r.handlers.error(u);
      }, r.promise.catch(function(u) {
      }), typeof t == "function" && (t = [new rs(t)]), Gi(t) ? t.then(function(u) {
        return r.start(u);
      }, r.handlers.error) : r.start(t), r;
    }
    return e.prototype.start = function(t) {
      this.sub === void 0 && (this.sources = Array.from(t), this.handlers.complete());
    }, e.prototype.deliverLastMessage = function(t) {
      if (this.latest) {
        var r = this.latest[0], u = t[r];
        u && u.call(t, this.latest[1]), this.sub === null && r === "next" && t.complete && t.complete();
      }
    }, e.prototype.addObserver = function(t) {
      this.observers.has(t) || (this.deliverLastMessage(t), this.observers.add(t));
    }, e.prototype.removeObserver = function(t) {
      this.observers.delete(t) && this.observers.size < 1 && this.handlers.complete();
    }, e.prototype.notify = function(t, r) {
      var u = this.nextResultListeners;
      u.size && (this.nextResultListeners = /* @__PURE__ */ new Set(), u.forEach(function(a) {
        return a(t, r);
      }));
    }, e.prototype.beforeNext = function(t) {
      var r = !1;
      this.nextResultListeners.add(function(u, a) {
        r || (r = !0, t(u, a));
      });
    }, e;
  }(rs)
);
hf(ye);
function be(s) {
  return "incremental" in s;
}
function oy(s) {
  return "hasNext" in s && "data" in s;
}
function My(s) {
  return be(s) || oy(s);
}
function $y(s) {
  return Ds(s) && "payload" in s;
}
function Sf(s, e) {
  var t = s, r = new ee();
  return be(e) && Rs(e.incremental) && e.incremental.forEach(function(u) {
    for (var a = u.data, i = u.path, _ = i.length - 1; _ >= 0; --_) {
      var h = i[_], f = !isNaN(+h), A = f ? [] : {};
      A[h] = a, a = A;
    }
    t = r.merge(t, a);
  }), t;
}
function bt(s) {
  var e = Rr(s);
  return Rs(e);
}
function Rr(s) {
  var e = Rs(s.errors) ? s.errors.slice(0) : [];
  return be(s) && Rs(s.incremental) && s.incremental.forEach(function(t) {
    t.errors && e.push.apply(e, t.errors);
  }), e;
}
function _e() {
  for (var s = [], e = 0; e < arguments.length; e++)
    s[e] = arguments[e];
  var t = /* @__PURE__ */ Object.create(null);
  return s.forEach(function(r) {
    r && Object.keys(r).forEach(function(u) {
      var a = r[u];
      a !== void 0 && (t[u] = a);
    });
  }), t;
}
function Ee(s, e) {
  return _e(s, e, e.variables && {
    variables: _e(p(p({}, s && s.variables), e.variables))
  });
}
function Ar(s) {
  return new rs(function(e) {
    e.error(s);
  });
}
var Af = function(s, e, t) {
  var r = new Error(t);
  throw r.name = "ServerError", r.response = s, r.statusCode = s.status, r.result = e, r;
};
function Ty(s) {
  for (var e = [
    "query",
    "operationName",
    "variables",
    "extensions",
    "context"
  ], t = 0, r = Object.keys(s); t < r.length; t++) {
    var u = r[t];
    if (e.indexOf(u) < 0)
      throw Ps(44, u);
  }
  return s;
}
function Py(s, e) {
  var t = p({}, s), r = function(a) {
    typeof a == "function" ? t = p(p({}, t), a(t)) : t = p(p({}, t), a);
  }, u = function() {
    return p({}, t);
  };
  return Object.defineProperty(e, "setContext", {
    enumerable: !1,
    value: r
  }), Object.defineProperty(e, "getContext", {
    enumerable: !1,
    value: u
  }), e;
}
function By(s) {
  var e = {
    variables: s.variables || {},
    extensions: s.extensions || {},
    operationName: s.operationName,
    query: s.query
  };
  return e.operationName || (e.operationName = typeof e.query != "string" ? Pr(e.query) || void 0 : ""), e;
}
function qy(s, e) {
  var t = p({}, s), r = new Set(Object.keys(s));
  return Xs(e, {
    Variable: function(u, a, i) {
      i && i.kind !== "VariableDefinition" && r.delete(u.name.value);
    }
  }), r.forEach(function(u) {
    delete t[u];
  }), t;
}
function Ri(s, e) {
  return e ? e(s) : rs.of();
}
function Be(s) {
  return typeof s == "function" ? new Is(s) : s;
}
function nt(s) {
  return s.request.length <= 1;
}
var Is = (
  /** @class */
  function() {
    function s(e) {
      e && (this.request = e);
    }
    return s.empty = function() {
      return new s(function() {
        return rs.of();
      });
    }, s.from = function(e) {
      return e.length === 0 ? s.empty() : e.map(Be).reduce(function(t, r) {
        return t.concat(r);
      });
    }, s.split = function(e, t, r) {
      var u = Be(t), a = Be(r || new s(Ri)), i;
      return nt(u) && nt(a) ? i = new s(function(_) {
        return e(_) ? u.request(_) || rs.of() : a.request(_) || rs.of();
      }) : i = new s(function(_, h) {
        return e(_) ? u.request(_, h) || rs.of() : a.request(_, h) || rs.of();
      }), Object.assign(i, { left: u, right: a });
    }, s.execute = function(e, t) {
      return e.request(Py(t.context, By(Ty(t)))) || rs.of();
    }, s.concat = function(e, t) {
      var r = Be(e);
      if (nt(r))
        return globalThis.__DEV__ !== !1 && Q.warn(36, r), r;
      var u = Be(t), a;
      return nt(u) ? a = new s(function(i) {
        return r.request(i, function(_) {
          return u.request(_) || rs.of();
        }) || rs.of();
      }) : a = new s(function(i, _) {
        return r.request(i, function(h) {
          return u.request(h, _) || rs.of();
        }) || rs.of();
      }), Object.assign(a, { left: r, right: u });
    }, s.prototype.split = function(e, t, r) {
      return this.concat(s.split(e, t, r || new s(Ri)));
    }, s.prototype.concat = function(e) {
      return s.concat(this, e);
    }, s.prototype.request = function(e, t) {
      throw Ps(37);
    }, s.prototype.onError = function(e, t) {
      if (t && t.error)
        return t.error(e), !1;
      throw e;
    }, s.prototype.setOnError = function(e) {
      return this.onError = e, this;
    }, s;
  }()
), nu = Is.from, jr = Is.execute;
function Gy(s) {
  var e, t = s[Symbol.asyncIterator]();
  return e = {
    next: function() {
      return t.next();
    }
  }, e[Symbol.asyncIterator] = function() {
    return this;
  }, e;
}
function Ry(s) {
  var e = null, t = null, r = !1, u = [], a = [];
  function i(y) {
    if (!t) {
      if (a.length) {
        var c = a.shift();
        if (Array.isArray(c) && c[0])
          return c[0]({ value: y, done: !1 });
      }
      u.push(y);
    }
  }
  function _(y) {
    t = y;
    var c = a.slice();
    c.forEach(function(n) {
      n[1](y);
    }), !e || e();
  }
  function h() {
    r = !0;
    var y = a.slice();
    y.forEach(function(c) {
      c[0]({ value: void 0, done: !0 });
    }), !e || e();
  }
  e = function() {
    e = null, s.removeListener("data", i), s.removeListener("error", _), s.removeListener("end", h), s.removeListener("finish", h), s.removeListener("close", h);
  }, s.on("data", i), s.on("error", _), s.on("end", h), s.on("finish", h), s.on("close", h);
  function f() {
    return new Promise(function(y, c) {
      if (t)
        return c(t);
      if (u.length)
        return y({ value: u.shift(), done: !1 });
      if (r)
        return y({ value: void 0, done: !0 });
      a.push([y, c]);
    });
  }
  var A = {
    next: function() {
      return f();
    }
  };
  return Bt && (A[Symbol.asyncIterator] = function() {
    return this;
  }), A;
}
function jy(s) {
  var e = !1, t = {
    next: function() {
      return e ? Promise.resolve({
        value: void 0,
        done: !0
      }) : (e = !0, new Promise(function(r, u) {
        s.then(function(a) {
          r({ value: a, done: !1 });
        }).catch(u);
      }));
    }
  };
  return Bt && (t[Symbol.asyncIterator] = function() {
    return this;
  }), t;
}
function ji(s) {
  var e = {
    next: function() {
      return s.read();
    }
  };
  return Bt && (e[Symbol.asyncIterator] = function() {
    return this;
  }), e;
}
function Uy(s) {
  return !!s.body;
}
function Qy(s) {
  return !!s.getReader;
}
function zy(s) {
  return !!(Bt && s[Symbol.asyncIterator]);
}
function Wy(s) {
  return !!s.stream;
}
function Ny(s) {
  return !!s.arrayBuffer;
}
function Iy(s) {
  return !!s.pipe;
}
function Jy(s) {
  var e = s;
  if (Uy(s) && (e = s.body), zy(e))
    return Gy(e);
  if (Qy(e))
    return ji(e.getReader());
  if (Wy(e))
    return ji(e.stream().getReader());
  if (Ny(e))
    return jy(e.arrayBuffer());
  if (Iy(e))
    return Ry(e);
  throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}
var Du = Symbol();
function Hy(s) {
  return s.extensions ? Array.isArray(s.extensions[Du]) : !1;
}
function yf(s) {
  return s.hasOwnProperty("graphQLErrors");
}
var Yy = function(s) {
  var e = Bs(Bs(Bs([], s.graphQLErrors, !0), s.clientErrors, !0), s.protocolErrors, !0);
  return s.networkError && e.push(s.networkError), e.map(function(t) {
    return Ds(t) && t.message || "Error message not found.";
  }).join(`
`);
}, Ys = (
  /** @class */
  function(s) {
    zs(e, s);
    function e(t) {
      var r = t.graphQLErrors, u = t.protocolErrors, a = t.clientErrors, i = t.networkError, _ = t.errorMessage, h = t.extraInfo, f = s.call(this, _) || this;
      return f.name = "ApolloError", f.graphQLErrors = r || [], f.protocolErrors = u || [], f.clientErrors = a || [], f.networkError = i || null, f.message = _ || Yy(f), f.extraInfo = h, f.cause = Bs(Bs(Bs([
        i
      ], r || [], !0), u || [], !0), a || [], !0).find(function(A) {
        return !!A;
      }) || null, f.__proto__ = e.prototype, f;
    }
    return e;
  }(Error)
), Ui = Object.prototype.hasOwnProperty;
function Ky(s, e) {
  return Js(this, void 0, void 0, function() {
    var t, r, u, a, i, _, h, f, A, y, c, n, d, E, V, b, F, l, T, $, q, z, U, Z;
    return Hs(this, function(O) {
      switch (O.label) {
        case 0:
          if (TextDecoder === void 0)
            throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
          t = new TextDecoder("utf-8"), r = (Z = s.headers) === null || Z === void 0 ? void 0 : Z.get("content-type"), u = "boundary=", a = r != null && r.includes(u) ? r == null ? void 0 : r.substring((r == null ? void 0 : r.indexOf(u)) + u.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-", i = `\r
--`.concat(a), _ = "", h = Jy(s), f = !0, O.label = 1;
        case 1:
          return f ? [4, h.next()] : [3, 3];
        case 2:
          for (A = O.sent(), y = A.value, c = A.done, n = typeof y == "string" ? y : t.decode(y), d = _.length - i.length + 1, f = !c, _ += n, E = _.indexOf(i, d); E > -1; ) {
            if (V = void 0, z = [
              _.slice(0, E),
              _.slice(E + i.length)
            ], V = z[0], _ = z[1], b = V.indexOf(`\r
\r
`), F = Xy(V.slice(0, b)), l = F["content-type"], l && l.toLowerCase().indexOf("application/json") === -1)
              throw new Error("Unsupported patch content type: application/json is required.");
            if (T = V.slice(b), T) {
              if ($ = cf(s, T), Object.keys($).length > 1 || "data" in $ || "incremental" in $ || "errors" in $ || "payload" in $)
                if ($y($)) {
                  if (q = {}, "payload" in $) {
                    if (Object.keys($).length === 1 && $.payload === null)
                      return [
                        2
                        /*return*/
                      ];
                    q = p({}, $.payload);
                  }
                  "errors" in $ && (q = p(p({}, q), { extensions: p(p({}, "extensions" in q ? q.extensions : null), (U = {}, U[Du] = $.errors, U)) })), e(q);
                } else
                  e($);
              else if (
                // If the chunk contains only a "hasNext: false", we can call
                // observer.complete() immediately.
                Object.keys($).length === 1 && "hasNext" in $ && !$.hasNext
              )
                return [
                  2
                  /*return*/
                ];
            }
            E = _.indexOf(i);
          }
          return [3, 1];
        case 3:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
function Xy(s) {
  var e = {};
  return s.split(`
`).forEach(function(t) {
    var r = t.indexOf(":");
    if (r > -1) {
      var u = t.slice(0, r).trim().toLowerCase(), a = t.slice(r + 1).trim();
      e[u] = a;
    }
  }), e;
}
function cf(s, e) {
  if (s.status >= 300) {
    var t = function() {
      try {
        return JSON.parse(e);
      } catch {
        return e;
      }
    };
    Af(s, t(), "Response not successful: Received status code ".concat(s.status));
  }
  try {
    return JSON.parse(e);
  } catch (u) {
    var r = u;
    throw r.name = "ServerParseError", r.response = s, r.statusCode = s.status, r.bodyText = e, r;
  }
}
function Zy(s, e) {
  s.result && s.result.errors && s.result.data && e.next(s.result), e.error(s);
}
function Cy(s) {
  return function(e) {
    return e.text().then(function(t) {
      return cf(e, t);
    }).then(function(t) {
      return !Array.isArray(t) && !Ui.call(t, "data") && !Ui.call(t, "errors") && Af(e, t, "Server response was missing for query '".concat(Array.isArray(s) ? s.map(function(r) {
        return r.operationName;
      }) : s.operationName, "'.")), t;
    });
  };
}
var Ur = function(s, e) {
  var t;
  try {
    t = JSON.stringify(s);
  } catch (u) {
    var r = Ps(40, e, u.message);
    throw r.parseError = u, r;
  }
  return t;
}, gy = {
  includeQuery: !0,
  includeExtensions: !1,
  preserveHeaderCase: !1
}, ky = {
  // headers are case insensitive (https://stackoverflow.com/a/5259004)
  accept: "*/*",
  // The content-type header describes the type of the body of the request, and
  // so it typically only is sent with requests that actually have bodies. One
  // could imagine that Apollo Client would remove this header when constructing
  // a GET request (which has no body), but we historically have not done that.
  // This means that browsers will preflight all Apollo Client requests (even
  // GET requests). Apollo Server's CSRF prevention feature (introduced in
  // AS3.7) takes advantage of this fact and does not block requests with this
  // header. If you want to drop this header from GET requests, then you should
  // probably replace it with a `apollo-require-preflight` header, or servers
  // with CSRF prevention enabled might block your GET request. See
  // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
  // for more details.
  "content-type": "application/json"
}, Oy = {
  method: "POST"
}, Ly = {
  http: gy,
  headers: ky,
  options: Oy
}, sc = function(s, e) {
  return e(s);
};
function ec(s, e) {
  for (var t = [], r = 2; r < arguments.length; r++)
    t[r - 2] = arguments[r];
  var u = {}, a = {};
  t.forEach(function(y) {
    u = p(p(p({}, u), y.options), { headers: p(p({}, u.headers), y.headers) }), y.credentials && (u.credentials = y.credentials), a = p(p({}, a), y.http);
  }), u.headers && (u.headers = tc(u.headers, a.preserveHeaderCase));
  var i = s.operationName, _ = s.extensions, h = s.variables, f = s.query, A = { operationName: i, variables: h };
  return a.includeExtensions && (A.extensions = _), a.includeQuery && (A.query = e(f, zt)), {
    options: u,
    body: A
  };
}
function tc(s, e) {
  if (!e) {
    var t = {};
    return Object.keys(Object(s)).forEach(function(a) {
      t[a.toLowerCase()] = s[a];
    }), t;
  }
  var r = {};
  Object.keys(Object(s)).forEach(function(a) {
    r[a.toLowerCase()] = {
      originalName: a,
      value: s[a]
    };
  });
  var u = {};
  return Object.keys(r).forEach(function(a) {
    u[r[a].originalName] = r[a].value;
  }), u;
}
var rc = function(s) {
  if (!s && typeof fetch > "u")
    throw Ps(38);
}, uc = function(s, e) {
  var t = s.getContext(), r = t.uri;
  return r || (typeof e == "function" ? e(s) : e || "/graphql");
};
function ac(s, e) {
  var t = [], r = function(y, c) {
    t.push("".concat(y, "=").concat(encodeURIComponent(c)));
  };
  if ("query" in e && r("query", e.query), e.operationName && r("operationName", e.operationName), e.variables) {
    var u = void 0;
    try {
      u = Ur(e.variables, "Variables map");
    } catch (y) {
      return { parseError: y };
    }
    r("variables", u);
  }
  if (e.extensions) {
    var a = void 0;
    try {
      a = Ur(e.extensions, "Extensions map");
    } catch (y) {
      return { parseError: y };
    }
    r("extensions", a);
  }
  var i = "", _ = s, h = s.indexOf("#");
  h !== -1 && (i = s.substr(h), _ = s.substr(0, h));
  var f = _.indexOf("?") === -1 ? "?" : "&", A = _ + f + t.join("&") + i;
  return { newURI: A };
}
var Qi = Qs(function() {
  return fetch;
}), nf = function(s) {
  s === void 0 && (s = {});
  var e = s.uri, t = e === void 0 ? "/graphql" : e, r = s.fetch, u = s.print, a = u === void 0 ? sc : u, i = s.includeExtensions, _ = s.preserveHeaderCase, h = s.useGETForQueries, f = s.includeUnusedVariables, A = f === void 0 ? !1 : f, y = Gs(s, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]);
  globalThis.__DEV__ !== !1 && rc(r || Qi);
  var c = {
    http: { includeExtensions: i, preserveHeaderCase: _ },
    options: y.fetchOptions,
    credentials: y.credentials,
    headers: y.headers
  };
  return new Is(function(n) {
    var d = uc(n, t), E = n.getContext(), V = {};
    if (E.clientAwareness) {
      var b = E.clientAwareness, F = b.name, l = b.version;
      F && (V["apollographql-client-name"] = F), l && (V["apollographql-client-version"] = l);
    }
    var T = p(p({}, V), E.headers), $ = {
      http: E.http,
      options: E.fetchOptions,
      credentials: E.credentials,
      headers: T
    };
    if (Ie(["client"], n.query)) {
      var q = rf(n.query);
      if (!q)
        return Ar(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
      n.query = q;
    }
    var z = ec(n, a, Ly, c, $), U = z.options, Z = z.body;
    Z.variables && !A && (Z.variables = qy(Z.variables, n.query));
    var O;
    !U.signal && typeof AbortController < "u" && (O = new AbortController(), U.signal = O.signal);
    var os = function(ws) {
      return ws.kind === "OperationDefinition" && ws.operation === "mutation";
    }, qs = function(ws) {
      return ws.kind === "OperationDefinition" && ws.operation === "subscription";
    }, fs = qs(ke(n.query)), ls = Ie(["defer"], n.query);
    if (h && !n.query.definitions.some(os) && (U.method = "GET"), ls || fs) {
      U.headers = U.headers || {};
      var Ms = "multipart/mixed;";
      fs && ls && globalThis.__DEV__ !== !1 && Q.warn(39), fs ? Ms += "boundary=graphql;subscriptionSpec=1.0,application/json" : ls && (Ms += "deferSpec=20220824,application/json"), U.headers.accept = Ms;
    }
    if (U.method === "GET") {
      var js = ac(d, Z), J = js.newURI, Ws = js.parseError;
      if (Ws)
        return Ar(Ws);
      d = J;
    } else
      try {
        U.body = Ur(Z, "Payload");
      } catch (ws) {
        return Ar(ws);
      }
    return new rs(function(ws) {
      var v = r || Qs(function() {
        return fetch;
      }) || Qi, B = ws.next.bind(ws);
      return v(d, U).then(function(Y) {
        var ss;
        n.setContext({ response: Y });
        var C = (ss = Y.headers) === null || ss === void 0 ? void 0 : ss.get("content-type");
        return C !== null && /^multipart\/mixed/i.test(C) ? Ky(Y, B) : Cy(n)(Y).then(B);
      }).then(function() {
        O = void 0, ws.complete();
      }).catch(function(Y) {
        O = void 0, Zy(Y, ws);
      }), function() {
        O && O.abort();
      };
    });
  });
}, ic = (
  /** @class */
  function(s) {
    zs(e, s);
    function e(t) {
      t === void 0 && (t = {});
      var r = s.call(this, nf(t).request) || this;
      return r.options = t, r;
    }
    return e;
  }(Is)
);
const { toString: zi, hasOwnProperty: _c } = Object.prototype, Wi = Function.prototype.toString, Qr = /* @__PURE__ */ new Map();
function us(s, e) {
  try {
    return zr(s, e);
  } finally {
    Qr.clear();
  }
}
function zr(s, e) {
  if (s === e)
    return !0;
  const t = zi.call(s), r = zi.call(e);
  if (t !== r)
    return !1;
  switch (t) {
    case "[object Array]":
      if (s.length !== e.length)
        return !1;
    case "[object Object]": {
      if (Ii(s, e))
        return !0;
      const u = Ni(s), a = Ni(e), i = u.length;
      if (i !== a.length)
        return !1;
      for (let _ = 0; _ < i; ++_)
        if (!_c.call(e, u[_]))
          return !1;
      for (let _ = 0; _ < i; ++_) {
        const h = u[_];
        if (!zr(s[h], e[h]))
          return !1;
      }
      return !0;
    }
    case "[object Error]":
      return s.name === e.name && s.message === e.message;
    case "[object Number]":
      if (s !== s)
        return e !== e;
    case "[object Boolean]":
    case "[object Date]":
      return +s == +e;
    case "[object RegExp]":
    case "[object String]":
      return s == `${e}`;
    case "[object Map]":
    case "[object Set]": {
      if (s.size !== e.size)
        return !1;
      if (Ii(s, e))
        return !0;
      const u = s.entries(), a = t === "[object Map]";
      for (; ; ) {
        const i = u.next();
        if (i.done)
          break;
        const [_, h] = i.value;
        if (!e.has(_) || a && !zr(h, e.get(_)))
          return !1;
      }
      return !0;
    }
    case "[object Uint16Array]":
    case "[object Uint8Array]":
    case "[object Uint32Array]":
    case "[object Int32Array]":
    case "[object Int8Array]":
    case "[object Int16Array]":
    case "[object ArrayBuffer]":
      s = new Uint8Array(s), e = new Uint8Array(e);
    case "[object DataView]": {
      let u = s.byteLength;
      if (u === e.byteLength)
        for (; u-- && s[u] === e[u]; )
          ;
      return u === -1;
    }
    case "[object AsyncFunction]":
    case "[object GeneratorFunction]":
    case "[object AsyncGeneratorFunction]":
    case "[object Function]": {
      const u = Wi.call(s);
      return u !== Wi.call(e) ? !1 : !Sc(u, hc);
    }
  }
  return !1;
}
function Ni(s) {
  return Object.keys(s).filter(fc, s);
}
function fc(s) {
  return this[s] !== void 0;
}
const hc = "{ [native code] }";
function Sc(s, e) {
  const t = s.length - e.length;
  return t >= 0 && s.indexOf(e, t) === t;
}
function Ii(s, e) {
  let t = Qr.get(s);
  if (t) {
    if (t.has(e))
      return !0;
  } else
    Qr.set(s, t = /* @__PURE__ */ new Set());
  return t.add(e), !1;
}
function Df(s, e, t, r) {
  var u = e.data, a = Gs(e, ["data"]), i = t.data, _ = Gs(t, ["data"]);
  return us(a, _) && Et(ke(s).selectionSet, u, i, {
    fragmentMap: qt(jt(s)),
    variables: r
  });
}
function Et(s, e, t, r) {
  if (e === t)
    return !0;
  var u = /* @__PURE__ */ new Set();
  return s.selections.every(function(a) {
    if (u.has(a) || (u.add(a), !Ze(a, r.variables)) || Ji(a))
      return !0;
    if (Ls(a)) {
      var i = Os(a), _ = e && e[i], h = t && t[i], f = a.selectionSet;
      if (!f)
        return us(_, h);
      var A = Array.isArray(_), y = Array.isArray(h);
      if (A !== y)
        return !1;
      if (A && y) {
        var c = _.length;
        if (h.length !== c)
          return !1;
        for (var n = 0; n < c; ++n)
          if (!Et(f, _[n], h[n], r))
            return !1;
        return !0;
      }
      return Et(f, _, h, r);
    } else {
      var d = Gt(a, r.fragmentMap);
      if (d)
        return Ji(d) ? !0 : Et(
          d.selectionSet,
          // Notice that we reuse the same aResult and bResult values here,
          // since the fragment ...spread does not specify a field name, but
          // consists of multiple fields (within the fragment's selection set)
          // that should be applied to the current result value(s).
          e,
          t,
          r
        );
    }
  });
}
function Ji(s) {
  return !!s.directives && s.directives.some(Ac);
}
function Ac(s) {
  return s.name.value === "nonreactive";
}
var df = (
  /** @class */
  function() {
    function s() {
      this.assumeImmutableResults = !1, this.getFragmentDoc = He(pA, {
        max: Ns["cache.fragmentQueryDocuments"] || 1e3,
        cache: wt
      });
    }
    return s.prototype.batch = function(e) {
      var t = this, r = typeof e.optimistic == "string" ? e.optimistic : e.optimistic === !1 ? null : void 0, u;
      return this.performTransaction(function() {
        return u = e.update(t);
      }, r), u;
    }, s.prototype.recordOptimisticTransaction = function(e, t) {
      this.performTransaction(e, t);
    }, s.prototype.transformDocument = function(e) {
      return e;
    }, s.prototype.transformForLink = function(e) {
      return e;
    }, s.prototype.identify = function(e) {
    }, s.prototype.gc = function() {
      return [];
    }, s.prototype.modify = function(e) {
      return !1;
    }, s.prototype.readQuery = function(e, t) {
      return t === void 0 && (t = !!e.optimistic), this.read(p(p({}, e), { rootId: e.id || "ROOT_QUERY", optimistic: t }));
    }, s.prototype.watchFragment = function(e) {
      var t = this, r = e.fragment, u = e.fragmentName, a = e.from, i = e.optimistic, _ = i === void 0 ? !0 : i, h = Gs(e, ["fragment", "fragmentName", "from", "optimistic"]), f = this.getFragmentDoc(r, u), A = p(p({}, h), { returnPartialData: !0, id: (
        // While our TypeScript types do not allow for `undefined` as a valid
        // `from`, its possible `useFragment` gives us an `undefined` since it
        // calls` cache.identify` and provides that value to `from`. We are
        // adding this fix here however to ensure those using plain JavaScript
        // and using `cache.identify` themselves will avoid seeing the obscure
        // warning.
        typeof a > "u" || typeof a == "string" ? a : this.identify(a)
      ), query: f, optimistic: _ }), y;
      return new rs(function(c) {
        return t.watch(p(p({}, A), { immediate: !0, callback: function(n) {
          if (
            // Always ensure we deliver the first result
            !(y && Df(f, { data: y == null ? void 0 : y.result }, { data: n.result }))
          ) {
            var d = {
              data: n.result,
              complete: !!n.complete
            };
            n.missing && (d.missing = Wt(n.missing.map(function(E) {
              return E.missing;
            }))), y = n, c.next(d);
          }
        } }));
      });
    }, s.prototype.readFragment = function(e, t) {
      return t === void 0 && (t = !!e.optimistic), this.read(p(p({}, e), { query: this.getFragmentDoc(e.fragment, e.fragmentName), rootId: e.id, optimistic: t }));
    }, s.prototype.writeQuery = function(e) {
      var t = e.id, r = e.data, u = Gs(e, ["id", "data"]);
      return this.write(Object.assign(u, {
        dataId: t || "ROOT_QUERY",
        result: r
      }));
    }, s.prototype.writeFragment = function(e) {
      var t = e.id, r = e.data, u = e.fragment, a = e.fragmentName, i = Gs(e, ["id", "data", "fragment", "fragmentName"]);
      return this.write(Object.assign(i, {
        query: this.getFragmentDoc(u, a),
        dataId: t,
        result: r
      }));
    }, s.prototype.updateQuery = function(e, t) {
      return this.batch({
        update: function(r) {
          var u = r.readQuery(e), a = t(u);
          return a == null ? u : (r.writeQuery(p(p({}, e), { data: a })), a);
        }
      });
    }, s.prototype.updateFragment = function(e, t) {
      return this.batch({
        update: function(r) {
          var u = r.readFragment(e), a = t(u);
          return a == null ? u : (r.writeFragment(p(p({}, e), { data: a })), a);
        }
      });
    }, s;
  }()
);
globalThis.__DEV__ !== !1 && (df.prototype.getMemoryInternals = MA);
var pf = (
  /** @class */
  function(s) {
    zs(e, s);
    function e(t, r, u, a) {
      var i, _ = s.call(this, t) || this;
      if (_.message = t, _.path = r, _.query = u, _.variables = a, Array.isArray(_.path)) {
        _.missing = _.message;
        for (var h = _.path.length - 1; h >= 0; --h)
          _.missing = (i = {}, i[_.path[h]] = _.missing, i);
      } else
        _.missing = _.path;
      return _.__proto__ = e.prototype, _;
    }
    return e;
  }(Error)
), vs = Object.prototype.hasOwnProperty;
function qe(s) {
  return s == null;
}
function bf(s, e) {
  var t = s.__typename, r = s.id, u = s._id;
  if (typeof t == "string" && (e && (e.keyObject = qe(r) ? qe(u) ? void 0 : { _id: u } : { id: r }), qe(r) && !qe(u) && (r = u), !qe(r)))
    return "".concat(t, ":").concat(typeof r == "number" || typeof r == "string" ? r : JSON.stringify(r));
}
var Ef = {
  dataIdFromObject: bf,
  addTypename: !0,
  resultCaching: !0,
  // Thanks to the shouldCanonizeResults helper, this should be the only line
  // you have to change to reenable canonization by default in the future.
  canonizeResults: !1
};
function yc(s) {
  return _e(Ef, s);
}
function vf(s) {
  var e = s.canonizeResults;
  return e === void 0 ? Ef.canonizeResults : e;
}
function cc(s, e) {
  return ts(e) ? s.get(e.__ref, "__typename") : e && e.__typename;
}
var mf = /^[_a-z][_0-9a-z]*/i;
function te(s) {
  var e = s.match(mf);
  return e ? e[0] : s;
}
function Wr(s, e, t) {
  return Ds(e) ? ds(e) ? e.every(function(r) {
    return Wr(s, r, t);
  }) : s.selections.every(function(r) {
    if (Ls(r) && Ze(r, t)) {
      var u = Os(r);
      return vs.call(e, u) && (!r.selectionSet || Wr(r.selectionSet, e[u], t));
    }
    return !0;
  }) : !1;
}
function De(s) {
  return Ds(s) && !ts(s) && !ds(s);
}
function nc() {
  return new ee();
}
function Vf(s, e) {
  var t = qt(jt(s));
  return {
    fragmentMap: t,
    lookupFragment: function(r) {
      var u = t[r];
      return !u && e && (u = e.lookup(r)), u || null;
    }
  };
}
var vt = /* @__PURE__ */ Object.create(null), yr = function() {
  return vt;
}, Hi = /* @__PURE__ */ Object.create(null), Ke = (
  /** @class */
  function() {
    function s(e, t) {
      var r = this;
      this.policies = e, this.group = t, this.data = /* @__PURE__ */ Object.create(null), this.rootIds = /* @__PURE__ */ Object.create(null), this.refs = /* @__PURE__ */ Object.create(null), this.getFieldValue = function(u, a) {
        return Ye(ts(u) ? r.get(u.__ref, a) : u && u[a]);
      }, this.canRead = function(u) {
        return ts(u) ? r.has(u.__ref) : typeof u == "object";
      }, this.toReference = function(u, a) {
        if (typeof u == "string")
          return pe(u);
        if (ts(u))
          return u;
        var i = r.policies.identify(u)[0];
        if (i) {
          var _ = pe(i);
          return a && r.merge(i, u), _;
        }
      };
    }
    return s.prototype.toObject = function() {
      return p({}, this.data);
    }, s.prototype.has = function(e) {
      return this.lookup(e, !0) !== void 0;
    }, s.prototype.get = function(e, t) {
      if (this.group.depend(e, t), vs.call(this.data, e)) {
        var r = this.data[e];
        if (r && vs.call(r, t))
          return r[t];
      }
      if (t === "__typename" && vs.call(this.policies.rootTypenamesById, e))
        return this.policies.rootTypenamesById[e];
      if (this instanceof Cs)
        return this.parent.get(e, t);
    }, s.prototype.lookup = function(e, t) {
      if (t && this.group.depend(e, "__exists"), vs.call(this.data, e))
        return this.data[e];
      if (this instanceof Cs)
        return this.parent.lookup(e, t);
      if (this.policies.rootTypenamesById[e])
        return /* @__PURE__ */ Object.create(null);
    }, s.prototype.merge = function(e, t) {
      var r = this, u;
      ts(e) && (e = e.__ref), ts(t) && (t = t.__ref);
      var a = typeof e == "string" ? this.lookup(u = e) : e, i = typeof t == "string" ? this.lookup(u = t) : t;
      if (i) {
        Q(typeof u == "string", 1);
        var _ = new ee(dc).merge(a, i);
        if (this.data[u] = _, _ !== a && (delete this.refs[u], this.group.caching)) {
          var h = /* @__PURE__ */ Object.create(null);
          a || (h.__exists = 1), Object.keys(i).forEach(function(f) {
            if (!a || a[f] !== _[f]) {
              h[f] = 1;
              var A = te(f);
              A !== f && !r.policies.hasKeyArgs(_.__typename, A) && (h[A] = 1), _[f] === void 0 && !(r instanceof Cs) && delete _[f];
            }
          }), h.__typename && !(a && a.__typename) && // Since we return default root __typename strings
          // automatically from store.get, we don't need to dirty the
          // ROOT_QUERY.__typename field if merged.__typename is equal
          // to the default string (usually "Query").
          this.policies.rootTypenamesById[u] === _.__typename && delete h.__typename, Object.keys(h).forEach(function(f) {
            return r.group.dirty(u, f);
          });
        }
      }
    }, s.prototype.modify = function(e, t) {
      var r = this, u = this.lookup(e);
      if (u) {
        var a = /* @__PURE__ */ Object.create(null), i = !1, _ = !0, h = {
          DELETE: vt,
          INVALIDATE: Hi,
          isReference: ts,
          toReference: this.toReference,
          canRead: this.canRead,
          readField: function(f, A) {
            return r.policies.readField(typeof f == "string" ? {
              fieldName: f,
              from: A || pe(e)
            } : f, { store: r });
          }
        };
        if (Object.keys(u).forEach(function(f) {
          var A = te(f), y = u[f];
          if (y !== void 0) {
            var c = typeof t == "function" ? t : t[f] || t[A];
            if (c) {
              var n = c === yr ? vt : c(Ye(y), p(p({}, h), { fieldName: A, storeFieldName: f, storage: r.getStorage(e, f) }));
              if (n === Hi)
                r.group.dirty(e, f);
              else if (n === vt && (n = void 0), n !== y && (a[f] = n, i = !0, y = n, globalThis.__DEV__ !== !1)) {
                var d = function($) {
                  if (r.lookup($.__ref) === void 0)
                    return globalThis.__DEV__ !== !1 && Q.warn(2, $), !0;
                };
                if (ts(n))
                  d(n);
                else if (Array.isArray(n))
                  for (var E = !1, V = void 0, b = 0, F = n; b < F.length; b++) {
                    var l = F[b];
                    if (ts(l)) {
                      if (E = !0, d(l))
                        break;
                    } else if (typeof l == "object" && l) {
                      var T = r.policies.identify(l)[0];
                      T && (V = l);
                    }
                    if (E && V !== void 0) {
                      globalThis.__DEV__ !== !1 && Q.warn(3, V);
                      break;
                    }
                  }
              }
            }
            y !== void 0 && (_ = !1);
          }
        }), i)
          return this.merge(e, a), _ && (this instanceof Cs ? this.data[e] = void 0 : delete this.data[e], this.group.dirty(e, "__exists")), !0;
      }
      return !1;
    }, s.prototype.delete = function(e, t, r) {
      var u, a = this.lookup(e);
      if (a) {
        var i = this.getFieldValue(a, "__typename"), _ = t && r ? this.policies.getStoreFieldName({ typename: i, fieldName: t, args: r }) : t;
        return this.modify(e, _ ? (u = {}, u[_] = yr, u) : yr);
      }
      return !1;
    }, s.prototype.evict = function(e, t) {
      var r = !1;
      return e.id && (vs.call(this.data, e.id) && (r = this.delete(e.id, e.fieldName, e.args)), this instanceof Cs && this !== t && (r = this.parent.evict(e, t) || r), (e.fieldName || r) && this.group.dirty(e.id, e.fieldName || "__exists")), r;
    }, s.prototype.clear = function() {
      this.replace(null);
    }, s.prototype.extract = function() {
      var e = this, t = this.toObject(), r = [];
      return this.getRootIdSet().forEach(function(u) {
        vs.call(e.policies.rootTypenamesById, u) || r.push(u);
      }), r.length && (t.__META = { extraRootIds: r.sort() }), t;
    }, s.prototype.replace = function(e) {
      var t = this;
      if (Object.keys(this.data).forEach(function(a) {
        e && vs.call(e, a) || t.delete(a);
      }), e) {
        var r = e.__META, u = Gs(e, ["__META"]);
        Object.keys(u).forEach(function(a) {
          t.merge(a, u[a]);
        }), r && r.extraRootIds.forEach(this.retain, this);
      }
    }, s.prototype.retain = function(e) {
      return this.rootIds[e] = (this.rootIds[e] || 0) + 1;
    }, s.prototype.release = function(e) {
      if (this.rootIds[e] > 0) {
        var t = --this.rootIds[e];
        return t || delete this.rootIds[e], t;
      }
      return 0;
    }, s.prototype.getRootIdSet = function(e) {
      return e === void 0 && (e = /* @__PURE__ */ new Set()), Object.keys(this.rootIds).forEach(e.add, e), this instanceof Cs ? this.parent.getRootIdSet(e) : Object.keys(this.policies.rootTypenamesById).forEach(e.add, e), e;
    }, s.prototype.gc = function() {
      var e = this, t = this.getRootIdSet(), r = this.toObject();
      t.forEach(function(i) {
        vs.call(r, i) && (Object.keys(e.findChildRefIds(i)).forEach(t.add, t), delete r[i]);
      });
      var u = Object.keys(r);
      if (u.length) {
        for (var a = this; a instanceof Cs; )
          a = a.parent;
        u.forEach(function(i) {
          return a.delete(i);
        });
      }
      return u;
    }, s.prototype.findChildRefIds = function(e) {
      if (!vs.call(this.refs, e)) {
        var t = this.refs[e] = /* @__PURE__ */ Object.create(null), r = this.data[e];
        if (!r)
          return t;
        var u = /* @__PURE__ */ new Set([r]);
        u.forEach(function(a) {
          ts(a) && (t[a.__ref] = !0), Ds(a) && Object.keys(a).forEach(function(i) {
            var _ = a[i];
            Ds(_) && u.add(_);
          });
        });
      }
      return this.refs[e];
    }, s.prototype.makeCacheKey = function() {
      return this.group.keyMaker.lookupArray(arguments);
    }, s;
  }()
), lf = (
  /** @class */
  function() {
    function s(e, t) {
      t === void 0 && (t = null), this.caching = e, this.parent = t, this.d = null, this.resetCaching();
    }
    return s.prototype.resetCaching = function() {
      this.d = this.caching ? L_() : null, this.keyMaker = new Fe(xe);
    }, s.prototype.depend = function(e, t) {
      if (this.d) {
        this.d(cr(e, t));
        var r = te(t);
        r !== t && this.d(cr(e, r)), this.parent && this.parent.depend(e, t);
      }
    }, s.prototype.dirty = function(e, t) {
      this.d && this.d.dirty(
        cr(e, t),
        // When storeFieldName === "__exists", that means the entity identified
        // by dataId has either disappeared from the cache or was newly added,
        // so the result caching system would do well to "forget everything it
        // knows" about that object. To achieve that kind of invalidation, we
        // not only dirty the associated result cache entry, but also remove it
        // completely from the dependency graph. For the optimism implementation
        // details, see https://github.com/benjamn/optimism/pull/195.
        t === "__exists" ? "forget" : "setDirty"
      );
    }, s;
  }()
);
function cr(s, e) {
  return e + "#" + s;
}
function Yi(s, e) {
  ze(s) && s.group.depend(e, "__exists");
}
(function(s) {
  var e = (
    /** @class */
    function(t) {
      zs(r, t);
      function r(u) {
        var a = u.policies, i = u.resultCaching, _ = i === void 0 ? !0 : i, h = u.seed, f = t.call(this, a, new lf(_)) || this;
        return f.stump = new Dc(f), f.storageTrie = new Fe(xe), h && f.replace(h), f;
      }
      return r.prototype.addLayer = function(u, a) {
        return this.stump.addLayer(u, a);
      }, r.prototype.removeLayer = function() {
        return this;
      }, r.prototype.getStorage = function() {
        return this.storageTrie.lookupArray(arguments);
      }, r;
    }(s)
  );
  s.Root = e;
})(Ke || (Ke = {}));
var Cs = (
  /** @class */
  function(s) {
    zs(e, s);
    function e(t, r, u, a) {
      var i = s.call(this, r.policies, a) || this;
      return i.id = t, i.parent = r, i.replay = u, i.group = a, u(i), i;
    }
    return e.prototype.addLayer = function(t, r) {
      return new e(t, this, r, this.group);
    }, e.prototype.removeLayer = function(t) {
      var r = this, u = this.parent.removeLayer(t);
      return t === this.id ? (this.group.caching && Object.keys(this.data).forEach(function(a) {
        var i = r.data[a], _ = u.lookup(a);
        _ ? i ? i !== _ && Object.keys(i).forEach(function(h) {
          us(i[h], _[h]) || r.group.dirty(a, h);
        }) : (r.group.dirty(a, "__exists"), Object.keys(_).forEach(function(h) {
          r.group.dirty(a, h);
        })) : r.delete(a);
      }), u) : u === this.parent ? this : u.addLayer(this.id, this.replay);
    }, e.prototype.toObject = function() {
      return p(p({}, this.parent.toObject()), this.data);
    }, e.prototype.findChildRefIds = function(t) {
      var r = this.parent.findChildRefIds(t);
      return vs.call(this.data, t) ? p(p({}, r), s.prototype.findChildRefIds.call(this, t)) : r;
    }, e.prototype.getStorage = function() {
      for (var t = this.parent; t.parent; )
        t = t.parent;
      return t.getStorage.apply(
        t,
        // @ts-expect-error
        arguments
      );
    }, e;
  }(Ke)
), Dc = (
  /** @class */
  function(s) {
    zs(e, s);
    function e(t) {
      return s.call(this, "EntityStore.Stump", t, function() {
      }, new lf(t.group.caching, t.group)) || this;
    }
    return e.prototype.removeLayer = function() {
      return this;
    }, e.prototype.merge = function(t, r) {
      return this.parent.merge(t, r);
    }, e;
  }(Cs)
);
function dc(s, e, t) {
  var r = s[t], u = e[t];
  return us(r, u) ? r : u;
}
function ze(s) {
  return !!(s instanceof Ke && s.group.caching);
}
function pc(s) {
  return Ds(s) ? ds(s) ? s.slice(0) : p({ __proto__: Object.getPrototypeOf(s) }, s) : s;
}
var Ki = (
  /** @class */
  function() {
    function s() {
      this.known = new (G_ ? WeakSet : Set)(), this.pool = new Fe(xe), this.passes = /* @__PURE__ */ new WeakMap(), this.keysByJSON = /* @__PURE__ */ new Map(), this.empty = this.admit({});
    }
    return s.prototype.isKnown = function(e) {
      return Ds(e) && this.known.has(e);
    }, s.prototype.pass = function(e) {
      if (Ds(e)) {
        var t = pc(e);
        return this.passes.set(t, e), t;
      }
      return e;
    }, s.prototype.admit = function(e) {
      var t = this;
      if (Ds(e)) {
        var r = this.passes.get(e);
        if (r)
          return r;
        var u = Object.getPrototypeOf(e);
        switch (u) {
          case Array.prototype: {
            if (this.known.has(e))
              return e;
            var a = e.map(this.admit, this), i = this.pool.lookupArray(a);
            return i.array || (this.known.add(i.array = a), globalThis.__DEV__ !== !1 && Object.freeze(a)), i.array;
          }
          case null:
          case Object.prototype: {
            if (this.known.has(e))
              return e;
            var _ = Object.getPrototypeOf(e), h = [_], f = this.sortedKeys(e);
            h.push(f.json);
            var A = h.length;
            f.sorted.forEach(function(n) {
              h.push(t.admit(e[n]));
            });
            var i = this.pool.lookupArray(h);
            if (!i.object) {
              var y = i.object = Object.create(_);
              this.known.add(y), f.sorted.forEach(function(n, d) {
                y[n] = h[A + d];
              }), globalThis.__DEV__ !== !1 && Object.freeze(y);
            }
            return i.object;
          }
        }
      }
      return e;
    }, s.prototype.sortedKeys = function(e) {
      var t = Object.keys(e), r = this.pool.lookupArray(t);
      if (!r.keys) {
        t.sort();
        var u = JSON.stringify(t);
        (r.keys = this.keysByJSON.get(u)) || this.keysByJSON.set(u, r.keys = { sorted: t, json: u });
      }
      return r.keys;
    }, s;
  }()
);
function Xi(s) {
  return [
    s.selectionSet,
    s.objectOrReference,
    s.context,
    // We split out this property so we can pass different values
    // independently without modifying options.context itself.
    s.context.canonizeResults
  ];
}
var bc = (
  /** @class */
  function() {
    function s(e) {
      var t = this;
      this.knownResults = new (xe ? WeakMap : Map)(), this.config = _e(e, {
        addTypename: e.addTypename !== !1,
        canonizeResults: vf(e)
      }), this.canon = e.canon || new Ki(), this.executeSelectionSet = He(function(r) {
        var u, a = r.context.canonizeResults, i = Xi(r);
        i[3] = !a;
        var _ = (u = t.executeSelectionSet).peek.apply(u, i);
        return _ ? a ? p(p({}, _), {
          // If we previously read this result without canonizing it, we can
          // reuse that result simply by canonizing it now.
          result: t.canon.admit(_.result)
        }) : _ : (Yi(r.context.store, r.enclosingRef.__ref), t.execSelectionSetImpl(r));
      }, {
        max: this.config.resultCacheMaxSize || Ns["inMemoryCache.executeSelectionSet"] || 5e4,
        keyArgs: Xi,
        // Note that the parameters of makeCacheKey are determined by the
        // array returned by keyArgs.
        makeCacheKey: function(r, u, a, i) {
          if (ze(a.store))
            return a.store.makeCacheKey(r, ts(u) ? u.__ref : u, a.varString, i);
        }
      }), this.executeSubSelectedArray = He(function(r) {
        return Yi(r.context.store, r.enclosingRef.__ref), t.execSubSelectedArrayImpl(r);
      }, {
        max: this.config.resultCacheMaxSize || Ns["inMemoryCache.executeSubSelectedArray"] || 1e4,
        makeCacheKey: function(r) {
          var u = r.field, a = r.array, i = r.context;
          if (ze(i.store))
            return i.store.makeCacheKey(u, a, i.varString);
        }
      });
    }
    return s.prototype.resetCanon = function() {
      this.canon = new Ki();
    }, s.prototype.diffQueryAgainstStore = function(e) {
      var t = e.store, r = e.query, u = e.rootId, a = u === void 0 ? "ROOT_QUERY" : u, i = e.variables, _ = e.returnPartialData, h = _ === void 0 ? !0 : _, f = e.canonizeResults, A = f === void 0 ? this.config.canonizeResults : f, y = this.config.cache.policies;
      i = p(p({}, uu(N_(r))), i);
      var c = pe(a), n = this.executeSelectionSet({
        selectionSet: ke(r).selectionSet,
        objectOrReference: c,
        enclosingRef: c,
        context: p({ store: t, query: r, policies: y, variables: i, varString: ks(i), canonizeResults: A }, Vf(r, this.config.fragments))
      }), d;
      if (n.missing && (d = [
        new pf(Ec(n.missing), n.missing, r, i)
      ], !h))
        throw d[0];
      return {
        result: n.result,
        complete: !d,
        missing: d
      };
    }, s.prototype.isFresh = function(e, t, r, u) {
      if (ze(u.store) && this.knownResults.get(e) === r) {
        var a = this.executeSelectionSet.peek(
          r,
          t,
          u,
          // If result is canonical, then it could only have been previously
          // cached by the canonizing version of executeSelectionSet, so we can
          // avoid checking both possibilities here.
          this.canon.isKnown(e)
        );
        if (a && e === a.result)
          return !0;
      }
      return !1;
    }, s.prototype.execSelectionSetImpl = function(e) {
      var t = this, r = e.selectionSet, u = e.objectOrReference, a = e.enclosingRef, i = e.context;
      if (ts(u) && !i.policies.rootTypenamesById[u.__ref] && !i.store.has(u.__ref))
        return {
          result: this.canon.empty,
          missing: "Dangling reference to missing ".concat(u.__ref, " object")
        };
      var _ = i.variables, h = i.policies, f = i.store, A = f.getFieldValue(u, "__typename"), y = [], c, n = new ee();
      this.config.addTypename && typeof A == "string" && !h.rootIdsByTypename[A] && y.push({ __typename: A });
      function d(l, T) {
        var $;
        return l.missing && (c = n.merge(c, ($ = {}, $[T] = l.missing, $))), l.result;
      }
      var E = new Set(r.selections);
      E.forEach(function(l) {
        var T, $;
        if (Ze(l, _))
          if (Ls(l)) {
            var q = h.readField({
              fieldName: l.name.value,
              field: l,
              variables: i.variables,
              from: u
            }, i), z = Os(l);
            q === void 0 ? hu.added(l) || (c = n.merge(c, (T = {}, T[z] = "Can't find field '".concat(l.name.value, "' on ").concat(ts(u) ? u.__ref + " object" : "object " + JSON.stringify(u, null, 2)), T))) : ds(q) ? q.length > 0 && (q = d(t.executeSubSelectedArray({
              field: l,
              array: q,
              enclosingRef: a,
              context: i
            }), z)) : l.selectionSet ? q != null && (q = d(t.executeSelectionSet({
              selectionSet: l.selectionSet,
              objectOrReference: q,
              enclosingRef: ts(q) ? q : a,
              context: i
            }), z)) : i.canonizeResults && (q = t.canon.pass(q)), q !== void 0 && y.push(($ = {}, $[z] = q, $));
          } else {
            var U = Gt(l, i.lookupFragment);
            if (!U && l.kind === G.FRAGMENT_SPREAD)
              throw Ps(9, l.name.value);
            U && h.fragmentMatches(U, A) && U.selectionSet.selections.forEach(E.add, E);
          }
      });
      var V = Wt(y), b = { result: V, missing: c }, F = i.canonizeResults ? this.canon.admit(b) : Ye(b);
      return F.result && this.knownResults.set(F.result, r), F;
    }, s.prototype.execSubSelectedArrayImpl = function(e) {
      var t = this, r = e.field, u = e.array, a = e.enclosingRef, i = e.context, _, h = new ee();
      function f(A, y) {
        var c;
        return A.missing && (_ = h.merge(_, (c = {}, c[y] = A.missing, c))), A.result;
      }
      return r.selectionSet && (u = u.filter(i.store.canRead)), u = u.map(function(A, y) {
        return A === null ? null : ds(A) ? f(t.executeSubSelectedArray({
          field: r,
          array: A,
          enclosingRef: a,
          context: i
        }), y) : r.selectionSet ? f(t.executeSelectionSet({
          selectionSet: r.selectionSet,
          objectOrReference: A,
          enclosingRef: ts(A) ? A : a,
          context: i
        }), y) : (globalThis.__DEV__ !== !1 && vc(i.store, r, A), A);
      }), {
        result: i.canonizeResults ? this.canon.admit(u) : u,
        missing: _
      };
    }, s;
  }()
);
function Ec(s) {
  try {
    JSON.stringify(s, function(e, t) {
      if (typeof t == "string")
        throw t;
      return t;
    });
  } catch (e) {
    return e;
  }
}
function vc(s, e, t) {
  if (!e.selectionSet) {
    var r = /* @__PURE__ */ new Set([t]);
    r.forEach(function(u) {
      Ds(u) && (Q(
        !ts(u),
        10,
        cc(s, u),
        e.name.value
      ), Object.values(u).forEach(r.add, r));
    });
  }
}
var du = new I_(), Zi = /* @__PURE__ */ new WeakMap();
function We(s) {
  var e = Zi.get(s);
  return e || Zi.set(s, e = {
    vars: /* @__PURE__ */ new Set(),
    dep: L_()
  }), e;
}
function Ci(s) {
  We(s).vars.forEach(function(e) {
    return e.forgetCache(s);
  });
}
function mc(s) {
  We(s).vars.forEach(function(e) {
    return e.attachCache(s);
  });
}
function Vc(s) {
  var e = /* @__PURE__ */ new Set(), t = /* @__PURE__ */ new Set(), r = function(a) {
    if (arguments.length > 0) {
      if (s !== a) {
        s = a, e.forEach(function(h) {
          We(h).dep.dirty(r), lc(h);
        });
        var i = Array.from(t);
        t.clear(), i.forEach(function(h) {
          return h(s);
        });
      }
    } else {
      var _ = du.getValue();
      _ && (u(_), We(_).dep(r));
    }
    return s;
  };
  r.onNextChange = function(a) {
    return t.add(a), function() {
      t.delete(a);
    };
  };
  var u = r.attachCache = function(a) {
    return e.add(a), We(a).vars.add(r), r;
  };
  return r.forgetCache = function(a) {
    return e.delete(a);
  }, r;
}
function lc(s) {
  s.broadcastWatches && s.broadcastWatches();
}
var gi = /* @__PURE__ */ Object.create(null);
function pu(s) {
  var e = JSON.stringify(s);
  return gi[e] || (gi[e] = /* @__PURE__ */ Object.create(null));
}
function ki(s) {
  var e = pu(s);
  return e.keyFieldsFn || (e.keyFieldsFn = function(t, r) {
    var u = function(i, _) {
      return r.readField(_, i);
    }, a = r.keyObject = bu(s, function(i) {
      var _ = ve(
        r.storeObject,
        i,
        // Using context.readField to extract paths from context.storeObject
        // allows the extraction to see through Reference objects and respect
        // custom read functions.
        u
      );
      return _ === void 0 && t !== r.storeObject && vs.call(t, i[0]) && (_ = ve(t, i, Ff)), Q(_ !== void 0, 4, i.join("."), t), _;
    });
    return "".concat(r.typename, ":").concat(JSON.stringify(a));
  });
}
function Oi(s) {
  var e = pu(s);
  return e.keyArgsFn || (e.keyArgsFn = function(t, r) {
    var u = r.field, a = r.variables, i = r.fieldName, _ = bu(s, function(f) {
      var A = f[0], y = A.charAt(0);
      if (y === "@") {
        if (u && Rs(u.directives)) {
          var c = A.slice(1), n = u.directives.find(function(b) {
            return b.name.value === c;
          }), d = n && Rt(n, a);
          return d && ve(
            d,
            // If keyPath.length === 1, this code calls extractKeyPath with an
            // empty path, which works because it uses directiveArgs as the
            // extracted value.
            f.slice(1)
          );
        }
        return;
      }
      if (y === "$") {
        var E = A.slice(1);
        if (a && vs.call(a, E)) {
          var V = f.slice(0);
          return V[0] = E, ve(a, V);
        }
        return;
      }
      if (t)
        return ve(t, f);
    }), h = JSON.stringify(_);
    return (t || h !== "{}") && (i += ":" + h), i;
  });
}
function bu(s, e) {
  var t = new ee();
  return wf(s).reduce(function(r, u) {
    var a, i = e(u);
    if (i !== void 0) {
      for (var _ = u.length - 1; _ >= 0; --_)
        i = (a = {}, a[u[_]] = i, a);
      r = t.merge(r, i);
    }
    return r;
  }, /* @__PURE__ */ Object.create(null));
}
function wf(s) {
  var e = pu(s);
  if (!e.paths) {
    var t = e.paths = [], r = [];
    s.forEach(function(u, a) {
      ds(u) ? (wf(u).forEach(function(i) {
        return t.push(r.concat(i));
      }), r.length = 0) : (r.push(u), ds(s[a + 1]) || (t.push(r.slice(0)), r.length = 0));
    });
  }
  return e.paths;
}
function Ff(s, e) {
  return s[e];
}
function ve(s, e, t) {
  return t = t || Ff, xf(e.reduce(function r(u, a) {
    return ds(u) ? u.map(function(i) {
      return r(i, a);
    }) : u && t(u, a);
  }, s));
}
function xf(s) {
  return Ds(s) ? ds(s) ? s.map(xf) : bu(Object.keys(s).sort(), function(e) {
    return ve(s, e);
  }) : s;
}
function Nr(s) {
  return s.args !== void 0 ? s.args : s.field ? Rt(s.field, s.variables) : null;
}
var wc = function() {
}, Li = function(s, e) {
  return e.fieldName;
}, s_ = function(s, e, t) {
  var r = t.mergeObjects;
  return r(s, e);
}, e_ = function(s, e) {
  return e;
}, Fc = (
  /** @class */
  function() {
    function s(e) {
      this.config = e, this.typePolicies = /* @__PURE__ */ Object.create(null), this.toBeAdded = /* @__PURE__ */ Object.create(null), this.supertypeMap = /* @__PURE__ */ new Map(), this.fuzzySubtypes = /* @__PURE__ */ new Map(), this.rootIdsByTypename = /* @__PURE__ */ Object.create(null), this.rootTypenamesById = /* @__PURE__ */ Object.create(null), this.usingPossibleTypes = !1, this.config = p({ dataIdFromObject: bf }, e), this.cache = this.config.cache, this.setRootTypename("Query"), this.setRootTypename("Mutation"), this.setRootTypename("Subscription"), e.possibleTypes && this.addPossibleTypes(e.possibleTypes), e.typePolicies && this.addTypePolicies(e.typePolicies);
    }
    return s.prototype.identify = function(e, t) {
      var r, u = this, a = t && (t.typename || ((r = t.storeObject) === null || r === void 0 ? void 0 : r.__typename)) || e.__typename;
      if (a === this.rootTypenamesById.ROOT_QUERY)
        return ["ROOT_QUERY"];
      for (var i = t && t.storeObject || e, _ = p(p({}, t), { typename: a, storeObject: i, readField: t && t.readField || function() {
        var c = Eu(arguments, i);
        return u.readField(c, {
          store: u.cache.data,
          variables: c.variables
        });
      } }), h, f = a && this.getTypePolicy(a), A = f && f.keyFn || this.config.dataIdFromObject; A; ) {
        var y = A(p(p({}, e), i), _);
        if (ds(y))
          A = ki(y);
        else {
          h = y;
          break;
        }
      }
      return h = h ? String(h) : void 0, _.keyObject ? [h, _.keyObject] : [h];
    }, s.prototype.addTypePolicies = function(e) {
      var t = this;
      Object.keys(e).forEach(function(r) {
        var u = e[r], a = u.queryType, i = u.mutationType, _ = u.subscriptionType, h = Gs(u, ["queryType", "mutationType", "subscriptionType"]);
        a && t.setRootTypename("Query", r), i && t.setRootTypename("Mutation", r), _ && t.setRootTypename("Subscription", r), vs.call(t.toBeAdded, r) ? t.toBeAdded[r].push(h) : t.toBeAdded[r] = [h];
      });
    }, s.prototype.updateTypePolicy = function(e, t) {
      var r = this, u = this.getTypePolicy(e), a = t.keyFields, i = t.fields;
      function _(h, f) {
        h.merge = typeof f == "function" ? f : f === !0 ? s_ : f === !1 ? e_ : h.merge;
      }
      _(u, t.merge), u.keyFn = // Pass false to disable normalization for this typename.
      a === !1 ? wc : ds(a) ? ki(a) : typeof a == "function" ? a : u.keyFn, i && Object.keys(i).forEach(function(h) {
        var f = r.getFieldPolicy(e, h, !0), A = i[h];
        if (typeof A == "function")
          f.read = A;
        else {
          var y = A.keyArgs, c = A.read, n = A.merge;
          f.keyFn = // Pass false to disable argument-based differentiation of
          // field identities.
          y === !1 ? Li : ds(y) ? Oi(y) : typeof y == "function" ? y : f.keyFn, typeof c == "function" && (f.read = c), _(f, n);
        }
        f.read && f.merge && (f.keyFn = f.keyFn || Li);
      });
    }, s.prototype.setRootTypename = function(e, t) {
      t === void 0 && (t = e);
      var r = "ROOT_" + e.toUpperCase(), u = this.rootTypenamesById[r];
      t !== u && (Q(!u || u === e, 5, e), u && delete this.rootIdsByTypename[u], this.rootIdsByTypename[t] = r, this.rootTypenamesById[r] = t);
    }, s.prototype.addPossibleTypes = function(e) {
      var t = this;
      this.usingPossibleTypes = !0, Object.keys(e).forEach(function(r) {
        t.getSupertypeSet(r, !0), e[r].forEach(function(u) {
          t.getSupertypeSet(u, !0).add(r);
          var a = u.match(mf);
          (!a || a[0] !== u) && t.fuzzySubtypes.set(u, new RegExp(u));
        });
      });
    }, s.prototype.getTypePolicy = function(e) {
      var t = this;
      if (!vs.call(this.typePolicies, e)) {
        var r = this.typePolicies[e] = /* @__PURE__ */ Object.create(null);
        r.fields = /* @__PURE__ */ Object.create(null);
        var u = this.supertypeMap.get(e);
        !u && this.fuzzySubtypes.size && (u = this.getSupertypeSet(e, !0), this.fuzzySubtypes.forEach(function(i, _) {
          if (i.test(e)) {
            var h = t.supertypeMap.get(_);
            h && h.forEach(function(f) {
              return u.add(f);
            });
          }
        })), u && u.size && u.forEach(function(i) {
          var _ = t.getTypePolicy(i), h = _.fields, f = Gs(_, ["fields"]);
          Object.assign(r, f), Object.assign(r.fields, h);
        });
      }
      var a = this.toBeAdded[e];
      return a && a.length && a.splice(0).forEach(function(i) {
        t.updateTypePolicy(e, i);
      }), this.typePolicies[e];
    }, s.prototype.getFieldPolicy = function(e, t, r) {
      if (e) {
        var u = this.getTypePolicy(e).fields;
        return u[t] || r && (u[t] = /* @__PURE__ */ Object.create(null));
      }
    }, s.prototype.getSupertypeSet = function(e, t) {
      var r = this.supertypeMap.get(e);
      return !r && t && this.supertypeMap.set(e, r = /* @__PURE__ */ new Set()), r;
    }, s.prototype.fragmentMatches = function(e, t, r, u) {
      var a = this;
      if (!e.typeCondition)
        return !0;
      if (!t)
        return !1;
      var i = e.typeCondition.name.value;
      if (t === i)
        return !0;
      if (this.usingPossibleTypes && this.supertypeMap.has(i))
        for (var _ = this.getSupertypeSet(t, !0), h = [_], f = function(d) {
          var E = a.getSupertypeSet(d, !1);
          E && E.size && h.indexOf(E) < 0 && h.push(E);
        }, A = !!(r && this.fuzzySubtypes.size), y = !1, c = 0; c < h.length; ++c) {
          var n = h[c];
          if (n.has(i))
            return _.has(i) || (y && globalThis.__DEV__ !== !1 && Q.warn(6, t, i), _.add(i)), !0;
          n.forEach(f), A && // Start checking fuzzy subtypes only after exhausting all
          // non-fuzzy subtypes (after the final iteration of the loop).
          c === h.length - 1 && // We could wait to compare fragment.selectionSet to result
          // after we verify the supertype, but this check is often less
          // expensive than that search, and we will have to do the
          // comparison anyway whenever we find a potential match.
          Wr(e.selectionSet, r, u) && (A = !1, y = !0, this.fuzzySubtypes.forEach(function(d, E) {
            var V = t.match(d);
            V && V[0] === t && f(E);
          }));
        }
      return !1;
    }, s.prototype.hasKeyArgs = function(e, t) {
      var r = this.getFieldPolicy(e, t, !1);
      return !!(r && r.keyFn);
    }, s.prototype.getStoreFieldName = function(e) {
      var t = e.typename, r = e.fieldName, u = this.getFieldPolicy(t, r, !1), a, i = u && u.keyFn;
      if (i && t)
        for (var _ = {
          typename: t,
          fieldName: r,
          field: e.field || null,
          variables: e.variables
        }, h = Nr(e); i; ) {
          var f = i(h, _);
          if (ds(f))
            i = Oi(f);
          else {
            a = f || r;
            break;
          }
        }
      return a === void 0 && (a = e.field ? YA(e.field, e.variables) : W_(r, Nr(e))), a === !1 ? r : r === te(a) ? a : r + ":" + a;
    }, s.prototype.readField = function(e, t) {
      var r = e.from;
      if (r) {
        var u = e.field || e.fieldName;
        if (u) {
          if (e.typename === void 0) {
            var a = t.store.getFieldValue(r, "__typename");
            a && (e.typename = a);
          }
          var i = this.getStoreFieldName(e), _ = te(i), h = t.store.getFieldValue(r, i), f = this.getFieldPolicy(e.typename, _, !1), A = f && f.read;
          if (A) {
            var y = t_(this, r, e, t, t.store.getStorage(ts(r) ? r.__ref : r, i));
            return du.withValue(this.cache, A, [
              h,
              y
            ]);
          }
          return h;
        }
      }
    }, s.prototype.getReadFunction = function(e, t) {
      var r = this.getFieldPolicy(e, t, !1);
      return r && r.read;
    }, s.prototype.getMergeFunction = function(e, t, r) {
      var u = this.getFieldPolicy(e, t, !1), a = u && u.merge;
      return !a && r && (u = this.getTypePolicy(r), a = u && u.merge), a;
    }, s.prototype.runMergeFunction = function(e, t, r, u, a) {
      var i = r.field, _ = r.typename, h = r.merge;
      return h === s_ ? of(u.store)(e, t) : h === e_ ? t : (u.overwrite && (e = void 0), h(e, t, t_(
        this,
        // Unlike options.readField for read functions, we do not fall
        // back to the current object if no foreignObjOrRef is provided,
        // because it's not clear what the current object should be for
        // merge functions: the (possibly undefined) existing object, or
        // the incoming object? If you think your merge function needs
        // to read sibling fields in order to produce a new value for
        // the current field, you might want to rethink your strategy,
        // because that's a recipe for making merge behavior sensitive
        // to the order in which fields are written into the cache.
        // However, readField(name, ref) is useful for merge functions
        // that need to deduplicate child objects and references.
        void 0,
        {
          typename: _,
          fieldName: i.name.value,
          field: i,
          variables: u.variables
        },
        u,
        a || /* @__PURE__ */ Object.create(null)
      )));
    }, s;
  }()
);
function t_(s, e, t, r, u) {
  var a = s.getStoreFieldName(t), i = te(a), _ = t.variables || r.variables, h = r.store, f = h.toReference, A = h.canRead;
  return {
    args: Nr(t),
    field: t.field || null,
    fieldName: i,
    storeFieldName: a,
    variables: _,
    isReference: ts,
    toReference: f,
    storage: u,
    cache: s.cache,
    canRead: A,
    readField: function() {
      return s.readField(Eu(arguments, e, _), r);
    },
    mergeObjects: of(r.store)
  };
}
function Eu(s, e, t) {
  var r = s[0], u = s[1], a = s.length, i;
  return typeof r == "string" ? i = {
    fieldName: r,
    // Default to objectOrReference only when no second argument was
    // passed for the from parameter, not when undefined is explicitly
    // passed as the second argument.
    from: a > 1 ? u : e
  } : (i = p({}, r), vs.call(i, "from") || (i.from = e)), globalThis.__DEV__ !== !1 && i.from === void 0 && globalThis.__DEV__ !== !1 && Q.warn(7, v_(Array.from(s))), i.variables === void 0 && (i.variables = t), i;
}
function of(s) {
  return function(t, r) {
    if (ds(t) || ds(r))
      throw Ps(8);
    if (Ds(t) && Ds(r)) {
      var u = s.getFieldValue(t, "__typename"), a = s.getFieldValue(r, "__typename"), i = u && a && u !== a;
      if (i)
        return r;
      if (ts(t) && De(r))
        return s.merge(t.__ref, r), t;
      if (De(t) && ts(r))
        return s.merge(t, r.__ref), r;
      if (De(t) && De(r))
        return p(p({}, t), r);
    }
    return r;
  };
}
function nr(s, e, t) {
  var r = "".concat(e).concat(t), u = s.flavors.get(r);
  return u || s.flavors.set(r, u = s.clientOnly === e && s.deferred === t ? s : p(p({}, s), { clientOnly: e, deferred: t })), u;
}
var xc = (
  /** @class */
  function() {
    function s(e, t, r) {
      this.cache = e, this.reader = t, this.fragments = r;
    }
    return s.prototype.writeToStore = function(e, t) {
      var r = this, u = t.query, a = t.result, i = t.dataId, _ = t.variables, h = t.overwrite, f = ge(u), A = nc();
      _ = p(p({}, uu(f)), _);
      var y = p(p({ store: e, written: /* @__PURE__ */ Object.create(null), merge: function(n, d) {
        return A.merge(n, d);
      }, variables: _, varString: ks(_) }, Vf(u, this.fragments)), { overwrite: !!h, incomingById: /* @__PURE__ */ new Map(), clientOnly: !1, deferred: !1, flavors: /* @__PURE__ */ new Map() }), c = this.processSelectionSet({
        result: a || /* @__PURE__ */ Object.create(null),
        dataId: i,
        selectionSet: f.selectionSet,
        mergeTree: { map: /* @__PURE__ */ new Map() },
        context: y
      });
      if (!ts(c))
        throw Ps(11, a);
      return y.incomingById.forEach(function(n, d) {
        var E = n.storeObject, V = n.mergeTree, b = n.fieldNodeSet, F = pe(d);
        if (V && V.map.size) {
          var l = r.applyMerges(V, F, E, y);
          if (ts(l))
            return;
          E = l;
        }
        if (globalThis.__DEV__ !== !1 && !y.overwrite) {
          var T = /* @__PURE__ */ Object.create(null);
          b.forEach(function(z) {
            z.selectionSet && (T[z.name.value] = !0);
          });
          var $ = function(z) {
            return T[te(z)] === !0;
          }, q = function(z) {
            var U = V && V.map.get(z);
            return !!(U && U.info && U.info.merge);
          };
          Object.keys(E).forEach(function(z) {
            $(z) && !q(z) && oc(F, E, z, y.store);
          });
        }
        e.merge(d, E);
      }), e.retain(c.__ref), c;
    }, s.prototype.processSelectionSet = function(e) {
      var t = this, r = e.dataId, u = e.result, a = e.selectionSet, i = e.context, _ = e.mergeTree, h = this.cache.policies, f = /* @__PURE__ */ Object.create(null), A = r && h.rootTypenamesById[r] || Tr(u, a, i.fragmentMap) || r && i.store.get(r, "__typename");
      typeof A == "string" && (f.__typename = A);
      var y = function() {
        var l = Eu(arguments, f, i.variables);
        if (ts(l.from)) {
          var T = i.incomingById.get(l.from.__ref);
          if (T) {
            var $ = h.readField(p(p({}, l), { from: T.storeObject }), i);
            if ($ !== void 0)
              return $;
          }
        }
        return h.readField(l, i);
      }, c = /* @__PURE__ */ new Set();
      this.flattenFields(
        a,
        u,
        // This WriteContext will be the default context value for fields returned
        // by the flattenFields method, but some fields may be assigned a modified
        // context, depending on the presence of @client and other directives.
        i,
        A
      ).forEach(function(l, T) {
        var $, q = Os(T), z = u[q];
        if (c.add(T), z !== void 0) {
          var U = h.getStoreFieldName({
            typename: A,
            fieldName: T.name.value,
            field: T,
            variables: l.variables
          }), Z = r_(_, U), O = t.processFieldValue(
            z,
            T,
            // Reset context.clientOnly and context.deferred to their default
            // values before processing nested selection sets.
            T.selectionSet ? nr(l, !1, !1) : l,
            Z
          ), os = void 0;
          T.selectionSet && (ts(O) || De(O)) && (os = y("__typename", O));
          var qs = h.getMergeFunction(A, T.name.value, os);
          qs ? Z.info = {
            // TODO Check compatibility against any existing childTree.field?
            field: T,
            typename: A,
            merge: qs
          } : u_(_, U), f = l.merge(f, ($ = {}, $[U] = O, $));
        } else globalThis.__DEV__ !== !1 && !l.clientOnly && !l.deferred && !hu.added(T) && // If the field has a read function, it may be a synthetic field or
        // provide a default value, so its absence from the written data should
        // not be cause for alarm.
        !h.getReadFunction(A, T.name.value) && globalThis.__DEV__ !== !1 && Q.error(12, Os(T), u);
      });
      try {
        var n = h.identify(u, {
          typename: A,
          selectionSet: a,
          fragmentMap: i.fragmentMap,
          storeObject: f,
          readField: y
        }), d = n[0], E = n[1];
        r = r || d, E && (f = i.merge(f, E));
      } catch (l) {
        if (!r)
          throw l;
      }
      if (typeof r == "string") {
        var V = pe(r), b = i.written[r] || (i.written[r] = []);
        if (b.indexOf(a) >= 0 || (b.push(a), this.reader && this.reader.isFresh(u, V, a, i)))
          return V;
        var F = i.incomingById.get(r);
        return F ? (F.storeObject = i.merge(F.storeObject, f), F.mergeTree = Ir(F.mergeTree, _), c.forEach(function(l) {
          return F.fieldNodeSet.add(l);
        })) : i.incomingById.set(r, {
          storeObject: f,
          // Save a reference to mergeTree only if it is not empty, because
          // empty MergeTrees may be recycled by maybeRecycleChildMergeTree and
          // reused for entirely different parts of the result tree.
          mergeTree: xt(_) ? void 0 : _,
          fieldNodeSet: c
        }), V;
      }
      return f;
    }, s.prototype.processFieldValue = function(e, t, r, u) {
      var a = this;
      return !t.selectionSet || e === null ? globalThis.__DEV__ !== !1 ? ff(e) : e : ds(e) ? e.map(function(i, _) {
        var h = a.processFieldValue(i, t, r, r_(u, _));
        return u_(u, _), h;
      }) : this.processSelectionSet({
        result: e,
        selectionSet: t.selectionSet,
        context: r,
        mergeTree: u
      });
    }, s.prototype.flattenFields = function(e, t, r, u) {
      u === void 0 && (u = Tr(t, e, r.fragmentMap));
      var a = /* @__PURE__ */ new Map(), i = this.cache.policies, _ = new Fe(!1);
      return function h(f, A) {
        var y = _.lookup(
          f,
          // Because we take inheritedClientOnly and inheritedDeferred into
          // consideration here (in addition to selectionSet), it's possible for
          // the same selection set to be flattened more than once, if it appears
          // in the query with different @client and/or @directive configurations.
          A.clientOnly,
          A.deferred
        );
        y.visited || (y.visited = !0, f.selections.forEach(function(c) {
          if (Ze(c, r.variables)) {
            var n = A.clientOnly, d = A.deferred;
            if (
              // Since the presence of @client or @defer on this field can only
              // cause clientOnly or deferred to become true, we can skip the
              // forEach loop if both clientOnly and deferred are already true.
              !(n && d) && Rs(c.directives) && c.directives.forEach(function(b) {
                var F = b.name.value;
                if (F === "client" && (n = !0), F === "defer") {
                  var l = Rt(b, r.variables);
                  (!l || l.if !== !1) && (d = !0);
                }
              }), Ls(c)
            ) {
              var E = a.get(c);
              E && (n = n && E.clientOnly, d = d && E.deferred), a.set(c, nr(r, n, d));
            } else {
              var V = Gt(c, r.lookupFragment);
              if (!V && c.kind === G.FRAGMENT_SPREAD)
                throw Ps(13, c.name.value);
              V && i.fragmentMatches(V, u, t, r.variables) && h(V.selectionSet, nr(r, n, d));
            }
          }
        }));
      }(e, r), a;
    }, s.prototype.applyMerges = function(e, t, r, u, a) {
      var i, _ = this;
      if (e.map.size && !ts(r)) {
        var h = (
          // Items in the same position in different arrays are not
          // necessarily related to each other, so when incoming is an array
          // we process its elements as if there was no existing data.
          !ds(r) && // Likewise, existing must be either a Reference or a StoreObject
          // in order for its fields to be safe to merge with the fields of
          // the incoming object.
          (ts(t) || De(t)) ? t : void 0
        ), f = r;
        h && !a && (a = [ts(h) ? h.__ref : h]);
        var A, y = function(c, n) {
          return ds(c) ? typeof n == "number" ? c[n] : void 0 : u.store.getFieldValue(c, String(n));
        };
        e.map.forEach(function(c, n) {
          var d = y(h, n), E = y(f, n);
          if (E !== void 0) {
            a && a.push(n);
            var V = _.applyMerges(c, d, E, u, a);
            V !== E && (A = A || /* @__PURE__ */ new Map(), A.set(n, V)), a && Q(a.pop() === n);
          }
        }), A && (r = ds(f) ? f.slice(0) : p({}, f), A.forEach(function(c, n) {
          r[n] = c;
        }));
      }
      return e.info ? this.cache.policies.runMergeFunction(t, r, e.info, u, a && (i = u.store).getStorage.apply(i, a)) : r;
    }, s;
  }()
), Mf = [];
function r_(s, e) {
  var t = s.map;
  return t.has(e) || t.set(e, Mf.pop() || { map: /* @__PURE__ */ new Map() }), t.get(e);
}
function Ir(s, e) {
  if (s === e || !e || xt(e))
    return s;
  if (!s || xt(s))
    return e;
  var t = s.info && e.info ? p(p({}, s.info), e.info) : s.info || e.info, r = s.map.size && e.map.size, u = r ? /* @__PURE__ */ new Map() : s.map.size ? s.map : e.map, a = { info: t, map: u };
  if (r) {
    var i = new Set(e.map.keys());
    s.map.forEach(function(_, h) {
      a.map.set(h, Ir(_, e.map.get(h))), i.delete(h);
    }), i.forEach(function(_) {
      a.map.set(_, Ir(e.map.get(_), s.map.get(_)));
    });
  }
  return a;
}
function xt(s) {
  return !s || !(s.info || s.map.size);
}
function u_(s, e) {
  var t = s.map, r = t.get(e);
  r && xt(r) && (Mf.push(r), t.delete(e));
}
var a_ = /* @__PURE__ */ new Set();
function oc(s, e, t, r) {
  var u = function(y) {
    var c = r.getFieldValue(y, t);
    return typeof c == "object" && c;
  }, a = u(s);
  if (a) {
    var i = u(e);
    if (i && !ts(a) && !us(a, i) && !Object.keys(a).every(function(y) {
      return r.getFieldValue(i, y) !== void 0;
    })) {
      var _ = r.getFieldValue(s, "__typename") || r.getFieldValue(e, "__typename"), h = te(t), f = "".concat(_, ".").concat(h);
      if (!a_.has(f)) {
        a_.add(f);
        var A = [];
        !ds(a) && !ds(i) && [a, i].forEach(function(y) {
          var c = r.getFieldValue(y, "__typename");
          typeof c == "string" && !A.includes(c) && A.push(c);
        }), globalThis.__DEV__ !== !1 && Q.warn(14, h, _, A.length ? "either ensure all objects of type " + A.join(" and ") + " have an ID or a custom merge function, or " : "", f, p({}, a), p({}, i));
      }
    }
  }
}
var vu = (
  /** @class */
  function(s) {
    zs(e, s);
    function e(t) {
      t === void 0 && (t = {});
      var r = s.call(this) || this;
      return r.watches = /* @__PURE__ */ new Set(), r.addTypenameTransform = new sf(hu), r.assumeImmutableResults = !0, r.makeVar = Vc, r.txCount = 0, r.config = yc(t), r.addTypename = !!r.config.addTypename, r.policies = new Fc({
        cache: r,
        dataIdFromObject: r.config.dataIdFromObject,
        possibleTypes: r.config.possibleTypes,
        typePolicies: r.config.typePolicies
      }), r.init(), r;
    }
    return e.prototype.init = function() {
      var t = this.data = new Ke.Root({
        policies: this.policies,
        resultCaching: this.config.resultCaching
      });
      this.optimisticData = t.stump, this.resetResultCache();
    }, e.prototype.resetResultCache = function(t) {
      var r = this, u = this.storeReader, a = this.config.fragments;
      this.storeWriter = new xc(this, this.storeReader = new bc({
        cache: this,
        addTypename: this.addTypename,
        resultCacheMaxSize: this.config.resultCacheMaxSize,
        canonizeResults: vf(this.config),
        canon: t ? void 0 : u && u.canon,
        fragments: a
      }), a), this.maybeBroadcastWatch = He(function(i, _) {
        return r.broadcastWatch(i, _);
      }, {
        max: this.config.resultCacheMaxSize || Ns["inMemoryCache.maybeBroadcastWatch"] || 5e3,
        makeCacheKey: function(i) {
          var _ = i.optimistic ? r.optimisticData : r.data;
          if (ze(_)) {
            var h = i.optimistic, f = i.id, A = i.variables;
            return _.makeCacheKey(
              i.query,
              // Different watches can have the same query, optimistic
              // status, rootId, and variables, but if their callbacks are
              // different, the (identical) result needs to be delivered to
              // each distinct callback. The easiest way to achieve that
              // separation is to include c.callback in the cache key for
              // maybeBroadcastWatch calls. See issue #5733.
              i.callback,
              ks({ optimistic: h, id: f, variables: A })
            );
          }
        }
      }), (/* @__PURE__ */ new Set([this.data.group, this.optimisticData.group])).forEach(function(i) {
        return i.resetCaching();
      });
    }, e.prototype.restore = function(t) {
      return this.init(), t && this.data.replace(t), this;
    }, e.prototype.extract = function(t) {
      return t === void 0 && (t = !1), (t ? this.optimisticData : this.data).extract();
    }, e.prototype.read = function(t) {
      var r = t.returnPartialData, u = r === void 0 ? !1 : r;
      try {
        return this.storeReader.diffQueryAgainstStore(p(p({}, t), { store: t.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: u })).result || null;
      } catch (a) {
        if (a instanceof pf)
          return null;
        throw a;
      }
    }, e.prototype.write = function(t) {
      try {
        return ++this.txCount, this.storeWriter.writeToStore(this.data, t);
      } finally {
        !--this.txCount && t.broadcast !== !1 && this.broadcastWatches();
      }
    }, e.prototype.modify = function(t) {
      if (vs.call(t, "id") && !t.id)
        return !1;
      var r = t.optimistic ? this.optimisticData : this.data;
      try {
        return ++this.txCount, r.modify(t.id || "ROOT_QUERY", t.fields);
      } finally {
        !--this.txCount && t.broadcast !== !1 && this.broadcastWatches();
      }
    }, e.prototype.diff = function(t) {
      return this.storeReader.diffQueryAgainstStore(p(p({}, t), { store: t.optimistic ? this.optimisticData : this.data, rootId: t.id || "ROOT_QUERY", config: this.config }));
    }, e.prototype.watch = function(t) {
      var r = this;
      return this.watches.size || mc(this), this.watches.add(t), t.immediate && this.maybeBroadcastWatch(t), function() {
        r.watches.delete(t) && !r.watches.size && Ci(r), r.maybeBroadcastWatch.forget(t);
      };
    }, e.prototype.gc = function(t) {
      var r;
      ks.reset(), zt.reset(), this.addTypenameTransform.resetCache(), (r = this.config.fragments) === null || r === void 0 || r.resetCaches();
      var u = this.optimisticData.gc();
      return t && !this.txCount && (t.resetResultCache ? this.resetResultCache(t.resetResultIdentities) : t.resetResultIdentities && this.storeReader.resetCanon()), u;
    }, e.prototype.retain = function(t, r) {
      return (r ? this.optimisticData : this.data).retain(t);
    }, e.prototype.release = function(t, r) {
      return (r ? this.optimisticData : this.data).release(t);
    }, e.prototype.identify = function(t) {
      if (ts(t))
        return t.__ref;
      try {
        return this.policies.identify(t)[0];
      } catch (r) {
        globalThis.__DEV__ !== !1 && Q.warn(r);
      }
    }, e.prototype.evict = function(t) {
      if (!t.id) {
        if (vs.call(t, "id"))
          return !1;
        t = p(p({}, t), { id: "ROOT_QUERY" });
      }
      try {
        return ++this.txCount, this.optimisticData.evict(t, this.data);
      } finally {
        !--this.txCount && t.broadcast !== !1 && this.broadcastWatches();
      }
    }, e.prototype.reset = function(t) {
      var r = this;
      return this.init(), ks.reset(), t && t.discardWatches ? (this.watches.forEach(function(u) {
        return r.maybeBroadcastWatch.forget(u);
      }), this.watches.clear(), Ci(this)) : this.broadcastWatches(), Promise.resolve();
    }, e.prototype.removeOptimistic = function(t) {
      var r = this.optimisticData.removeLayer(t);
      r !== this.optimisticData && (this.optimisticData = r, this.broadcastWatches());
    }, e.prototype.batch = function(t) {
      var r = this, u = t.update, a = t.optimistic, i = a === void 0 ? !0 : a, _ = t.removeOptimistic, h = t.onWatchUpdated, f, A = function(c) {
        var n = r, d = n.data, E = n.optimisticData;
        ++r.txCount, c && (r.data = r.optimisticData = c);
        try {
          return f = u(r);
        } finally {
          --r.txCount, r.data = d, r.optimisticData = E;
        }
      }, y = /* @__PURE__ */ new Set();
      return h && !this.txCount && this.broadcastWatches(p(p({}, t), { onWatchUpdated: function(c) {
        return y.add(c), !1;
      } })), typeof i == "string" ? this.optimisticData = this.optimisticData.addLayer(i, A) : i === !1 ? A(this.data) : A(), typeof _ == "string" && (this.optimisticData = this.optimisticData.removeLayer(_)), h && y.size ? (this.broadcastWatches(p(p({}, t), { onWatchUpdated: function(c, n) {
        var d = h.call(this, c, n);
        return d !== !1 && y.delete(c), d;
      } })), y.size && y.forEach(function(c) {
        return r.maybeBroadcastWatch.dirty(c);
      })) : this.broadcastWatches(t), f;
    }, e.prototype.performTransaction = function(t, r) {
      return this.batch({
        update: t,
        optimistic: r || r !== null
      });
    }, e.prototype.transformDocument = function(t) {
      return this.addTypenameToDocument(this.addFragmentsToDocument(t));
    }, e.prototype.broadcastWatches = function(t) {
      var r = this;
      this.txCount || this.watches.forEach(function(u) {
        return r.maybeBroadcastWatch(u, t);
      });
    }, e.prototype.addFragmentsToDocument = function(t) {
      var r = this.config.fragments;
      return r ? r.transform(t) : t;
    }, e.prototype.addTypenameToDocument = function(t) {
      return this.addTypename ? this.addTypenameTransform.transformDocument(t) : t;
    }, e.prototype.broadcastWatch = function(t, r) {
      var u = t.lastDiff, a = this.diff(t);
      r && (t.optimistic && typeof r.optimistic == "string" && (a.fromOptimisticTransaction = !0), r.onWatchUpdated && r.onWatchUpdated.call(this, t, a, u) === !1) || (!u || !us(u.result, a.result)) && t.callback(t.lastDiff = a, u);
    }, e;
  }(df)
);
globalThis.__DEV__ !== !1 && (vu.prototype.getMemoryInternals = oA);
var es;
(function(s) {
  s[s.loading = 1] = "loading", s[s.setVariables = 2] = "setVariables", s[s.fetchMore = 3] = "fetchMore", s[s.refetch = 4] = "refetch", s[s.poll = 6] = "poll", s[s.ready = 7] = "ready", s[s.error = 8] = "error";
})(es || (es = {}));
function Xe(s) {
  return s ? s < 7 : !1;
}
var i_ = Object.assign, Mc = Object.hasOwnProperty, Jr = (
  /** @class */
  function(s) {
    zs(e, s);
    function e(t) {
      var r = t.queryManager, u = t.queryInfo, a = t.options, i = s.call(this, function(V) {
        try {
          var b = V._subscription._observer;
          b && !b.error && (b.error = $c);
        } catch {
        }
        var F = !i.observers.size;
        i.observers.add(V);
        var l = i.last;
        return l && l.error ? V.error && V.error(l.error) : l && l.result && V.next && V.next(l.result), F && i.reobserve().catch(function() {
        }), function() {
          i.observers.delete(V) && !i.observers.size && i.tearDownQuery();
        };
      }) || this;
      i.observers = /* @__PURE__ */ new Set(), i.subscriptions = /* @__PURE__ */ new Set(), i.queryInfo = u, i.queryManager = r, i.waitForOwnResult = Dr(a.fetchPolicy), i.isTornDown = !1, i.subscribeToMore = i.subscribeToMore.bind(i);
      var _ = r.defaultOptions.watchQuery, h = _ === void 0 ? {} : _, f = h.fetchPolicy, A = f === void 0 ? "cache-first" : f, y = a.fetchPolicy, c = y === void 0 ? A : y, n = a.initialFetchPolicy, d = n === void 0 ? c === "standby" ? A : c : n;
      i.options = p(p({}, a), {
        // Remember the initial options.fetchPolicy so we can revert back to this
        // policy when variables change. This information can also be specified
        // (or overridden) by providing options.initialFetchPolicy explicitly.
        initialFetchPolicy: d,
        // This ensures this.options.fetchPolicy always has a string value, in
        // case options.fetchPolicy was not provided.
        fetchPolicy: c
      }), i.queryId = u.queryId || r.generateQueryId();
      var E = ge(i.query);
      return i.queryName = E && E.name && E.name.value, i;
    }
    return Object.defineProperty(e.prototype, "query", {
      // The `query` computed property will always reflect the document transformed
      // by the last run query. `this.options.query` will always reflect the raw
      // untransformed query to ensure document transforms with runtime conditionals
      // are run on the original document.
      get: function() {
        return this.lastQuery || this.options.query;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "variables", {
      // Computed shorthand for this.options.variables, preserved for
      // backwards compatibility.
      /**
       * An object containing the variables that were provided for the query.
       */
      get: function() {
        return this.options.variables;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.result = function() {
      var t = this;
      return new Promise(function(r, u) {
        var a = {
          next: function(_) {
            r(_), t.observers.delete(a), t.observers.size || t.queryManager.removeQuery(t.queryId), setTimeout(function() {
              i.unsubscribe();
            }, 0);
          },
          error: u
        }, i = t.subscribe(a);
      });
    }, e.prototype.resetDiff = function() {
      this.queryInfo.resetDiff();
    }, e.prototype.getCurrentResult = function(t) {
      t === void 0 && (t = !0);
      var r = this.getLastResult(!0), u = this.queryInfo.networkStatus || r && r.networkStatus || es.ready, a = p(p({}, r), { loading: Xe(u), networkStatus: u }), i = this.options.fetchPolicy, _ = i === void 0 ? "cache-first" : i;
      if (
        // These fetch policies should never deliver data from the cache, unless
        // redelivering a previously delivered result.
        !(Dr(_) || // If this.options.query has @client(always: true) fields, we cannot
        // trust diff.result, since it was read from the cache without running
        // local resolvers (and it's too late to run resolvers now, since we must
        // return a result synchronously).
        this.queryManager.getDocumentInfo(this.query).hasForcedResolvers)
      ) if (this.waitForOwnResult)
        this.queryInfo.updateWatch();
      else {
        var h = this.queryInfo.getDiff();
        (h.complete || this.options.returnPartialData) && (a.data = h.result), us(a.data, {}) && (a.data = void 0), h.complete ? (delete a.partial, h.complete && a.networkStatus === es.loading && (_ === "cache-first" || _ === "cache-only") && (a.networkStatus = es.ready, a.loading = !1)) : a.partial = !0, globalThis.__DEV__ !== !1 && !h.complete && !this.options.partialRefetch && !a.loading && !a.data && !a.error && Tf(h.missing);
      }
      return t && this.updateLastResult(a), a;
    }, e.prototype.isDifferentFromLastResult = function(t, r) {
      if (!this.last)
        return !0;
      var u = this.queryManager.getDocumentInfo(this.query).hasNonreactiveDirective ? !Df(this.query, this.last.result, t, this.variables) : !us(this.last.result, t);
      return u || r && !us(this.last.variables, r);
    }, e.prototype.getLast = function(t, r) {
      var u = this.last;
      if (u && u[t] && (!r || us(u.variables, this.variables)))
        return u[t];
    }, e.prototype.getLastResult = function(t) {
      return this.getLast("result", t);
    }, e.prototype.getLastError = function(t) {
      return this.getLast("error", t);
    }, e.prototype.resetLastResults = function() {
      delete this.last, this.isTornDown = !1;
    }, e.prototype.resetQueryStoreErrors = function() {
      this.queryManager.resetErrors(this.queryId);
    }, e.prototype.refetch = function(t) {
      var r, u = {
        // Always disable polling for refetches.
        pollInterval: 0
      }, a = this.options.fetchPolicy;
      if (a === "cache-and-network" ? u.fetchPolicy = a : a === "no-cache" ? u.fetchPolicy = "no-cache" : u.fetchPolicy = "network-only", globalThis.__DEV__ !== !1 && t && Mc.call(t, "variables")) {
        var i = N_(this.query), _ = i.variableDefinitions;
        (!_ || !_.some(function(h) {
          return h.variable.name.value === "variables";
        })) && globalThis.__DEV__ !== !1 && Q.warn(
          20,
          t,
          ((r = i.name) === null || r === void 0 ? void 0 : r.value) || i
        );
      }
      return t && !us(this.options.variables, t) && (u.variables = this.options.variables = p(p({}, this.options.variables), t)), this.queryInfo.resetLastWrite(), this.reobserve(u, es.refetch);
    }, e.prototype.fetchMore = function(t) {
      var r = this, u = p(p({}, t.query ? t : p(p(p(p({}, this.options), { query: this.options.query }), t), { variables: p(p({}, this.options.variables), t.variables) })), {
        // The fetchMore request goes immediately to the network and does
        // not automatically write its result to the cache (hence no-cache
        // instead of network-only), because we allow the caller of
        // fetchMore to provide an updateQuery callback that determines how
        // the data gets written to the cache.
        fetchPolicy: "no-cache"
      });
      u.query = this.transformDocument(u.query);
      var a = this.queryManager.generateQueryId();
      this.lastQuery = t.query ? this.transformDocument(this.options.query) : u.query;
      var i = this.queryInfo, _ = i.networkStatus;
      i.networkStatus = es.fetchMore, u.notifyOnNetworkStatusChange && this.observe();
      var h = /* @__PURE__ */ new Set(), f = t == null ? void 0 : t.updateQuery, A = this.options.fetchPolicy !== "no-cache";
      return A || Q(f, 21), this.queryManager.fetchQuery(a, u, es.fetchMore).then(function(y) {
        if (r.queryManager.removeQuery(a), i.networkStatus === es.fetchMore && (i.networkStatus = _), A)
          r.queryManager.cache.batch({
            update: function(d) {
              var E = t.updateQuery;
              E ? d.updateQuery({
                query: r.query,
                variables: r.variables,
                returnPartialData: !0,
                optimistic: !1
              }, function(V) {
                return E(V, {
                  fetchMoreResult: y.data,
                  variables: u.variables
                });
              }) : d.writeQuery({
                query: u.query,
                variables: u.variables,
                data: y.data
              });
            },
            onWatchUpdated: function(d) {
              h.add(d.query);
            }
          });
        else {
          var c = r.getLast("result"), n = f(c.data, {
            fetchMoreResult: y.data,
            variables: u.variables
          });
          r.reportResult(p(p({}, c), { data: n }), r.variables);
        }
        return y;
      }).finally(function() {
        A && !h.has(r.query) && $f(r);
      });
    }, e.prototype.subscribeToMore = function(t) {
      var r = this, u = this.queryManager.startGraphQLSubscription({
        query: t.document,
        variables: t.variables,
        context: t.context
      }).subscribe({
        next: function(a) {
          var i = t.updateQuery;
          i && r.updateQuery(function(_, h) {
            var f = h.variables;
            return i(_, {
              subscriptionData: a,
              variables: f
            });
          });
        },
        error: function(a) {
          if (t.onError) {
            t.onError(a);
            return;
          }
          globalThis.__DEV__ !== !1 && Q.error(22, a);
        }
      });
      return this.subscriptions.add(u), function() {
        r.subscriptions.delete(u) && u.unsubscribe();
      };
    }, e.prototype.setOptions = function(t) {
      return this.reobserve(t);
    }, e.prototype.silentSetOptions = function(t) {
      var r = _e(this.options, t || {});
      i_(this.options, r);
    }, e.prototype.setVariables = function(t) {
      return us(this.variables, t) ? this.observers.size ? this.result() : Promise.resolve() : (this.options.variables = t, this.observers.size ? this.reobserve({
        // Reset options.fetchPolicy to its original value.
        fetchPolicy: this.options.initialFetchPolicy,
        variables: t
      }, es.setVariables) : Promise.resolve());
    }, e.prototype.updateQuery = function(t) {
      var r = this.queryManager, u = r.cache.diff({
        query: this.options.query,
        variables: this.variables,
        returnPartialData: !0,
        optimistic: !1
      }).result, a = t(u, {
        variables: this.variables
      });
      a && (r.cache.writeQuery({
        query: this.options.query,
        data: a,
        variables: this.variables
      }), r.broadcastQueries());
    }, e.prototype.startPolling = function(t) {
      this.options.pollInterval = t, this.updatePolling();
    }, e.prototype.stopPolling = function() {
      this.options.pollInterval = 0, this.updatePolling();
    }, e.prototype.applyNextFetchPolicy = function(t, r) {
      if (r.nextFetchPolicy) {
        var u = r.fetchPolicy, a = u === void 0 ? "cache-first" : u, i = r.initialFetchPolicy, _ = i === void 0 ? a : i;
        a === "standby" || (typeof r.nextFetchPolicy == "function" ? r.fetchPolicy = r.nextFetchPolicy(a, {
          reason: t,
          options: r,
          observable: this,
          initialFetchPolicy: _
        }) : t === "variables-changed" ? r.fetchPolicy = _ : r.fetchPolicy = r.nextFetchPolicy);
      }
      return r.fetchPolicy;
    }, e.prototype.fetch = function(t, r, u) {
      return this.queryManager.setObservableQuery(this), this.queryManager.fetchConcastWithInfo(this.queryId, t, r, u);
    }, e.prototype.updatePolling = function() {
      var t = this;
      if (!this.queryManager.ssrMode) {
        var r = this, u = r.pollingInfo, a = r.options.pollInterval;
        if (!a || !this.hasObservers()) {
          u && (clearTimeout(u.timeout), delete this.pollingInfo);
          return;
        }
        if (!(u && u.interval === a)) {
          Q(a, 23);
          var i = u || (this.pollingInfo = {});
          i.interval = a;
          var _ = function() {
            var f, A;
            t.pollingInfo && (!Xe(t.queryInfo.networkStatus) && !(!((A = (f = t.options).skipPollAttempt) === null || A === void 0) && A.call(f)) ? t.reobserve({
              // Most fetchPolicy options don't make sense to use in a polling context, as
              // users wouldn't want to be polling the cache directly. However, network-only and
              // no-cache are both useful for when the user wants to control whether or not the
              // polled results are written to the cache.
              fetchPolicy: t.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
            }, es.poll).then(h, h) : h());
          }, h = function() {
            var f = t.pollingInfo;
            f && (clearTimeout(f.timeout), f.timeout = setTimeout(_, f.interval));
          };
          h();
        }
      }
    }, e.prototype.updateLastResult = function(t, r) {
      r === void 0 && (r = this.variables);
      var u = this.getLastError();
      return u && this.last && !us(r, this.last.variables) && (u = void 0), this.last = p({ result: this.queryManager.assumeImmutableResults ? t : ff(t), variables: r }, u ? { error: u } : null);
    }, e.prototype.reobserveAsConcast = function(t, r) {
      var u = this;
      this.isTornDown = !1;
      var a = (
        // Refetching uses a disposable Concast to allow refetches using different
        // options/variables, without permanently altering the options of the
        // original ObservableQuery.
        r === es.refetch || // The fetchMore method does not actually call the reobserve method, but,
        // if it did, it would definitely use a disposable Concast.
        r === es.fetchMore || // Polling uses a disposable Concast so the polling options (which force
        // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
        r === es.poll
      ), i = this.options.variables, _ = this.options.fetchPolicy, h = _e(this.options, t || {}), f = a ? (
        // Disposable Concast fetches receive a shallow copy of this.options
        // (merged with newOptions), leaving this.options unmodified.
        h
      ) : i_(this.options, h), A = this.transformDocument(f.query);
      this.lastQuery = A, a || (this.updatePolling(), t && t.variables && !us(t.variables, i) && // Don't mess with the fetchPolicy if it's currently "standby".
      f.fetchPolicy !== "standby" && // If we're changing the fetchPolicy anyway, don't try to change it here
      // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
      (f.fetchPolicy === _ || // A `nextFetchPolicy` function has even higher priority, though,
      // so in that case `applyNextFetchPolicy` must be called.
      typeof f.nextFetchPolicy == "function") && (this.applyNextFetchPolicy("variables-changed", f), r === void 0 && (r = es.setVariables))), this.waitForOwnResult && (this.waitForOwnResult = Dr(f.fetchPolicy));
      var y = function() {
        u.concast === d && (u.waitForOwnResult = !1);
      }, c = f.variables && p({}, f.variables), n = this.fetch(f, r, A), d = n.concast, E = n.fromLink, V = {
        next: function(b) {
          us(u.variables, c) && (y(), u.reportResult(b, c));
        },
        error: function(b) {
          us(u.variables, c) && (yf(b) || (b = new Ys({ networkError: b })), y(), u.reportError(b, c));
        }
      };
      return !a && (E || !this.concast) && (this.concast && this.observer && this.concast.removeObserver(this.observer), this.concast = d, this.observer = V), d.addObserver(V), d;
    }, e.prototype.reobserve = function(t, r) {
      return this.reobserveAsConcast(t, r).promise;
    }, e.prototype.resubscribeAfterError = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      var u = this.last;
      this.resetLastResults();
      var a = this.subscribe.apply(this, t);
      return this.last = u, a;
    }, e.prototype.observe = function() {
      this.reportResult(
        // Passing false is important so that this.getCurrentResult doesn't
        // save the fetchMore result as this.lastResult, causing it to be
        // ignored due to the this.isDifferentFromLastResult check in
        // this.reportResult.
        this.getCurrentResult(!1),
        this.variables
      );
    }, e.prototype.reportResult = function(t, r) {
      var u = this.getLastError(), a = this.isDifferentFromLastResult(t, r);
      (u || !t.partial || this.options.returnPartialData) && this.updateLastResult(t, r), (u || a) && Qe(this.observers, "next", t);
    }, e.prototype.reportError = function(t, r) {
      var u = p(p({}, this.getLastResult()), { error: t, errors: t.graphQLErrors, networkStatus: es.error, loading: !1 });
      this.updateLastResult(u, r), Qe(this.observers, "error", this.last.error = t);
    }, e.prototype.hasObservers = function() {
      return this.observers.size > 0;
    }, e.prototype.tearDownQuery = function() {
      this.isTornDown || (this.concast && this.observer && (this.concast.removeObserver(this.observer), delete this.concast, delete this.observer), this.stopPolling(), this.subscriptions.forEach(function(t) {
        return t.unsubscribe();
      }), this.subscriptions.clear(), this.queryManager.stopQuery(this.queryId), this.observers.clear(), this.isTornDown = !0);
    }, e.prototype.transformDocument = function(t) {
      return this.queryManager.transform(t);
    }, e;
  }(rs)
);
hf(Jr);
function $f(s) {
  var e = s.options, t = e.fetchPolicy, r = e.nextFetchPolicy;
  return t === "cache-and-network" || t === "network-only" ? s.reobserve({
    fetchPolicy: "cache-first",
    // Use a temporary nextFetchPolicy function that replaces itself with the
    // previous nextFetchPolicy value and returns the original fetchPolicy.
    nextFetchPolicy: function(u, a) {
      return this.nextFetchPolicy = r, typeof this.nextFetchPolicy == "function" ? this.nextFetchPolicy(u, a) : t;
    }
  }) : s.reobserve();
}
function $c(s) {
  globalThis.__DEV__ !== !1 && Q.error(24, s.message, s.stack);
}
function Tf(s) {
  globalThis.__DEV__ !== !1 && s && globalThis.__DEV__ !== !1 && Q.debug(25, s);
}
function Dr(s) {
  return s === "network-only" || s === "no-cache" || s === "standby";
}
var de = new (xe ? WeakMap : Map)();
function dr(s, e) {
  var t = s[e];
  typeof t == "function" && (s[e] = function() {
    return de.set(
      s,
      // The %1e15 allows the count to wrap around to 0 safely every
      // quadrillion evictions, so there's no risk of overflow. To be
      // clear, this is more of a pedantic principle than something
      // that matters in any conceivable practical scenario.
      (de.get(s) + 1) % 1e15
    ), t.apply(this, arguments);
  });
}
function __(s) {
  s.notifyTimeout && (clearTimeout(s.notifyTimeout), s.notifyTimeout = void 0);
}
var pr = (
  /** @class */
  function() {
    function s(e, t) {
      t === void 0 && (t = e.generateQueryId()), this.queryId = t, this.listeners = /* @__PURE__ */ new Set(), this.document = null, this.lastRequestId = 1, this.stopped = !1, this.dirty = !1, this.observableQuery = null;
      var r = this.cache = e.cache;
      de.has(r) || (de.set(r, 0), dr(r, "evict"), dr(r, "modify"), dr(r, "reset"));
    }
    return s.prototype.init = function(e) {
      var t = e.networkStatus || es.loading;
      return this.variables && this.networkStatus !== es.loading && !us(this.variables, e.variables) && (t = es.setVariables), us(e.variables, this.variables) || (this.lastDiff = void 0), Object.assign(this, {
        document: e.document,
        variables: e.variables,
        networkError: null,
        graphQLErrors: this.graphQLErrors || [],
        networkStatus: t
      }), e.observableQuery && this.setObservableQuery(e.observableQuery), e.lastRequestId && (this.lastRequestId = e.lastRequestId), this;
    }, s.prototype.reset = function() {
      __(this), this.dirty = !1;
    }, s.prototype.resetDiff = function() {
      this.lastDiff = void 0;
    }, s.prototype.getDiff = function() {
      var e = this.getDiffOptions();
      if (this.lastDiff && us(e, this.lastDiff.options))
        return this.lastDiff.diff;
      this.updateWatch(this.variables);
      var t = this.observableQuery;
      if (t && t.options.fetchPolicy === "no-cache")
        return { complete: !1 };
      var r = this.cache.diff(e);
      return this.updateLastDiff(r, e), r;
    }, s.prototype.updateLastDiff = function(e, t) {
      this.lastDiff = e ? {
        diff: e,
        options: t || this.getDiffOptions()
      } : void 0;
    }, s.prototype.getDiffOptions = function(e) {
      var t;
      return e === void 0 && (e = this.variables), {
        query: this.document,
        variables: e,
        returnPartialData: !0,
        optimistic: !0,
        canonizeResults: (t = this.observableQuery) === null || t === void 0 ? void 0 : t.options.canonizeResults
      };
    }, s.prototype.setDiff = function(e) {
      var t = this, r, u = this.lastDiff && this.lastDiff.diff;
      e && !e.complete && (!((r = this.observableQuery) === null || r === void 0) && r.getLastError()) || (this.updateLastDiff(e), !this.dirty && !us(u && u.result, e && e.result) && (this.dirty = !0, this.notifyTimeout || (this.notifyTimeout = setTimeout(function() {
        return t.notify();
      }, 0))));
    }, s.prototype.setObservableQuery = function(e) {
      var t = this;
      e !== this.observableQuery && (this.oqListener && this.listeners.delete(this.oqListener), this.observableQuery = e, e ? (e.queryInfo = this, this.listeners.add(this.oqListener = function() {
        var r = t.getDiff();
        r.fromOptimisticTransaction ? e.observe() : $f(e);
      })) : delete this.oqListener);
    }, s.prototype.notify = function() {
      var e = this;
      __(this), this.shouldNotify() && this.listeners.forEach(function(t) {
        return t(e);
      }), this.dirty = !1;
    }, s.prototype.shouldNotify = function() {
      if (!this.dirty || !this.listeners.size)
        return !1;
      if (Xe(this.networkStatus) && this.observableQuery) {
        var e = this.observableQuery.options.fetchPolicy;
        if (e !== "cache-only" && e !== "cache-and-network")
          return !1;
      }
      return !0;
    }, s.prototype.stop = function() {
      if (!this.stopped) {
        this.stopped = !0, this.reset(), this.cancel(), this.cancel = s.prototype.cancel;
        var e = this.observableQuery;
        e && e.stopPolling();
      }
    }, s.prototype.cancel = function() {
    }, s.prototype.updateWatch = function(e) {
      var t = this;
      e === void 0 && (e = this.variables);
      var r = this.observableQuery;
      if (!(r && r.options.fetchPolicy === "no-cache")) {
        var u = p(p({}, this.getDiffOptions(e)), { watcher: this, callback: function(a) {
          return t.setDiff(a);
        } });
        (!this.lastWatch || !us(u, this.lastWatch)) && (this.cancel(), this.cancel = this.cache.watch(this.lastWatch = u));
      }
    }, s.prototype.resetLastWrite = function() {
      this.lastWrite = void 0;
    }, s.prototype.shouldWrite = function(e, t) {
      var r = this.lastWrite;
      return !(r && // If cache.evict has been called since the last time we wrote this
      // data into the cache, there's a chance writing this result into
      // the cache will repair what was evicted.
      r.dmCount === de.get(this.cache) && us(t, r.variables) && us(e.data, r.result.data));
    }, s.prototype.markResult = function(e, t, r, u) {
      var a = this, i = new ee(), _ = Rs(e.errors) ? e.errors.slice(0) : [];
      if (this.reset(), "incremental" in e && Rs(e.incremental)) {
        var h = Sf(this.getDiff().result, e);
        e.data = h;
      } else if ("hasNext" in e && e.hasNext) {
        var f = this.getDiff();
        e.data = i.merge(f.result, e.data);
      }
      this.graphQLErrors = _, r.fetchPolicy === "no-cache" ? this.updateLastDiff({ result: e.data, complete: !0 }, this.getDiffOptions(r.variables)) : u !== 0 && (Hr(e, r.errorPolicy) ? this.cache.performTransaction(function(A) {
        if (a.shouldWrite(e, r.variables))
          A.writeQuery({
            query: t,
            data: e.data,
            variables: r.variables,
            overwrite: u === 1
          }), a.lastWrite = {
            result: e,
            variables: r.variables,
            dmCount: de.get(a.cache)
          };
        else if (a.lastDiff && a.lastDiff.diff.complete) {
          e.data = a.lastDiff.diff.result;
          return;
        }
        var y = a.getDiffOptions(r.variables), c = A.diff(y);
        !a.stopped && us(a.variables, r.variables) && a.updateWatch(r.variables), a.updateLastDiff(c, y), c.complete && (e.data = c.result);
      }) : this.lastWrite = void 0);
    }, s.prototype.markReady = function() {
      return this.networkError = null, this.networkStatus = es.ready;
    }, s.prototype.markError = function(e) {
      return this.networkStatus = es.error, this.lastWrite = void 0, this.reset(), e.graphQLErrors && (this.graphQLErrors = e.graphQLErrors), e.networkError && (this.networkError = e.networkError), e;
    }, s;
  }()
);
function Hr(s, e) {
  e === void 0 && (e = "none");
  var t = e === "ignore" || e === "all", r = !bt(s);
  return !r && t && s.data && (r = !0), r;
}
var Tc = Object.prototype.hasOwnProperty, f_ = /* @__PURE__ */ Object.create(null), Pc = (
  /** @class */
  function() {
    function s(e) {
      var t = this;
      this.clientAwareness = {}, this.queries = /* @__PURE__ */ new Map(), this.fetchCancelFns = /* @__PURE__ */ new Map(), this.transformCache = new tu(
        Ns["queryManager.getDocumentInfo"] || 2e3
        /* defaultCacheSizes["queryManager.getDocumentInfo"] */
      ), this.queryIdCounter = 1, this.requestIdCounter = 1, this.mutationIdCounter = 1, this.inFlightLinkObservables = new Fe(!1);
      var r = new sf(
        function(a) {
          return t.cache.transformDocument(a);
        },
        // Allow the apollo cache to manage its own transform caches
        { cache: !1 }
      );
      this.cache = e.cache, this.link = e.link, this.defaultOptions = e.defaultOptions, this.queryDeduplication = e.queryDeduplication, this.clientAwareness = e.clientAwareness, this.localState = e.localState, this.ssrMode = e.ssrMode, this.assumeImmutableResults = e.assumeImmutableResults;
      var u = e.documentTransform;
      this.documentTransform = u ? r.concat(u).concat(r) : r, this.defaultContext = e.defaultContext || /* @__PURE__ */ Object.create(null), (this.onBroadcast = e.onBroadcast) && (this.mutationStore = /* @__PURE__ */ Object.create(null));
    }
    return s.prototype.stop = function() {
      var e = this;
      this.queries.forEach(function(t, r) {
        e.stopQueryNoBroadcast(r);
      }), this.cancelPendingFetches(Ps(26));
    }, s.prototype.cancelPendingFetches = function(e) {
      this.fetchCancelFns.forEach(function(t) {
        return t(e);
      }), this.fetchCancelFns.clear();
    }, s.prototype.mutate = function(e) {
      return Js(this, arguments, void 0, function(t) {
        var r, u, a, i, _, h, f, A = t.mutation, y = t.variables, c = t.optimisticResponse, n = t.updateQueries, d = t.refetchQueries, E = d === void 0 ? [] : d, V = t.awaitRefetchQueries, b = V === void 0 ? !1 : V, F = t.update, l = t.onQueryUpdated, T = t.fetchPolicy, $ = T === void 0 ? ((h = this.defaultOptions.mutate) === null || h === void 0 ? void 0 : h.fetchPolicy) || "network-only" : T, q = t.errorPolicy, z = q === void 0 ? ((f = this.defaultOptions.mutate) === null || f === void 0 ? void 0 : f.errorPolicy) || "none" : q, U = t.keepRootFields, Z = t.context;
        return Hs(this, function(O) {
          switch (O.label) {
            case 0:
              return Q(A, 27), Q($ === "network-only" || $ === "no-cache", 28), r = this.generateMutationId(), A = this.cache.transformForLink(this.transform(A)), u = this.getDocumentInfo(A).hasClientExports, y = this.getVariables(A, y), u ? [4, this.localState.addExportedVariables(A, y, Z)] : [3, 2];
            case 1:
              y = O.sent(), O.label = 2;
            case 2:
              return a = this.mutationStore && (this.mutationStore[r] = {
                mutation: A,
                variables: y,
                loading: !0,
                error: null
              }), i = c && this.markMutationOptimistic(c, {
                mutationId: r,
                document: A,
                variables: y,
                fetchPolicy: $,
                errorPolicy: z,
                context: Z,
                updateQueries: n,
                update: F,
                keepRootFields: U
              }), this.broadcastQueries(), _ = this, [2, new Promise(function(os, qs) {
                return Sr(_.getObservableFromLink(A, p(p({}, Z), { optimisticResponse: i ? c : void 0 }), y, {}, !1), function(fs) {
                  if (bt(fs) && z === "none")
                    throw new Ys({
                      graphQLErrors: Rr(fs)
                    });
                  a && (a.loading = !1, a.error = null);
                  var ls = p({}, fs);
                  return typeof E == "function" && (E = E(ls)), z === "ignore" && bt(ls) && delete ls.errors, _.markMutationResult({
                    mutationId: r,
                    result: ls,
                    document: A,
                    variables: y,
                    fetchPolicy: $,
                    errorPolicy: z,
                    context: Z,
                    update: F,
                    updateQueries: n,
                    awaitRefetchQueries: b,
                    refetchQueries: E,
                    removeOptimistic: i ? r : void 0,
                    onQueryUpdated: l,
                    keepRootFields: U
                  });
                }).subscribe({
                  next: function(fs) {
                    _.broadcastQueries(), (!("hasNext" in fs) || fs.hasNext === !1) && os(fs);
                  },
                  error: function(fs) {
                    a && (a.loading = !1, a.error = fs), i && _.cache.removeOptimistic(r), _.broadcastQueries(), qs(fs instanceof Ys ? fs : new Ys({
                      networkError: fs
                    }));
                  }
                });
              })];
          }
        });
      });
    }, s.prototype.markMutationResult = function(e, t) {
      var r = this;
      t === void 0 && (t = this.cache);
      var u = e.result, a = [], i = e.fetchPolicy === "no-cache";
      if (!i && Hr(u, e.errorPolicy)) {
        if (be(u) || a.push({
          result: u.data,
          dataId: "ROOT_MUTATION",
          query: e.document,
          variables: e.variables
        }), be(u) && Rs(u.incremental)) {
          var _ = t.diff({
            id: "ROOT_MUTATION",
            // The cache complains if passed a mutation where it expects a
            // query, so we transform mutations and subscriptions to queries
            // (only once, thanks to this.transformCache).
            query: this.getDocumentInfo(e.document).asQuery,
            variables: e.variables,
            optimistic: !1,
            returnPartialData: !0
          }), h = void 0;
          _.result && (h = Sf(_.result, u)), typeof h < "u" && (u.data = h, a.push({
            result: h,
            dataId: "ROOT_MUTATION",
            query: e.document,
            variables: e.variables
          }));
        }
        var f = e.updateQueries;
        f && this.queries.forEach(function(y, c) {
          var n = y.observableQuery, d = n && n.queryName;
          if (!(!d || !Tc.call(f, d))) {
            var E = f[d], V = r.queries.get(c), b = V.document, F = V.variables, l = t.diff({
              query: b,
              variables: F,
              returnPartialData: !0,
              optimistic: !1
            }), T = l.result, $ = l.complete;
            if ($ && T) {
              var q = E(T, {
                mutationResult: u,
                queryName: b && Pr(b) || void 0,
                queryVariables: F
              });
              q && a.push({
                result: q,
                dataId: "ROOT_QUERY",
                query: b,
                variables: F
              });
            }
          }
        });
      }
      if (a.length > 0 || (e.refetchQueries || "").length > 0 || e.update || e.onQueryUpdated || e.removeOptimistic) {
        var A = [];
        if (this.refetchQueries({
          updateCache: function(y) {
            i || a.forEach(function(E) {
              return y.write(E);
            });
            var c = e.update, n = !My(u) || be(u) && !u.hasNext;
            if (c) {
              if (!i) {
                var d = y.diff({
                  id: "ROOT_MUTATION",
                  // The cache complains if passed a mutation where it expects a
                  // query, so we transform mutations and subscriptions to queries
                  // (only once, thanks to this.transformCache).
                  query: r.getDocumentInfo(e.document).asQuery,
                  variables: e.variables,
                  optimistic: !1,
                  returnPartialData: !0
                });
                d.complete && (u = p(p({}, u), { data: d.result }), "incremental" in u && delete u.incremental, "hasNext" in u && delete u.hasNext);
              }
              n && c(y, u, {
                context: e.context,
                variables: e.variables
              });
            }
            !i && !e.keepRootFields && n && y.modify({
              id: "ROOT_MUTATION",
              fields: function(E, V) {
                var b = V.fieldName, F = V.DELETE;
                return b === "__typename" ? E : F;
              }
            });
          },
          include: e.refetchQueries,
          // Write the final mutation.result to the root layer of the cache.
          optimistic: !1,
          // Remove the corresponding optimistic layer at the same time as we
          // write the final non-optimistic result.
          removeOptimistic: e.removeOptimistic,
          // Let the caller of client.mutate optionally determine the refetching
          // behavior for watched queries after the mutation.update function runs.
          // If no onQueryUpdated function was provided for this mutation, pass
          // null instead of undefined to disable the default refetching behavior.
          onQueryUpdated: e.onQueryUpdated || null
        }).forEach(function(y) {
          return A.push(y);
        }), e.awaitRefetchQueries || e.onQueryUpdated)
          return Promise.all(A).then(function() {
            return u;
          });
      }
      return Promise.resolve(u);
    }, s.prototype.markMutationOptimistic = function(e, t) {
      var r = this, u = typeof e == "function" ? e(t.variables, { IGNORE: f_ }) : e;
      return u === f_ ? !1 : (this.cache.recordOptimisticTransaction(function(a) {
        try {
          r.markMutationResult(p(p({}, t), { result: { data: u } }), a);
        } catch (i) {
          globalThis.__DEV__ !== !1 && Q.error(i);
        }
      }, t.mutationId), !0);
    }, s.prototype.fetchQuery = function(e, t, r) {
      return this.fetchConcastWithInfo(e, t, r).concast.promise;
    }, s.prototype.getQueryStore = function() {
      var e = /* @__PURE__ */ Object.create(null);
      return this.queries.forEach(function(t, r) {
        e[r] = {
          variables: t.variables,
          networkStatus: t.networkStatus,
          networkError: t.networkError,
          graphQLErrors: t.graphQLErrors
        };
      }), e;
    }, s.prototype.resetErrors = function(e) {
      var t = this.queries.get(e);
      t && (t.networkError = void 0, t.graphQLErrors = []);
    }, s.prototype.transform = function(e) {
      return this.documentTransform.transformDocument(e);
    }, s.prototype.getDocumentInfo = function(e) {
      var t = this.transformCache;
      if (!t.has(e)) {
        var r = {
          // TODO These three calls (hasClientExports, shouldForceResolvers, and
          // usesNonreactiveDirective) are performing independent full traversals
          // of the transformed document. We should consider merging these
          // traversals into a single pass in the future, though the work is
          // cached after the first time.
          hasClientExports: fA(e),
          hasForcedResolvers: this.localState.shouldForceResolvers(e),
          hasNonreactiveDirective: Ie(["nonreactive"], e),
          clientQuery: this.localState.clientQuery(e),
          serverQuery: tf([
            { name: "client", remove: !0 },
            { name: "connection" },
            { name: "nonreactive" }
          ], e),
          defaultVars: uu(ge(e)),
          // Transform any mutation or subscription operations to query operations
          // so we can read/write them from/to the cache.
          asQuery: p(p({}, e), { definitions: e.definitions.map(function(u) {
            return u.kind === "OperationDefinition" && u.operation !== "query" ? p(p({}, u), { operation: "query" }) : u;
          }) })
        };
        t.set(e, r);
      }
      return t.get(e);
    }, s.prototype.getVariables = function(e, t) {
      return p(p({}, this.getDocumentInfo(e).defaultVars), t);
    }, s.prototype.watchQuery = function(e) {
      var t = this.transform(e.query);
      e = p(p({}, e), { variables: this.getVariables(t, e.variables) }), typeof e.notifyOnNetworkStatusChange > "u" && (e.notifyOnNetworkStatusChange = !1);
      var r = new pr(this), u = new Jr({
        queryManager: this,
        queryInfo: r,
        options: e
      });
      return u.lastQuery = t, this.queries.set(u.queryId, r), r.init({
        document: t,
        observableQuery: u,
        variables: u.variables
      }), u;
    }, s.prototype.query = function(e, t) {
      var r = this;
      return t === void 0 && (t = this.generateQueryId()), Q(e.query, 29), Q(e.query.kind === "Document", 30), Q(!e.returnPartialData, 31), Q(!e.pollInterval, 32), this.fetchQuery(t, p(p({}, e), { query: this.transform(e.query) })).finally(function() {
        return r.stopQuery(t);
      });
    }, s.prototype.generateQueryId = function() {
      return String(this.queryIdCounter++);
    }, s.prototype.generateRequestId = function() {
      return this.requestIdCounter++;
    }, s.prototype.generateMutationId = function() {
      return String(this.mutationIdCounter++);
    }, s.prototype.stopQueryInStore = function(e) {
      this.stopQueryInStoreNoBroadcast(e), this.broadcastQueries();
    }, s.prototype.stopQueryInStoreNoBroadcast = function(e) {
      var t = this.queries.get(e);
      t && t.stop();
    }, s.prototype.clearStore = function(e) {
      return e === void 0 && (e = {
        discardWatches: !0
      }), this.cancelPendingFetches(Ps(33)), this.queries.forEach(function(t) {
        t.observableQuery ? t.networkStatus = es.loading : t.stop();
      }), this.mutationStore && (this.mutationStore = /* @__PURE__ */ Object.create(null)), this.cache.reset(e);
    }, s.prototype.getObservableQueries = function(e) {
      var t = this;
      e === void 0 && (e = "active");
      var r = /* @__PURE__ */ new Map(), u = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Set();
      return Array.isArray(e) && e.forEach(function(i) {
        typeof i == "string" ? u.set(i, !1) : RA(i) ? u.set(t.transform(i), !1) : Ds(i) && i.query && a.add(i);
      }), this.queries.forEach(function(i, _) {
        var h = i.observableQuery, f = i.document;
        if (h) {
          if (e === "all") {
            r.set(_, h);
            return;
          }
          var A = h.queryName, y = h.options.fetchPolicy;
          if (y === "standby" || e === "active" && !h.hasObservers())
            return;
          (e === "active" || A && u.has(A) || f && u.has(f)) && (r.set(_, h), A && u.set(A, !0), f && u.set(f, !0));
        }
      }), a.size && a.forEach(function(i) {
        var _ = Vr("legacyOneTimeQuery"), h = t.getQuery(_).init({
          document: i.query,
          variables: i.variables
        }), f = new Jr({
          queryManager: t,
          queryInfo: h,
          options: p(p({}, i), { fetchPolicy: "network-only" })
        });
        Q(f.queryId === _), h.setObservableQuery(f), r.set(_, f);
      }), globalThis.__DEV__ !== !1 && u.size && u.forEach(function(i, _) {
        i || globalThis.__DEV__ !== !1 && Q.warn(typeof _ == "string" ? 34 : 35, _);
      }), r;
    }, s.prototype.reFetchObservableQueries = function(e) {
      var t = this;
      e === void 0 && (e = !1);
      var r = [];
      return this.getObservableQueries(e ? "all" : "active").forEach(function(u, a) {
        var i = u.options.fetchPolicy;
        u.resetLastResults(), (e || i !== "standby" && i !== "cache-only") && r.push(u.refetch()), t.getQuery(a).setDiff(null);
      }), this.broadcastQueries(), Promise.all(r);
    }, s.prototype.setObservableQuery = function(e) {
      this.getQuery(e.queryId).setObservableQuery(e);
    }, s.prototype.startGraphQLSubscription = function(e) {
      var t = this, r = e.query, u = e.fetchPolicy, a = e.errorPolicy, i = a === void 0 ? "none" : a, _ = e.variables, h = e.context, f = h === void 0 ? {} : h, A = e.extensions, y = A === void 0 ? {} : A;
      r = this.transform(r), _ = this.getVariables(r, _);
      var c = function(d) {
        return t.getObservableFromLink(r, f, d, y).map(function(E) {
          u !== "no-cache" && (Hr(E, i) && t.cache.write({
            query: r,
            result: E.data,
            dataId: "ROOT_SUBSCRIPTION",
            variables: d
          }), t.broadcastQueries());
          var V = bt(E), b = Hy(E);
          if (V || b) {
            var F = {};
            if (V && (F.graphQLErrors = E.errors), b && (F.protocolErrors = E.extensions[Du]), i === "none" || b)
              throw new Ys(F);
          }
          return i === "ignore" && delete E.errors, E;
        });
      };
      if (this.getDocumentInfo(r).hasClientExports) {
        var n = this.localState.addExportedVariables(r, _, f).then(c);
        return new rs(function(d) {
          var E = null;
          return n.then(function(V) {
            return E = V.subscribe(d);
          }, d.error), function() {
            return E && E.unsubscribe();
          };
        });
      }
      return c(_);
    }, s.prototype.stopQuery = function(e) {
      this.stopQueryNoBroadcast(e), this.broadcastQueries();
    }, s.prototype.stopQueryNoBroadcast = function(e) {
      this.stopQueryInStoreNoBroadcast(e), this.removeQuery(e);
    }, s.prototype.removeQuery = function(e) {
      this.fetchCancelFns.delete(e), this.queries.has(e) && (this.getQuery(e).stop(), this.queries.delete(e));
    }, s.prototype.broadcastQueries = function() {
      this.onBroadcast && this.onBroadcast(), this.queries.forEach(function(e) {
        return e.notify();
      });
    }, s.prototype.getLocalState = function() {
      return this.localState;
    }, s.prototype.getObservableFromLink = function(e, t, r, u, a) {
      var i = this, _;
      a === void 0 && (a = (_ = t == null ? void 0 : t.queryDeduplication) !== null && _ !== void 0 ? _ : this.queryDeduplication);
      var h, f = this.getDocumentInfo(e), A = f.serverQuery, y = f.clientQuery;
      if (A) {
        var c = this, n = c.inFlightLinkObservables, d = c.link, E = {
          query: A,
          variables: r,
          operationName: Pr(A) || void 0,
          context: this.prepareContext(p(p({}, t), { forceFetch: !a })),
          extensions: u
        };
        if (t = E.context, a) {
          var V = zt(A), b = ks(r), F = n.lookup(V, b);
          if (h = F.observable, !h) {
            var l = new ye([
              jr(d, E)
            ]);
            h = F.observable = l, l.beforeNext(function() {
              n.remove(V, b);
            });
          }
        } else
          h = new ye([
            jr(d, E)
          ]);
      } else
        h = new ye([rs.of({ data: {} })]), t = this.prepareContext(t);
      return y && (h = Sr(h, function(T) {
        return i.localState.runResolvers({
          document: y,
          remoteResult: T,
          context: t,
          variables: r
        });
      })), h;
    }, s.prototype.getResultsFromLink = function(e, t, r) {
      var u = e.lastRequestId = this.generateRequestId(), a = this.cache.transformForLink(r.query);
      return Sr(this.getObservableFromLink(a, r.context, r.variables), function(i) {
        var _ = Rr(i), h = _.length > 0, f = r.errorPolicy;
        if (u >= e.lastRequestId) {
          if (h && f === "none")
            throw e.markError(new Ys({
              graphQLErrors: _
            }));
          e.markResult(i, a, r, t), e.markReady();
        }
        var A = {
          data: i.data,
          loading: !1,
          networkStatus: es.ready
        };
        return h && f === "none" && (A.data = void 0), h && f !== "ignore" && (A.errors = _, A.networkStatus = es.error), A;
      }, function(i) {
        var _ = yf(i) ? i : new Ys({ networkError: i });
        throw u >= e.lastRequestId && e.markError(_), _;
      });
    }, s.prototype.fetchConcastWithInfo = function(e, t, r, u) {
      var a = this;
      r === void 0 && (r = es.loading), u === void 0 && (u = t.query);
      var i = this.getVariables(u, t.variables), _ = this.getQuery(e), h = this.defaultOptions.watchQuery, f = t.fetchPolicy, A = f === void 0 ? h && h.fetchPolicy || "cache-first" : f, y = t.errorPolicy, c = y === void 0 ? h && h.errorPolicy || "none" : y, n = t.returnPartialData, d = n === void 0 ? !1 : n, E = t.notifyOnNetworkStatusChange, V = E === void 0 ? !1 : E, b = t.context, F = b === void 0 ? {} : b, l = Object.assign({}, t, {
        query: u,
        variables: i,
        fetchPolicy: A,
        errorPolicy: c,
        returnPartialData: d,
        notifyOnNetworkStatusChange: V,
        context: F
      }), T = function(Z) {
        l.variables = Z;
        var O = a.fetchQueryByPolicy(_, l, r);
        return (
          // If we're in standby, postpone advancing options.fetchPolicy using
          // applyNextFetchPolicy.
          l.fetchPolicy !== "standby" && // The "standby" policy currently returns [] from fetchQueryByPolicy, so
          // this is another way to detect when nothing was done/fetched.
          O.sources.length > 0 && _.observableQuery && _.observableQuery.applyNextFetchPolicy("after-fetch", t), O
        );
      }, $ = function() {
        return a.fetchCancelFns.delete(e);
      };
      this.fetchCancelFns.set(e, function(Z) {
        $(), setTimeout(function() {
          return q.cancel(Z);
        });
      });
      var q, z;
      if (this.getDocumentInfo(l.query).hasClientExports)
        q = new ye(this.localState.addExportedVariables(l.query, l.variables, l.context).then(T).then(function(Z) {
          return Z.sources;
        })), z = !0;
      else {
        var U = T(l.variables);
        z = U.fromLink, q = new ye(U.sources);
      }
      return q.promise.then($, $), {
        concast: q,
        fromLink: z
      };
    }, s.prototype.refetchQueries = function(e) {
      var t = this, r = e.updateCache, u = e.include, a = e.optimistic, i = a === void 0 ? !1 : a, _ = e.removeOptimistic, h = _ === void 0 ? i ? Vr("refetchQueries") : void 0 : _, f = e.onQueryUpdated, A = /* @__PURE__ */ new Map();
      u && this.getObservableQueries(u).forEach(function(c, n) {
        A.set(n, {
          oq: c,
          lastDiff: t.getQuery(n).getDiff()
        });
      });
      var y = /* @__PURE__ */ new Map();
      return r && this.cache.batch({
        update: r,
        // Since you can perform any combination of cache reads and/or writes in
        // the cache.batch update function, its optimistic option can be either
        // a boolean or a string, representing three distinct modes of
        // operation:
        //
        // * false: read/write only the root layer
        // * true: read/write the topmost layer
        // * string: read/write a fresh optimistic layer with that ID string
        //
        // When typeof optimistic === "string", a new optimistic layer will be
        // temporarily created within cache.batch with that string as its ID. If
        // we then pass that same string as the removeOptimistic option, we can
        // make cache.batch immediately remove the optimistic layer after
        // running the updateCache function, triggering only one broadcast.
        //
        // However, the refetchQueries method accepts only true or false for its
        // optimistic option (not string). We interpret true to mean a temporary
        // optimistic layer should be created, to allow efficiently rolling back
        // the effect of the updateCache function, which involves passing a
        // string instead of true as the optimistic option to cache.batch, when
        // refetchQueries receives optimistic: true.
        //
        // In other words, we are deliberately not supporting the use case of
        // writing to an *existing* optimistic layer (using the refetchQueries
        // updateCache function), since that would potentially interfere with
        // other optimistic updates in progress. Instead, you can read/write
        // only the root layer by passing optimistic: false to refetchQueries,
        // or you can read/write a brand new optimistic layer that will be
        // automatically removed by passing optimistic: true.
        optimistic: i && h || !1,
        // The removeOptimistic option can also be provided by itself, even if
        // optimistic === false, to remove some previously-added optimistic
        // layer safely and efficiently, like we do in markMutationResult.
        //
        // If an explicit removeOptimistic string is provided with optimistic:
        // true, the removeOptimistic string will determine the ID of the
        // temporary optimistic layer, in case that ever matters.
        removeOptimistic: h,
        onWatchUpdated: function(c, n, d) {
          var E = c.watcher instanceof pr && c.watcher.observableQuery;
          if (E) {
            if (f) {
              A.delete(E.queryId);
              var V = f(E, n, d);
              return V === !0 && (V = E.refetch()), V !== !1 && y.set(E, V), V;
            }
            f !== null && A.set(E.queryId, { oq: E, lastDiff: d, diff: n });
          }
        }
      }), A.size && A.forEach(function(c, n) {
        var d = c.oq, E = c.lastDiff, V = c.diff, b;
        if (f) {
          if (!V) {
            var F = d.queryInfo;
            F.reset(), V = F.getDiff();
          }
          b = f(d, V, E);
        }
        (!f || b === !0) && (b = d.refetch()), b !== !1 && y.set(d, b), n.indexOf("legacyOneTimeQuery") >= 0 && t.stopQueryNoBroadcast(n);
      }), h && this.cache.removeOptimistic(h), y;
    }, s.prototype.fetchQueryByPolicy = function(e, t, r) {
      var u = this, a = t.query, i = t.variables, _ = t.fetchPolicy, h = t.refetchWritePolicy, f = t.errorPolicy, A = t.returnPartialData, y = t.context, c = t.notifyOnNetworkStatusChange, n = e.networkStatus;
      e.init({
        document: a,
        variables: i,
        networkStatus: r
      });
      var d = function() {
        return e.getDiff();
      }, E = function(T, $) {
        $ === void 0 && ($ = e.networkStatus || es.loading);
        var q = T.result;
        globalThis.__DEV__ !== !1 && !A && !us(q, {}) && Tf(T.missing);
        var z = function(U) {
          return rs.of(p({ data: U, loading: Xe($), networkStatus: $ }, T.complete ? null : { partial: !0 }));
        };
        return q && u.getDocumentInfo(a).hasForcedResolvers ? u.localState.runResolvers({
          document: a,
          remoteResult: { data: q },
          context: y,
          variables: i,
          onlyRunForcedResolvers: !0
        }).then(function(U) {
          return z(U.data || void 0);
        }) : f === "none" && $ === es.refetch && Array.isArray(T.missing) ? z(void 0) : z(q);
      }, V = _ === "no-cache" ? 0 : r === es.refetch && h !== "merge" ? 1 : 2, b = function() {
        return u.getResultsFromLink(e, V, {
          query: a,
          variables: i,
          context: y,
          fetchPolicy: _,
          errorPolicy: f
        });
      }, F = c && typeof n == "number" && n !== r && Xe(r);
      switch (_) {
        default:
        case "cache-first": {
          var l = d();
          return l.complete ? {
            fromLink: !1,
            sources: [E(l, e.markReady())]
          } : A || F ? {
            fromLink: !0,
            sources: [E(l), b()]
          } : { fromLink: !0, sources: [b()] };
        }
        case "cache-and-network": {
          var l = d();
          return l.complete || A || F ? {
            fromLink: !0,
            sources: [E(l), b()]
          } : { fromLink: !0, sources: [b()] };
        }
        case "cache-only":
          return {
            fromLink: !1,
            sources: [E(d(), e.markReady())]
          };
        case "network-only":
          return F ? {
            fromLink: !0,
            sources: [E(d()), b()]
          } : { fromLink: !0, sources: [b()] };
        case "no-cache":
          return F ? {
            fromLink: !0,
            // Note that queryInfo.getDiff() for no-cache queries does not call
            // cache.diff, but instead returns a { complete: false } stub result
            // when there is no queryInfo.diff already defined.
            sources: [E(e.getDiff()), b()]
          } : { fromLink: !0, sources: [b()] };
        case "standby":
          return { fromLink: !1, sources: [] };
      }
    }, s.prototype.getQuery = function(e) {
      return e && !this.queries.has(e) && this.queries.set(e, new pr(this, e)), this.queries.get(e);
    }, s.prototype.prepareContext = function(e) {
      e === void 0 && (e = {});
      var t = this.localState.prepareContext(e);
      return p(p(p({}, this.defaultContext), t), { clientAwareness: this.clientAwareness });
    }, s;
  }()
), Bc = (
  /** @class */
  function() {
    function s(e) {
      var t = e.cache, r = e.client, u = e.resolvers, a = e.fragmentMatcher;
      this.selectionsToResolveCache = /* @__PURE__ */ new WeakMap(), this.cache = t, r && (this.client = r), u && this.addResolvers(u), a && this.setFragmentMatcher(a);
    }
    return s.prototype.addResolvers = function(e) {
      var t = this;
      this.resolvers = this.resolvers || {}, Array.isArray(e) ? e.forEach(function(r) {
        t.resolvers = $i(t.resolvers, r);
      }) : this.resolvers = $i(this.resolvers, e);
    }, s.prototype.setResolvers = function(e) {
      this.resolvers = {}, this.addResolvers(e);
    }, s.prototype.getResolvers = function() {
      return this.resolvers || {};
    }, s.prototype.runResolvers = function(e) {
      return Js(this, arguments, void 0, function(t) {
        var r = t.document, u = t.remoteResult, a = t.context, i = t.variables, _ = t.onlyRunForcedResolvers, h = _ === void 0 ? !1 : _;
        return Hs(this, function(f) {
          return r ? [2, this.resolveDocument(r, u.data, a, i, this.fragmentMatcher, h).then(function(A) {
            return p(p({}, u), { data: A.result });
          })] : [2, u];
        });
      });
    }, s.prototype.setFragmentMatcher = function(e) {
      this.fragmentMatcher = e;
    }, s.prototype.getFragmentMatcher = function() {
      return this.fragmentMatcher;
    }, s.prototype.clientQuery = function(e) {
      return Ie(["client"], e) && this.resolvers ? e : null;
    }, s.prototype.serverQuery = function(e) {
      return rf(e);
    }, s.prototype.prepareContext = function(e) {
      var t = this.cache;
      return p(p({}, e), {
        cache: t,
        // Getting an entry's cache key is useful for local state resolvers.
        getCacheKey: function(r) {
          return t.identify(r);
        }
      });
    }, s.prototype.addExportedVariables = function(e) {
      return Js(this, arguments, void 0, function(t, r, u) {
        return r === void 0 && (r = {}), u === void 0 && (u = {}), Hs(this, function(a) {
          return t ? [2, this.resolveDocument(t, this.buildRootValueFromCache(t, r) || {}, this.prepareContext(u), r).then(function(i) {
            return p(p({}, r), i.exportedVariables);
          })] : [2, p({}, r)];
        });
      });
    }, s.prototype.shouldForceResolvers = function(e) {
      var t = !1;
      return Xs(e, {
        Directive: {
          enter: function(r) {
            if (r.name.value === "client" && r.arguments && (t = r.arguments.some(function(u) {
              return u.name.value === "always" && u.value.kind === "BooleanValue" && u.value.value === !0;
            }), t))
              return su;
          }
        }
      }), t;
    }, s.prototype.buildRootValueFromCache = function(e, t) {
      return this.cache.diff({
        query: cy(e),
        variables: t,
        returnPartialData: !0,
        optimistic: !1
      }).result;
    }, s.prototype.resolveDocument = function(e, t) {
      return Js(this, arguments, void 0, function(r, u, a, i, _, h) {
        var f, A, y, c, n, d, E, V, b, F, l;
        return a === void 0 && (a = {}), i === void 0 && (i = {}), _ === void 0 && (_ = function() {
          return !0;
        }), h === void 0 && (h = !1), Hs(this, function(T) {
          return f = ke(r), A = jt(r), y = qt(A), c = this.collectSelectionsToResolve(f, y), n = f.operation, d = n ? n.charAt(0).toUpperCase() + n.slice(1) : "Query", E = this, V = E.cache, b = E.client, F = {
            fragmentMap: y,
            context: p(p({}, a), { cache: V, client: b }),
            variables: i,
            fragmentMatcher: _,
            defaultOperationType: d,
            exportedVariables: {},
            selectionsToResolve: c,
            onlyRunForcedResolvers: h
          }, l = !1, [2, this.resolveSelectionSet(f.selectionSet, l, u, F).then(function($) {
            return {
              result: $,
              exportedVariables: F.exportedVariables
            };
          })];
        });
      });
    }, s.prototype.resolveSelectionSet = function(e, t, r, u) {
      return Js(this, void 0, void 0, function() {
        var a, i, _, h, f, A = this;
        return Hs(this, function(y) {
          return a = u.fragmentMap, i = u.context, _ = u.variables, h = [r], f = function(c) {
            return Js(A, void 0, void 0, function() {
              var n, d;
              return Hs(this, function(E) {
                return !t && !u.selectionsToResolve.has(c) ? [
                  2
                  /*return*/
                ] : Ze(c, _) ? Ls(c) ? [2, this.resolveField(c, t, r, u).then(function(V) {
                  var b;
                  typeof V < "u" && h.push((b = {}, b[Os(c)] = V, b));
                })] : (XA(c) ? n = c : (n = a[c.name.value], Q(n, 18, c.name.value)), n && n.typeCondition && (d = n.typeCondition.name.value, u.fragmentMatcher(r, d, i)) ? [2, this.resolveSelectionSet(n.selectionSet, t, r, u).then(function(V) {
                  h.push(V);
                })] : [
                  2
                  /*return*/
                ]) : [
                  2
                  /*return*/
                ];
              });
            });
          }, [2, Promise.all(e.selections.map(f)).then(function() {
            return Wt(h);
          })];
        });
      });
    }, s.prototype.resolveField = function(e, t, r, u) {
      return Js(this, void 0, void 0, function() {
        var a, i, _, h, f, A, y, c, n, d = this;
        return Hs(this, function(E) {
          return r ? (a = u.variables, i = e.name.value, _ = Os(e), h = i !== _, f = r[_] || r[i], A = Promise.resolve(f), (!u.onlyRunForcedResolvers || this.shouldForceResolvers(e)) && (y = r.__typename || u.defaultOperationType, c = this.resolvers && this.resolvers[y], c && (n = c[h ? i : _], n && (A = Promise.resolve(
            // In case the resolve function accesses reactive variables,
            // set cacheSlot to the current cache instance.
            du.withValue(this.cache, n, [
              r,
              Rt(e, a),
              u.context,
              { field: e, fragmentMap: u.fragmentMap }
            ])
          )))), [2, A.then(function(V) {
            var b, F;
            if (V === void 0 && (V = f), e.directives && e.directives.forEach(function(T) {
              T.name.value === "export" && T.arguments && T.arguments.forEach(function($) {
                $.name.value === "as" && $.value.kind === "StringValue" && (u.exportedVariables[$.value.value] = V);
              });
            }), !e.selectionSet || V == null)
              return V;
            var l = (F = (b = e.directives) === null || b === void 0 ? void 0 : b.some(function(T) {
              return T.name.value === "client";
            })) !== null && F !== void 0 ? F : !1;
            if (Array.isArray(V))
              return d.resolveSubSelectedArray(e, t || l, V, u);
            if (e.selectionSet)
              return d.resolveSelectionSet(e.selectionSet, t || l, V, u);
          })]) : [2, null];
        });
      });
    }, s.prototype.resolveSubSelectedArray = function(e, t, r, u) {
      var a = this;
      return Promise.all(r.map(function(i) {
        if (i === null)
          return null;
        if (Array.isArray(i))
          return a.resolveSubSelectedArray(e, t, i, u);
        if (e.selectionSet)
          return a.resolveSelectionSet(e.selectionSet, t, i, u);
      }));
    }, s.prototype.collectSelectionsToResolve = function(e, t) {
      var r = function(i) {
        return !Array.isArray(i);
      }, u = this.selectionsToResolveCache;
      function a(i) {
        if (!u.has(i)) {
          var _ = /* @__PURE__ */ new Set();
          u.set(i, _), Xs(i, {
            Directive: function(h, f, A, y, c) {
              h.name.value === "client" && c.forEach(function(n) {
                r(n) && Ei(n) && _.add(n);
              });
            },
            FragmentSpread: function(h, f, A, y, c) {
              var n = t[h.name.value];
              Q(n, 19, h.name.value);
              var d = a(n);
              d.size > 0 && (c.forEach(function(E) {
                r(E) && Ei(E) && _.add(E);
              }), _.add(h), d.forEach(function(E) {
                _.add(E);
              }));
            }
          });
        }
        return u.get(i);
      }
      return a(e);
    }, s;
  }()
), h_ = !1, mu = (
  /** @class */
  function() {
    function s(e) {
      var t = this;
      if (this.resetStoreCallbacks = [], this.clearStoreCallbacks = [], !e.cache)
        throw Ps(15);
      var r = e.uri, u = e.credentials, a = e.headers, i = e.cache, _ = e.documentTransform, h = e.ssrMode, f = h === void 0 ? !1 : h, A = e.ssrForceFetchDelay, y = A === void 0 ? 0 : A, c = e.connectToDevTools, n = e.queryDeduplication, d = n === void 0 ? !0 : n, E = e.defaultOptions, V = e.defaultContext, b = e.assumeImmutableResults, F = b === void 0 ? i.assumeImmutableResults : b, l = e.resolvers, T = e.typeDefs, $ = e.fragmentMatcher, q = e.name, z = e.version, U = e.devtools, Z = e.link;
      Z || (Z = r ? new ic({ uri: r, credentials: u, headers: a }) : Is.empty()), this.link = Z, this.cache = i, this.disableNetworkFetches = f || y > 0, this.queryDeduplication = d, this.defaultOptions = E || /* @__PURE__ */ Object.create(null), this.typeDefs = T, this.devtoolsConfig = p(p({}, U), { enabled: (U == null ? void 0 : U.enabled) || c }), this.devtoolsConfig.enabled === void 0 && (this.devtoolsConfig.enabled = globalThis.__DEV__ !== !1), y && setTimeout(function() {
        return t.disableNetworkFetches = !1;
      }, y), this.watchQuery = this.watchQuery.bind(this), this.query = this.query.bind(this), this.mutate = this.mutate.bind(this), this.watchFragment = this.watchFragment.bind(this), this.resetStore = this.resetStore.bind(this), this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this), this.version = Cr, this.localState = new Bc({
        cache: i,
        client: this,
        resolvers: l,
        fragmentMatcher: $
      }), this.queryManager = new Pc({
        cache: this.cache,
        link: this.link,
        defaultOptions: this.defaultOptions,
        defaultContext: V,
        documentTransform: _,
        queryDeduplication: d,
        ssrMode: f,
        clientAwareness: {
          name: q,
          version: z
        },
        localState: this.localState,
        assumeImmutableResults: F,
        onBroadcast: this.devtoolsConfig.enabled ? function() {
          t.devToolsHookCb && t.devToolsHookCb({
            action: {},
            state: {
              queries: t.queryManager.getQueryStore(),
              mutations: t.queryManager.mutationStore || {}
            },
            dataWithOptimisticResults: t.cache.extract(!0)
          });
        } : void 0
      }), this.devtoolsConfig.enabled && this.connectToDevTools();
    }
    return s.prototype.connectToDevTools = function() {
      if (!(typeof window > "u")) {
        var e = window, t = Symbol.for("apollo.devtools");
        (e[t] = e[t] || []).push(this), e.__APOLLO_CLIENT__ = this, !h_ && globalThis.__DEV__ !== !1 && (h_ = !0, window.document && window.top === window.self && /^(https?|file):$/.test(window.location.protocol) && setTimeout(function() {
          if (!window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
            var r = window.navigator, u = r && r.userAgent, a = void 0;
            typeof u == "string" && (u.indexOf("Chrome/") > -1 ? a = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm" : u.indexOf("Firefox/") > -1 && (a = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/")), a && globalThis.__DEV__ !== !1 && Q.log("Download the Apollo DevTools for a better development experience: %s", a);
          }
        }, 1e4));
      }
    }, Object.defineProperty(s.prototype, "documentTransform", {
      /**
       * The `DocumentTransform` used to modify GraphQL documents before a request
       * is made. If a custom `DocumentTransform` is not provided, this will be the
       * default document transform.
       */
      get: function() {
        return this.queryManager.documentTransform;
      },
      enumerable: !1,
      configurable: !0
    }), s.prototype.stop = function() {
      this.queryManager.stop();
    }, s.prototype.watchQuery = function(e) {
      return this.defaultOptions.watchQuery && (e = Ee(this.defaultOptions.watchQuery, e)), this.disableNetworkFetches && (e.fetchPolicy === "network-only" || e.fetchPolicy === "cache-and-network") && (e = p(p({}, e), { fetchPolicy: "cache-first" })), this.queryManager.watchQuery(e);
    }, s.prototype.query = function(e) {
      return this.defaultOptions.query && (e = Ee(this.defaultOptions.query, e)), Q(e.fetchPolicy !== "cache-and-network", 16), this.disableNetworkFetches && e.fetchPolicy === "network-only" && (e = p(p({}, e), { fetchPolicy: "cache-first" })), this.queryManager.query(e);
    }, s.prototype.mutate = function(e) {
      return this.defaultOptions.mutate && (e = Ee(this.defaultOptions.mutate, e)), this.queryManager.mutate(e);
    }, s.prototype.subscribe = function(e) {
      return this.queryManager.startGraphQLSubscription(e);
    }, s.prototype.readQuery = function(e, t) {
      return t === void 0 && (t = !1), this.cache.readQuery(e, t);
    }, s.prototype.watchFragment = function(e) {
      return this.cache.watchFragment(e);
    }, s.prototype.readFragment = function(e, t) {
      return t === void 0 && (t = !1), this.cache.readFragment(e, t);
    }, s.prototype.writeQuery = function(e) {
      var t = this.cache.writeQuery(e);
      return e.broadcast !== !1 && this.queryManager.broadcastQueries(), t;
    }, s.prototype.writeFragment = function(e) {
      var t = this.cache.writeFragment(e);
      return e.broadcast !== !1 && this.queryManager.broadcastQueries(), t;
    }, s.prototype.__actionHookForDevTools = function(e) {
      this.devToolsHookCb = e;
    }, s.prototype.__requestRaw = function(e) {
      return jr(this.link, e);
    }, s.prototype.resetStore = function() {
      var e = this;
      return Promise.resolve().then(function() {
        return e.queryManager.clearStore({
          discardWatches: !1
        });
      }).then(function() {
        return Promise.all(e.resetStoreCallbacks.map(function(t) {
          return t();
        }));
      }).then(function() {
        return e.reFetchObservableQueries();
      });
    }, s.prototype.clearStore = function() {
      var e = this;
      return Promise.resolve().then(function() {
        return e.queryManager.clearStore({
          discardWatches: !0
        });
      }).then(function() {
        return Promise.all(e.clearStoreCallbacks.map(function(t) {
          return t();
        }));
      });
    }, s.prototype.onResetStore = function(e) {
      var t = this;
      return this.resetStoreCallbacks.push(e), function() {
        t.resetStoreCallbacks = t.resetStoreCallbacks.filter(function(r) {
          return r !== e;
        });
      };
    }, s.prototype.onClearStore = function(e) {
      var t = this;
      return this.clearStoreCallbacks.push(e), function() {
        t.clearStoreCallbacks = t.clearStoreCallbacks.filter(function(r) {
          return r !== e;
        });
      };
    }, s.prototype.reFetchObservableQueries = function(e) {
      return this.queryManager.reFetchObservableQueries(e);
    }, s.prototype.refetchQueries = function(e) {
      var t = this.queryManager.refetchQueries(e), r = [], u = [];
      t.forEach(function(i, _) {
        r.push(_), u.push(i);
      });
      var a = Promise.all(u);
      return a.queries = r, a.results = u, a.catch(function(i) {
        globalThis.__DEV__ !== !1 && Q.debug(17, i);
      }), a;
    }, s.prototype.getObservableQueries = function(e) {
      return e === void 0 && (e = "active"), this.queryManager.getObservableQueries(e);
    }, s.prototype.extract = function(e) {
      return this.cache.extract(e);
    }, s.prototype.restore = function(e) {
      return this.cache.restore(e);
    }, s.prototype.addResolvers = function(e) {
      this.localState.addResolvers(e);
    }, s.prototype.setResolvers = function(e) {
      this.localState.setResolvers(e);
    }, s.prototype.getResolvers = function() {
      return this.localState.getResolvers();
    }, s.prototype.setLocalStateFragmentMatcher = function(e) {
      this.localState.setFragmentMatcher(e);
    }, s.prototype.setLink = function(e) {
      this.link = this.queryManager.link = e;
    }, Object.defineProperty(s.prototype, "defaultContext", {
      get: function() {
        return this.queryManager.defaultContext;
      },
      enumerable: !1,
      configurable: !0
    }), s;
  }()
);
globalThis.__DEV__ !== !1 && (mu.prototype.getMemoryInternals = xA);
var mt = /* @__PURE__ */ new Map(), Yr = /* @__PURE__ */ new Map(), Pf = !0, ot = !1;
function Bf(s) {
  return s.replace(/[\s,]+/g, " ").trim();
}
function qc(s) {
  return Bf(s.source.body.substring(s.start, s.end));
}
function Gc(s) {
  var e = /* @__PURE__ */ new Set(), t = [];
  return s.definitions.forEach(function(r) {
    if (r.kind === "FragmentDefinition") {
      var u = r.name.value, a = qc(r.loc), i = Yr.get(u);
      i && !i.has(a) ? Pf && console.warn("Warning: fragment with name " + u + ` already exists.
graphql-tag enforces all fragment names across your application to be unique; read more about
this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names`) : i || Yr.set(u, i = /* @__PURE__ */ new Set()), i.add(a), e.has(a) || (e.add(a), t.push(r));
    } else
      t.push(r);
  }), lt(lt({}, s), { definitions: t });
}
function Rc(s) {
  var e = new Set(s.definitions);
  e.forEach(function(r) {
    r.loc && delete r.loc, Object.keys(r).forEach(function(u) {
      var a = r[u];
      a && typeof a == "object" && e.add(a);
    });
  });
  var t = s.loc;
  return t && (delete t.startToken, delete t.endToken), s;
}
function jc(s) {
  var e = Bf(s);
  if (!mt.has(e)) {
    var t = OS(s, {
      experimentalFragmentVariables: ot,
      allowLegacyFragmentVariables: ot
    });
    if (!t || t.kind !== "Document")
      throw new Error("Not a valid GraphQL document.");
    mt.set(e, Rc(Gc(t)));
  }
  return mt.get(e);
}
function o(s) {
  for (var e = [], t = 1; t < arguments.length; t++)
    e[t - 1] = arguments[t];
  typeof s == "string" && (s = [s]);
  var r = s[0];
  return e.forEach(function(u, a) {
    u && u.kind === "Document" ? r += u.loc.source.body : r += u, r += s[a + 1];
  }), jc(r);
}
function Uc() {
  mt.clear(), Yr.clear();
}
function Qc() {
  Pf = !1;
}
function zc() {
  ot = !0;
}
function Wc() {
  ot = !1;
}
var Ge = {
  gql: o,
  resetCaches: Uc,
  disableFragmentWarnings: Qc,
  enableExperimentalFragmentVariables: zc,
  disableExperimentalFragmentVariables: Wc
};
(function(s) {
  s.gql = Ge.gql, s.resetCaches = Ge.resetCaches, s.disableFragmentWarnings = Ge.disableFragmentWarnings, s.enableExperimentalFragmentVariables = Ge.enableExperimentalFragmentVariables, s.disableExperimentalFragmentVariables = Ge.disableExperimentalFragmentVariables;
})(o || (o = {}));
o.default = o;
function Nc(s) {
  return s && s.__esModule && Object.prototype.hasOwnProperty.call(s, "default") ? s.default : s;
}
var qf = { exports: {} }, Kr = { exports: {} }, g = {};
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var S_;
function Ic() {
  if (S_) return g;
  S_ = 1;
  var s = Symbol.for("react.element"), e = Symbol.for("react.portal"), t = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), u = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), i = Symbol.for("react.context"), _ = Symbol.for("react.forward_ref"), h = Symbol.for("react.suspense"), f = Symbol.for("react.memo"), A = Symbol.for("react.lazy"), y = Symbol.iterator;
  function c(v) {
    return v === null || typeof v != "object" ? null : (v = y && v[y] || v["@@iterator"], typeof v == "function" ? v : null);
  }
  var n = { isMounted: function() {
    return !1;
  }, enqueueForceUpdate: function() {
  }, enqueueReplaceState: function() {
  }, enqueueSetState: function() {
  } }, d = Object.assign, E = {};
  function V(v, B, Y) {
    this.props = v, this.context = B, this.refs = E, this.updater = Y || n;
  }
  V.prototype.isReactComponent = {}, V.prototype.setState = function(v, B) {
    if (typeof v != "object" && typeof v != "function" && v != null) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, v, B, "setState");
  }, V.prototype.forceUpdate = function(v) {
    this.updater.enqueueForceUpdate(this, v, "forceUpdate");
  };
  function b() {
  }
  b.prototype = V.prototype;
  function F(v, B, Y) {
    this.props = v, this.context = B, this.refs = E, this.updater = Y || n;
  }
  var l = F.prototype = new b();
  l.constructor = F, d(l, V.prototype), l.isPureReactComponent = !0;
  var T = Array.isArray, $ = Object.prototype.hasOwnProperty, q = { current: null }, z = { key: !0, ref: !0, __self: !0, __source: !0 };
  function U(v, B, Y) {
    var ss, C = {}, hs = null, ps = null;
    if (B != null) for (ss in B.ref !== void 0 && (ps = B.ref), B.key !== void 0 && (hs = "" + B.key), B) $.call(B, ss) && !z.hasOwnProperty(ss) && (C[ss] = B[ss]);
    var Ss = arguments.length - 2;
    if (Ss === 1) C.children = Y;
    else if (1 < Ss) {
      for (var As = Array(Ss), $s = 0; $s < Ss; $s++) As[$s] = arguments[$s + 2];
      C.children = As;
    }
    if (v && v.defaultProps) for (ss in Ss = v.defaultProps, Ss) C[ss] === void 0 && (C[ss] = Ss[ss]);
    return { $$typeof: s, type: v, key: hs, ref: ps, props: C, _owner: q.current };
  }
  function Z(v, B) {
    return { $$typeof: s, type: v.type, key: B, ref: v.ref, props: v.props, _owner: v._owner };
  }
  function O(v) {
    return typeof v == "object" && v !== null && v.$$typeof === s;
  }
  function os(v) {
    var B = { "=": "=0", ":": "=2" };
    return "$" + v.replace(/[=:]/g, function(Y) {
      return B[Y];
    });
  }
  var qs = /\/+/g;
  function fs(v, B) {
    return typeof v == "object" && v !== null && v.key != null ? os("" + v.key) : B.toString(36);
  }
  function ls(v, B, Y, ss, C) {
    var hs = typeof v;
    (hs === "undefined" || hs === "boolean") && (v = null);
    var ps = !1;
    if (v === null) ps = !0;
    else switch (hs) {
      case "string":
      case "number":
        ps = !0;
        break;
      case "object":
        switch (v.$$typeof) {
          case s:
          case e:
            ps = !0;
        }
    }
    if (ps) return ps = v, C = C(ps), v = ss === "" ? "." + fs(ps, 0) : ss, T(C) ? (Y = "", v != null && (Y = v.replace(qs, "$&/") + "/"), ls(C, B, Y, "", function($s) {
      return $s;
    })) : C != null && (O(C) && (C = Z(C, Y + (!C.key || ps && ps.key === C.key ? "" : ("" + C.key).replace(qs, "$&/") + "/") + v)), B.push(C)), 1;
    if (ps = 0, ss = ss === "" ? "." : ss + ":", T(v)) for (var Ss = 0; Ss < v.length; Ss++) {
      hs = v[Ss];
      var As = ss + fs(hs, Ss);
      ps += ls(hs, B, Y, As, C);
    }
    else if (As = c(v), typeof As == "function") for (v = As.call(v), Ss = 0; !(hs = v.next()).done; ) hs = hs.value, As = ss + fs(hs, Ss++), ps += ls(hs, B, Y, As, C);
    else if (hs === "object") throw B = String(v), Error("Objects are not valid as a React child (found: " + (B === "[object Object]" ? "object with keys {" + Object.keys(v).join(", ") + "}" : B) + "). If you meant to render a collection of children, use an array instead.");
    return ps;
  }
  function Ms(v, B, Y) {
    if (v == null) return v;
    var ss = [], C = 0;
    return ls(v, ss, "", "", function(hs) {
      return B.call(Y, hs, C++);
    }), ss;
  }
  function js(v) {
    if (v._status === -1) {
      var B = v._result;
      B = B(), B.then(function(Y) {
        (v._status === 0 || v._status === -1) && (v._status = 1, v._result = Y);
      }, function(Y) {
        (v._status === 0 || v._status === -1) && (v._status = 2, v._result = Y);
      }), v._status === -1 && (v._status = 0, v._result = B);
    }
    if (v._status === 1) return v._result.default;
    throw v._result;
  }
  var J = { current: null }, Ws = { transition: null }, ws = { ReactCurrentDispatcher: J, ReactCurrentBatchConfig: Ws, ReactCurrentOwner: q };
  return g.Children = { map: Ms, forEach: function(v, B, Y) {
    Ms(v, function() {
      B.apply(this, arguments);
    }, Y);
  }, count: function(v) {
    var B = 0;
    return Ms(v, function() {
      B++;
    }), B;
  }, toArray: function(v) {
    return Ms(v, function(B) {
      return B;
    }) || [];
  }, only: function(v) {
    if (!O(v)) throw Error("React.Children.only expected to receive a single React element child.");
    return v;
  } }, g.Component = V, g.Fragment = t, g.Profiler = u, g.PureComponent = F, g.StrictMode = r, g.Suspense = h, g.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ws, g.cloneElement = function(v, B, Y) {
    if (v == null) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + v + ".");
    var ss = d({}, v.props), C = v.key, hs = v.ref, ps = v._owner;
    if (B != null) {
      if (B.ref !== void 0 && (hs = B.ref, ps = q.current), B.key !== void 0 && (C = "" + B.key), v.type && v.type.defaultProps) var Ss = v.type.defaultProps;
      for (As in B) $.call(B, As) && !z.hasOwnProperty(As) && (ss[As] = B[As] === void 0 && Ss !== void 0 ? Ss[As] : B[As]);
    }
    var As = arguments.length - 2;
    if (As === 1) ss.children = Y;
    else if (1 < As) {
      Ss = Array(As);
      for (var $s = 0; $s < As; $s++) Ss[$s] = arguments[$s + 2];
      ss.children = Ss;
    }
    return { $$typeof: s, type: v.type, key: C, ref: hs, props: ss, _owner: ps };
  }, g.createContext = function(v) {
    return v = { $$typeof: i, _currentValue: v, _currentValue2: v, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null }, v.Provider = { $$typeof: a, _context: v }, v.Consumer = v;
  }, g.createElement = U, g.createFactory = function(v) {
    var B = U.bind(null, v);
    return B.type = v, B;
  }, g.createRef = function() {
    return { current: null };
  }, g.forwardRef = function(v) {
    return { $$typeof: _, render: v };
  }, g.isValidElement = O, g.lazy = function(v) {
    return { $$typeof: A, _payload: { _status: -1, _result: v }, _init: js };
  }, g.memo = function(v, B) {
    return { $$typeof: f, type: v, compare: B === void 0 ? null : B };
  }, g.startTransition = function(v) {
    var B = Ws.transition;
    Ws.transition = {};
    try {
      v();
    } finally {
      Ws.transition = B;
    }
  }, g.unstable_act = function() {
    throw Error("act(...) is not supported in production builds of React.");
  }, g.useCallback = function(v, B) {
    return J.current.useCallback(v, B);
  }, g.useContext = function(v) {
    return J.current.useContext(v);
  }, g.useDebugValue = function() {
  }, g.useDeferredValue = function(v) {
    return J.current.useDeferredValue(v);
  }, g.useEffect = function(v, B) {
    return J.current.useEffect(v, B);
  }, g.useId = function() {
    return J.current.useId();
  }, g.useImperativeHandle = function(v, B, Y) {
    return J.current.useImperativeHandle(v, B, Y);
  }, g.useInsertionEffect = function(v, B) {
    return J.current.useInsertionEffect(v, B);
  }, g.useLayoutEffect = function(v, B) {
    return J.current.useLayoutEffect(v, B);
  }, g.useMemo = function(v, B) {
    return J.current.useMemo(v, B);
  }, g.useReducer = function(v, B, Y) {
    return J.current.useReducer(v, B, Y);
  }, g.useRef = function(v) {
    return J.current.useRef(v);
  }, g.useState = function(v) {
    return J.current.useState(v);
  }, g.useSyncExternalStore = function(v, B, Y) {
    return J.current.useSyncExternalStore(v, B, Y);
  }, g.useTransition = function() {
    return J.current.useTransition();
  }, g.version = "18.2.0", g;
}
var je = { exports: {} };
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
je.exports;
var A_;
function Jc() {
  return A_ || (A_ = 1, function(s, e) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var t = "18.2.0", r = Symbol.for("react.element"), u = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), _ = Symbol.for("react.profiler"), h = Symbol.for("react.provider"), f = Symbol.for("react.context"), A = Symbol.for("react.forward_ref"), y = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), n = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), E = Symbol.for("react.offscreen"), V = Symbol.iterator, b = "@@iterator";
      function F(S) {
        if (S === null || typeof S != "object")
          return null;
        var D = V && S[V] || S[b];
        return typeof D == "function" ? D : null;
      }
      var l = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      }, T = {
        transition: null
      }, $ = {
        current: null,
        // Used to reproduce behavior of `batchedUpdates` in legacy mode.
        isBatchingLegacy: !1,
        didScheduleLegacyUpdate: !1
      }, q = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      }, z = {}, U = null;
      function Z(S) {
        U = S;
      }
      z.setExtraStackFrame = function(S) {
        U = S;
      }, z.getCurrentStack = null, z.getStackAddendum = function() {
        var S = "";
        U && (S += U);
        var D = z.getCurrentStack;
        return D && (S += D() || ""), S;
      };
      var O = !1, os = !1, qs = !1, fs = !1, ls = !1, Ms = {
        ReactCurrentDispatcher: l,
        ReactCurrentBatchConfig: T,
        ReactCurrentOwner: q
      };
      Ms.ReactDebugCurrentFrame = z, Ms.ReactCurrentActQueue = $;
      function js(S) {
        {
          for (var D = arguments.length, m = new Array(D > 1 ? D - 1 : 0), w = 1; w < D; w++)
            m[w - 1] = arguments[w];
          Ws("warn", S, m);
        }
      }
      function J(S) {
        {
          for (var D = arguments.length, m = new Array(D > 1 ? D - 1 : 0), w = 1; w < D; w++)
            m[w - 1] = arguments[w];
          Ws("error", S, m);
        }
      }
      function Ws(S, D, m) {
        {
          var w = Ms.ReactDebugCurrentFrame, P = w.getStackAddendum();
          P !== "" && (D += "%s", m = m.concat([P]));
          var H = m.map(function(j) {
            return String(j);
          });
          H.unshift("Warning: " + D), Function.prototype.apply.call(console[S], console, H);
        }
      }
      var ws = {};
      function v(S, D) {
        {
          var m = S.constructor, w = m && (m.displayName || m.name) || "ReactClass", P = w + "." + D;
          if (ws[P])
            return;
          J("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", D, w), ws[P] = !0;
        }
      }
      var B = {
        /**
         * Checks whether or not this composite component is mounted.
         * @param {ReactClass} publicInstance The instance we want to test.
         * @return {boolean} True if mounted, false otherwise.
         * @protected
         * @final
         */
        isMounted: function(S) {
          return !1;
        },
        /**
         * Forces an update. This should only be invoked when it is known with
         * certainty that we are **not** in a DOM transaction.
         *
         * You may want to call this when you know that some deeper aspect of the
         * component's state has changed but `setState` was not called.
         *
         * This will not invoke `shouldComponentUpdate`, but it will invoke
         * `componentWillUpdate` and `componentDidUpdate`.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueForceUpdate: function(S, D, m) {
          v(S, "forceUpdate");
        },
        /**
         * Replaces all of the state. Always use this or `setState` to mutate state.
         * You should treat `this.state` as immutable.
         *
         * There is no guarantee that `this.state` will be immediately updated, so
         * accessing `this.state` after calling this method may return the old value.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} completeState Next state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueReplaceState: function(S, D, m, w) {
          v(S, "replaceState");
        },
        /**
         * Sets a subset of the state. This only exists because _pendingState is
         * internal. This provides a merging strategy that is not available to deep
         * properties which is confusing. TODO: Expose pendingState or don't use it
         * during the merge.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} partialState Next partial state to be merged with state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} Name of the calling function in the public API.
         * @internal
         */
        enqueueSetState: function(S, D, m, w) {
          v(S, "setState");
        }
      }, Y = Object.assign, ss = {};
      Object.freeze(ss);
      function C(S, D, m) {
        this.props = S, this.context = D, this.refs = ss, this.updater = m || B;
      }
      C.prototype.isReactComponent = {}, C.prototype.setState = function(S, D) {
        if (typeof S != "object" && typeof S != "function" && S != null)
          throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, S, D, "setState");
      }, C.prototype.forceUpdate = function(S) {
        this.updater.enqueueForceUpdate(this, S, "forceUpdate");
      };
      {
        var hs = {
          isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
          replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
        }, ps = function(S, D) {
          Object.defineProperty(C.prototype, S, {
            get: function() {
              js("%s(...) is deprecated in plain JavaScript React classes. %s", D[0], D[1]);
            }
          });
        };
        for (var Ss in hs)
          hs.hasOwnProperty(Ss) && ps(Ss, hs[Ss]);
      }
      function As() {
      }
      As.prototype = C.prototype;
      function $s(S, D, m) {
        this.props = S, this.context = D, this.refs = ss, this.updater = m || B;
      }
      var Yt = $s.prototype = new As();
      Yt.constructor = $s, Y(Yt, C.prototype), Yt.isPureReactComponent = !0;
      function Sh() {
        var S = {
          current: null
        };
        return Object.seal(S), S;
      }
      var Ah = Array.isArray;
      function st(S) {
        return Ah(S);
      }
      function yh(S) {
        {
          var D = typeof Symbol == "function" && Symbol.toStringTag, m = D && S[Symbol.toStringTag] || S.constructor.name || "Object";
          return m;
        }
      }
      function ch(S) {
        try {
          return $a(S), !1;
        } catch {
          return !0;
        }
      }
      function $a(S) {
        return "" + S;
      }
      function et(S) {
        if (ch(S))
          return J("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", yh(S)), $a(S);
      }
      function nh(S, D, m) {
        var w = S.displayName;
        if (w)
          return w;
        var P = D.displayName || D.name || "";
        return P !== "" ? m + "(" + P + ")" : m;
      }
      function Ta(S) {
        return S.displayName || "Context";
      }
      function Zs(S) {
        if (S == null)
          return null;
        if (typeof S.tag == "number" && J("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof S == "function")
          return S.displayName || S.name || null;
        if (typeof S == "string")
          return S;
        switch (S) {
          case a:
            return "Fragment";
          case u:
            return "Portal";
          case _:
            return "Profiler";
          case i:
            return "StrictMode";
          case y:
            return "Suspense";
          case c:
            return "SuspenseList";
        }
        if (typeof S == "object")
          switch (S.$$typeof) {
            case f:
              var D = S;
              return Ta(D) + ".Consumer";
            case h:
              var m = S;
              return Ta(m._context) + ".Provider";
            case A:
              return nh(S, S.render, "ForwardRef");
            case n:
              var w = S.displayName || null;
              return w !== null ? w : Zs(S.type) || "Memo";
            case d: {
              var P = S, H = P._payload, j = P._init;
              try {
                return Zs(j(H));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var oe = Object.prototype.hasOwnProperty, Pa = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Ba, qa, Kt;
      Kt = {};
      function Ga(S) {
        if (oe.call(S, "ref")) {
          var D = Object.getOwnPropertyDescriptor(S, "ref").get;
          if (D && D.isReactWarning)
            return !1;
        }
        return S.ref !== void 0;
      }
      function Ra(S) {
        if (oe.call(S, "key")) {
          var D = Object.getOwnPropertyDescriptor(S, "key").get;
          if (D && D.isReactWarning)
            return !1;
        }
        return S.key !== void 0;
      }
      function Dh(S, D) {
        var m = function() {
          Ba || (Ba = !0, J("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", D));
        };
        m.isReactWarning = !0, Object.defineProperty(S, "key", {
          get: m,
          configurable: !0
        });
      }
      function dh(S, D) {
        var m = function() {
          qa || (qa = !0, J("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", D));
        };
        m.isReactWarning = !0, Object.defineProperty(S, "ref", {
          get: m,
          configurable: !0
        });
      }
      function ph(S) {
        if (typeof S.ref == "string" && q.current && S.__self && q.current.stateNode !== S.__self) {
          var D = Zs(q.current.type);
          Kt[D] || (J('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', D, S.ref), Kt[D] = !0);
        }
      }
      var Xt = function(S, D, m, w, P, H, j) {
        var X = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: r,
          // Built-in properties that belong on the element
          type: S,
          key: D,
          ref: m,
          props: j,
          // Record the component responsible for creating this element.
          _owner: H
        };
        return X._store = {}, Object.defineProperty(X._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(X, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: w
        }), Object.defineProperty(X, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: P
        }), Object.freeze && (Object.freeze(X.props), Object.freeze(X)), X;
      };
      function bh(S, D, m) {
        var w, P = {}, H = null, j = null, X = null, L = null;
        if (D != null) {
          Ga(D) && (j = D.ref, ph(D)), Ra(D) && (et(D.key), H = "" + D.key), X = D.__self === void 0 ? null : D.__self, L = D.__source === void 0 ? null : D.__source;
          for (w in D)
            oe.call(D, w) && !Pa.hasOwnProperty(w) && (P[w] = D[w]);
        }
        var is = arguments.length - 2;
        if (is === 1)
          P.children = m;
        else if (is > 1) {
          for (var ys = Array(is), cs = 0; cs < is; cs++)
            ys[cs] = arguments[cs + 2];
          Object.freeze && Object.freeze(ys), P.children = ys;
        }
        if (S && S.defaultProps) {
          var ns = S.defaultProps;
          for (w in ns)
            P[w] === void 0 && (P[w] = ns[w]);
        }
        if (H || j) {
          var bs = typeof S == "function" ? S.displayName || S.name || "Unknown" : S;
          H && Dh(P, bs), j && dh(P, bs);
        }
        return Xt(S, H, j, X, L, q.current, P);
      }
      function Eh(S, D) {
        var m = Xt(S.type, D, S.ref, S._self, S._source, S._owner, S.props);
        return m;
      }
      function vh(S, D, m) {
        if (S == null)
          throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + S + ".");
        var w, P = Y({}, S.props), H = S.key, j = S.ref, X = S._self, L = S._source, is = S._owner;
        if (D != null) {
          Ga(D) && (j = D.ref, is = q.current), Ra(D) && (et(D.key), H = "" + D.key);
          var ys;
          S.type && S.type.defaultProps && (ys = S.type.defaultProps);
          for (w in D)
            oe.call(D, w) && !Pa.hasOwnProperty(w) && (D[w] === void 0 && ys !== void 0 ? P[w] = ys[w] : P[w] = D[w]);
        }
        var cs = arguments.length - 2;
        if (cs === 1)
          P.children = m;
        else if (cs > 1) {
          for (var ns = Array(cs), bs = 0; bs < cs; bs++)
            ns[bs] = arguments[bs + 2];
          P.children = ns;
        }
        return Xt(S.type, H, j, X, L, is, P);
      }
      function fe(S) {
        return typeof S == "object" && S !== null && S.$$typeof === r;
      }
      var ja = ".", mh = ":";
      function Vh(S) {
        var D = /[=:]/g, m = {
          "=": "=0",
          ":": "=2"
        }, w = S.replace(D, function(P) {
          return m[P];
        });
        return "$" + w;
      }
      var Ua = !1, lh = /\/+/g;
      function Qa(S) {
        return S.replace(lh, "$&/");
      }
      function Zt(S, D) {
        return typeof S == "object" && S !== null && S.key != null ? (et(S.key), Vh("" + S.key)) : D.toString(36);
      }
      function tt(S, D, m, w, P) {
        var H = typeof S;
        (H === "undefined" || H === "boolean") && (S = null);
        var j = !1;
        if (S === null)
          j = !0;
        else
          switch (H) {
            case "string":
            case "number":
              j = !0;
              break;
            case "object":
              switch (S.$$typeof) {
                case r:
                case u:
                  j = !0;
              }
          }
        if (j) {
          var X = S, L = P(X), is = w === "" ? ja + Zt(X, 0) : w;
          if (st(L)) {
            var ys = "";
            is != null && (ys = Qa(is) + "/"), tt(L, D, ys, "", function(dS) {
              return dS;
            });
          } else L != null && (fe(L) && (L.key && (!X || X.key !== L.key) && et(L.key), L = Eh(
            L,
            // Keep both the (mapped) and old keys if they differ, just as
            // traverseAllChildren used to do for objects as children
            m + // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
            (L.key && (!X || X.key !== L.key) ? (
              // $FlowFixMe Flow incorrectly thinks existing element's key can be a number
              // eslint-disable-next-line react-internal/safe-string-coercion
              Qa("" + L.key) + "/"
            ) : "") + is
          )), D.push(L));
          return 1;
        }
        var cs, ns, bs = 0, Fs = w === "" ? ja : w + mh;
        if (st(S))
          for (var St = 0; St < S.length; St++)
            cs = S[St], ns = Fs + Zt(cs, St), bs += tt(cs, D, m, ns, P);
        else {
          var rr = F(S);
          if (typeof rr == "function") {
            var fi = S;
            rr === fi.entries && (Ua || js("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), Ua = !0);
            for (var nS = rr.call(fi), hi, DS = 0; !(hi = nS.next()).done; )
              cs = hi.value, ns = Fs + Zt(cs, DS++), bs += tt(cs, D, m, ns, P);
          } else if (H === "object") {
            var Si = String(S);
            throw new Error("Objects are not valid as a React child (found: " + (Si === "[object Object]" ? "object with keys {" + Object.keys(S).join(", ") + "}" : Si) + "). If you meant to render a collection of children, use an array instead.");
          }
        }
        return bs;
      }
      function rt(S, D, m) {
        if (S == null)
          return S;
        var w = [], P = 0;
        return tt(S, w, "", "", function(H) {
          return D.call(m, H, P++);
        }), w;
      }
      function wh(S) {
        var D = 0;
        return rt(S, function() {
          D++;
        }), D;
      }
      function Fh(S, D, m) {
        rt(S, function() {
          D.apply(this, arguments);
        }, m);
      }
      function xh(S) {
        return rt(S, function(D) {
          return D;
        }) || [];
      }
      function oh(S) {
        if (!fe(S))
          throw new Error("React.Children.only expected to receive a single React element child.");
        return S;
      }
      function Mh(S) {
        var D = {
          $$typeof: f,
          // As a workaround to support multiple concurrent renderers, we categorize
          // some renderers as primary and others as secondary. We only expect
          // there to be two concurrent renderers at most: React Native (primary) and
          // Fabric (secondary); React DOM (primary) and React ART (secondary).
          // Secondary renderers store their context values on separate fields.
          _currentValue: S,
          _currentValue2: S,
          // Used to track how many concurrent renderers this context currently
          // supports within in a single renderer. Such as parallel server rendering.
          _threadCount: 0,
          // These are circular
          Provider: null,
          Consumer: null,
          // Add these to use same hidden class in VM as ServerContext
          _defaultValue: null,
          _globalName: null
        };
        D.Provider = {
          $$typeof: h,
          _context: D
        };
        var m = !1, w = !1, P = !1;
        {
          var H = {
            $$typeof: f,
            _context: D
          };
          Object.defineProperties(H, {
            Provider: {
              get: function() {
                return w || (w = !0, J("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?")), D.Provider;
              },
              set: function(j) {
                D.Provider = j;
              }
            },
            _currentValue: {
              get: function() {
                return D._currentValue;
              },
              set: function(j) {
                D._currentValue = j;
              }
            },
            _currentValue2: {
              get: function() {
                return D._currentValue2;
              },
              set: function(j) {
                D._currentValue2 = j;
              }
            },
            _threadCount: {
              get: function() {
                return D._threadCount;
              },
              set: function(j) {
                D._threadCount = j;
              }
            },
            Consumer: {
              get: function() {
                return m || (m = !0, J("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?")), D.Consumer;
              }
            },
            displayName: {
              get: function() {
                return D.displayName;
              },
              set: function(j) {
                P || (js("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", j), P = !0);
              }
            }
          }), D.Consumer = H;
        }
        return D._currentRenderer = null, D._currentRenderer2 = null, D;
      }
      var Me = -1, Ct = 0, za = 1, $h = 2;
      function Th(S) {
        if (S._status === Me) {
          var D = S._result, m = D();
          if (m.then(function(H) {
            if (S._status === Ct || S._status === Me) {
              var j = S;
              j._status = za, j._result = H;
            }
          }, function(H) {
            if (S._status === Ct || S._status === Me) {
              var j = S;
              j._status = $h, j._result = H;
            }
          }), S._status === Me) {
            var w = S;
            w._status = Ct, w._result = m;
          }
        }
        if (S._status === za) {
          var P = S._result;
          return P === void 0 && J(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))

Did you accidentally put curly braces around the import?`, P), "default" in P || J(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`, P), P.default;
        } else
          throw S._result;
      }
      function Ph(S) {
        var D = {
          // We use these fields to store the result.
          _status: Me,
          _result: S
        }, m = {
          $$typeof: d,
          _payload: D,
          _init: Th
        };
        {
          var w, P;
          Object.defineProperties(m, {
            defaultProps: {
              configurable: !0,
              get: function() {
                return w;
              },
              set: function(H) {
                J("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), w = H, Object.defineProperty(m, "defaultProps", {
                  enumerable: !0
                });
              }
            },
            propTypes: {
              configurable: !0,
              get: function() {
                return P;
              },
              set: function(H) {
                J("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), P = H, Object.defineProperty(m, "propTypes", {
                  enumerable: !0
                });
              }
            }
          });
        }
        return m;
      }
      function Bh(S) {
        S != null && S.$$typeof === n ? J("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : typeof S != "function" ? J("forwardRef requires a render function but was given %s.", S === null ? "null" : typeof S) : S.length !== 0 && S.length !== 2 && J("forwardRef render functions accept exactly two parameters: props and ref. %s", S.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."), S != null && (S.defaultProps != null || S.propTypes != null) && J("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        var D = {
          $$typeof: A,
          render: S
        };
        {
          var m;
          Object.defineProperty(D, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return m;
            },
            set: function(w) {
              m = w, !S.name && !S.displayName && (S.displayName = w);
            }
          });
        }
        return D;
      }
      var Wa;
      Wa = Symbol.for("react.module.reference");
      function Na(S) {
        return !!(typeof S == "string" || typeof S == "function" || S === a || S === _ || ls || S === i || S === y || S === c || fs || S === E || O || os || qs || typeof S == "object" && S !== null && (S.$$typeof === d || S.$$typeof === n || S.$$typeof === h || S.$$typeof === f || S.$$typeof === A || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        S.$$typeof === Wa || S.getModuleId !== void 0));
      }
      function qh(S, D) {
        Na(S) || J("memo: The first argument must be a component. Instead received: %s", S === null ? "null" : typeof S);
        var m = {
          $$typeof: n,
          type: S,
          compare: D === void 0 ? null : D
        };
        {
          var w;
          Object.defineProperty(m, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return w;
            },
            set: function(P) {
              w = P, !S.name && !S.displayName && (S.displayName = P);
            }
          });
        }
        return m;
      }
      function Ts() {
        var S = l.current;
        return S === null && J(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`), S;
      }
      function Gh(S) {
        var D = Ts();
        if (S._context !== void 0) {
          var m = S._context;
          m.Consumer === S ? J("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?") : m.Provider === S && J("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return D.useContext(S);
      }
      function Rh(S) {
        var D = Ts();
        return D.useState(S);
      }
      function jh(S, D, m) {
        var w = Ts();
        return w.useReducer(S, D, m);
      }
      function Uh(S) {
        var D = Ts();
        return D.useRef(S);
      }
      function Qh(S, D) {
        var m = Ts();
        return m.useEffect(S, D);
      }
      function zh(S, D) {
        var m = Ts();
        return m.useInsertionEffect(S, D);
      }
      function Wh(S, D) {
        var m = Ts();
        return m.useLayoutEffect(S, D);
      }
      function Nh(S, D) {
        var m = Ts();
        return m.useCallback(S, D);
      }
      function Ih(S, D) {
        var m = Ts();
        return m.useMemo(S, D);
      }
      function Jh(S, D, m) {
        var w = Ts();
        return w.useImperativeHandle(S, D, m);
      }
      function Hh(S, D) {
        {
          var m = Ts();
          return m.useDebugValue(S, D);
        }
      }
      function Yh() {
        var S = Ts();
        return S.useTransition();
      }
      function Kh(S) {
        var D = Ts();
        return D.useDeferredValue(S);
      }
      function Xh() {
        var S = Ts();
        return S.useId();
      }
      function Zh(S, D, m) {
        var w = Ts();
        return w.useSyncExternalStore(S, D, m);
      }
      var $e = 0, Ia, Ja, Ha, Ya, Ka, Xa, Za;
      function Ca() {
      }
      Ca.__reactDisabledLog = !0;
      function Ch() {
        {
          if ($e === 0) {
            Ia = console.log, Ja = console.info, Ha = console.warn, Ya = console.error, Ka = console.group, Xa = console.groupCollapsed, Za = console.groupEnd;
            var S = {
              configurable: !0,
              enumerable: !0,
              value: Ca,
              writable: !0
            };
            Object.defineProperties(console, {
              info: S,
              log: S,
              warn: S,
              error: S,
              group: S,
              groupCollapsed: S,
              groupEnd: S
            });
          }
          $e++;
        }
      }
      function gh() {
        {
          if ($e--, $e === 0) {
            var S = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: Y({}, S, {
                value: Ia
              }),
              info: Y({}, S, {
                value: Ja
              }),
              warn: Y({}, S, {
                value: Ha
              }),
              error: Y({}, S, {
                value: Ya
              }),
              group: Y({}, S, {
                value: Ka
              }),
              groupCollapsed: Y({}, S, {
                value: Xa
              }),
              groupEnd: Y({}, S, {
                value: Za
              })
            });
          }
          $e < 0 && J("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var gt = Ms.ReactCurrentDispatcher, kt;
      function ut(S, D, m) {
        {
          if (kt === void 0)
            try {
              throw Error();
            } catch (P) {
              var w = P.stack.trim().match(/\n( *(at )?)/);
              kt = w && w[1] || "";
            }
          return `
` + kt + S;
        }
      }
      var Ot = !1, at;
      {
        var kh = typeof WeakMap == "function" ? WeakMap : Map;
        at = new kh();
      }
      function ga(S, D) {
        if (!S || Ot)
          return "";
        {
          var m = at.get(S);
          if (m !== void 0)
            return m;
        }
        var w;
        Ot = !0;
        var P = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var H;
        H = gt.current, gt.current = null, Ch();
        try {
          if (D) {
            var j = function() {
              throw Error();
            };
            if (Object.defineProperty(j.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(j, []);
              } catch (Fs) {
                w = Fs;
              }
              Reflect.construct(S, [], j);
            } else {
              try {
                j.call();
              } catch (Fs) {
                w = Fs;
              }
              S.call(j.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (Fs) {
              w = Fs;
            }
            S();
          }
        } catch (Fs) {
          if (Fs && w && typeof Fs.stack == "string") {
            for (var X = Fs.stack.split(`
`), L = w.stack.split(`
`), is = X.length - 1, ys = L.length - 1; is >= 1 && ys >= 0 && X[is] !== L[ys]; )
              ys--;
            for (; is >= 1 && ys >= 0; is--, ys--)
              if (X[is] !== L[ys]) {
                if (is !== 1 || ys !== 1)
                  do
                    if (is--, ys--, ys < 0 || X[is] !== L[ys]) {
                      var cs = `
` + X[is].replace(" at new ", " at ");
                      return S.displayName && cs.includes("<anonymous>") && (cs = cs.replace("<anonymous>", S.displayName)), typeof S == "function" && at.set(S, cs), cs;
                    }
                  while (is >= 1 && ys >= 0);
                break;
              }
          }
        } finally {
          Ot = !1, gt.current = H, gh(), Error.prepareStackTrace = P;
        }
        var ns = S ? S.displayName || S.name : "", bs = ns ? ut(ns) : "";
        return typeof S == "function" && at.set(S, bs), bs;
      }
      function Oh(S, D, m) {
        return ga(S, !1);
      }
      function Lh(S) {
        var D = S.prototype;
        return !!(D && D.isReactComponent);
      }
      function it(S, D, m) {
        if (S == null)
          return "";
        if (typeof S == "function")
          return ga(S, Lh(S));
        if (typeof S == "string")
          return ut(S);
        switch (S) {
          case y:
            return ut("Suspense");
          case c:
            return ut("SuspenseList");
        }
        if (typeof S == "object")
          switch (S.$$typeof) {
            case A:
              return Oh(S.render);
            case n:
              return it(S.type, D, m);
            case d: {
              var w = S, P = w._payload, H = w._init;
              try {
                return it(H(P), D, m);
              } catch {
              }
            }
          }
        return "";
      }
      var ka = {}, Oa = Ms.ReactDebugCurrentFrame;
      function _t(S) {
        if (S) {
          var D = S._owner, m = it(S.type, S._source, D ? D.type : null);
          Oa.setExtraStackFrame(m);
        } else
          Oa.setExtraStackFrame(null);
      }
      function sS(S, D, m, w, P) {
        {
          var H = Function.call.bind(oe);
          for (var j in S)
            if (H(S, j)) {
              var X = void 0;
              try {
                if (typeof S[j] != "function") {
                  var L = Error((w || "React class") + ": " + m + " type `" + j + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof S[j] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw L.name = "Invariant Violation", L;
                }
                X = S[j](D, j, w, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (is) {
                X = is;
              }
              X && !(X instanceof Error) && (_t(P), J("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", w || "React class", m, j, typeof X), _t(null)), X instanceof Error && !(X.message in ka) && (ka[X.message] = !0, _t(P), J("Failed %s type: %s", m, X.message), _t(null));
            }
        }
      }
      function he(S) {
        if (S) {
          var D = S._owner, m = it(S.type, S._source, D ? D.type : null);
          Z(m);
        } else
          Z(null);
      }
      var Lt;
      Lt = !1;
      function La() {
        if (q.current) {
          var S = Zs(q.current.type);
          if (S)
            return `

Check the render method of \`` + S + "`.";
        }
        return "";
      }
      function eS(S) {
        if (S !== void 0) {
          var D = S.fileName.replace(/^.*[\\\/]/, ""), m = S.lineNumber;
          return `

Check your code at ` + D + ":" + m + ".";
        }
        return "";
      }
      function tS(S) {
        return S != null ? eS(S.__source) : "";
      }
      var si = {};
      function rS(S) {
        var D = La();
        if (!D) {
          var m = typeof S == "string" ? S : S.displayName || S.name;
          m && (D = `

Check the top-level render call using <` + m + ">.");
        }
        return D;
      }
      function ei(S, D) {
        if (!(!S._store || S._store.validated || S.key != null)) {
          S._store.validated = !0;
          var m = rS(D);
          if (!si[m]) {
            si[m] = !0;
            var w = "";
            S && S._owner && S._owner !== q.current && (w = " It was passed a child from " + Zs(S._owner.type) + "."), he(S), J('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, w), he(null);
          }
        }
      }
      function ti(S, D) {
        if (typeof S == "object") {
          if (st(S))
            for (var m = 0; m < S.length; m++) {
              var w = S[m];
              fe(w) && ei(w, D);
            }
          else if (fe(S))
            S._store && (S._store.validated = !0);
          else if (S) {
            var P = F(S);
            if (typeof P == "function" && P !== S.entries)
              for (var H = P.call(S), j; !(j = H.next()).done; )
                fe(j.value) && ei(j.value, D);
          }
        }
      }
      function ri(S) {
        {
          var D = S.type;
          if (D == null || typeof D == "string")
            return;
          var m;
          if (typeof D == "function")
            m = D.propTypes;
          else if (typeof D == "object" && (D.$$typeof === A || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          D.$$typeof === n))
            m = D.propTypes;
          else
            return;
          if (m) {
            var w = Zs(D);
            sS(m, S.props, "prop", w, S);
          } else if (D.PropTypes !== void 0 && !Lt) {
            Lt = !0;
            var P = Zs(D);
            J("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
          }
          typeof D.getDefaultProps == "function" && !D.getDefaultProps.isReactClassApproved && J("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function uS(S) {
        {
          for (var D = Object.keys(S.props), m = 0; m < D.length; m++) {
            var w = D[m];
            if (w !== "children" && w !== "key") {
              he(S), J("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", w), he(null);
              break;
            }
          }
          S.ref !== null && (he(S), J("Invalid attribute `ref` supplied to `React.Fragment`."), he(null));
        }
      }
      function ui(S, D, m) {
        var w = Na(S);
        if (!w) {
          var P = "";
          (S === void 0 || typeof S == "object" && S !== null && Object.keys(S).length === 0) && (P += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var H = tS(D);
          H ? P += H : P += La();
          var j;
          S === null ? j = "null" : st(S) ? j = "array" : S !== void 0 && S.$$typeof === r ? (j = "<" + (Zs(S.type) || "Unknown") + " />", P = " Did you accidentally export a JSX literal instead of a component?") : j = typeof S, J("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", j, P);
        }
        var X = bh.apply(this, arguments);
        if (X == null)
          return X;
        if (w)
          for (var L = 2; L < arguments.length; L++)
            ti(arguments[L], S);
        return S === a ? uS(X) : ri(X), X;
      }
      var ai = !1;
      function aS(S) {
        var D = ui.bind(null, S);
        return D.type = S, ai || (ai = !0, js("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.")), Object.defineProperty(D, "type", {
          enumerable: !1,
          get: function() {
            return js("Factory.type is deprecated. Access the class directly before passing it to createFactory."), Object.defineProperty(this, "type", {
              value: S
            }), S;
          }
        }), D;
      }
      function iS(S, D, m) {
        for (var w = vh.apply(this, arguments), P = 2; P < arguments.length; P++)
          ti(arguments[P], w.type);
        return ri(w), w;
      }
      function _S(S, D) {
        var m = T.transition;
        T.transition = {};
        var w = T.transition;
        T.transition._updatedFibers = /* @__PURE__ */ new Set();
        try {
          S();
        } finally {
          if (T.transition = m, m === null && w._updatedFibers) {
            var P = w._updatedFibers.size;
            P > 10 && js("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), w._updatedFibers.clear();
          }
        }
      }
      var ii = !1, ft = null;
      function fS(S) {
        if (ft === null)
          try {
            var D = ("require" + Math.random()).slice(0, 7), m = s && s[D];
            ft = m.call(s, "timers").setImmediate;
          } catch {
            ft = function(P) {
              ii === !1 && (ii = !0, typeof MessageChannel > "u" && J("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."));
              var H = new MessageChannel();
              H.port1.onmessage = P, H.port2.postMessage(void 0);
            };
          }
        return ft(S);
      }
      var Se = 0, _i = !1;
      function hS(S) {
        {
          var D = Se;
          Se++, $.current === null && ($.current = []);
          var m = $.isBatchingLegacy, w;
          try {
            if ($.isBatchingLegacy = !0, w = S(), !m && $.didScheduleLegacyUpdate) {
              var P = $.current;
              P !== null && ($.didScheduleLegacyUpdate = !1, tr(P));
            }
          } catch (ns) {
            throw ht(D), ns;
          } finally {
            $.isBatchingLegacy = m;
          }
          if (w !== null && typeof w == "object" && typeof w.then == "function") {
            var H = w, j = !1, X = {
              then: function(ns, bs) {
                j = !0, H.then(function(Fs) {
                  ht(D), Se === 0 ? sr(Fs, ns, bs) : ns(Fs);
                }, function(Fs) {
                  ht(D), bs(Fs);
                });
              }
            };
            return !_i && typeof Promise < "u" && Promise.resolve().then(function() {
            }).then(function() {
              j || (_i = !0, J("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"));
            }), X;
          } else {
            var L = w;
            if (ht(D), Se === 0) {
              var is = $.current;
              is !== null && (tr(is), $.current = null);
              var ys = {
                then: function(ns, bs) {
                  $.current === null ? ($.current = [], sr(L, ns, bs)) : ns(L);
                }
              };
              return ys;
            } else {
              var cs = {
                then: function(ns, bs) {
                  ns(L);
                }
              };
              return cs;
            }
          }
        }
      }
      function ht(S) {
        S !== Se - 1 && J("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. "), Se = S;
      }
      function sr(S, D, m) {
        {
          var w = $.current;
          if (w !== null)
            try {
              tr(w), fS(function() {
                w.length === 0 ? ($.current = null, D(S)) : sr(S, D, m);
              });
            } catch (P) {
              m(P);
            }
          else
            D(S);
        }
      }
      var er = !1;
      function tr(S) {
        if (!er) {
          er = !0;
          var D = 0;
          try {
            for (; D < S.length; D++) {
              var m = S[D];
              do
                m = m(!0);
              while (m !== null);
            }
            S.length = 0;
          } catch (w) {
            throw S = S.slice(D + 1), w;
          } finally {
            er = !1;
          }
        }
      }
      var SS = ui, AS = iS, yS = aS, cS = {
        map: rt,
        forEach: Fh,
        count: wh,
        toArray: xh,
        only: oh
      };
      e.Children = cS, e.Component = C, e.Fragment = a, e.Profiler = _, e.PureComponent = $s, e.StrictMode = i, e.Suspense = y, e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Ms, e.cloneElement = AS, e.createContext = Mh, e.createElement = SS, e.createFactory = yS, e.createRef = Sh, e.forwardRef = Bh, e.isValidElement = fe, e.lazy = Ph, e.memo = qh, e.startTransition = _S, e.unstable_act = hS, e.useCallback = Nh, e.useContext = Gh, e.useDebugValue = Hh, e.useDeferredValue = Kh, e.useEffect = Qh, e.useId = Xh, e.useImperativeHandle = Jh, e.useInsertionEffect = zh, e.useLayoutEffect = Wh, e.useMemo = Ih, e.useReducer = jh, e.useRef = Uh, e.useState = Rh, e.useSyncExternalStore = Zh, e.useTransition = Yh, e.version = t, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(je, je.exports)), je.exports;
}
process.env.NODE_ENV === "production" ? Kr.exports = Ic() : Kr.exports = Jc();
var Hc = Kr.exports;
(function(s) {
  s.exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = void 0, s.exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = void 0, s.exports.__SERVER_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = void 0, Object.assign(s.exports, Hc);
})(qf);
var as = qf.exports;
const Yc = /* @__PURE__ */ Nc(as), Gf = /* @__PURE__ */ pS({
  __proto__: null,
  default: Yc
}, [as]);
var y_ = eu ? Symbol.for("__APOLLO_CONTEXT__") : "__APOLLO_CONTEXT__";
function Rf() {
  Q("createContext" in Gf, 46);
  var s = as.createContext[y_];
  return s || (Object.defineProperty(as.createContext, y_, {
    value: s = as.createContext({}),
    enumerable: !1,
    writable: !1,
    configurable: !0
  }), s.displayName = "ApolloContext"), s;
}
function jf(s) {
  var e = as.useContext(Rf()), t = s || e.client;
  return Q(!!t, 50), t;
}
var c_ = !1, Kc = "useSyncExternalStore", Xc = Gf[Kc], Zc = Xc || function(s, e, t) {
  var r = e();
  // DEVIATION: Using __DEV__
  globalThis.__DEV__ !== !1 && !c_ && // DEVIATION: Not using Object.is because we know our snapshots will never
  // be exotic primitive values like NaN, which is !== itself.
  r !== e() && (c_ = !0, globalThis.__DEV__ !== !1 && Q.error(60));
  var u = as.useState({
    inst: { value: r, getSnapshot: e }
  }), a = u[0].inst, i = u[1];
  return dA ? as.useLayoutEffect(function() {
    Object.assign(a, { value: r, getSnapshot: e }), br(a) && i({ inst: a });
  }, [s, r, e]) : Object.assign(a, { value: r, getSnapshot: e }), as.useEffect(function() {
    return br(a) && i({ inst: a }), s(function() {
      br(a) && i({ inst: a });
    });
  }, [s]), r;
};
function br(s) {
  var e = s.value, t = s.getSnapshot;
  try {
    return e !== t();
  } catch {
    return !0;
  }
}
var Ks;
(function(s) {
  s[s.Query = 0] = "Query", s[s.Mutation = 1] = "Mutation", s[s.Subscription = 2] = "Subscription";
})(Ks || (Ks = {}));
var ae;
function n_(s) {
  var e;
  switch (s) {
    case Ks.Query:
      e = "Query";
      break;
    case Ks.Mutation:
      e = "Mutation";
      break;
    case Ks.Subscription:
      e = "Subscription";
      break;
  }
  return e;
}
function Uf(s) {
  ae || (ae = new tu(
    Ns.parser || 1e3
    /* defaultCacheSizes.parser */
  ));
  var e = ae.get(s);
  if (e)
    return e;
  var t, r, u;
  Q(!!s && !!s.kind, 62, s);
  for (var a = [], i = [], _ = [], h = [], f = 0, A = s.definitions; f < A.length; f++) {
    var y = A[f];
    if (y.kind === "FragmentDefinition") {
      a.push(y);
      continue;
    }
    if (y.kind === "OperationDefinition")
      switch (y.operation) {
        case "query":
          i.push(y);
          break;
        case "mutation":
          _.push(y);
          break;
        case "subscription":
          h.push(y);
          break;
      }
  }
  Q(!a.length || i.length || _.length || h.length, 63), Q(
    i.length + _.length + h.length <= 1,
    64,
    s,
    i.length,
    h.length,
    _.length
  ), r = i.length ? Ks.Query : Ks.Mutation, !i.length && !_.length && (r = Ks.Subscription);
  var c = i.length ? i : _.length ? _ : h;
  Q(c.length === 1, 65, s, c.length);
  var n = c[0];
  t = n.variableDefinitions || [], n.name && n.name.kind === "Name" ? u = n.name.value : u = "data";
  var d = { name: u, type: r, variables: t };
  return ae.set(s, d), d;
}
Uf.resetCache = function() {
  ae = void 0;
};
globalThis.__DEV__ !== !1 && ru("parser", function() {
  return ae ? ae.size : 0;
});
function Cc(s, e) {
  var t = Uf(s), r = n_(e), u = n_(t.type);
  Q(
    t.type === e,
    66,
    r,
    r,
    u
  );
}
var gc = R_ ? as.useLayoutEffect : as.useEffect, kc = Symbol.for("apollo.hook.wrappers");
function Oc(s, e, t) {
  var r = t.queryManager, u = r && r[kc], a = u && u[s];
  return a ? a(e) : e;
}
var Lc = Object.prototype.hasOwnProperty;
function D_() {
}
var Vt = Symbol();
function W(s, e) {
  return e === void 0 && (e = /* @__PURE__ */ Object.create(null)), Oc("useQuery", sn, jf(e && e.client))(s, e);
}
function sn(s, e) {
  var t = Qf(s, e), r = t.result, u = t.obsQueryFields;
  return as.useMemo(function() {
    return p(p({}, r), u);
  }, [r, u]);
}
function en(s, e, t, r, u) {
  function a(y) {
    var c;
    Cc(e, Ks.Query);
    var n = {
      client: s,
      query: e,
      observable: (
        // See if there is an existing observable that was used to fetch the same
        // data and if so, use it instead since it will contain the proper queryId
        // to fetch the result set. This is used during SSR.
        r && r.getSSRObservable(u()) || s.watchQuery(Vu(void 0, s, t, u()))
      ),
      resultData: {
        // Reuse previousData from previous InternalState (if any) to provide
        // continuity of previousData even if/when the query or client changes.
        previousData: (c = y == null ? void 0 : y.resultData.current) === null || c === void 0 ? void 0 : c.data
      }
    };
    return n;
  }
  var i = as.useState(a), _ = i[0], h = i[1];
  function f(y) {
    var c, n;
    Object.assign(_.observable, (c = {}, c[Vt] = y, c));
    var d = _.resultData;
    h(p(p({}, _), {
      // might be a different query
      query: y.query,
      resultData: Object.assign(d, {
        // We need to modify the previous `resultData` object as we rely on the
        // object reference in other places
        previousData: ((n = d.current) === null || n === void 0 ? void 0 : n.data) || d.previousData,
        current: void 0
      })
    }));
  }
  if (s !== _.client || e !== _.query) {
    var A = a(_);
    return h(A), [A, f];
  }
  return [_, f];
}
function Qf(s, e) {
  var t = jf(e.client), r = as.useContext(Rf()).renderPromises, u = !!r, a = t.disableNetworkFetches, i = e.ssr !== !1 && !e.skip, _ = e.partialRefetch, h = zf(t, s, e, u), f = en(t, s, e, r, h), A = f[0], y = A.observable, c = A.resultData, n = f[1], d = h(y);
  un(
    c,
    // might get mutated during render
    y,
    // might get mutated during render
    t,
    e,
    d
  );
  var E = as.useMemo(function() {
    return hn(y);
  }, [y]);
  rn(y, r, i);
  var V = tn(c, y, t, e, d, a, _, u, {
    onCompleted: e.onCompleted || D_,
    onError: e.onError || D_
  });
  return {
    result: V,
    obsQueryFields: E,
    observable: y,
    resultData: c,
    client: t,
    onQueryExecuted: n
  };
}
function tn(s, e, t, r, u, a, i, _, h) {
  var f = as.useRef(h);
  as.useEffect(function() {
    f.current = h;
  });
  var A = (_ || a) && r.ssr === !1 && !r.skip ? (
    // If SSR has been explicitly disabled, and this function has been called
    // on the server side, return the default loading state.
    Wf
  ) : r.skip || u.fetchPolicy === "standby" ? (
    // When skipping a query (ie. we're not querying for data but still want to
    // render children), make sure the `data` is cleared out and `loading` is
    // set to `false` (since we aren't loading anything).
    //
    // NOTE: We no longer think this is the correct behavior. Skipping should
    // not automatically set `data` to `undefined`, but instead leave the
    // previous data in place. In other words, skipping should not mandate that
    // previously received data is all of a sudden removed. Unfortunately,
    // changing this is breaking, so we'll have to wait until Apollo Client 4.0
    // to address this.
    Nf
  ) : void 0, y = s.previousData, c = as.useMemo(function() {
    return A && Mt(A, y, e, t);
  }, [t, e, A, y]);
  return Zc(as.useCallback(function(n) {
    if (_)
      return function() {
      };
    var d = function() {
      var b = s.current, F = e.getCurrentResult();
      b && b.loading === F.loading && b.networkStatus === F.networkStatus && us(b.data, F.data) || Xr(F, s, e, t, i, n, f.current);
    }, E = function(b) {
      if (V.current.unsubscribe(), V.current = e.resubscribeAfterError(d, E), !Lc.call(b, "graphQLErrors"))
        throw b;
      var F = s.current;
      (!F || F && F.loading || !us(b, F.error)) && Xr({
        data: F && F.data,
        error: b,
        loading: !1,
        networkStatus: es.error
      }, s, e, t, i, n, f.current);
    }, V = { current: e.subscribe(d, E) };
    return function() {
      setTimeout(function() {
        return V.current.unsubscribe();
      });
    };
  }, [
    a,
    _,
    e,
    s,
    i,
    t
  ]), function() {
    return c || d_(s, e, f.current, i, t);
  }, function() {
    return c || d_(s, e, f.current, i, t);
  });
}
function rn(s, e, t) {
  e && t && (e.registerSSRObservable(s), s.getCurrentResult().loading && e.addObservableQueryPromise(s));
}
function un(s, e, t, r, u) {
  var a;
  e[Vt] && !us(e[Vt], u) && (e.reobserve(Vu(e, t, r, u)), s.previousData = ((a = s.current) === null || a === void 0 ? void 0 : a.data) || s.previousData, s.current = void 0), e[Vt] = u;
}
function zf(s, e, t, r) {
  t === void 0 && (t = {});
  var u = t.skip;
  t.ssr, t.onCompleted, t.onError;
  var a = t.defaultOptions, i = Gs(t, ["skip", "ssr", "onCompleted", "onError", "defaultOptions"]);
  return function(_) {
    var h = Object.assign(i, { query: e });
    return r && (h.fetchPolicy === "network-only" || h.fetchPolicy === "cache-and-network") && (h.fetchPolicy = "cache-first"), h.variables || (h.variables = {}), u ? (h.initialFetchPolicy = h.initialFetchPolicy || h.fetchPolicy || Zr(a, s.defaultOptions), h.fetchPolicy = "standby") : h.fetchPolicy || (h.fetchPolicy = (_ == null ? void 0 : _.options.initialFetchPolicy) || Zr(a, s.defaultOptions)), h;
  };
}
function Vu(s, e, t, r) {
  var u = [], a = e.defaultOptions.watchQuery;
  return a && u.push(a), t.defaultOptions && u.push(t.defaultOptions), u.push(_e(s && s.options, r)), u.reduce(Ee);
}
function Xr(s, e, t, r, u, a, i) {
  var _ = e.current;
  _ && _.data && (e.previousData = _.data), !s.error && Rs(s.errors) && (s.error = new Ys({ graphQLErrors: s.errors })), e.current = Mt(fn(s, t, u), e.previousData, t, r), a(), an(s, _ == null ? void 0 : _.networkStatus, i);
}
function an(s, e, t) {
  if (!s.loading) {
    var r = _n(s);
    Promise.resolve().then(function() {
      r ? t.onError(r) : s.data && e !== s.networkStatus && s.networkStatus === es.ready && t.onCompleted(s.data);
    }).catch(function(u) {
      globalThis.__DEV__ !== !1 && Q.warn(u);
    });
  }
}
function d_(s, e, t, r, u) {
  return s.current || Xr(e.getCurrentResult(), s, e, u, r, function() {
  }, t), s.current;
}
function Zr(s, e) {
  var t;
  return (s == null ? void 0 : s.fetchPolicy) || ((t = e == null ? void 0 : e.watchQuery) === null || t === void 0 ? void 0 : t.fetchPolicy) || "cache-first";
}
function _n(s) {
  return Rs(s.errors) ? new Ys({ graphQLErrors: s.errors }) : s.error;
}
function Mt(s, e, t, r) {
  var u = s.data;
  s.partial;
  var a = Gs(s, ["data", "partial"]), i = p(p({ data: u }, a), { client: r, observable: t, variables: t.variables, called: s !== Wf && s !== Nf, previousData: e });
  return i;
}
function fn(s, e, t) {
  return s.partial && t && !s.loading && (!s.data || Object.keys(s.data).length === 0) && e.options.fetchPolicy !== "cache-only" ? (e.refetch(), p(p({}, s), { loading: !0, networkStatus: es.refetch })) : s;
}
var Wf = Ye({
  loading: !0,
  data: void 0,
  error: void 0,
  networkStatus: es.loading
}), Nf = Ye({
  loading: !1,
  data: void 0,
  error: void 0,
  networkStatus: es.ready
});
function hn(s) {
  return {
    refetch: s.refetch.bind(s),
    reobserve: s.reobserve.bind(s),
    fetchMore: s.fetchMore.bind(s),
    updateQuery: s.updateQuery.bind(s),
    startPolling: s.startPolling.bind(s),
    stopPolling: s.stopPolling.bind(s),
    subscribeToMore: s.subscribeToMore.bind(s)
  };
}
var Sn = [
  "refetch",
  "reobserve",
  "fetchMore",
  "updateQuery",
  "startPolling",
  "stopPolling",
  "subscribeToMore"
];
function N(s, e) {
  var t, r = as.useRef(), u = as.useRef(), a = as.useRef(), i = Ee(e, r.current || {}), _ = (t = i == null ? void 0 : i.query) !== null && t !== void 0 ? t : s;
  u.current = e, a.current = _;
  var h = p(p({}, i), { skip: !r.current }), f = Qf(_, h), A = f.obsQueryFields, y = f.result, c = f.client, n = f.resultData, d = f.observable, E = f.onQueryExecuted, V = d.options.initialFetchPolicy || Zr(h.defaultOptions, c.defaultOptions), b = as.useReducer(function(U) {
    return U + 1;
  }, 0)[1], F = as.useMemo(function() {
    for (var U = {}, Z = function(fs) {
      var ls = A[fs];
      U[fs] = function() {
        return r.current || (r.current = /* @__PURE__ */ Object.create(null), b()), ls.apply(this, arguments);
      };
    }, O = 0, os = Sn; O < os.length; O++) {
      var qs = os[O];
      Z(qs);
    }
    return U;
  }, [b, A]), l = !!r.current, T = as.useMemo(function() {
    return p(p(p({}, y), F), { called: l });
  }, [y, F, l]), $ = as.useCallback(function(U) {
    r.current = U ? p(p({}, U), { fetchPolicy: U.fetchPolicy || V }) : {
      fetchPolicy: V
    };
    var Z = Ee(u.current, p({ query: a.current }, r.current)), O = An(n, d, c, _, p(p({}, Z), { skip: !1 }), E).then(function(os) {
      return Object.assign(os, F);
    });
    return O.catch(function() {
    }), O;
  }, [
    c,
    _,
    F,
    V,
    d,
    n,
    E
  ]), q = as.useRef($);
  gc(function() {
    q.current = $;
  });
  var z = as.useCallback(function() {
    for (var U = [], Z = 0; Z < arguments.length; Z++)
      U[Z] = arguments[Z];
    return q.current.apply(q, U);
  }, []);
  return [z, T];
}
function An(s, e, t, r, u, a) {
  var i = u.query || r, _ = zf(t, i, u, !1)(e), h = e.reobserveAsConcast(Vu(e, t, u, _));
  return a(_), new Promise(function(f) {
    var A;
    h.subscribe({
      next: function(y) {
        A = y;
      },
      error: function() {
        f(Mt(e.getCurrentResult(), s.previousData, e, t));
      },
      complete: function() {
        f(Mt(A, s.previousData, e, t));
      }
    });
  });
}
const M = {};
var yn = /* @__PURE__ */ ((s) => (s.LinkTextAsc = "linkText_ASC", s.LinkTextDesc = "linkText_DESC", s.SlugAsc = "slug_ASC", s.SlugDesc = "slug_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TextAsc = "text_ASC", s.TextDesc = "text_DESC", s.UrlAsc = "url_ASC", s.UrlDesc = "url_DESC", s))(yn || {}), cn = /* @__PURE__ */ ((s) => (s.ActionAsc = "action_ASC", s.ActionDesc = "action_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(cn || {}), nn = /* @__PURE__ */ ((s) => (s.ContentTypeAsc = "contentType_ASC", s.ContentTypeDesc = "contentType_DESC", s.FileNameAsc = "fileName_ASC", s.FileNameDesc = "fileName_DESC", s.HeightAsc = "height_ASC", s.HeightDesc = "height_DESC", s.SizeAsc = "size_ASC", s.SizeDesc = "size_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.UrlAsc = "url_ASC", s.UrlDesc = "url_DESC", s.WidthAsc = "width_ASC", s.WidthDesc = "width_DESC", s))(nn || {}), Dn = /* @__PURE__ */ ((s) => (s.BodyMaxWidthAsc = "bodyMaxWidth_ASC", s.BodyMaxWidthDesc = "bodyMaxWidth_DESC", s.CardSizeAsc = "cardSize_ASC", s.CardSizeDesc = "cardSize_DESC", s.FixLinkToBottomAsc = "fixLinkToBottom_ASC", s.FixLinkToBottomDesc = "fixLinkToBottom_DESC", s.IconSizeAsc = "iconSize_ASC", s.IconSizeDesc = "iconSize_DESC", s.MarkTextAsc = "markText_ASC", s.MarkTextDesc = "markText_DESC", s.ShadowAsc = "shadow_ASC", s.ShadowDesc = "shadow_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TagColorAsc = "tagColor_ASC", s.TagColorDesc = "tagColor_DESC", s.TagCrossedAsc = "tagCrossed_ASC", s.TagCrossedDesc = "tagCrossed_DESC", s.TagPositionAsc = "tagPosition_ASC", s.TagPositionDesc = "tagPosition_DESC", s.TagTextAsc = "tagText_ASC", s.TagTextDesc = "tagText_DESC", s.TextColorAsc = "textColor_ASC", s.TextColorDesc = "textColor_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(Dn || {}), dn = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.FullWidthContentAsc = "fullWidthContent_ASC", s.FullWidthContentDesc = "fullWidthContent_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(dn || {}), pn = /* @__PURE__ */ ((s) => (s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.ContentAlignAsc = "contentAlign_ASC", s.ContentAlignDesc = "contentAlign_DESC", s.ContentSpacingAsc = "contentSpacing_ASC", s.ContentSpacingDesc = "contentSpacing_DESC", s.ContentWidthAsc = "contentWidth_ASC", s.ContentWidthDesc = "contentWidth_DESC", s.DescriptionTextSizeAsc = "descriptionTextSize_ASC", s.DescriptionTextSizeDesc = "descriptionTextSize_DESC", s.DeveloperStoriesTagAsc = "developerStoriesTag_ASC", s.DeveloperStoriesTagDesc = "developerStoriesTag_DESC", s.HeadingFontAsc = "headingFont_ASC", s.HeadingFontDesc = "headingFont_DESC", s.HeadingTextSizeAsc = "headingTextSize_ASC", s.HeadingTextSizeDesc = "headingTextSize_DESC", s.HideImageOnMobileAsc = "hideImageOnMobile_ASC", s.HideImageOnMobileDesc = "hideImageOnMobile_DESC", s.LogoHeaderAsc = "logoHeader_ASC", s.LogoHeaderDesc = "logoHeader_DESC", s.ReverseItemsOrderOnMobileAsc = "reverseItemsOrderOnMobile_ASC", s.ReverseItemsOrderOnMobileDesc = "reverseItemsOrderOnMobile_DESC", s.StickyImageOnMobileAsc = "stickyImageOnMobile_ASC", s.StickyImageOnMobileDesc = "stickyImageOnMobile_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(pn || {}), bn = /* @__PURE__ */ ((s) => (s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TagTextAsc = "tagText_ASC", s.TagTextDesc = "tagText_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(bn || {}), En = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.CardSliderViewOnDesktopAsc = "cardSliderViewOnDesktop_ASC", s.CardSliderViewOnDesktopDesc = "cardSliderViewOnDesktop_DESC", s.CardSliderViewOnMobileAsc = "cardSliderViewOnMobile_ASC", s.CardSliderViewOnMobileDesc = "cardSliderViewOnMobile_DESC", s.ColumnCountAsc = "columnCount_ASC", s.ColumnCountDesc = "columnCount_DESC", s.LayoutModeAsc = "layoutMode_ASC", s.LayoutModeDesc = "layoutMode_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.ReverseOnMobileAsc = "reverseOnMobile_ASC", s.ReverseOnMobileDesc = "reverseOnMobile_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TopSpacingAsc = "topSpacing_ASC", s.TopSpacingDesc = "topSpacing_DESC", s.UnlimitedItemWidthAsc = "unlimitedItemWidth_ASC", s.UnlimitedItemWidthDesc = "unlimitedItemWidth_DESC", s))(En || {}), vn = /* @__PURE__ */ ((s) => (s.PeriodAsc = "period_ASC", s.PeriodDesc = "period_DESC", s.PricingPlanTagAsc = "pricingPlanTag_ASC", s.PricingPlanTagDesc = "pricingPlanTag_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TextAfterOptionsAsc = "textAfterOptions_ASC", s.TextAfterOptionsDesc = "textAfterOptions_DESC", s.TextBeforeOptionsAsc = "textBeforeOptions_ASC", s.TextBeforeOptionsDesc = "textBeforeOptions_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(vn || {}), mn = /* @__PURE__ */ ((s) => (s.AdvantagesTitleAsc = "advantagesTitle_ASC", s.AdvantagesTitleDesc = "advantagesTitle_DESC", s.PeriodAsc = "period_ASC", s.PeriodDesc = "period_DESC", s.PriceAsc = "price_ASC", s.PriceDesc = "price_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TagAsc = "tag_ASC", s.TagDesc = "tag_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(mn || {}), Vn = /* @__PURE__ */ ((s) => (s.BoldTextAsc = "boldText_ASC", s.BoldTextDesc = "boldText_DESC", s.ColorAsc = "color_ASC", s.ColorDesc = "color_DESC", s.IdAsc = "id_ASC", s.IdDesc = "id_DESC", s.LocationAsc = "location_ASC", s.LocationDesc = "location_DESC", s.RightIconAsc = "rightIcon_ASC", s.RightIconDesc = "rightIcon_DESC", s.SizeAsc = "size_ASC", s.SizeDesc = "size_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TextAlignmentAsc = "textAlignment_ASC", s.TextAlignmentDesc = "textAlignment_DESC", s.TextAsc = "text_ASC", s.TextDesc = "text_DESC", s.UppercaseAsc = "uppercase_ASC", s.UppercaseDesc = "uppercase_DESC", s.UrlAsc = "url_ASC", s.UrlDesc = "url_DESC", s.VariantAsc = "variant_ASC", s.VariantDesc = "variant_DESC", s.WidthAsc = "width_ASC", s.WidthDesc = "width_DESC", s))(Vn || {}), ln = /* @__PURE__ */ ((s) => (s.BackgroundColorOnMobileAsc = "backgroundColorOnMobile_ASC", s.BackgroundColorOnMobileDesc = "backgroundColorOnMobile_DESC", s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.BackgroundImagePositionAsc = "backgroundImagePosition_ASC", s.BackgroundImagePositionDesc = "backgroundImagePosition_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.OverflowAsc = "overflow_ASC", s.OverflowDesc = "overflow_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.VerticalPaddingAsc = "verticalPadding_ASC", s.VerticalPaddingDesc = "verticalPadding_DESC", s))(ln || {}), wn = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.CardSliderViewOnDesktopAsc = "cardSliderViewOnDesktop_ASC", s.CardSliderViewOnDesktopDesc = "cardSliderViewOnDesktop_DESC", s.CardSliderViewOnMobileAsc = "cardSliderViewOnMobile_ASC", s.CardSliderViewOnMobileDesc = "cardSliderViewOnMobile_DESC", s.ColumnCountAsc = "columnCount_ASC", s.ColumnCountDesc = "columnCount_DESC", s.LayoutModeAsc = "layoutMode_ASC", s.LayoutModeDesc = "layoutMode_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.ReverseOnMobileAsc = "reverseOnMobile_ASC", s.ReverseOnMobileDesc = "reverseOnMobile_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TopSpacingAsc = "topSpacing_ASC", s.TopSpacingDesc = "topSpacing_DESC", s.UnlimitedItemWidthAsc = "unlimitedItemWidth_ASC", s.UnlimitedItemWidthDesc = "unlimitedItemWidth_DESC", s))(wn || {}), Fn = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.CardSliderViewOnDesktopAsc = "cardSliderViewOnDesktop_ASC", s.CardSliderViewOnDesktopDesc = "cardSliderViewOnDesktop_DESC", s.CardSliderViewOnMobileAsc = "cardSliderViewOnMobile_ASC", s.CardSliderViewOnMobileDesc = "cardSliderViewOnMobile_DESC", s.ColumnCountAsc = "columnCount_ASC", s.ColumnCountDesc = "columnCount_DESC", s.LayoutModeAsc = "layoutMode_ASC", s.LayoutModeDesc = "layoutMode_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.ReverseOnMobileAsc = "reverseOnMobile_ASC", s.ReverseOnMobileDesc = "reverseOnMobile_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TopSpacingAsc = "topSpacing_ASC", s.TopSpacingDesc = "topSpacing_DESC", s.UnlimitedItemWidthAsc = "unlimitedItemWidth_ASC", s.UnlimitedItemWidthDesc = "unlimitedItemWidth_DESC", s))(Fn || {}), xn = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.FullWidthContentAsc = "fullWidthContent_ASC", s.FullWidthContentDesc = "fullWidthContent_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(xn || {}), on = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.CardSliderViewOnDesktopAsc = "cardSliderViewOnDesktop_ASC", s.CardSliderViewOnDesktopDesc = "cardSliderViewOnDesktop_DESC", s.CardSliderViewOnMobileAsc = "cardSliderViewOnMobile_ASC", s.CardSliderViewOnMobileDesc = "cardSliderViewOnMobile_DESC", s.ColumnCountAsc = "columnCount_ASC", s.ColumnCountDesc = "columnCount_DESC", s.LayoutModeAsc = "layoutMode_ASC", s.LayoutModeDesc = "layoutMode_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.ReverseOnMobileAsc = "reverseOnMobile_ASC", s.ReverseOnMobileDesc = "reverseOnMobile_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TopSpacingAsc = "topSpacing_ASC", s.TopSpacingDesc = "topSpacing_DESC", s.UnlimitedItemWidthAsc = "unlimitedItemWidth_ASC", s.UnlimitedItemWidthDesc = "unlimitedItemWidth_DESC", s))(on || {}), Mn = /* @__PURE__ */ ((s) => (s.BodyMaxWidthAsc = "bodyMaxWidth_ASC", s.BodyMaxWidthDesc = "bodyMaxWidth_DESC", s.CardSizeAsc = "cardSize_ASC", s.CardSizeDesc = "cardSize_DESC", s.FixLinkToBottomAsc = "fixLinkToBottom_ASC", s.FixLinkToBottomDesc = "fixLinkToBottom_DESC", s.IconSizeAsc = "iconSize_ASC", s.IconSizeDesc = "iconSize_DESC", s.MarkTextAsc = "markText_ASC", s.MarkTextDesc = "markText_DESC", s.ShadowAsc = "shadow_ASC", s.ShadowDesc = "shadow_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TagColorAsc = "tagColor_ASC", s.TagColorDesc = "tagColor_DESC", s.TagCrossedAsc = "tagCrossed_ASC", s.TagCrossedDesc = "tagCrossed_DESC", s.TagPositionAsc = "tagPosition_ASC", s.TagPositionDesc = "tagPosition_DESC", s.TagTextAsc = "tagText_ASC", s.TagTextDesc = "tagText_DESC", s.TextColorAsc = "textColor_ASC", s.TextColorDesc = "textColor_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(Mn || {}), $n = /* @__PURE__ */ ((s) => (s.AdvantageImageStickyAsc = "advantageImageSticky_ASC", s.AdvantageImageStickyDesc = "advantageImageSticky_DESC", s.CtaButtonTextAsc = "ctaButtonText_ASC", s.CtaButtonTextDesc = "ctaButtonText_DESC", s.CtaButtonUrlAsc = "ctaButtonUrl_ASC", s.CtaButtonUrlDesc = "ctaButtonUrl_DESC", s.FeaturesTitleAsc = "featuresTitle_ASC", s.FeaturesTitleDesc = "featuresTitle_DESC", s.GettingStartedStep1TitleAsc = "gettingStartedStep1Title_ASC", s.GettingStartedStep1TitleDesc = "gettingStartedStep1Title_DESC", s.GettingStartedStep2TitleAsc = "gettingStartedStep2Title_ASC", s.GettingStartedStep2TitleDesc = "gettingStartedStep2Title_DESC", s.GettingStartedStep3TitleAsc = "gettingStartedStep3Title_ASC", s.GettingStartedStep3TitleDesc = "gettingStartedStep3Title_DESC", s.GettingStartedStep4TitleAsc = "gettingStartedStep4Title_ASC", s.GettingStartedStep4TitleDesc = "gettingStartedStep4Title_DESC", s.HeroPrimaryButtonTextAsc = "heroPrimaryButtonText_ASC", s.HeroPrimaryButtonTextDesc = "heroPrimaryButtonText_DESC", s.HeroPrimaryButtonUrlAsc = "heroPrimaryButtonUrl_ASC", s.HeroPrimaryButtonUrlDesc = "heroPrimaryButtonUrl_DESC", s.HeroSecondaryButtonTextAsc = "heroSecondaryButtonText_ASC", s.HeroSecondaryButtonTextDesc = "heroSecondaryButtonText_DESC", s.HeroSecondaryButtonUrlAsc = "heroSecondaryButtonUrl_ASC", s.HeroSecondaryButtonUrlDesc = "heroSecondaryButtonUrl_DESC", s.HeroShowDinLogoAsc = "heroShowDinLogo_ASC", s.HeroShowDinLogoDesc = "heroShowDinLogo_DESC", s.HeroTitleAsc = "heroTitle_ASC", s.HeroTitleDesc = "heroTitle_DESC", s.NetworkNameAsc = "networkName_ASC", s.NetworkNameDesc = "networkName_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))($n || {}), Tn = /* @__PURE__ */ ((s) => (s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(Tn || {}), Pn = /* @__PURE__ */ ((s) => (s.CustomerNameAsc = "customerName_ASC", s.CustomerNameDesc = "customerName_DESC", s.HeroBackgroundColorAsc = "heroBackgroundColor_ASC", s.HeroBackgroundColorDesc = "heroBackgroundColor_DESC", s.HeroTitleFontAsc = "heroTitleFont_ASC", s.HeroTitleFontDesc = "heroTitleFont_DESC", s.HeroTitleSizeAsc = "heroTitleSize_ASC", s.HeroTitleSizeDesc = "heroTitleSize_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s.UrlAsc = "url_ASC", s.UrlDesc = "url_DESC", s.VerticalAsc = "vertical_ASC", s.VerticalDesc = "vertical_DESC", s))(Pn || {}), Bn = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.FullWidthContentAsc = "fullWidthContent_ASC", s.FullWidthContentDesc = "fullWidthContent_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(Bn || {}), qn = /* @__PURE__ */ ((s) => (s.BackgroundColorOnMobileAsc = "backgroundColorOnMobile_ASC", s.BackgroundColorOnMobileDesc = "backgroundColorOnMobile_DESC", s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.BackgroundImagePositionAsc = "backgroundImagePosition_ASC", s.BackgroundImagePositionDesc = "backgroundImagePosition_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.OverflowAsc = "overflow_ASC", s.OverflowDesc = "overflow_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.VerticalPaddingAsc = "verticalPadding_ASC", s.VerticalPaddingDesc = "verticalPadding_DESC", s))(qn || {}), Gn = /* @__PURE__ */ ((s) => (s.IconPositionAsc = "iconPosition_ASC", s.IconPositionDesc = "iconPosition_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(Gn || {}), Rn = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.CardSliderViewOnDesktopAsc = "cardSliderViewOnDesktop_ASC", s.CardSliderViewOnDesktopDesc = "cardSliderViewOnDesktop_DESC", s.CardSliderViewOnMobileAsc = "cardSliderViewOnMobile_ASC", s.CardSliderViewOnMobileDesc = "cardSliderViewOnMobile_DESC", s.ColumnCountAsc = "columnCount_ASC", s.ColumnCountDesc = "columnCount_DESC", s.LayoutModeAsc = "layoutMode_ASC", s.LayoutModeDesc = "layoutMode_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.ReverseOnMobileAsc = "reverseOnMobile_ASC", s.ReverseOnMobileDesc = "reverseOnMobile_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TopSpacingAsc = "topSpacing_ASC", s.TopSpacingDesc = "topSpacing_DESC", s.UnlimitedItemWidthAsc = "unlimitedItemWidth_ASC", s.UnlimitedItemWidthDesc = "unlimitedItemWidth_DESC", s))(Rn || {}), jn = /* @__PURE__ */ ((s) => (s.BackgroundColorOnMobileAsc = "backgroundColorOnMobile_ASC", s.BackgroundColorOnMobileDesc = "backgroundColorOnMobile_DESC", s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.BackgroundImagePositionAsc = "backgroundImagePosition_ASC", s.BackgroundImagePositionDesc = "backgroundImagePosition_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.OverflowAsc = "overflow_ASC", s.OverflowDesc = "overflow_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.VerticalPaddingAsc = "verticalPadding_ASC", s.VerticalPaddingDesc = "verticalPadding_DESC", s))(jn || {}), Un = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.FullWidthContentAsc = "fullWidthContent_ASC", s.FullWidthContentDesc = "fullWidthContent_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(Un || {}), Qn = /* @__PURE__ */ ((s) => (s.CustomerNameAsc = "customerName_ASC", s.CustomerNameDesc = "customerName_DESC", s.HeroBackgroundColorAsc = "heroBackgroundColor_ASC", s.HeroBackgroundColorDesc = "heroBackgroundColor_DESC", s.HeroTitleFontAsc = "heroTitleFont_ASC", s.HeroTitleFontDesc = "heroTitleFont_DESC", s.HeroTitleSizeAsc = "heroTitleSize_ASC", s.HeroTitleSizeDesc = "heroTitleSize_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s.UrlAsc = "url_ASC", s.UrlDesc = "url_DESC", s.VerticalAsc = "vertical_ASC", s.VerticalDesc = "vertical_DESC", s))(Qn || {}), zn = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.FullWidthContentAsc = "fullWidthContent_ASC", s.FullWidthContentDesc = "fullWidthContent_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(zn || {}), Wn = /* @__PURE__ */ ((s) => (s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(Wn || {}), Nn = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.CardSliderViewOnDesktopAsc = "cardSliderViewOnDesktop_ASC", s.CardSliderViewOnDesktopDesc = "cardSliderViewOnDesktop_DESC", s.CardSliderViewOnMobileAsc = "cardSliderViewOnMobile_ASC", s.CardSliderViewOnMobileDesc = "cardSliderViewOnMobile_DESC", s.ColumnCountAsc = "columnCount_ASC", s.ColumnCountDesc = "columnCount_DESC", s.LayoutModeAsc = "layoutMode_ASC", s.LayoutModeDesc = "layoutMode_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.ReverseOnMobileAsc = "reverseOnMobile_ASC", s.ReverseOnMobileDesc = "reverseOnMobile_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TopSpacingAsc = "topSpacing_ASC", s.TopSpacingDesc = "topSpacing_DESC", s.UnlimitedItemWidthAsc = "unlimitedItemWidth_ASC", s.UnlimitedItemWidthDesc = "unlimitedItemWidth_DESC", s))(Nn || {}), In = /* @__PURE__ */ ((s) => (s.BackgroundColorOnMobileAsc = "backgroundColorOnMobile_ASC", s.BackgroundColorOnMobileDesc = "backgroundColorOnMobile_DESC", s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.BackgroundImagePositionAsc = "backgroundImagePosition_ASC", s.BackgroundImagePositionDesc = "backgroundImagePosition_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.OverflowAsc = "overflow_ASC", s.OverflowDesc = "overflow_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.VerticalPaddingAsc = "verticalPadding_ASC", s.VerticalPaddingDesc = "verticalPadding_DESC", s))(In || {}), Jn = /* @__PURE__ */ ((s) => (s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.VerticalPaddingAsc = "verticalPadding_ASC", s.VerticalPaddingDesc = "verticalPadding_DESC", s))(Jn || {}), Hn = /* @__PURE__ */ ((s) => (s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(Hn || {}), Yn = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.PaddingAsc = "padding_ASC", s.PaddingDesc = "padding_DESC", s.SubtitleTextAsc = "subtitleText_ASC", s.SubtitleTextDesc = "subtitleText_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleFontAsc = "titleFont_ASC", s.TitleFontDesc = "titleFont_DESC", s.TitleSizeAsc = "titleSize_ASC", s.TitleSizeDesc = "titleSize_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s.WidthAsc = "width_ASC", s.WidthDesc = "width_DESC", s))(Yn || {}), Kn = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(Kn || {}), Xn = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.BodyTextSizeAsc = "bodyTextSize_ASC", s.BodyTextSizeDesc = "bodyTextSize_DESC", s.HeadingFontAsc = "headingFont_ASC", s.HeadingFontDesc = "headingFont_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.PaddingHorizontalAsc = "paddingHorizontal_ASC", s.PaddingHorizontalDesc = "paddingHorizontal_DESC", s.PaddingAsc = "padding_ASC", s.PaddingDesc = "padding_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(Xn || {}), Zn = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.CardSliderViewOnDesktopAsc = "cardSliderViewOnDesktop_ASC", s.CardSliderViewOnDesktopDesc = "cardSliderViewOnDesktop_DESC", s.CardSliderViewOnMobileAsc = "cardSliderViewOnMobile_ASC", s.CardSliderViewOnMobileDesc = "cardSliderViewOnMobile_DESC", s.ColumnCountAsc = "columnCount_ASC", s.ColumnCountDesc = "columnCount_DESC", s.LayoutModeAsc = "layoutMode_ASC", s.LayoutModeDesc = "layoutMode_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.ReverseOnMobileAsc = "reverseOnMobile_ASC", s.ReverseOnMobileDesc = "reverseOnMobile_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TopSpacingAsc = "topSpacing_ASC", s.TopSpacingDesc = "topSpacing_DESC", s.UnlimitedItemWidthAsc = "unlimitedItemWidth_ASC", s.UnlimitedItemWidthDesc = "unlimitedItemWidth_DESC", s))(Zn || {}), Cn = /* @__PURE__ */ ((s) => (s.BackgroundColorOnMobileAsc = "backgroundColorOnMobile_ASC", s.BackgroundColorOnMobileDesc = "backgroundColorOnMobile_DESC", s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.BackgroundImagePositionAsc = "backgroundImagePosition_ASC", s.BackgroundImagePositionDesc = "backgroundImagePosition_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.OverflowAsc = "overflow_ASC", s.OverflowDesc = "overflow_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.VerticalPaddingAsc = "verticalPadding_ASC", s.VerticalPaddingDesc = "verticalPadding_DESC", s))(Cn || {}), gn = /* @__PURE__ */ ((s) => (s.PlaceholderAsc = "placeholder_ASC", s.PlaceholderDesc = "placeholder_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(gn || {}), kn = /* @__PURE__ */ ((s) => (s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(kn || {}), On = /* @__PURE__ */ ((s) => (s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(On || {}), Ln = /* @__PURE__ */ ((s) => (s.OrderAsc = "order_ASC", s.OrderDesc = "order_DESC", s.SlugAsc = "slug_ASC", s.SlugDesc = "slug_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(Ln || {}), sD = /* @__PURE__ */ ((s) => (s.QuestionAsc = "question_ASC", s.QuestionDesc = "question_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(sD || {}), eD = /* @__PURE__ */ ((s) => (s.OrderAsc = "order_ASC", s.OrderDesc = "order_DESC", s.SlugAsc = "slug_ASC", s.SlugDesc = "slug_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(eD || {}), tD = /* @__PURE__ */ ((s) => (s.QuestionAsc = "question_ASC", s.QuestionDesc = "question_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(tD || {}), rD = /* @__PURE__ */ ((s) => (s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.NetworkNameAsc = "networkName_ASC", s.NetworkNameDesc = "networkName_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(rD || {}), uD = /* @__PURE__ */ ((s) => (s.LayerOneNameAsc = "layerOneName_ASC", s.LayerOneNameDesc = "layerOneName_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.NetworkNameAsc = "networkName_ASC", s.NetworkNameDesc = "networkName_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(uD || {}), aD = /* @__PURE__ */ ((s) => (s.FeatureFlagAsc = "featureFlag_ASC", s.FeatureFlagDesc = "featureFlag_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.PathAsc = "path_ASC", s.PathDesc = "path_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(aD || {}), iD = /* @__PURE__ */ ((s) => (s.BackgroundColorOnMobileAsc = "backgroundColorOnMobile_ASC", s.BackgroundColorOnMobileDesc = "backgroundColorOnMobile_DESC", s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.BackgroundImagePositionAsc = "backgroundImagePosition_ASC", s.BackgroundImagePositionDesc = "backgroundImagePosition_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.OverflowAsc = "overflow_ASC", s.OverflowDesc = "overflow_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.VerticalPaddingAsc = "verticalPadding_ASC", s.VerticalPaddingDesc = "verticalPadding_DESC", s))(iD || {}), _D = /* @__PURE__ */ ((s) => (s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.VerticalPaddingAsc = "verticalPadding_ASC", s.VerticalPaddingDesc = "verticalPadding_DESC", s))(_D || {}), fD = /* @__PURE__ */ ((s) => (s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.ContentAlignAsc = "contentAlign_ASC", s.ContentAlignDesc = "contentAlign_DESC", s.ContentSpacingAsc = "contentSpacing_ASC", s.ContentSpacingDesc = "contentSpacing_DESC", s.ContentWidthAsc = "contentWidth_ASC", s.ContentWidthDesc = "contentWidth_DESC", s.DescriptionTextSizeAsc = "descriptionTextSize_ASC", s.DescriptionTextSizeDesc = "descriptionTextSize_DESC", s.DeveloperStoriesTagAsc = "developerStoriesTag_ASC", s.DeveloperStoriesTagDesc = "developerStoriesTag_DESC", s.HeadingFontAsc = "headingFont_ASC", s.HeadingFontDesc = "headingFont_DESC", s.HeadingTextSizeAsc = "headingTextSize_ASC", s.HeadingTextSizeDesc = "headingTextSize_DESC", s.HideImageOnMobileAsc = "hideImageOnMobile_ASC", s.HideImageOnMobileDesc = "hideImageOnMobile_DESC", s.LogoHeaderAsc = "logoHeader_ASC", s.LogoHeaderDesc = "logoHeader_DESC", s.ReverseItemsOrderOnMobileAsc = "reverseItemsOrderOnMobile_ASC", s.ReverseItemsOrderOnMobileDesc = "reverseItemsOrderOnMobile_DESC", s.StickyImageOnMobileAsc = "stickyImageOnMobile_ASC", s.StickyImageOnMobileDesc = "stickyImageOnMobile_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(fD || {}), hD = /* @__PURE__ */ ((s) => (s.CtaButtonTextAsc = "ctaButtonText_ASC", s.CtaButtonTextDesc = "ctaButtonText_DESC", s.CtaLinkAsc = "ctaLink_ASC", s.CtaLinkDesc = "ctaLink_DESC", s.DescriptionAsc = "description_ASC", s.DescriptionDesc = "description_DESC", s.HeadingAsc = "heading_ASC", s.HeadingDesc = "heading_DESC", s.PageTypeAsc = "pageType_ASC", s.PageTypeDesc = "pageType_DESC", s.PathAsc = "path_ASC", s.PathDesc = "path_DESC", s.SpeakersIntroTitleAsc = "speakersIntroTitle_ASC", s.SpeakersIntroTitleDesc = "speakersIntroTitle_DESC", s.SubheadingAsc = "subheading_ASC", s.SubheadingDesc = "subheading_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TagAsc = "tag_ASC", s.TagDesc = "tag_DESC", s.ThankYouHeaderAsc = "thankYouHeader_ASC", s.ThankYouHeaderDesc = "thankYouHeader_DESC", s))(hD || {}), SD = /* @__PURE__ */ ((s) => (s.SlugAsc = "slug_ASC", s.SlugDesc = "slug_DESC", s.SubdirectoryAsc = "subdirectory_ASC", s.SubdirectoryDesc = "subdirectory_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(SD || {}), AD = /* @__PURE__ */ ((s) => (s.HubspotFormIdAsc = "hubspotFormId_ASC", s.HubspotFormIdDesc = "hubspotFormId_DESC", s.HubspotPortalIdAsc = "hubspotPortalId_ASC", s.HubspotPortalIdDesc = "hubspotPortalId_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(AD || {}), yD = /* @__PURE__ */ ((s) => (s.DescriptionSizeAsc = "descriptionSize_ASC", s.DescriptionSizeDesc = "descriptionSize_DESC", s.IconPositionAsc = "iconPosition_ASC", s.IconPositionDesc = "iconPosition_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.PaddingAsc = "padding_ASC", s.PaddingDesc = "padding_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleSizeAsc = "titleSize_ASC", s.TitleSizeDesc = "titleSize_DESC", s.VerticalAlignmentAsc = "verticalAlignment_ASC", s.VerticalAlignmentDesc = "verticalAlignment_DESC", s))(yD || {}), cD = /* @__PURE__ */ ((s) => (s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TagTextAsc = "tagText_ASC", s.TagTextDesc = "tagText_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(cD || {}), nD = /* @__PURE__ */ ((s) => (s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TagTextAsc = "tagText_ASC", s.TagTextDesc = "tagText_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(nD || {}), DD = /* @__PURE__ */ ((s) => (s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.ContentAlignAsc = "contentAlign_ASC", s.ContentAlignDesc = "contentAlign_DESC", s.ContentSpacingAsc = "contentSpacing_ASC", s.ContentSpacingDesc = "contentSpacing_DESC", s.ContentWidthAsc = "contentWidth_ASC", s.ContentWidthDesc = "contentWidth_DESC", s.DescriptionTextSizeAsc = "descriptionTextSize_ASC", s.DescriptionTextSizeDesc = "descriptionTextSize_DESC", s.DeveloperStoriesTagAsc = "developerStoriesTag_ASC", s.DeveloperStoriesTagDesc = "developerStoriesTag_DESC", s.HeadingFontAsc = "headingFont_ASC", s.HeadingFontDesc = "headingFont_DESC", s.HeadingTextSizeAsc = "headingTextSize_ASC", s.HeadingTextSizeDesc = "headingTextSize_DESC", s.HideImageOnMobileAsc = "hideImageOnMobile_ASC", s.HideImageOnMobileDesc = "hideImageOnMobile_DESC", s.LogoHeaderAsc = "logoHeader_ASC", s.LogoHeaderDesc = "logoHeader_DESC", s.ReverseItemsOrderOnMobileAsc = "reverseItemsOrderOnMobile_ASC", s.ReverseItemsOrderOnMobileDesc = "reverseItemsOrderOnMobile_DESC", s.StickyImageOnMobileAsc = "stickyImageOnMobile_ASC", s.StickyImageOnMobileDesc = "stickyImageOnMobile_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(DD || {}), dD = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.CardSliderViewOnDesktopAsc = "cardSliderViewOnDesktop_ASC", s.CardSliderViewOnDesktopDesc = "cardSliderViewOnDesktop_DESC", s.CardSliderViewOnMobileAsc = "cardSliderViewOnMobile_ASC", s.CardSliderViewOnMobileDesc = "cardSliderViewOnMobile_DESC", s.ColumnCountAsc = "columnCount_ASC", s.ColumnCountDesc = "columnCount_DESC", s.LayoutModeAsc = "layoutMode_ASC", s.LayoutModeDesc = "layoutMode_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.ReverseOnMobileAsc = "reverseOnMobile_ASC", s.ReverseOnMobileDesc = "reverseOnMobile_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TopSpacingAsc = "topSpacing_ASC", s.TopSpacingDesc = "topSpacing_DESC", s.UnlimitedItemWidthAsc = "unlimitedItemWidth_ASC", s.UnlimitedItemWidthDesc = "unlimitedItemWidth_DESC", s))(dD || {}), pD = /* @__PURE__ */ ((s) => (s.AdvantageImageStickyAsc = "advantageImageSticky_ASC", s.AdvantageImageStickyDesc = "advantageImageSticky_DESC", s.CtaButtonTextAsc = "ctaButtonText_ASC", s.CtaButtonTextDesc = "ctaButtonText_DESC", s.CtaButtonUrlAsc = "ctaButtonUrl_ASC", s.CtaButtonUrlDesc = "ctaButtonUrl_DESC", s.FeaturesTitleAsc = "featuresTitle_ASC", s.FeaturesTitleDesc = "featuresTitle_DESC", s.GettingStartedStep1TitleAsc = "gettingStartedStep1Title_ASC", s.GettingStartedStep1TitleDesc = "gettingStartedStep1Title_DESC", s.GettingStartedStep2TitleAsc = "gettingStartedStep2Title_ASC", s.GettingStartedStep2TitleDesc = "gettingStartedStep2Title_DESC", s.GettingStartedStep3TitleAsc = "gettingStartedStep3Title_ASC", s.GettingStartedStep3TitleDesc = "gettingStartedStep3Title_DESC", s.GettingStartedStep4TitleAsc = "gettingStartedStep4Title_ASC", s.GettingStartedStep4TitleDesc = "gettingStartedStep4Title_DESC", s.HeroPrimaryButtonTextAsc = "heroPrimaryButtonText_ASC", s.HeroPrimaryButtonTextDesc = "heroPrimaryButtonText_DESC", s.HeroPrimaryButtonUrlAsc = "heroPrimaryButtonUrl_ASC", s.HeroPrimaryButtonUrlDesc = "heroPrimaryButtonUrl_DESC", s.HeroSecondaryButtonTextAsc = "heroSecondaryButtonText_ASC", s.HeroSecondaryButtonTextDesc = "heroSecondaryButtonText_DESC", s.HeroSecondaryButtonUrlAsc = "heroSecondaryButtonUrl_ASC", s.HeroSecondaryButtonUrlDesc = "heroSecondaryButtonUrl_DESC", s.HeroShowDinLogoAsc = "heroShowDinLogo_ASC", s.HeroShowDinLogoDesc = "heroShowDinLogo_DESC", s.HeroTitleAsc = "heroTitle_ASC", s.HeroTitleDesc = "heroTitle_DESC", s.NetworkNameAsc = "networkName_ASC", s.NetworkNameDesc = "networkName_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(pD || {}), bD = /* @__PURE__ */ ((s) => (s.DescriptionSizeAsc = "descriptionSize_ASC", s.DescriptionSizeDesc = "descriptionSize_DESC", s.IconPositionAsc = "iconPosition_ASC", s.IconPositionDesc = "iconPosition_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.PaddingAsc = "padding_ASC", s.PaddingDesc = "padding_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleSizeAsc = "titleSize_ASC", s.TitleSizeDesc = "titleSize_DESC", s.VerticalAlignmentAsc = "verticalAlignment_ASC", s.VerticalAlignmentDesc = "verticalAlignment_DESC", s))(bD || {}), ED = /* @__PURE__ */ ((s) => (s.Avif = "AVIF", s.Jpg = "JPG", s.JpgProgressive = "JPG_PROGRESSIVE", s.Png = "PNG", s.Png8 = "PNG8", s.Webp = "WEBP", s))(ED || {}), vD = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.FullWidthContentAsc = "fullWidthContent_ASC", s.FullWidthContentDesc = "fullWidthContent_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(vD || {}), mD = /* @__PURE__ */ ((s) => (s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(mD || {}), VD = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.CardSliderViewOnDesktopAsc = "cardSliderViewOnDesktop_ASC", s.CardSliderViewOnDesktopDesc = "cardSliderViewOnDesktop_DESC", s.CardSliderViewOnMobileAsc = "cardSliderViewOnMobile_ASC", s.CardSliderViewOnMobileDesc = "cardSliderViewOnMobile_DESC", s.ColumnCountAsc = "columnCount_ASC", s.ColumnCountDesc = "columnCount_DESC", s.LayoutModeAsc = "layoutMode_ASC", s.LayoutModeDesc = "layoutMode_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.ReverseOnMobileAsc = "reverseOnMobile_ASC", s.ReverseOnMobileDesc = "reverseOnMobile_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TopSpacingAsc = "topSpacing_ASC", s.TopSpacingDesc = "topSpacing_DESC", s.UnlimitedItemWidthAsc = "unlimitedItemWidth_ASC", s.UnlimitedItemWidthDesc = "unlimitedItemWidth_DESC", s))(VD || {}), lD = /* @__PURE__ */ ((s) => (s.BackgroundColorOnMobileAsc = "backgroundColorOnMobile_ASC", s.BackgroundColorOnMobileDesc = "backgroundColorOnMobile_DESC", s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.BackgroundImagePositionAsc = "backgroundImagePosition_ASC", s.BackgroundImagePositionDesc = "backgroundImagePosition_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.OverflowAsc = "overflow_ASC", s.OverflowDesc = "overflow_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.VerticalPaddingAsc = "verticalPadding_ASC", s.VerticalPaddingDesc = "verticalPadding_DESC", s))(lD || {}), wD = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.HideInMobileAsc = "hideInMobile_ASC", s.HideInMobileDesc = "hideInMobile_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.PaddingAsc = "padding_ASC", s.PaddingDesc = "padding_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(wD || {}), FD = /* @__PURE__ */ ((s) => (s.Bottom = "BOTTOM", s.BottomLeft = "BOTTOM_LEFT", s.BottomRight = "BOTTOM_RIGHT", s.Center = "CENTER", s.Face = "FACE", s.Faces = "FACES", s.Left = "LEFT", s.Right = "RIGHT", s.Top = "TOP", s.TopLeft = "TOP_LEFT", s.TopRight = "TOP_RIGHT", s))(FD || {}), xD = /* @__PURE__ */ ((s) => (s.Crop = "CROP", s.Fill = "FILL", s.Fit = "FIT", s.Pad = "PAD", s.Scale = "SCALE", s.Thumb = "THUMB", s))(xD || {}), oD = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.CardSliderViewOnDesktopAsc = "cardSliderViewOnDesktop_ASC", s.CardSliderViewOnDesktopDesc = "cardSliderViewOnDesktop_DESC", s.CardSliderViewOnMobileAsc = "cardSliderViewOnMobile_ASC", s.CardSliderViewOnMobileDesc = "cardSliderViewOnMobile_DESC", s.ColumnCountAsc = "columnCount_ASC", s.ColumnCountDesc = "columnCount_DESC", s.LayoutModeAsc = "layoutMode_ASC", s.LayoutModeDesc = "layoutMode_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.ReverseOnMobileAsc = "reverseOnMobile_ASC", s.ReverseOnMobileDesc = "reverseOnMobile_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TopSpacingAsc = "topSpacing_ASC", s.TopSpacingDesc = "topSpacing_DESC", s.UnlimitedItemWidthAsc = "unlimitedItemWidth_ASC", s.UnlimitedItemWidthDesc = "unlimitedItemWidth_DESC", s))(oD || {}), MD = /* @__PURE__ */ ((s) => (s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(MD || {}), $D = /* @__PURE__ */ ((s) => (s.LinkTextAsc = "linkText_ASC", s.LinkTextDesc = "linkText_DESC", s.LocationAsc = "location_ASC", s.LocationDesc = "location_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TagTextAsc = "tagText_ASC", s.TagTextDesc = "tagText_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s.UrlAsc = "url_ASC", s.UrlDesc = "url_DESC", s))($D || {}), TD = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.FullWidthContentAsc = "fullWidthContent_ASC", s.FullWidthContentDesc = "fullWidthContent_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(TD || {}), PD = /* @__PURE__ */ ((s) => (s.IconForLabelAsc = "iconForLabel_ASC", s.IconForLabelDesc = "iconForLabel_DESC", s.LabelColorAsc = "labelColor_ASC", s.LabelColorDesc = "labelColor_DESC", s.LabelTextAsc = "labelText_ASC", s.LabelTextDesc = "labelText_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(PD || {}), BD = /* @__PURE__ */ ((s) => (s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.NetworkNameAsc = "networkName_ASC", s.NetworkNameDesc = "networkName_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(BD || {}), qD = /* @__PURE__ */ ((s) => (s.BackgroundColorOnMobileAsc = "backgroundColorOnMobile_ASC", s.BackgroundColorOnMobileDesc = "backgroundColorOnMobile_DESC", s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.BackgroundImagePositionAsc = "backgroundImagePosition_ASC", s.BackgroundImagePositionDesc = "backgroundImagePosition_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.OverflowAsc = "overflow_ASC", s.OverflowDesc = "overflow_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.VerticalPaddingAsc = "verticalPadding_ASC", s.VerticalPaddingDesc = "verticalPadding_DESC", s))(qD || {}), GD = /* @__PURE__ */ ((s) => (s.LayerOneNameAsc = "layerOneName_ASC", s.LayerOneNameDesc = "layerOneName_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.NetworkNameAsc = "networkName_ASC", s.NetworkNameDesc = "networkName_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(GD || {}), RD = /* @__PURE__ */ ((s) => (s.BackgroundColorOnMobileAsc = "backgroundColorOnMobile_ASC", s.BackgroundColorOnMobileDesc = "backgroundColorOnMobile_DESC", s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.BackgroundImagePositionAsc = "backgroundImagePosition_ASC", s.BackgroundImagePositionDesc = "backgroundImagePosition_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.OverflowAsc = "overflow_ASC", s.OverflowDesc = "overflow_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.VerticalPaddingAsc = "verticalPadding_ASC", s.VerticalPaddingDesc = "verticalPadding_DESC", s))(RD || {}), jD = /* @__PURE__ */ ((s) => (s.CtaButtonTextAsc = "ctaButtonText_ASC", s.CtaButtonTextDesc = "ctaButtonText_DESC", s.CtaLinkAsc = "ctaLink_ASC", s.CtaLinkDesc = "ctaLink_DESC", s.DescriptionAsc = "description_ASC", s.DescriptionDesc = "description_DESC", s.HeadingAsc = "heading_ASC", s.HeadingDesc = "heading_DESC", s.PageTypeAsc = "pageType_ASC", s.PageTypeDesc = "pageType_DESC", s.PathAsc = "path_ASC", s.PathDesc = "path_DESC", s.SpeakersIntroTitleAsc = "speakersIntroTitle_ASC", s.SpeakersIntroTitleDesc = "speakersIntroTitle_DESC", s.SubheadingAsc = "subheading_ASC", s.SubheadingDesc = "subheading_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TagAsc = "tag_ASC", s.TagDesc = "tag_DESC", s.ThankYouHeaderAsc = "thankYouHeader_ASC", s.ThankYouHeaderDesc = "thankYouHeader_DESC", s))(jD || {}), UD = /* @__PURE__ */ ((s) => (s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(UD || {}), QD = /* @__PURE__ */ ((s) => (s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(QD || {}), zD = /* @__PURE__ */ ((s) => (s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.ContentAlignAsc = "contentAlign_ASC", s.ContentAlignDesc = "contentAlign_DESC", s.ContentSpacingAsc = "contentSpacing_ASC", s.ContentSpacingDesc = "contentSpacing_DESC", s.ContentWidthAsc = "contentWidth_ASC", s.ContentWidthDesc = "contentWidth_DESC", s.DescriptionTextSizeAsc = "descriptionTextSize_ASC", s.DescriptionTextSizeDesc = "descriptionTextSize_DESC", s.DeveloperStoriesTagAsc = "developerStoriesTag_ASC", s.DeveloperStoriesTagDesc = "developerStoriesTag_DESC", s.HeadingFontAsc = "headingFont_ASC", s.HeadingFontDesc = "headingFont_DESC", s.HeadingTextSizeAsc = "headingTextSize_ASC", s.HeadingTextSizeDesc = "headingTextSize_DESC", s.HideImageOnMobileAsc = "hideImageOnMobile_ASC", s.HideImageOnMobileDesc = "hideImageOnMobile_DESC", s.LogoHeaderAsc = "logoHeader_ASC", s.LogoHeaderDesc = "logoHeader_DESC", s.ReverseItemsOrderOnMobileAsc = "reverseItemsOrderOnMobile_ASC", s.ReverseItemsOrderOnMobileDesc = "reverseItemsOrderOnMobile_DESC", s.StickyImageOnMobileAsc = "stickyImageOnMobile_ASC", s.StickyImageOnMobileDesc = "stickyImageOnMobile_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(zD || {}), WD = /* @__PURE__ */ ((s) => (s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.PriceAsc = "price_ASC", s.PriceDesc = "price_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(WD || {}), ND = /* @__PURE__ */ ((s) => (s.QuizQuestionAsc = "quizQuestion_ASC", s.QuizQuestionDesc = "quizQuestion_DESC", s.SubTitleAsc = "subTitle_ASC", s.SubTitleDesc = "subTitle_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(ND || {}), ID = /* @__PURE__ */ ((s) => (s.LocationAsc = "location_ASC", s.LocationDesc = "location_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s.UrlAsc = "url_ASC", s.UrlDesc = "url_DESC", s))(ID || {}), JD = /* @__PURE__ */ ((s) => (s.BackgroundColorOnMobileAsc = "backgroundColorOnMobile_ASC", s.BackgroundColorOnMobileDesc = "backgroundColorOnMobile_DESC", s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.BackgroundImagePositionAsc = "backgroundImagePosition_ASC", s.BackgroundImagePositionDesc = "backgroundImagePosition_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.OverflowAsc = "overflow_ASC", s.OverflowDesc = "overflow_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.VerticalPaddingAsc = "verticalPadding_ASC", s.VerticalPaddingDesc = "verticalPadding_DESC", s))(JD || {}), HD = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.ColorAsc = "color_ASC", s.ColorDesc = "color_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.QueryKeyAsc = "queryKey_ASC", s.QueryKeyDesc = "queryKey_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(HD || {}), YD = /* @__PURE__ */ ((s) => (s.LabelAsc = "label_ASC", s.LabelDesc = "label_DESC", s.QueryValueAsc = "queryValue_ASC", s.QueryValueDesc = "queryValue_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.UppercaseAsc = "uppercase_ASC", s.UppercaseDesc = "uppercase_DESC", s))(YD || {}), KD = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.CardSliderViewOnDesktopAsc = "cardSliderViewOnDesktop_ASC", s.CardSliderViewOnDesktopDesc = "cardSliderViewOnDesktop_DESC", s.CardSliderViewOnMobileAsc = "cardSliderViewOnMobile_ASC", s.CardSliderViewOnMobileDesc = "cardSliderViewOnMobile_DESC", s.ColumnCountAsc = "columnCount_ASC", s.ColumnCountDesc = "columnCount_DESC", s.LayoutModeAsc = "layoutMode_ASC", s.LayoutModeDesc = "layoutMode_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.ReverseOnMobileAsc = "reverseOnMobile_ASC", s.ReverseOnMobileDesc = "reverseOnMobile_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TopSpacingAsc = "topSpacing_ASC", s.TopSpacingDesc = "topSpacing_DESC", s.UnlimitedItemWidthAsc = "unlimitedItemWidth_ASC", s.UnlimitedItemWidthDesc = "unlimitedItemWidth_DESC", s))(KD || {}), XD = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.HideInMobileAsc = "hideInMobile_ASC", s.HideInMobileDesc = "hideInMobile_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.PaddingAsc = "padding_ASC", s.PaddingDesc = "padding_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(XD || {}), ZD = /* @__PURE__ */ ((s) => (s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(ZD || {}), CD = /* @__PURE__ */ ((s) => (s.BackgroundColorOnMobileAsc = "backgroundColorOnMobile_ASC", s.BackgroundColorOnMobileDesc = "backgroundColorOnMobile_DESC", s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.BackgroundImagePositionAsc = "backgroundImagePosition_ASC", s.BackgroundImagePositionDesc = "backgroundImagePosition_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.OverflowAsc = "overflow_ASC", s.OverflowDesc = "overflow_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.VerticalPaddingAsc = "verticalPadding_ASC", s.VerticalPaddingDesc = "verticalPadding_DESC", s))(CD || {}), gD = /* @__PURE__ */ ((s) => (s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.VerticalPaddingAsc = "verticalPadding_ASC", s.VerticalPaddingDesc = "verticalPadding_DESC", s))(gD || {}), kD = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.CardSliderViewOnDesktopAsc = "cardSliderViewOnDesktop_ASC", s.CardSliderViewOnDesktopDesc = "cardSliderViewOnDesktop_DESC", s.CardSliderViewOnMobileAsc = "cardSliderViewOnMobile_ASC", s.CardSliderViewOnMobileDesc = "cardSliderViewOnMobile_DESC", s.ColumnCountAsc = "columnCount_ASC", s.ColumnCountDesc = "columnCount_DESC", s.LayoutModeAsc = "layoutMode_ASC", s.LayoutModeDesc = "layoutMode_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.ReverseOnMobileAsc = "reverseOnMobile_ASC", s.ReverseOnMobileDesc = "reverseOnMobile_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TopSpacingAsc = "topSpacing_ASC", s.TopSpacingDesc = "topSpacing_DESC", s.UnlimitedItemWidthAsc = "unlimitedItemWidth_ASC", s.UnlimitedItemWidthDesc = "unlimitedItemWidth_DESC", s))(kD || {}), OD = /* @__PURE__ */ ((s) => (s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(OD || {}), LD = /* @__PURE__ */ ((s) => (s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(LD || {}), sd = /* @__PURE__ */ ((s) => (s.AnimationOnHoverAsc = "animationOnHover_ASC", s.AnimationOnHoverDesc = "animationOnHover_DESC", s.DescriptionAsc = "description_ASC", s.DescriptionDesc = "description_DESC", s.HideOnDesktopAsc = "hideOnDesktop_ASC", s.HideOnDesktopDesc = "hideOnDesktop_DESC", s.HideOnMobileAsc = "hideOnMobile_ASC", s.HideOnMobileDesc = "hideOnMobile_DESC", s.IconBackgroundAsc = "iconBackground_ASC", s.IconBackgroundDesc = "iconBackground_DESC", s.IconFormAsc = "iconForm_ASC", s.IconFormDesc = "iconForm_DESC", s.IconSizeAsc = "iconSize_ASC", s.IconSizeDesc = "iconSize_DESC", s.IsExternalLinkAsc = "isExternalLink_ASC", s.IsExternalLinkDesc = "isExternalLink_DESC", s.LinkAsc = "link_ASC", s.LinkDesc = "link_DESC", s.ShowArrowAsc = "showArrow_ASC", s.ShowArrowDesc = "showArrow_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TagTextAsc = "tagText_ASC", s.TagTextDesc = "tagText_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(sd || {}), ed = /* @__PURE__ */ ((s) => (s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(ed || {}), td = /* @__PURE__ */ ((s) => (s.LinkAsc = "link_ASC", s.LinkDesc = "link_DESC", s.OrderAsc = "order_ASC", s.OrderDesc = "order_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(td || {}), rd = /* @__PURE__ */ ((s) => (s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(rd || {}), ud = /* @__PURE__ */ ((s) => (s.LinkAsc = "link_ASC", s.LinkDesc = "link_DESC", s.OrderAsc = "order_ASC", s.OrderDesc = "order_DESC", s.SectionsLayoutAsc = "sectionsLayout_ASC", s.SectionsLayoutDesc = "sectionsLayout_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(ud || {}), ad = /* @__PURE__ */ ((s) => (s.AnimationOnHoverAsc = "animationOnHover_ASC", s.AnimationOnHoverDesc = "animationOnHover_DESC", s.DescriptionAsc = "description_ASC", s.DescriptionDesc = "description_DESC", s.HideOnDesktopAsc = "hideOnDesktop_ASC", s.HideOnDesktopDesc = "hideOnDesktop_DESC", s.HideOnMobileAsc = "hideOnMobile_ASC", s.HideOnMobileDesc = "hideOnMobile_DESC", s.IconBackgroundAsc = "iconBackground_ASC", s.IconBackgroundDesc = "iconBackground_DESC", s.IconFormAsc = "iconForm_ASC", s.IconFormDesc = "iconForm_DESC", s.IconSizeAsc = "iconSize_ASC", s.IconSizeDesc = "iconSize_DESC", s.IsExternalLinkAsc = "isExternalLink_ASC", s.IsExternalLinkDesc = "isExternalLink_DESC", s.LinkAsc = "link_ASC", s.LinkDesc = "link_DESC", s.ShowArrowAsc = "showArrow_ASC", s.ShowArrowDesc = "showArrow_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TagTextAsc = "tagText_ASC", s.TagTextDesc = "tagText_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(ad || {}), id = /* @__PURE__ */ ((s) => (s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(id || {}), _d = /* @__PURE__ */ ((s) => (s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(_d || {}), fd = /* @__PURE__ */ ((s) => (s.AnimationOnHoverAsc = "animationOnHover_ASC", s.AnimationOnHoverDesc = "animationOnHover_DESC", s.DescriptionAsc = "description_ASC", s.DescriptionDesc = "description_DESC", s.HideOnDesktopAsc = "hideOnDesktop_ASC", s.HideOnDesktopDesc = "hideOnDesktop_DESC", s.HideOnMobileAsc = "hideOnMobile_ASC", s.HideOnMobileDesc = "hideOnMobile_DESC", s.IconBackgroundAsc = "iconBackground_ASC", s.IconBackgroundDesc = "iconBackground_DESC", s.IconFormAsc = "iconForm_ASC", s.IconFormDesc = "iconForm_DESC", s.IconSizeAsc = "iconSize_ASC", s.IconSizeDesc = "iconSize_DESC", s.IsExternalLinkAsc = "isExternalLink_ASC", s.IsExternalLinkDesc = "isExternalLink_DESC", s.LinkAsc = "link_ASC", s.LinkDesc = "link_DESC", s.ShowArrowAsc = "showArrow_ASC", s.ShowArrowDesc = "showArrow_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TagTextAsc = "tagText_ASC", s.TagTextDesc = "tagText_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(fd || {}), hd = /* @__PURE__ */ ((s) => (s.PlaceholderAsc = "placeholder_ASC", s.PlaceholderDesc = "placeholder_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(hd || {}), Sd = /* @__PURE__ */ ((s) => (s.AnimationOnHoverAsc = "animationOnHover_ASC", s.AnimationOnHoverDesc = "animationOnHover_DESC", s.DescriptionAsc = "description_ASC", s.DescriptionDesc = "description_DESC", s.HideOnDesktopAsc = "hideOnDesktop_ASC", s.HideOnDesktopDesc = "hideOnDesktop_DESC", s.HideOnMobileAsc = "hideOnMobile_ASC", s.HideOnMobileDesc = "hideOnMobile_DESC", s.IconBackgroundAsc = "iconBackground_ASC", s.IconBackgroundDesc = "iconBackground_DESC", s.IconFormAsc = "iconForm_ASC", s.IconFormDesc = "iconForm_DESC", s.IconSizeAsc = "iconSize_ASC", s.IconSizeDesc = "iconSize_DESC", s.IsExternalLinkAsc = "isExternalLink_ASC", s.IsExternalLinkDesc = "isExternalLink_DESC", s.LinkAsc = "link_ASC", s.LinkDesc = "link_DESC", s.ShowArrowAsc = "showArrow_ASC", s.ShowArrowDesc = "showArrow_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TagTextAsc = "tagText_ASC", s.TagTextDesc = "tagText_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(Sd || {}), Ad = /* @__PURE__ */ ((s) => (s.LinkAsc = "link_ASC", s.LinkDesc = "link_DESC", s.OrderAsc = "order_ASC", s.OrderDesc = "order_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(Ad || {}), yd = /* @__PURE__ */ ((s) => (s.LinkAsc = "link_ASC", s.LinkDesc = "link_DESC", s.OrderAsc = "order_ASC", s.OrderDesc = "order_DESC", s.SectionsLayoutAsc = "sectionsLayout_ASC", s.SectionsLayoutDesc = "sectionsLayout_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(yd || {}), cd = /* @__PURE__ */ ((s) => (s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(cd || {}), nd = /* @__PURE__ */ ((s) => (s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(nd || {}), Dd = /* @__PURE__ */ ((s) => (s.LinkAsc = "link_ASC", s.LinkDesc = "link_DESC", s.OrderAsc = "order_ASC", s.OrderDesc = "order_DESC", s.SectionsLayoutAsc = "sectionsLayout_ASC", s.SectionsLayoutDesc = "sectionsLayout_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(Dd || {}), dd = /* @__PURE__ */ ((s) => (s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(dd || {}), pd = /* @__PURE__ */ ((s) => (s.ColumnInHomepageNetworkCardsAsc = "columnInHomepageNetworkCards_ASC", s.ColumnInHomepageNetworkCardsDesc = "columnInHomepageNetworkCards_DESC", s.ColumnInNavigationAsc = "columnInNavigation_ASC", s.ColumnInNavigationDesc = "columnInNavigation_DESC", s.LayerAsc = "layer_ASC", s.LayerDesc = "layer_DESC", s.NetworkNameAsc = "networkName_ASC", s.NetworkNameDesc = "networkName_DESC", s.OrderInDinNetworkCarouselAsc = "orderInDinNetworkCarousel_ASC", s.OrderInDinNetworkCarouselDesc = "orderInDinNetworkCarousel_DESC", s.OrderInGasApiCarouselAsc = "orderInGasApiCarousel_ASC", s.OrderInGasApiCarouselDesc = "orderInGasApiCarousel_DESC", s.OrderInHomepageNetworkCardsAsc = "orderInHomepageNetworkCards_ASC", s.OrderInHomepageNetworkCardsDesc = "orderInHomepageNetworkCards_DESC", s.OrderInNavigationColumnAsc = "orderInNavigationColumn_ASC", s.OrderInNavigationColumnDesc = "orderInNavigationColumn_DESC", s.OrderInNetworkPreviewCardsAsc = "orderInNetworkPreviewCards_ASC", s.OrderInNetworkPreviewCardsDesc = "orderInNetworkPreviewCards_DESC", s.ShortDescriptionAsc = "shortDescription_ASC", s.ShortDescriptionDesc = "shortDescription_DESC", s.ShowInGasApiCarouselAsc = "showInGasApiCarousel_ASC", s.ShowInGasApiCarouselDesc = "showInGasApiCarousel_DESC", s.ShowInHomepageNetworkCardsAsc = "showInHomepageNetworkCards_ASC", s.ShowInHomepageNetworkCardsDesc = "showInHomepageNetworkCards_DESC", s.ShowInNavigationAsc = "showInNavigation_ASC", s.ShowInNavigationDesc = "showInNavigation_DESC", s.ShowInNetworkPreviewCardsAsc = "showInNetworkPreviewCards_ASC", s.ShowInNetworkPreviewCardsDesc = "showInNetworkPreviewCards_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.UrlAsc = "url_ASC", s.UrlDesc = "url_DESC", s))(pd || {}), bd = /* @__PURE__ */ ((s) => (s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.LabelAsc = "label_ASC", s.LabelDesc = "label_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(bd || {}), Ed = /* @__PURE__ */ ((s) => (s.BackgroundColorOnMobileAsc = "backgroundColorOnMobile_ASC", s.BackgroundColorOnMobileDesc = "backgroundColorOnMobile_DESC", s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.BackgroundImagePositionAsc = "backgroundImagePosition_ASC", s.BackgroundImagePositionDesc = "backgroundImagePosition_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.OverflowAsc = "overflow_ASC", s.OverflowDesc = "overflow_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.VerticalPaddingAsc = "verticalPadding_ASC", s.VerticalPaddingDesc = "verticalPadding_DESC", s))(Ed || {}), vd = /* @__PURE__ */ ((s) => (s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.VerticalPaddingAsc = "verticalPadding_ASC", s.VerticalPaddingDesc = "verticalPadding_DESC", s))(vd || {}), md = /* @__PURE__ */ ((s) => (s.ConsensusAlgorithmAsc = "consensusAlgorithm_ASC", s.ConsensusAlgorithmDesc = "consensusAlgorithm_DESC", s.DecentralizationAsc = "decentralization_ASC", s.DecentralizationDesc = "decentralization_DESC", s.EvmCompatibilityAsc = "evmCompatibility_ASC", s.EvmCompatibilityDesc = "evmCompatibility_DESC", s.GenesisBlockDateAsc = "genesisBlockDate_ASC", s.GenesisBlockDateDesc = "genesisBlockDate_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TransactionConfirmationTimeAsc = "transactionConfirmationTime_ASC", s.TransactionConfirmationTimeDesc = "transactionConfirmationTime_DESC", s.TransactionCostAsc = "transactionCost_ASC", s.TransactionCostDesc = "transactionCost_DESC", s.TypeAsc = "type_ASC", s.TypeDesc = "type_DESC", s.UseCaseAsc = "useCase_ASC", s.UseCaseDesc = "useCase_DESC", s))(md || {}), Vd = /* @__PURE__ */ ((s) => (s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TableNameAsc = "tableName_ASC", s.TableNameDesc = "tableName_DESC", s))(Vd || {}), ld = /* @__PURE__ */ ((s) => (s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TableNameAsc = "tableName_ASC", s.TableNameDesc = "tableName_DESC", s))(ld || {}), wd = /* @__PURE__ */ ((s) => (s.ConsensusAlgorithmAsc = "consensusAlgorithm_ASC", s.ConsensusAlgorithmDesc = "consensusAlgorithm_DESC", s.DecentralizationAsc = "decentralization_ASC", s.DecentralizationDesc = "decentralization_DESC", s.EvmCompatibilityAsc = "evmCompatibility_ASC", s.EvmCompatibilityDesc = "evmCompatibility_DESC", s.GenesisBlockDateAsc = "genesisBlockDate_ASC", s.GenesisBlockDateDesc = "genesisBlockDate_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TransactionConfirmationTimeAsc = "transactionConfirmationTime_ASC", s.TransactionConfirmationTimeDesc = "transactionConfirmationTime_DESC", s.TransactionCostAsc = "transactionCost_ASC", s.TransactionCostDesc = "transactionCost_DESC", s.TypeAsc = "type_ASC", s.TypeDesc = "type_DESC", s.UseCaseAsc = "useCase_ASC", s.UseCaseDesc = "useCase_DESC", s))(wd || {}), Fd = /* @__PURE__ */ ((s) => (s.ColumnInHomepageNetworkCardsAsc = "columnInHomepageNetworkCards_ASC", s.ColumnInHomepageNetworkCardsDesc = "columnInHomepageNetworkCards_DESC", s.ColumnInNavigationAsc = "columnInNavigation_ASC", s.ColumnInNavigationDesc = "columnInNavigation_DESC", s.LayerAsc = "layer_ASC", s.LayerDesc = "layer_DESC", s.NetworkNameAsc = "networkName_ASC", s.NetworkNameDesc = "networkName_DESC", s.OrderInDinNetworkCarouselAsc = "orderInDinNetworkCarousel_ASC", s.OrderInDinNetworkCarouselDesc = "orderInDinNetworkCarousel_DESC", s.OrderInGasApiCarouselAsc = "orderInGasApiCarousel_ASC", s.OrderInGasApiCarouselDesc = "orderInGasApiCarousel_DESC", s.OrderInHomepageNetworkCardsAsc = "orderInHomepageNetworkCards_ASC", s.OrderInHomepageNetworkCardsDesc = "orderInHomepageNetworkCards_DESC", s.OrderInNavigationColumnAsc = "orderInNavigationColumn_ASC", s.OrderInNavigationColumnDesc = "orderInNavigationColumn_DESC", s.OrderInNetworkPreviewCardsAsc = "orderInNetworkPreviewCards_ASC", s.OrderInNetworkPreviewCardsDesc = "orderInNetworkPreviewCards_DESC", s.ShortDescriptionAsc = "shortDescription_ASC", s.ShortDescriptionDesc = "shortDescription_DESC", s.ShowInGasApiCarouselAsc = "showInGasApiCarousel_ASC", s.ShowInGasApiCarouselDesc = "showInGasApiCarousel_DESC", s.ShowInHomepageNetworkCardsAsc = "showInHomepageNetworkCards_ASC", s.ShowInHomepageNetworkCardsDesc = "showInHomepageNetworkCards_DESC", s.ShowInNavigationAsc = "showInNavigation_ASC", s.ShowInNavigationDesc = "showInNavigation_DESC", s.ShowInNetworkPreviewCardsAsc = "showInNetworkPreviewCards_ASC", s.ShowInNetworkPreviewCardsDesc = "showInNetworkPreviewCards_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.UrlAsc = "url_ASC", s.UrlDesc = "url_DESC", s))(Fd || {}), xd = /* @__PURE__ */ ((s) => (s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(xd || {}), od = /* @__PURE__ */ ((s) => (s.ColumnInHomepageNetworkCardsAsc = "columnInHomepageNetworkCards_ASC", s.ColumnInHomepageNetworkCardsDesc = "columnInHomepageNetworkCards_DESC", s.ColumnInNavigationAsc = "columnInNavigation_ASC", s.ColumnInNavigationDesc = "columnInNavigation_DESC", s.LayerAsc = "layer_ASC", s.LayerDesc = "layer_DESC", s.NetworkNameAsc = "networkName_ASC", s.NetworkNameDesc = "networkName_DESC", s.OrderInDinNetworkCarouselAsc = "orderInDinNetworkCarousel_ASC", s.OrderInDinNetworkCarouselDesc = "orderInDinNetworkCarousel_DESC", s.OrderInGasApiCarouselAsc = "orderInGasApiCarousel_ASC", s.OrderInGasApiCarouselDesc = "orderInGasApiCarousel_DESC", s.OrderInHomepageNetworkCardsAsc = "orderInHomepageNetworkCards_ASC", s.OrderInHomepageNetworkCardsDesc = "orderInHomepageNetworkCards_DESC", s.OrderInNavigationColumnAsc = "orderInNavigationColumn_ASC", s.OrderInNavigationColumnDesc = "orderInNavigationColumn_DESC", s.OrderInNetworkPreviewCardsAsc = "orderInNetworkPreviewCards_ASC", s.OrderInNetworkPreviewCardsDesc = "orderInNetworkPreviewCards_DESC", s.ShortDescriptionAsc = "shortDescription_ASC", s.ShortDescriptionDesc = "shortDescription_DESC", s.ShowInGasApiCarouselAsc = "showInGasApiCarousel_ASC", s.ShowInGasApiCarouselDesc = "showInGasApiCarousel_DESC", s.ShowInHomepageNetworkCardsAsc = "showInHomepageNetworkCards_ASC", s.ShowInHomepageNetworkCardsDesc = "showInHomepageNetworkCards_DESC", s.ShowInNavigationAsc = "showInNavigation_ASC", s.ShowInNavigationDesc = "showInNavigation_DESC", s.ShowInNetworkPreviewCardsAsc = "showInNetworkPreviewCards_ASC", s.ShowInNetworkPreviewCardsDesc = "showInNetworkPreviewCards_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.UrlAsc = "url_ASC", s.UrlDesc = "url_DESC", s))(od || {}), Md = /* @__PURE__ */ ((s) => (s.AdvantageImageStickyAsc = "advantageImageSticky_ASC", s.AdvantageImageStickyDesc = "advantageImageSticky_DESC", s.CtaButtonTextAsc = "ctaButtonText_ASC", s.CtaButtonTextDesc = "ctaButtonText_DESC", s.CtaButtonUrlAsc = "ctaButtonUrl_ASC", s.CtaButtonUrlDesc = "ctaButtonUrl_DESC", s.FeaturesTitleAsc = "featuresTitle_ASC", s.FeaturesTitleDesc = "featuresTitle_DESC", s.GettingStartedStep1TitleAsc = "gettingStartedStep1Title_ASC", s.GettingStartedStep1TitleDesc = "gettingStartedStep1Title_DESC", s.GettingStartedStep2TitleAsc = "gettingStartedStep2Title_ASC", s.GettingStartedStep2TitleDesc = "gettingStartedStep2Title_DESC", s.GettingStartedStep3TitleAsc = "gettingStartedStep3Title_ASC", s.GettingStartedStep3TitleDesc = "gettingStartedStep3Title_DESC", s.GettingStartedStep4TitleAsc = "gettingStartedStep4Title_ASC", s.GettingStartedStep4TitleDesc = "gettingStartedStep4Title_DESC", s.HeroPrimaryButtonTextAsc = "heroPrimaryButtonText_ASC", s.HeroPrimaryButtonTextDesc = "heroPrimaryButtonText_DESC", s.HeroPrimaryButtonUrlAsc = "heroPrimaryButtonUrl_ASC", s.HeroPrimaryButtonUrlDesc = "heroPrimaryButtonUrl_DESC", s.HeroSecondaryButtonTextAsc = "heroSecondaryButtonText_ASC", s.HeroSecondaryButtonTextDesc = "heroSecondaryButtonText_DESC", s.HeroSecondaryButtonUrlAsc = "heroSecondaryButtonUrl_ASC", s.HeroSecondaryButtonUrlDesc = "heroSecondaryButtonUrl_DESC", s.HeroShowDinLogoAsc = "heroShowDinLogo_ASC", s.HeroShowDinLogoDesc = "heroShowDinLogo_DESC", s.HeroTitleAsc = "heroTitle_ASC", s.HeroTitleDesc = "heroTitle_DESC", s.NetworkNameAsc = "networkName_ASC", s.NetworkNameDesc = "networkName_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(Md || {}), $d = /* @__PURE__ */ ((s) => (s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))($d || {}), Td = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.CardSliderViewOnDesktopAsc = "cardSliderViewOnDesktop_ASC", s.CardSliderViewOnDesktopDesc = "cardSliderViewOnDesktop_DESC", s.CardSliderViewOnMobileAsc = "cardSliderViewOnMobile_ASC", s.CardSliderViewOnMobileDesc = "cardSliderViewOnMobile_DESC", s.ColumnCountAsc = "columnCount_ASC", s.ColumnCountDesc = "columnCount_DESC", s.LayoutModeAsc = "layoutMode_ASC", s.LayoutModeDesc = "layoutMode_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.ReverseOnMobileAsc = "reverseOnMobile_ASC", s.ReverseOnMobileDesc = "reverseOnMobile_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TopSpacingAsc = "topSpacing_ASC", s.TopSpacingDesc = "topSpacing_DESC", s.UnlimitedItemWidthAsc = "unlimitedItemWidth_ASC", s.UnlimitedItemWidthDesc = "unlimitedItemWidth_DESC", s))(Td || {}), Pd = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.FullWidthContentAsc = "fullWidthContent_ASC", s.FullWidthContentDesc = "fullWidthContent_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(Pd || {}), Bd = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.BodyTextSizeAsc = "bodyTextSize_ASC", s.BodyTextSizeDesc = "bodyTextSize_DESC", s.HeadingFontAsc = "headingFont_ASC", s.HeadingFontDesc = "headingFont_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.PaddingHorizontalAsc = "paddingHorizontal_ASC", s.PaddingHorizontalDesc = "paddingHorizontal_DESC", s.PaddingAsc = "padding_ASC", s.PaddingDesc = "padding_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(Bd || {}), qd = /* @__PURE__ */ ((s) => (s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.ContentAlignAsc = "contentAlign_ASC", s.ContentAlignDesc = "contentAlign_DESC", s.ContentSpacingAsc = "contentSpacing_ASC", s.ContentSpacingDesc = "contentSpacing_DESC", s.ContentWidthAsc = "contentWidth_ASC", s.ContentWidthDesc = "contentWidth_DESC", s.DescriptionTextSizeAsc = "descriptionTextSize_ASC", s.DescriptionTextSizeDesc = "descriptionTextSize_DESC", s.DeveloperStoriesTagAsc = "developerStoriesTag_ASC", s.DeveloperStoriesTagDesc = "developerStoriesTag_DESC", s.HeadingFontAsc = "headingFont_ASC", s.HeadingFontDesc = "headingFont_DESC", s.HeadingTextSizeAsc = "headingTextSize_ASC", s.HeadingTextSizeDesc = "headingTextSize_DESC", s.HideImageOnMobileAsc = "hideImageOnMobile_ASC", s.HideImageOnMobileDesc = "hideImageOnMobile_DESC", s.LogoHeaderAsc = "logoHeader_ASC", s.LogoHeaderDesc = "logoHeader_DESC", s.ReverseItemsOrderOnMobileAsc = "reverseItemsOrderOnMobile_ASC", s.ReverseItemsOrderOnMobileDesc = "reverseItemsOrderOnMobile_DESC", s.StickyImageOnMobileAsc = "stickyImageOnMobile_ASC", s.StickyImageOnMobileDesc = "stickyImageOnMobile_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(qd || {}), Gd = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.CardSliderViewOnDesktopAsc = "cardSliderViewOnDesktop_ASC", s.CardSliderViewOnDesktopDesc = "cardSliderViewOnDesktop_DESC", s.CardSliderViewOnMobileAsc = "cardSliderViewOnMobile_ASC", s.CardSliderViewOnMobileDesc = "cardSliderViewOnMobile_DESC", s.ColumnCountAsc = "columnCount_ASC", s.ColumnCountDesc = "columnCount_DESC", s.LayoutModeAsc = "layoutMode_ASC", s.LayoutModeDesc = "layoutMode_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.ReverseOnMobileAsc = "reverseOnMobile_ASC", s.ReverseOnMobileDesc = "reverseOnMobile_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TopSpacingAsc = "topSpacing_ASC", s.TopSpacingDesc = "topSpacing_DESC", s.UnlimitedItemWidthAsc = "unlimitedItemWidth_ASC", s.UnlimitedItemWidthDesc = "unlimitedItemWidth_DESC", s))(Gd || {}), Rd = /* @__PURE__ */ ((s) => (s.BackgroundColorOnMobileAsc = "backgroundColorOnMobile_ASC", s.BackgroundColorOnMobileDesc = "backgroundColorOnMobile_DESC", s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.BackgroundImagePositionAsc = "backgroundImagePosition_ASC", s.BackgroundImagePositionDesc = "backgroundImagePosition_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.OverflowAsc = "overflow_ASC", s.OverflowDesc = "overflow_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.VerticalPaddingAsc = "verticalPadding_ASC", s.VerticalPaddingDesc = "verticalPadding_DESC", s))(Rd || {}), jd = /* @__PURE__ */ ((s) => (s.ShowColumnHeadersAsc = "showColumnHeaders_ASC", s.ShowColumnHeadersDesc = "showColumnHeaders_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleIconAsc = "titleIcon_ASC", s.TitleIconDesc = "titleIcon_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(jd || {}), Ud = /* @__PURE__ */ ((s) => (s.AllAsc = "all_ASC", s.AllDesc = "all_DESC", s.BottomAsc = "bottom_ASC", s.BottomDesc = "bottom_DESC", s.HorizontalAsc = "horizontal_ASC", s.HorizontalDesc = "horizontal_DESC", s.LeftAsc = "left_ASC", s.LeftDesc = "left_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.RightAsc = "right_ASC", s.RightDesc = "right_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TopAsc = "top_ASC", s.TopDesc = "top_DESC", s.VerticalAsc = "vertical_ASC", s.VerticalDesc = "vertical_DESC", s))(Ud || {}), Qd = /* @__PURE__ */ ((s) => (s.CtaLinkAsc = "ctaLink_ASC", s.CtaLinkDesc = "ctaLink_DESC", s.CtaTextAsc = "ctaText_ASC", s.CtaTextDesc = "ctaText_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(Qd || {}), zd = /* @__PURE__ */ ((s) => (s.FeatureFlagAsc = "featureFlag_ASC", s.FeatureFlagDesc = "featureFlag_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.PathAsc = "path_ASC", s.PathDesc = "path_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(zd || {}), Wd = /* @__PURE__ */ ((s) => (s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.NetworkNameAsc = "networkName_ASC", s.NetworkNameDesc = "networkName_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(Wd || {}), Nd = /* @__PURE__ */ ((s) => (s.LayerOneNameAsc = "layerOneName_ASC", s.LayerOneNameDesc = "layerOneName_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.NetworkNameAsc = "networkName_ASC", s.NetworkNameDesc = "networkName_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(Nd || {}), Id = /* @__PURE__ */ ((s) => (s.FeatureFlagAsc = "featureFlag_ASC", s.FeatureFlagDesc = "featureFlag_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.PathAsc = "path_ASC", s.PathDesc = "path_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(Id || {}), Jd = /* @__PURE__ */ ((s) => (s.BackgroundColorOnMobileAsc = "backgroundColorOnMobile_ASC", s.BackgroundColorOnMobileDesc = "backgroundColorOnMobile_DESC", s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.BackgroundImagePositionAsc = "backgroundImagePosition_ASC", s.BackgroundImagePositionDesc = "backgroundImagePosition_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.OverflowAsc = "overflow_ASC", s.OverflowDesc = "overflow_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.VerticalPaddingAsc = "verticalPadding_ASC", s.VerticalPaddingDesc = "verticalPadding_DESC", s))(Jd || {}), Hd = /* @__PURE__ */ ((s) => (s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(Hd || {}), Yd = /* @__PURE__ */ ((s) => (s.BackgroundColorOnMobileAsc = "backgroundColorOnMobile_ASC", s.BackgroundColorOnMobileDesc = "backgroundColorOnMobile_DESC", s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.BackgroundImagePositionAsc = "backgroundImagePosition_ASC", s.BackgroundImagePositionDesc = "backgroundImagePosition_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.OverflowAsc = "overflow_ASC", s.OverflowDesc = "overflow_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.VerticalPaddingAsc = "verticalPadding_ASC", s.VerticalPaddingDesc = "verticalPadding_DESC", s))(Yd || {}), Kd = /* @__PURE__ */ ((s) => (s.CustomerNameAsc = "customerName_ASC", s.CustomerNameDesc = "customerName_DESC", s.HeroBackgroundColorAsc = "heroBackgroundColor_ASC", s.HeroBackgroundColorDesc = "heroBackgroundColor_DESC", s.HeroTitleFontAsc = "heroTitleFont_ASC", s.HeroTitleFontDesc = "heroTitleFont_DESC", s.HeroTitleSizeAsc = "heroTitleSize_ASC", s.HeroTitleSizeDesc = "heroTitleSize_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s.UrlAsc = "url_ASC", s.UrlDesc = "url_DESC", s.VerticalAsc = "vertical_ASC", s.VerticalDesc = "vertical_DESC", s))(Kd || {}), Xd = /* @__PURE__ */ ((s) => (s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.NetworkNameAsc = "networkName_ASC", s.NetworkNameDesc = "networkName_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(Xd || {}), Zd = /* @__PURE__ */ ((s) => (s.LayerOneNameAsc = "layerOneName_ASC", s.LayerOneNameDesc = "layerOneName_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.NetworkNameAsc = "networkName_ASC", s.NetworkNameDesc = "networkName_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(Zd || {}), Cd = /* @__PURE__ */ ((s) => (s.AdvantageImageStickyAsc = "advantageImageSticky_ASC", s.AdvantageImageStickyDesc = "advantageImageSticky_DESC", s.CtaButtonTextAsc = "ctaButtonText_ASC", s.CtaButtonTextDesc = "ctaButtonText_DESC", s.CtaButtonUrlAsc = "ctaButtonUrl_ASC", s.CtaButtonUrlDesc = "ctaButtonUrl_DESC", s.FeaturesTitleAsc = "featuresTitle_ASC", s.FeaturesTitleDesc = "featuresTitle_DESC", s.GettingStartedStep1TitleAsc = "gettingStartedStep1Title_ASC", s.GettingStartedStep1TitleDesc = "gettingStartedStep1Title_DESC", s.GettingStartedStep2TitleAsc = "gettingStartedStep2Title_ASC", s.GettingStartedStep2TitleDesc = "gettingStartedStep2Title_DESC", s.GettingStartedStep3TitleAsc = "gettingStartedStep3Title_ASC", s.GettingStartedStep3TitleDesc = "gettingStartedStep3Title_DESC", s.GettingStartedStep4TitleAsc = "gettingStartedStep4Title_ASC", s.GettingStartedStep4TitleDesc = "gettingStartedStep4Title_DESC", s.HeroPrimaryButtonTextAsc = "heroPrimaryButtonText_ASC", s.HeroPrimaryButtonTextDesc = "heroPrimaryButtonText_DESC", s.HeroPrimaryButtonUrlAsc = "heroPrimaryButtonUrl_ASC", s.HeroPrimaryButtonUrlDesc = "heroPrimaryButtonUrl_DESC", s.HeroSecondaryButtonTextAsc = "heroSecondaryButtonText_ASC", s.HeroSecondaryButtonTextDesc = "heroSecondaryButtonText_DESC", s.HeroSecondaryButtonUrlAsc = "heroSecondaryButtonUrl_ASC", s.HeroSecondaryButtonUrlDesc = "heroSecondaryButtonUrl_DESC", s.HeroShowDinLogoAsc = "heroShowDinLogo_ASC", s.HeroShowDinLogoDesc = "heroShowDinLogo_DESC", s.HeroTitleAsc = "heroTitle_ASC", s.HeroTitleDesc = "heroTitle_DESC", s.NetworkNameAsc = "networkName_ASC", s.NetworkNameDesc = "networkName_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(Cd || {}), gd = /* @__PURE__ */ ((s) => (s.FeatureFlagAsc = "featureFlag_ASC", s.FeatureFlagDesc = "featureFlag_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.PathAsc = "path_ASC", s.PathDesc = "path_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(gd || {}), kd = /* @__PURE__ */ ((s) => (s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s.UrlAsc = "url_ASC", s.UrlDesc = "url_DESC", s))(kd || {}), Od = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.CardSliderViewOnDesktopAsc = "cardSliderViewOnDesktop_ASC", s.CardSliderViewOnDesktopDesc = "cardSliderViewOnDesktop_DESC", s.CardSliderViewOnMobileAsc = "cardSliderViewOnMobile_ASC", s.CardSliderViewOnMobileDesc = "cardSliderViewOnMobile_DESC", s.ColumnCountAsc = "columnCount_ASC", s.ColumnCountDesc = "columnCount_DESC", s.LayoutModeAsc = "layoutMode_ASC", s.LayoutModeDesc = "layoutMode_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.ReverseOnMobileAsc = "reverseOnMobile_ASC", s.ReverseOnMobileDesc = "reverseOnMobile_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TopSpacingAsc = "topSpacing_ASC", s.TopSpacingDesc = "topSpacing_DESC", s.UnlimitedItemWidthAsc = "unlimitedItemWidth_ASC", s.UnlimitedItemWidthDesc = "unlimitedItemWidth_DESC", s))(Od || {}), Ld = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.CardSliderViewOnDesktopAsc = "cardSliderViewOnDesktop_ASC", s.CardSliderViewOnDesktopDesc = "cardSliderViewOnDesktop_DESC", s.CardSliderViewOnMobileAsc = "cardSliderViewOnMobile_ASC", s.CardSliderViewOnMobileDesc = "cardSliderViewOnMobile_DESC", s.ColumnCountAsc = "columnCount_ASC", s.ColumnCountDesc = "columnCount_DESC", s.LayoutModeAsc = "layoutMode_ASC", s.LayoutModeDesc = "layoutMode_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.ReverseOnMobileAsc = "reverseOnMobile_ASC", s.ReverseOnMobileDesc = "reverseOnMobile_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TopSpacingAsc = "topSpacing_ASC", s.TopSpacingDesc = "topSpacing_DESC", s.UnlimitedItemWidthAsc = "unlimitedItemWidth_ASC", s.UnlimitedItemWidthDesc = "unlimitedItemWidth_DESC", s))(Ld || {}), sp = /* @__PURE__ */ ((s) => (s.PeriodAsc = "period_ASC", s.PeriodDesc = "period_DESC", s.PricingPlanTagAsc = "pricingPlanTag_ASC", s.PricingPlanTagDesc = "pricingPlanTag_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TextAfterOptionsAsc = "textAfterOptions_ASC", s.TextAfterOptionsDesc = "textAfterOptions_DESC", s.TextBeforeOptionsAsc = "textBeforeOptions_ASC", s.TextBeforeOptionsDesc = "textBeforeOptions_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(sp || {}), ep = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.CardSliderViewOnDesktopAsc = "cardSliderViewOnDesktop_ASC", s.CardSliderViewOnDesktopDesc = "cardSliderViewOnDesktop_DESC", s.CardSliderViewOnMobileAsc = "cardSliderViewOnMobile_ASC", s.CardSliderViewOnMobileDesc = "cardSliderViewOnMobile_DESC", s.ColumnCountAsc = "columnCount_ASC", s.ColumnCountDesc = "columnCount_DESC", s.LayoutModeAsc = "layoutMode_ASC", s.LayoutModeDesc = "layoutMode_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.ReverseOnMobileAsc = "reverseOnMobile_ASC", s.ReverseOnMobileDesc = "reverseOnMobile_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TopSpacingAsc = "topSpacing_ASC", s.TopSpacingDesc = "topSpacing_DESC", s.UnlimitedItemWidthAsc = "unlimitedItemWidth_ASC", s.UnlimitedItemWidthDesc = "unlimitedItemWidth_DESC", s))(ep || {}), tp = /* @__PURE__ */ ((s) => (s.ShowColumnHeadersAsc = "showColumnHeaders_ASC", s.ShowColumnHeadersDesc = "showColumnHeaders_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleIconAsc = "titleIcon_ASC", s.TitleIconDesc = "titleIcon_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(tp || {}), rp = /* @__PURE__ */ ((s) => (s.AdvantagesTitleAsc = "advantagesTitle_ASC", s.AdvantagesTitleDesc = "advantagesTitle_DESC", s.PeriodAsc = "period_ASC", s.PeriodDesc = "period_DESC", s.PriceAsc = "price_ASC", s.PriceDesc = "price_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TagAsc = "tag_ASC", s.TagDesc = "tag_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(rp || {}), up = /* @__PURE__ */ ((s) => (s.QuizQuestionAsc = "quizQuestion_ASC", s.QuizQuestionDesc = "quizQuestion_DESC", s.SubTitleAsc = "subTitle_ASC", s.SubTitleDesc = "subTitle_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(up || {}), ap = /* @__PURE__ */ ((s) => (s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.PriceAsc = "price_ASC", s.PriceDesc = "price_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(ap || {}), ip = /* @__PURE__ */ ((s) => (s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(ip || {}), _p = /* @__PURE__ */ ((s) => (s.BackgroundColorOnMobileAsc = "backgroundColorOnMobile_ASC", s.BackgroundColorOnMobileDesc = "backgroundColorOnMobile_DESC", s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.BackgroundImagePositionAsc = "backgroundImagePosition_ASC", s.BackgroundImagePositionDesc = "backgroundImagePosition_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.OverflowAsc = "overflow_ASC", s.OverflowDesc = "overflow_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.VerticalPaddingAsc = "verticalPadding_ASC", s.VerticalPaddingDesc = "verticalPadding_DESC", s))(_p || {}), fp = /* @__PURE__ */ ((s) => (s.ShowColumnHeadersAsc = "showColumnHeaders_ASC", s.ShowColumnHeadersDesc = "showColumnHeaders_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleIconAsc = "titleIcon_ASC", s.TitleIconDesc = "titleIcon_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(fp || {}), hp = /* @__PURE__ */ ((s) => (s.AdvantagesTitleAsc = "advantagesTitle_ASC", s.AdvantagesTitleDesc = "advantagesTitle_DESC", s.PeriodAsc = "period_ASC", s.PeriodDesc = "period_DESC", s.PriceAsc = "price_ASC", s.PriceDesc = "price_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TagAsc = "tag_ASC", s.TagDesc = "tag_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(hp || {}), Sp = /* @__PURE__ */ ((s) => (s.ShowColumnHeadersAsc = "showColumnHeaders_ASC", s.ShowColumnHeadersDesc = "showColumnHeaders_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleIconAsc = "titleIcon_ASC", s.TitleIconDesc = "titleIcon_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(Sp || {}), Ap = /* @__PURE__ */ ((s) => (s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(Ap || {}), yp = /* @__PURE__ */ ((s) => (s.BackgroundColorOnMobileAsc = "backgroundColorOnMobile_ASC", s.BackgroundColorOnMobileDesc = "backgroundColorOnMobile_DESC", s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.BackgroundImagePositionAsc = "backgroundImagePosition_ASC", s.BackgroundImagePositionDesc = "backgroundImagePosition_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.OverflowAsc = "overflow_ASC", s.OverflowDesc = "overflow_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.VerticalPaddingAsc = "verticalPadding_ASC", s.VerticalPaddingDesc = "verticalPadding_DESC", s))(yp || {}), cp = /* @__PURE__ */ ((s) => (s.QuizQuestionAsc = "quizQuestion_ASC", s.QuizQuestionDesc = "quizQuestion_DESC", s.SubTitleAsc = "subTitle_ASC", s.SubTitleDesc = "subTitle_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(cp || {}), np = /* @__PURE__ */ ((s) => (s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.PriceAsc = "price_ASC", s.PriceDesc = "price_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(np || {}), Dp = /* @__PURE__ */ ((s) => (s.DescriptionAsc = "description_ASC", s.DescriptionDesc = "description_DESC", s.IsDisabledAsc = "isDisabled_ASC", s.IsDisabledDesc = "isDisabled_DESC", s.LinkTextAsc = "linkText_ASC", s.LinkTextDesc = "linkText_DESC", s.LinkUrlAsc = "linkUrl_ASC", s.LinkUrlDesc = "linkUrl_DESC", s.OrderAsc = "order_ASC", s.OrderDesc = "order_DESC", s.StyleVariantAsc = "styleVariant_ASC", s.StyleVariantDesc = "styleVariant_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TagAsc = "tag_ASC", s.TagDesc = "tag_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(Dp || {}), dp = /* @__PURE__ */ ((s) => (s.BackgroundColorOnMobileAsc = "backgroundColorOnMobile_ASC", s.BackgroundColorOnMobileDesc = "backgroundColorOnMobile_DESC", s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.BackgroundImagePositionAsc = "backgroundImagePosition_ASC", s.BackgroundImagePositionDesc = "backgroundImagePosition_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.OverflowAsc = "overflow_ASC", s.OverflowDesc = "overflow_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.VerticalPaddingAsc = "verticalPadding_ASC", s.VerticalPaddingDesc = "verticalPadding_DESC", s))(dp || {}), pp = /* @__PURE__ */ ((s) => (s.FilterAsc = "filter_ASC", s.FilterDesc = "filter_DESC", s.ItemsLimitAsc = "itemsLimit_ASC", s.ItemsLimitDesc = "itemsLimit_DESC", s.SheetIdAsc = "sheetId_ASC", s.SheetIdDesc = "sheetId_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TabNameAsc = "tabName_ASC", s.TabNameDesc = "tabName_DESC", s))(pp || {}), bp = /* @__PURE__ */ ((s) => (s.SlugAsc = "slug_ASC", s.SlugDesc = "slug_DESC", s.SubdirectoryAsc = "subdirectory_ASC", s.SubdirectoryDesc = "subdirectory_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(bp || {}), Ep = /* @__PURE__ */ ((s) => (s.CtaButtonTextAsc = "ctaButtonText_ASC", s.CtaButtonTextDesc = "ctaButtonText_DESC", s.CtaLinkAsc = "ctaLink_ASC", s.CtaLinkDesc = "ctaLink_DESC", s.DescriptionAsc = "description_ASC", s.DescriptionDesc = "description_DESC", s.HeadingAsc = "heading_ASC", s.HeadingDesc = "heading_DESC", s.PageTypeAsc = "pageType_ASC", s.PageTypeDesc = "pageType_DESC", s.PathAsc = "path_ASC", s.PathDesc = "path_DESC", s.SpeakersIntroTitleAsc = "speakersIntroTitle_ASC", s.SpeakersIntroTitleDesc = "speakersIntroTitle_DESC", s.SubheadingAsc = "subheading_ASC", s.SubheadingDesc = "subheading_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TagAsc = "tag_ASC", s.TagDesc = "tag_DESC", s.ThankYouHeaderAsc = "thankYouHeader_ASC", s.ThankYouHeaderDesc = "thankYouHeader_DESC", s))(Ep || {}), vp = /* @__PURE__ */ ((s) => (s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(vp || {}), mp = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.CardSliderViewOnDesktopAsc = "cardSliderViewOnDesktop_ASC", s.CardSliderViewOnDesktopDesc = "cardSliderViewOnDesktop_DESC", s.CardSliderViewOnMobileAsc = "cardSliderViewOnMobile_ASC", s.CardSliderViewOnMobileDesc = "cardSliderViewOnMobile_DESC", s.ColumnCountAsc = "columnCount_ASC", s.ColumnCountDesc = "columnCount_DESC", s.LayoutModeAsc = "layoutMode_ASC", s.LayoutModeDesc = "layoutMode_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.ReverseOnMobileAsc = "reverseOnMobile_ASC", s.ReverseOnMobileDesc = "reverseOnMobile_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TopSpacingAsc = "topSpacing_ASC", s.TopSpacingDesc = "topSpacing_DESC", s.UnlimitedItemWidthAsc = "unlimitedItemWidth_ASC", s.UnlimitedItemWidthDesc = "unlimitedItemWidth_DESC", s))(mp || {}), Vp = /* @__PURE__ */ ((s) => (s.BackgroundColorOnMobileAsc = "backgroundColorOnMobile_ASC", s.BackgroundColorOnMobileDesc = "backgroundColorOnMobile_DESC", s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.BackgroundImagePositionAsc = "backgroundImagePosition_ASC", s.BackgroundImagePositionDesc = "backgroundImagePosition_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.OverflowAsc = "overflow_ASC", s.OverflowDesc = "overflow_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.VerticalPaddingAsc = "verticalPadding_ASC", s.VerticalPaddingDesc = "verticalPadding_DESC", s))(Vp || {}), lp = /* @__PURE__ */ ((s) => (s.ComponentNameAsc = "componentName_ASC", s.ComponentNameDesc = "componentName_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(lp || {}), wp = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.ColorAsc = "color_ASC", s.ColorDesc = "color_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.QueryKeyAsc = "queryKey_ASC", s.QueryKeyDesc = "queryKey_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(wp || {}), Fp = /* @__PURE__ */ ((s) => (s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.VerticalPaddingAsc = "verticalPadding_ASC", s.VerticalPaddingDesc = "verticalPadding_DESC", s))(Fp || {}), xp = /* @__PURE__ */ ((s) => (s.LabelAsc = "label_ASC", s.LabelDesc = "label_DESC", s.QueryValueAsc = "queryValue_ASC", s.QueryValueDesc = "queryValue_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.UppercaseAsc = "uppercase_ASC", s.UppercaseDesc = "uppercase_DESC", s))(xp || {}), op = /* @__PURE__ */ ((s) => (s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.VerticalPaddingAsc = "verticalPadding_ASC", s.VerticalPaddingDesc = "verticalPadding_DESC", s))(op || {}), Mp = /* @__PURE__ */ ((s) => (s.LabelAsc = "label_ASC", s.LabelDesc = "label_DESC", s.QueryValueAsc = "queryValue_ASC", s.QueryValueDesc = "queryValue_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.UppercaseAsc = "uppercase_ASC", s.UppercaseDesc = "uppercase_DESC", s))(Mp || {}), $p = /* @__PURE__ */ ((s) => (s.CustomerNameAsc = "customerName_ASC", s.CustomerNameDesc = "customerName_DESC", s.HeroBackgroundColorAsc = "heroBackgroundColor_ASC", s.HeroBackgroundColorDesc = "heroBackgroundColor_DESC", s.HeroTitleFontAsc = "heroTitleFont_ASC", s.HeroTitleFontDesc = "heroTitleFont_DESC", s.HeroTitleSizeAsc = "heroTitleSize_ASC", s.HeroTitleSizeDesc = "heroTitleSize_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s.UrlAsc = "url_ASC", s.UrlDesc = "url_DESC", s.VerticalAsc = "vertical_ASC", s.VerticalDesc = "vertical_DESC", s))($p || {}), Tp = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.FullWidthContentAsc = "fullWidthContent_ASC", s.FullWidthContentDesc = "fullWidthContent_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(Tp || {}), Pp = /* @__PURE__ */ ((s) => (s.BackgroundColorOnMobileAsc = "backgroundColorOnMobile_ASC", s.BackgroundColorOnMobileDesc = "backgroundColorOnMobile_DESC", s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.BackgroundImagePositionAsc = "backgroundImagePosition_ASC", s.BackgroundImagePositionDesc = "backgroundImagePosition_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.OverflowAsc = "overflow_ASC", s.OverflowDesc = "overflow_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.VerticalPaddingAsc = "verticalPadding_ASC", s.VerticalPaddingDesc = "verticalPadding_DESC", s))(Pp || {}), Bp = /* @__PURE__ */ ((s) => (s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(Bp || {}), qp = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(qp || {}), Gp = /* @__PURE__ */ ((s) => (s.LinkTextAsc = "linkText_ASC", s.LinkTextDesc = "linkText_DESC", s.LocationAsc = "location_ASC", s.LocationDesc = "location_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TagTextAsc = "tagText_ASC", s.TagTextDesc = "tagText_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s.UrlAsc = "url_ASC", s.UrlDesc = "url_DESC", s))(Gp || {}), Rp = /* @__PURE__ */ ((s) => (s.BackgroundColorOnMobileAsc = "backgroundColorOnMobile_ASC", s.BackgroundColorOnMobileDesc = "backgroundColorOnMobile_DESC", s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.BackgroundImagePositionAsc = "backgroundImagePosition_ASC", s.BackgroundImagePositionDesc = "backgroundImagePosition_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.OverflowAsc = "overflow_ASC", s.OverflowDesc = "overflow_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.VerticalPaddingAsc = "verticalPadding_ASC", s.VerticalPaddingDesc = "verticalPadding_DESC", s))(Rp || {}), jp = /* @__PURE__ */ ((s) => (s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.VerticalPaddingAsc = "verticalPadding_ASC", s.VerticalPaddingDesc = "verticalPadding_DESC", s))(jp || {}), Up = /* @__PURE__ */ ((s) => (s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(Up || {}), Qp = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.CardSliderViewOnDesktopAsc = "cardSliderViewOnDesktop_ASC", s.CardSliderViewOnDesktopDesc = "cardSliderViewOnDesktop_DESC", s.CardSliderViewOnMobileAsc = "cardSliderViewOnMobile_ASC", s.CardSliderViewOnMobileDesc = "cardSliderViewOnMobile_DESC", s.ColumnCountAsc = "columnCount_ASC", s.ColumnCountDesc = "columnCount_DESC", s.LayoutModeAsc = "layoutMode_ASC", s.LayoutModeDesc = "layoutMode_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.ReverseOnMobileAsc = "reverseOnMobile_ASC", s.ReverseOnMobileDesc = "reverseOnMobile_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TopSpacingAsc = "topSpacing_ASC", s.TopSpacingDesc = "topSpacing_DESC", s.UnlimitedItemWidthAsc = "unlimitedItemWidth_ASC", s.UnlimitedItemWidthDesc = "unlimitedItemWidth_DESC", s))(Qp || {}), zp = /* @__PURE__ */ ((s) => (s.BackgroundColorOnMobileAsc = "backgroundColorOnMobile_ASC", s.BackgroundColorOnMobileDesc = "backgroundColorOnMobile_DESC", s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.BackgroundImagePositionAsc = "backgroundImagePosition_ASC", s.BackgroundImagePositionDesc = "backgroundImagePosition_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.OverflowAsc = "overflow_ASC", s.OverflowDesc = "overflow_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.VerticalPaddingAsc = "verticalPadding_ASC", s.VerticalPaddingDesc = "verticalPadding_DESC", s))(zp || {}), Wp = /* @__PURE__ */ ((s) => (s.ComponentNameAsc = "componentName_ASC", s.ComponentNameDesc = "componentName_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(Wp || {}), Np = /* @__PURE__ */ ((s) => (s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.VerticalPaddingAsc = "verticalPadding_ASC", s.VerticalPaddingDesc = "verticalPadding_DESC", s))(Np || {}), Ip = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.PaddingAsc = "padding_ASC", s.PaddingDesc = "padding_DESC", s.SubtitleTextAsc = "subtitleText_ASC", s.SubtitleTextDesc = "subtitleText_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleFontAsc = "titleFont_ASC", s.TitleFontDesc = "titleFont_DESC", s.TitleSizeAsc = "titleSize_ASC", s.TitleSizeDesc = "titleSize_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s.WidthAsc = "width_ASC", s.WidthDesc = "width_DESC", s))(Ip || {}), Jp = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.CardSliderViewOnDesktopAsc = "cardSliderViewOnDesktop_ASC", s.CardSliderViewOnDesktopDesc = "cardSliderViewOnDesktop_DESC", s.CardSliderViewOnMobileAsc = "cardSliderViewOnMobile_ASC", s.CardSliderViewOnMobileDesc = "cardSliderViewOnMobile_DESC", s.ColumnCountAsc = "columnCount_ASC", s.ColumnCountDesc = "columnCount_DESC", s.LayoutModeAsc = "layoutMode_ASC", s.LayoutModeDesc = "layoutMode_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.ReverseOnMobileAsc = "reverseOnMobile_ASC", s.ReverseOnMobileDesc = "reverseOnMobile_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TopSpacingAsc = "topSpacing_ASC", s.TopSpacingDesc = "topSpacing_DESC", s.UnlimitedItemWidthAsc = "unlimitedItemWidth_ASC", s.UnlimitedItemWidthDesc = "unlimitedItemWidth_DESC", s))(Jp || {}), Hp = /* @__PURE__ */ ((s) => (s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(Hp || {}), Yp = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.TitleAsc = "title_ASC", s.TitleDesc = "title_DESC", s))(Yp || {}), Kp = /* @__PURE__ */ ((s) => (s.AlignmentAsc = "alignment_ASC", s.AlignmentDesc = "alignment_DESC", s.FullWidthContentAsc = "fullWidthContent_ASC", s.FullWidthContentDesc = "fullWidthContent_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s))(Kp || {}), Xp = /* @__PURE__ */ ((s) => (s.BackgroundColorOnMobileAsc = "backgroundColorOnMobile_ASC", s.BackgroundColorOnMobileDesc = "backgroundColorOnMobile_DESC", s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.BackgroundImagePositionAsc = "backgroundImagePosition_ASC", s.BackgroundImagePositionDesc = "backgroundImagePosition_DESC", s.MaxWidthAsc = "maxWidth_ASC", s.MaxWidthDesc = "maxWidth_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.OverflowAsc = "overflow_ASC", s.OverflowDesc = "overflow_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.VerticalPaddingAsc = "verticalPadding_ASC", s.VerticalPaddingDesc = "verticalPadding_DESC", s))(Xp || {}), Zp = /* @__PURE__ */ ((s) => (s.BackgroundColorAsc = "backgroundColor_ASC", s.BackgroundColorDesc = "backgroundColor_DESC", s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.VerticalPaddingAsc = "verticalPadding_ASC", s.VerticalPaddingDesc = "verticalPadding_DESC", s))(Zp || {}), Cp = /* @__PURE__ */ ((s) => (s.NameAsc = "name_ASC", s.NameDesc = "name_DESC", s.SysFirstPublishedAtAsc = "sys_firstPublishedAt_ASC", s.SysFirstPublishedAtDesc = "sys_firstPublishedAt_DESC", s.SysIdAsc = "sys_id_ASC", s.SysIdDesc = "sys_id_DESC", s.SysPublishedAtAsc = "sys_publishedAt_ASC", s.SysPublishedAtDesc = "sys_publishedAt_DESC", s.SysPublishedVersionAsc = "sys_publishedVersion_ASC", s.SysPublishedVersionDesc = "sys_publishedVersion_DESC", s.VideoIdAsc = "videoId_ASC", s.VideoIdDesc = "videoId_DESC", s))(Cp || {});
const Nt = o`
    fragment paddingFields on Padding {
  all
  vertical
  horizontal
  top
  right
  bottom
  left
}
    `, Oe = o`
    fragment richTextFields on ContentTypeRichText {
  maxWidth
  alignment
  bodyTextSize
  headingFont
  padding
  paddingHorizontal
  customPadding {
    ...paddingFields
  }
  richText {
    json
    links {
      assets {
        block {
          sys {
            id
          }
          url
          title
          width
          height
          description
        }
      }
    }
  }
}
    ${Nt}`, Vs = o`
    fragment imageFields on Asset {
  title
  description
  contentType
  url
  width
  height
}
    `, gp = o`
    fragment logoRowFields on LogoRow {
  title
  bodyText {
    ...richTextFields
  }
  logosCollection(limit: 20) {
    items {
      image {
        ...imageFields
      }
    }
  }
}
    ${Oe}
${Vs}`, Le = o`
    fragment buttonFields on Button {
  color
  id
  text
  url
  variant
  size
  uppercase
  width
  rightIcon
  textAlignment
  boldText
  location
}
    `, kp = o`
    fragment iconListItemFields on IconListItem {
  __typename
  title
  description
  icon {
    ...imageFields
  }
  link {
    ...buttonFields
  }
  tagText
}
    ${Vs}
${Le}`, If = o`
    fragment imageWithFooterFields on ImageWithFooter {
  title
  description
  image {
    ...imageFields
  }
  tagText
  linkText
  url
  location
}
    ${Vs}`, Op = o`
    fragment networkDetailsFields on NetworkDetails {
  name
  type
  useCase
  consensusAlgorithm
  evmCompatibility
  transactionCost
  transactionConfirmationTime
  decentralization
  genesisBlockDate
}
    `, Lp = o`
    fragment networkComparisonTableFields on NetworkComparisonTable {
  tableName
  networksCollection(limit: 20, preview: $preview, where: {name_exists: true}) {
    items {
      ...networkDetailsFields
    }
  }
}
    ${Op}`, Jf = o`
    fragment caseStudyFields on CaseStudy {
  __typename
  customerName
  logo {
    sys {
      id
    }
  }
  title
  vertical
  url
  heroImage {
    sys {
      id
    }
  }
  heroTitleSize
  heroTitleFont
  heroBackgroundColor
  listImage {
    sys {
      id
    }
  }
  body {
    sys {
      id
    }
  }
  textWithNavigation {
    sys {
      id
    }
  }
  seo {
    sys {
      id
    }
  }
}
    `, sb = o`
    fragment columnFields on Column {
  name
  alignment
  fullWidthContent
  contentCollection {
    items {
      __typename
      ... on Image {
        sys {
          id
        }
      }
      ... on Button {
        sys {
          id
        }
      }
      ... on ContentTypeRichText {
        sys {
          id
        }
      }
      ... on CollapseItem {
        sys {
          id
        }
      }
      ... on LabelWithIcon {
        sys {
          id
        }
      }
      ... on YouTubePlayer {
        sys {
          id
        }
      }
      ... on CardWithIcon {
        sys {
          id
        }
      }
    }
  }
  sys {
    id
  }
  columnPadding {
    sys {
      id
    }
  }
}
    `, eb = o`
    fragment multiItemLayoutFields on MultiItemLayout {
  name
  layoutMode
  columnCount
  alignment
  reverseOnMobile
  cardSliderViewOnDesktop
  cardSliderViewOnMobile
  topSpacing
  unlimitedItemWidth
  maxWidth
  layoutPadding {
    sys {
      id
    }
  }
  itemsCollection(limit: 10) {
    items {
      __typename
      ... on Column {
        sys {
          id
        }
      }
      ... on CardWithIcon {
        sys {
          id
        }
      }
      ... on CustomDropdown {
        sys {
          id
        }
      }
      ... on TitleAndDescription {
        sys {
          id
        }
      }
      ... on ImageWithFooter {
        sys {
          id
        }
      }
      ... on IconList {
        sys {
          id
        }
      }
      ... on Image {
        sys {
          id
        }
      }
      ... on Button {
        sys {
          id
        }
      }
      ... on ContentTypeRichText {
        sys {
          id
        }
      }
      ... on LogoRow {
        sys {
          id
        }
      }
      ... on StaticComponent {
        sys {
          id
        }
      }
      ... on PricingPlanInfo {
        sys {
          id
        }
      }
    }
  }
}
    `, Hf = o`
    fragment cardWithIconFields on CardWithIcon {
  title
  tagPosition
  tagColor
  tagCrossed
  tagText
  markText
  cardSize
  body {
    json
  }
  icon {
    ...imageFields
  }
  link {
    ...buttonFields
  }
  backgroundImage {
    ...imageFields
  }
  backgroundImageForTablet {
    ...imageFields
  }
  backgroundImageForMobile {
    ...imageFields
  }
  shadow
  iconSize
  bodyMaxWidth
  textColor
  fixLinkToBottom
}
    ${Vs}
${Le}`, tb = o`
    fragment pricingCardFields on PricingCard {
  title
  options
  period
  pricingPlanTag
  textAfterOptions
  textBeforeOptions
  actionButton {
    ...buttonFields
  }
}
    ${Le}`, rb = o`
    fragment cardItemsLayoutFields on CardItemsLayout {
  name
  layoutMode
  columnCount
  alignment
  reverseOnMobile
  cardSliderViewOnDesktop
  cardSliderViewOnMobile
  topSpacing
  unlimitedItemWidth
  maxWidth
  layoutPadding {
    ...paddingFields
  }
  itemsCollection {
    items {
      __typename
      ... on CardWithIcon {
        ...cardWithIconFields
      }
      ... on PricingCard {
        ...pricingCardFields
      }
    }
  }
}
    ${Nt}
${Hf}
${tb}`, ub = o`
    fragment tabItemFields on TabItem {
  label
  uppercase
  queryValue
}
    `, ab = o`
    fragment linkTabsFields on LinkTabs {
  name
  queryKey
  color
  tabsCollection(limit: 5) {
    items {
      __typename
      ... on TabItem {
        ...tabItemFields
      }
    }
  }
  alignment
}
    ${ub}`, Yf = o`
    fragment titleAndDescriptionFields on TitleAndDescription {
  __typename
  title
  titleFont
  titleSize
  richText {
    ...richTextFields
  }
  alignment
  padding
  width
  subtitleIcon {
    ...imageFields
  }
  subtitleText
}
    ${Oe}
${Vs}`, ib = o`
    fragment staticComponentFields on StaticComponent {
  titleAndDescription {
    ...titleAndDescriptionFields
  }
  componentName
}
    ${Yf}`, _b = o`
    fragment labelWithIconFields on LabelWithIcon {
  iconForLabel
  labelText
  labelColor
}
    `, fb = o`
    fragment customDropdown on CustomDropdown {
  title
  placeholder
  sectionsCollection(limit: 3) {
    items {
      title
      itemsCollection(limit: 20) {
        items {
          title
          description
          isExternalLink
          tagText
          link
          showArrow
          icon {
            ...imageFields
          }
          iconForm
          iconBackground
          iconSize
        }
      }
    }
  }
}
    ${Vs}`, hb = o`
    fragment pageSectionFields on PageSection {
  backgroundColor
  backgroundColorOnMobile
  verticalPadding
  backgroundImage {
    sys {
      id
    }
  }
  name
  contentCollection(limit: 10) {
    items {
      __typename
      ... on MultiItemLayout {
        sys {
          id
        }
      }
      ... on Column {
        sys {
          id
        }
      }
      ... on CardItemsLayout {
        sys {
          id
        }
      }
      ... on TitleAndDescription {
        sys {
          id
        }
      }
      ... on ContentTypeRichText {
        sys {
          id
        }
      }
      ... on Image {
        sys {
          id
        }
      }
      ... on ThreeImageLayout {
        sys {
          id
        }
      }
      ... on YouTubePlayer {
        sys {
          id
        }
      }
      ... on LinkTabs {
        sys {
          id
        }
      }
      ... on NetworkComparisonTable {
        sys {
          id
        }
      }
      ... on StaticComponent {
        sys {
          id
        }
      }
      ... on CustomDropdown {
        sys {
          id
        }
      }
      ... on ProvidersList {
        sys {
          id
        }
      }
      ... on PricingQuiz {
        sys {
          id
        }
      }
      ... on CollapseItem {
        sys {
          id
        }
      }
      ... on TextWithNavigation {
        sys {
          id
        }
      }
      ... on PricingPlansComparison {
        sys {
          id
        }
      }
    }
  }
  padding {
    sys {
      id
    }
  }
  maxWidth
  overflow
  backgroundImageForMobile {
    sys {
      id
    }
  }
  backgroundImageForTablet {
    sys {
      id
    }
  }
  backgroundImagePosition
}
    `, Sb = o`
    fragment faqFields on Faq {
  question
  answer {
    json
    links {
      assets {
        block {
          sys {
            id
          }
          url
          title
          width
          height
          description
        }
      }
    }
  }
  sys {
    id
  }
}
    `, Ab = o`
    fragment heroFields on Hero {
  title
  description
  logoHeader
  iconList {
    sys {
      id
    }
  }
  button {
    sys {
      id
    }
  }
  backgroundColor
  backgroundImage {
    sys {
      id
    }
  }
  image {
    sys {
      id
    }
  }
  imageOnMobile {
    sys {
      id
    }
  }
  logo {
    sys {
      id
    }
  }
  padding {
    sys {
      id
    }
  }
  contentSpacing
  contentWidth
  contentAlign
  headingFont
  headingTextSize
  hideImageOnMobile
  developerStoriesTag
  descriptionTextSize
  reverseItemsOrderOnMobile
  backgroundImageForMobile {
    sys {
      id
    }
  }
  backgroundImageForTablet {
    sys {
      id
    }
  }
  secondaryButton {
    sys {
      id
    }
  }
  additionalLinkLogo {
    sys {
      id
    }
  }
  stickyImageOnMobile
}
    `, yb = o`
    fragment providersList on ProvidersList {
  sheetId
  tabName
  filter
  itemsLimit
}
    `, iE = o`
    fragment seoFields on PageSeo {
  title
  description
  url
  opengraphImage {
    ...imageFields
  }
}
    ${Vs}`, cb = o`
    fragment pricingPlanFields on PricingPlan {
  name
  price
  options
  actionButton {
    title
    url
    location
  }
}
    `, nb = o`
    fragment pricingQuizFields on PricingQuiz {
  __typename
  title
  subTitle
  quizQuestion
  pricingPageLink {
    title
    url
    location
  }
  pricingPlanButtons
  pricingPlansCollection(limit: 10) {
    items {
      ...pricingPlanFields
    }
  }
}
    ${cb}`, Db = o`
    fragment collapseItemFields on CollapseItem {
  __typename
  iconPosition
  maxWidth
  title
  content {
    json
  }
}
    `, db = o`
    fragment titleAndRichTextFields on TitleAndRichText {
  __typename
  title
  richText {
    ...richTextFields
  }
  alignment
}
    ${Oe}`, pb = o`
    fragment textWithNavigationFields on TextWithNavigation {
  __typename
  title
  titleAndRichTextCollection(limit: 4) {
    items {
      ...titleAndRichTextFields
    }
  }
}
    ${db}`, Kf = o`
    fragment navigationItemFields on NavigationItem {
  animationOnHover
  title
  description
  hideOnDesktop
  hideOnMobile
  isExternalLink
  tagText
  link
  showArrow
  icon {
    ...imageFields
  }
  iconForm
  iconBackground
  iconSize
  sectionsCollection(limit: 3, preview: $preview) {
    items {
      title
      backgroundColor
      itemsCollection(limit: 7, preview: $preview) {
        items {
          animationOnHover
          title
          description
          hideOnDesktop
          hideOnMobile
          isExternalLink
          tagText
          link
          showArrow
          icon {
            ...imageFields
          }
          iconForm
          iconBackground
          iconSize
        }
      }
    }
  }
}
    ${Vs}`, bb = o`
    fragment navigationSectionRowFields on NavigationSectionRow {
  title
  backgroundColor
  itemsCollection(limit: 2, preview: $preview) {
    items {
      title
      backgroundColor
      icon {
        ...imageFields
      }
      itemsCollection {
        items {
          ...navigationItemFields
        }
      }
    }
  }
}
    ${Vs}
${Kf}`, Eb = o`
    fragment navigationSectionFields on NavigationSection {
  title
  backgroundColor
  itemsCollection(limit: 7, preview: $preview) {
    items {
      ...navigationItemFields
    }
  }
}
    ${Kf}`, Xf = o`
    fragment navigationParentFields on NavigationParent {
  sys {
    id
  }
  title
  link
  order
  sectionsCollection(limit: 3, preview: $preview) {
    items {
      ... on NavigationSection {
        sys {
          id
        }
      }
      ... on NavigationSectionRow {
        sys {
          id
        }
      }
    }
  }
  sectionsLayout
}
    `, Zf = o`
    fragment networkBoxFields on NetworkBox {
  sys {
    id
  }
  __typename
  logo {
    ...imageFields
  }
  label
  backgroundColor
}
    ${Vs}`, Cf = o`
    fragment linkActionFields on LinkAction {
  image {
    ...imageFields
  }
  location
  title
  url
}
    ${Vs}`, vb = o`
    fragment cardWithInfoFields on CardWithInfo {
  __typename
  actionLink {
    ...linkActionFields
  }
  icon {
    ...imageFields
  }
  text
  title
}
    ${Cf}
${Vs}`, lu = o`
    fragment defaultNetworkFields on Network {
  layer
  logo {
    sys {
      id
    }
  }
  networkName
  url
}
    `, mb = o`
    fragment networkFields on Network {
  ...defaultNetworkFields
  __typename
  sys {
    id
  }
  dinNetworkBox {
    sys {
      id
    }
  }
  inlineLogo {
    sys {
      id
    }
  }
  networkPage {
    sys {
      id
    }
  }
  shortDescription
  columnInNavigation
  orderInNavigationColumn
  showInNavigation
  showInGasApiCarousel
  showInHomepageNetworkCards
  columnInHomepageNetworkCards
  orderInHomepageNetworkCards
  showInNetworkPreviewCards
  orderInNetworkPreviewCards
  orderInDinNetworkCarousel
}
    ${lu}`, Vb = o`
    fragment networkNavigationFields on Network {
  ...defaultNetworkFields
  __typename
  sys {
    id
  }
  columnInNavigation
  orderInNavigationColumn
  showInNavigation
}
    ${lu}`, lb = o`
    fragment homepageNetworkCardFields on Network {
  layer
  logo {
    sys {
      id
    }
  }
  networkName
  columnInHomepageNetworkCards
  orderInHomepageNetworkCards
  url
}
    `, wb = o`
    fragment networkPreviewCardFields on Network {
  ...defaultNetworkFields
  shortDescription
  orderInNetworkPreviewCards
}
    ${lu}`, Fb = o`
    fragment networkGasAPICarouselFields on Network {
  logo {
    sys {
      id
    }
  }
  networkName
  showInGasApiCarousel
  orderInGasApiCarousel
}
    `, xb = o`
    fragment pricingPlansFeatureFields on PricingPlansFeature {
  title
  tooltipText
  values
}
    `, gf = o`
    fragment pricingPlanInfoFields on PricingPlanInfo {
  title
  options
  period
  price
  actionButton {
    ...buttonFields
  }
  tag
  advantagesTitle
  advantagesList
}
    ${Le}`, ob = o`
    fragment pricingPlansComparisonFields on PricingPlansComparison {
  title
  titleIcon
  showColumnHeaders
  featuresCollection(limit: 40) {
    items {
      ...pricingPlansFeatureFields
    }
  }
  pricingPlansInfoCollection(limit: 4) {
    items {
      ...pricingPlanInfoFields
    }
  }
  padding {
    ...paddingFields
  }
}
    ${xb}
${gf}
${Nt}`, Mb = o`
    fragment leadCapturePageBodyFields on LeadCapturePageBody {
  json
  links {
    assets {
      block {
        sys {
          id
        }
        url
        title
        width
        height
        description
      }
    }
  }
}
    `, $b = o`
    fragment leadCapturePageFields on LeadCapturePage {
  heading
  subheading
  path
  pageType
  tag
  description
  hubspotForm {
    ... on HubspotForm {
      hubspotFormId
      hubspotPortalId
    }
  }
  body {
    ...leadCapturePageBodyFields
  }
  image {
    title
    description
    width
    height
    url
  }
  openGraphImage {
    title
    description
    width
    height
    url
  }
  ctaButtonText
  ctaLink
  eBookFile {
    url
  }
  thankYouHeader
  thankYouBody {
    json
    links {
      assets {
        block {
          sys {
            id
          }
          url
          title
          width
          height
          description
        }
      }
    }
  }
  speakersIntroTitle
  speakersIntroText {
    json
    links {
      assets {
        block {
          sys {
            id
          }
          url
          title
          width
          height
          description
        }
      }
    }
  }
  speakersCollection {
    total
    items {
      name
      title
      image {
        ...imageFields
      }
    }
  }
}
    ${Mb}
${Vs}`, wu = o`
    fragment networkPageFields on NetworkPage {
  __typename
  aboutDescription
  aboutImage {
    sys {
      id
    }
  }
  advantageAdvantagesList {
    sys {
      id
    }
  }
  advantageImage {
    sys {
      id
    }
  }
  advantageImageSticky
  advantageTitle
  ctaButtonText
  ctaButtonUrl
  ctaText
  featuresCardsCollection(where: {title_exists: true}, limit: 3) {
    items {
      sys {
        id
      }
    }
  }
  featuresDescription
  featuresTitle
  gettingStartedImage {
    sys {
      id
    }
  }
  gettingStartedStep1Title
  gettingStartedStep1Description
  gettingStartedStep2Title
  gettingStartedStep2Description
  gettingStartedStep3Title
  gettingStartedStep3Description
  gettingStartedStep4Title
  gettingStartedStep4Description
  heroDescription
  heroImage {
    sys {
      id
    }
  }
  heroImageOnMobile {
    sys {
      id
    }
  }
  heroSecondaryButtonText
  heroSecondaryButtonUrl
  heroShowDinLogo
  heroPrimaryButtonText
  heroPrimaryButtonUrl
  heroTitle
  networkName
  quoteCompanyLogo {
    sys {
      id
    }
  }
  quoteText {
    json
  }
  seo {
    sys {
      id
    }
  }
  sys {
    id
  }
  wantToLearnDescription
  wantToLearnCardsCollection(where: {title_exists: true}, limit: 3) {
    items {
      sys {
        id
      }
    }
  }
}
    `, Fu = o`
    query GetFAQCategories {
  faqCategoryCollection(order: order_ASC, limit: 10) {
    items {
      title
      slug
      questionsCollection {
        items {
          ...faqFields
        }
      }
    }
  }
}
    ${Sb}`;
function _E(s) {
  const e = { ...M, ...s };
  return W(Fu, e);
}
function fE(s) {
  const e = { ...M, ...s };
  return N(Fu, e);
}
const xu = o`
    query GetLeadCapturePage($path: String!, $preview: Boolean = false) {
  leadCapturePageCollection(where: {path: $path}, limit: 1, preview: $preview) {
    items {
      ...leadCapturePageFields
    }
  }
}
    ${$b}`;
function hE(s) {
  const e = { ...M, ...s };
  return W(xu, e);
}
function SE(s) {
  const e = { ...M, ...s };
  return N(xu, e);
}
const ou = o`
    query GetAllLeadCapturePages {
  leadCapturePageCollection(order: path_ASC, limit: 1000) {
    items {
      path
      pageType
    }
  }
}
    `;
function AE(s) {
  const e = { ...M, ...s };
  return W(ou, e);
}
function yE(s) {
  const e = { ...M, ...s };
  return N(ou, e);
}
const Mu = o`
    query GetPageByPath($path: String, $locale: String, $preview: Boolean = false) {
  pageCollection(
    where: {path: $path}
    locale: $locale
    limit: 1
    preview: $preview
  ) {
    items {
      name
      path
      hero {
        sys {
          id
        }
      }
      seo {
        sys {
          id
        }
      }
      sectionsCollection(limit: 20) {
        items {
          __typename
          ... on PageSection {
            sys {
              id
            }
          }
        }
      }
      featureFlag
    }
  }
}
    `;
function cE(s) {
  const e = { ...M, ...s };
  return W(Mu, e);
}
function nE(s) {
  const e = { ...M, ...s };
  return N(Mu, e);
}
const $u = o`
    query GetAllPages {
  pageCollection(limit: 1000) {
    items {
      name
      path
    }
  }
}
    `;
function DE(s) {
  const e = { ...M, ...s };
  return W($u, e);
}
function dE(s) {
  const e = { ...M, ...s };
  return N($u, e);
}
const Tu = o`
    query GetPageSection($id: String!, $preview: Boolean = false, $locale: String) {
  pageSection(id: $id, preview: $preview, locale: $locale) {
    ...pageSectionFields
  }
}
    ${hb}`;
function pE(s) {
  const e = { ...M, ...s };
  return W(Tu, e);
}
function bE(s) {
  const e = { ...M, ...s };
  return N(Tu, e);
}
const Pu = o`
    query GetColumn($id: String!, $preview: Boolean = false, $locale: String) {
  column(id: $id, preview: $preview, locale: $locale) {
    ...columnFields
  }
}
    ${sb}`;
function EE(s) {
  const e = { ...M, ...s };
  return W(Pu, e);
}
function vE(s) {
  const e = { ...M, ...s };
  return N(Pu, e);
}
const Bu = o`
    query GetCardItemsLayout($id: String!, $preview: Boolean = false, $locale: String) {
  cardItemsLayout(id: $id, preview: $preview, locale: $locale) {
    ...cardItemsLayoutFields
  }
}
    ${rb}`;
function mE(s) {
  const e = { ...M, ...s };
  return W(Bu, e);
}
function VE(s) {
  const e = { ...M, ...s };
  return N(Bu, e);
}
const qu = o`
    query GetTitleAndDescription($id: String!, $preview: Boolean = false, $locale: String) {
  titleAndDescription(id: $id, preview: $preview, locale: $locale) {
    ...titleAndDescriptionFields
  }
}
    ${Yf}`;
function lE(s) {
  const e = { ...M, ...s };
  return W(qu, e);
}
function wE(s) {
  const e = { ...M, ...s };
  return N(qu, e);
}
const Gu = o`
    query GetContentTypeRichText($id: String!, $preview: Boolean = false, $locale: String) {
  contentTypeRichText(id: $id, preview: $preview, locale: $locale) {
    ...richTextFields
  }
}
    ${Oe}`;
function FE(s) {
  const e = { ...M, ...s };
  return W(Gu, e);
}
function xE(s) {
  const e = { ...M, ...s };
  return N(Gu, e);
}
const Ru = o`
    query GetContentTypeImage($id: String!, $preview: Boolean = false, $locale: String) {
  image(id: $id, preview: $preview, locale: $locale) {
    alignment
    hideInMobile
    padding
    image {
      ...imageFields
    }
  }
}
    ${Vs}`;
function oE(s) {
  const e = { ...M, ...s };
  return W(Ru, e);
}
function ME(s) {
  const e = { ...M, ...s };
  return N(Ru, e);
}
const ju = o`
    query GetContentfulImage($id: String!, $preview: Boolean = false, $locale: String) {
  asset(id: $id, preview: $preview, locale: $locale) {
    ...imageFields
  }
}
    ${Vs}`;
function $E(s) {
  const e = { ...M, ...s };
  return W(ju, e);
}
function TE(s) {
  const e = { ...M, ...s };
  return N(ju, e);
}
const Uu = o`
    query GetThreeImageLayout($id: String!, $preview: Boolean = false, $locale: String) {
  threeImageLayout(id: $id, preview: $preview, locale: $locale) {
    name
    text {
      ...richTextFields
    }
    imagesCollection {
      items {
        ...imageWithFooterFields
      }
    }
  }
}
    ${Oe}
${If}`;
function PE(s) {
  const e = { ...M, ...s };
  return W(Uu, e);
}
function BE(s) {
  const e = { ...M, ...s };
  return N(Uu, e);
}
const Qu = o`
    query GetYouTubePlayer($id: String!, $preview: Boolean = false, $locale: String) {
  youTubePlayer(id: $id, preview: $preview, locale: $locale) {
    videoId
    coverImage {
      ...imageFields
    }
  }
}
    ${Vs}`;
function qE(s) {
  const e = { ...M, ...s };
  return W(Qu, e);
}
function GE(s) {
  const e = { ...M, ...s };
  return N(Qu, e);
}
const zu = o`
    query GetLinkTabs($id: String!, $preview: Boolean = false, $locale: String) {
  linkTabs(id: $id, preview: $preview, locale: $locale) {
    ...linkTabsFields
  }
}
    ${ab}`;
function RE(s) {
  const e = { ...M, ...s };
  return W(zu, e);
}
function jE(s) {
  const e = { ...M, ...s };
  return N(zu, e);
}
const Wu = o`
    query GetNetworkComparisonTable($id: String!, $preview: Boolean = false, $locale: String) {
  networkComparisonTable(id: $id, preview: $preview, locale: $locale) {
    ...networkComparisonTableFields
  }
}
    ${Lp}`;
function UE(s) {
  const e = { ...M, ...s };
  return W(Wu, e);
}
function QE(s) {
  const e = { ...M, ...s };
  return N(Wu, e);
}
const Nu = o`
    query GetStaticComponent($id: String!, $preview: Boolean = false, $locale: String) {
  staticComponent(id: $id, preview: $preview, locale: $locale) {
    ...staticComponentFields
  }
}
    ${ib}`;
function zE(s) {
  const e = { ...M, ...s };
  return W(Nu, e);
}
function WE(s) {
  const e = { ...M, ...s };
  return N(Nu, e);
}
const Iu = o`
    query GetCustomDropdown($id: String!, $preview: Boolean = false, $locale: String) {
  customDropdown(id: $id, preview: $preview, locale: $locale) {
    ...customDropdown
  }
}
    ${fb}`;
function NE(s) {
  const e = { ...M, ...s };
  return W(Iu, e);
}
function IE(s) {
  const e = { ...M, ...s };
  return N(Iu, e);
}
const Ju = o`
    query GetProvidersList($id: String!, $preview: Boolean = false, $locale: String) {
  providersList(id: $id, preview: $preview, locale: $locale) {
    ...providersList
  }
}
    ${yb}`;
function JE(s) {
  const e = { ...M, ...s };
  return W(Ju, e);
}
function HE(s) {
  const e = { ...M, ...s };
  return N(Ju, e);
}
const Hu = o`
    query GetPricingQuiz($id: String!, $preview: Boolean = false, $locale: String) {
  pricingQuiz(id: $id, preview: $preview, locale: $locale) {
    ...pricingQuizFields
  }
}
    ${nb}`;
function YE(s) {
  const e = { ...M, ...s };
  return W(Hu, e);
}
function KE(s) {
  const e = { ...M, ...s };
  return N(Hu, e);
}
const Yu = o`
    query GetCollapseItem($id: String!, $preview: Boolean = false, $locale: String) {
  collapseItem(id: $id, preview: $preview, locale: $locale) {
    ...collapseItemFields
  }
}
    ${Db}`;
function XE(s) {
  const e = { ...M, ...s };
  return W(Yu, e);
}
function ZE(s) {
  const e = { ...M, ...s };
  return N(Yu, e);
}
const Ku = o`
    query GetTextWithNavigation($id: String!, $preview: Boolean = false, $locale: String) {
  textWithNavigation(id: $id, preview: $preview, locale: $locale) {
    ...textWithNavigationFields
  }
}
    ${pb}`;
function CE(s) {
  const e = { ...M, ...s };
  return W(Ku, e);
}
function gE(s) {
  const e = { ...M, ...s };
  return N(Ku, e);
}
const Xu = o`
    query GetPadding($id: String!, $preview: Boolean = false, $locale: String) {
  padding(id: $id, preview: $preview, locale: $locale) {
    ...paddingFields
  }
}
    ${Nt}`;
function kE(s) {
  const e = { ...M, ...s };
  return W(Xu, e);
}
function OE(s) {
  const e = { ...M, ...s };
  return N(Xu, e);
}
const Zu = o`
    query GetCardWithIcon($id: String!, $preview: Boolean = false, $locale: String) {
  cardWithIcon(id: $id, preview: $preview, locale: $locale) {
    ...cardWithIconFields
  }
}
    ${Hf}`;
function LE(s) {
  const e = { ...M, ...s };
  return W(Zu, e);
}
function sv(s) {
  const e = { ...M, ...s };
  return N(Zu, e);
}
const Cu = o`
    query GetImageWithFooter($id: String!, $preview: Boolean = false, $locale: String) {
  imageWithFooter(id: $id, preview: $preview, locale: $locale) {
    ...imageWithFooterFields
  }
}
    ${If}`;
function ev(s) {
  const e = { ...M, ...s };
  return W(Cu, e);
}
function tv(s) {
  const e = { ...M, ...s };
  return N(Cu, e);
}
const gu = o`
    query GetIconList($id: String!, $preview: Boolean = false, $locale: String) {
  iconList(id: $id, preview: $preview, locale: $locale) {
    padding
    iconPosition
    itemsCollection(where: {title_exists: true}, limit: 5) {
      items {
        ...iconListItemFields
      }
    }
    verticalAlignment
    titleSize
    descriptionSize
  }
}
    ${kp}`;
function rv(s) {
  const e = { ...M, ...s };
  return W(gu, e);
}
function uv(s) {
  const e = { ...M, ...s };
  return N(gu, e);
}
const ku = o`
    query GetButton($id: String!, $preview: Boolean = false, $locale: String) {
  button(id: $id, preview: $preview, locale: $locale) {
    ...buttonFields
  }
}
    ${Le}`;
function av(s) {
  const e = { ...M, ...s };
  return W(ku, e);
}
function iv(s) {
  const e = { ...M, ...s };
  return N(ku, e);
}
const Ou = o`
    query GetLogoRow($id: String!, $preview: Boolean = false, $locale: String) {
  logoRow(id: $id, preview: $preview, locale: $locale) {
    ...logoRowFields
  }
}
    ${gp}`;
function _v(s) {
  const e = { ...M, ...s };
  return W(Ou, e);
}
function fv(s) {
  const e = { ...M, ...s };
  return N(Ou, e);
}
const Lu = o`
    query GetPageSEO($id: String!, $preview: Boolean = false, $locale: String) {
  pageSeo(id: $id, preview: $preview, locale: $locale) {
    title
    description
    url
    opengraphImage {
      ...imageFields
    }
  }
}
    ${Vs}`;
function hv(s) {
  const e = { ...M, ...s };
  return W(Lu, e);
}
function Sv(s) {
  const e = { ...M, ...s };
  return N(Lu, e);
}
const sa = o`
    query GetHero($id: String!, $preview: Boolean = false, $locale: String) {
  hero(id: $id, preview: $preview, locale: $locale) {
    ...heroFields
  }
}
    ${Ab}`;
function Av(s) {
  const e = { ...M, ...s };
  return W(sa, e);
}
function yv(s) {
  const e = { ...M, ...s };
  return N(sa, e);
}
const ea = o`
    query GetLinkAction($id: String!, $preview: Boolean = false, $locale: String) {
  linkAction(id: $id, preview: $preview, locale: $locale) {
    ...linkActionFields
  }
}
    ${Cf}`;
function cv(s) {
  const e = { ...M, ...s };
  return W(ea, e);
}
function nv(s) {
  const e = { ...M, ...s };
  return N(ea, e);
}
const ta = o`
    query GetLabelWithIcon($id: String!, $preview: Boolean = false, $locale: String) {
  labelWithIcon(id: $id, preview: $preview, locale: $locale) {
    ...labelWithIconFields
  }
}
    ${_b}`;
function Dv(s) {
  const e = { ...M, ...s };
  return W(ta, e);
}
function dv(s) {
  const e = { ...M, ...s };
  return N(ta, e);
}
const ra = o`
    query GetMultiItemLayout($id: String!, $preview: Boolean = false, $locale: String) {
  multiItemLayout(id: $id, preview: $preview, locale: $locale) {
    ...multiItemLayoutFields
  }
}
    ${eb}`;
function pv(s) {
  const e = { ...M, ...s };
  return W(ra, e);
}
function bv(s) {
  const e = { ...M, ...s };
  return N(ra, e);
}
const ua = o`
    query GetProjectDashboardCards($preview: Boolean = false) {
  projectDashboardCardCollection(limit: 15, preview: $preview) {
    items {
      isDisabled
      styleVariant
      tag
      title
      description
      linkText
      linkUrl
      order
    }
  }
}
    `;
function Ev(s) {
  const e = { ...M, ...s };
  return W(ua, e);
}
function vv(s) {
  const e = { ...M, ...s };
  return N(ua, e);
}
const aa = o`
    query GetMarketingNavigationSection($id: String!, $preview: Boolean = false, $locale: String) {
  navigationSection(id: $id, preview: $preview, locale: $locale) {
    ...navigationSectionFields
  }
}
    ${Eb}`;
function mv(s) {
  const e = { ...M, ...s };
  return W(aa, e);
}
function Vv(s) {
  const e = { ...M, ...s };
  return N(aa, e);
}
const ia = o`
    query GetMarketingNavigationSectionRow($id: String!, $preview: Boolean = false, $locale: String) {
  navigationSectionRow(id: $id, preview: $preview, locale: $locale) {
    ...navigationSectionRowFields
  }
}
    ${bb}`;
function lv(s) {
  const e = { ...M, ...s };
  return W(ia, e);
}
function wv(s) {
  const e = { ...M, ...s };
  return N(ia, e);
}
const _a = o`
    query GetMarketingNavigationParent($id: String!, $preview: Boolean = false, $locale: String) {
  navigationParent(id: $id, preview: $preview, locale: $locale) {
    ...navigationParentFields
  }
}
    ${Xf}`;
function Fv(s) {
  const e = { ...M, ...s };
  return W(_a, e);
}
function xv(s) {
  const e = { ...M, ...s };
  return N(_a, e);
}
const fa = o`
    query GetMarketingNavigation($preview: Boolean = false, $locale: String) {
  navigationParentCollection(
    limit: 5
    order: order_ASC
    preview: $preview
    locale: $locale
  ) {
    items {
      ...navigationParentFields
    }
  }
}
    ${Xf}`;
function ov(s) {
  const e = { ...M, ...s };
  return W(fa, e);
}
function Mv(s) {
  const e = { ...M, ...s };
  return N(fa, e);
}
const ha = o`
    query GetCaseStudies($preview: Boolean, $limit: Int, $skip: Int, $locale: String) {
  caseStudyCollection(
    limit: $limit
    skip: $skip
    preview: $preview
    locale: $locale
  ) {
    items {
      ...caseStudyFields
    }
    total
    skip
    limit
  }
}
    ${Jf}`;
function $v(s) {
  const e = { ...M, ...s };
  return W(ha, e);
}
function Tv(s) {
  const e = { ...M, ...s };
  return N(ha, e);
}
const Sa = o`
    query GetCaseStudyByUrl($url: String, $preview: Boolean, $limit: Int, $skip: Int, $locale: String) {
  caseStudyCollection(
    where: {url: $url}
    limit: $limit
    skip: $skip
    preview: $preview
    locale: $locale
  ) {
    items {
      ...caseStudyFields
    }
    total
    skip
    limit
  }
}
    ${Jf}`;
function Pv(s) {
  const e = { ...M, ...s };
  return W(Sa, e);
}
function Bv(s) {
  const e = { ...M, ...s };
  return N(Sa, e);
}
const Aa = o`
    query GetPageBanners($preview: Boolean = false, $locale: String) {
  pageBannerCollection(limit: 8, preview: $preview, locale: $locale) {
    items {
      text {
        json
      }
      icon {
        ...imageFields
      }
      ctaText
      ctaLink
      include
      exclude
    }
  }
}
    ${Vs}`;
function qv(s) {
  const e = { ...M, ...s };
  return W(Aa, e);
}
function Gv(s) {
  const e = { ...M, ...s };
  return N(Aa, e);
}
const ya = o`
    query GetNetworkBox($id: String!, $preview: Boolean = false, $locale: String) {
  networkBox(id: $id, preview: $preview, locale: $locale) {
    ...networkBoxFields
  }
}
    ${Zf}`;
function Rv(s) {
  const e = { ...M, ...s };
  return W(ya, e);
}
function jv(s) {
  const e = { ...M, ...s };
  return N(ya, e);
}
const ca = o`
    query GetNetworkBoxes($preview: Boolean, $limit: Int, $locale: String) {
  networkCollection(
    where: {dinNetworkBox_exists: true}
    limit: $limit
    preview: $preview
    locale: $locale
  ) {
    items {
      orderInDinNetworkCarousel
      dinNetworkBox {
        ...networkBoxFields
      }
    }
  }
}
    ${Zf}`;
function Uv(s) {
  const e = { ...M, ...s };
  return W(ca, e);
}
function Qv(s) {
  const e = { ...M, ...s };
  return N(ca, e);
}
const na = o`
    query GetCardWithInfo($id: String!, $preview: Boolean = false, $locale: String) {
  cardWithInfo(id: $id, preview: $preview, locale: $locale) {
    ...cardWithInfoFields
  }
}
    ${vb}`;
function zv(s) {
  const e = { ...M, ...s };
  return W(na, e);
}
function Wv(s) {
  const e = { ...M, ...s };
  return N(na, e);
}
const Da = o`
    query GetNetworkPage($id: String!, $preview: Boolean = false, $locale: String) {
  networkPage(id: $id, preview: $preview, locale: $locale) {
    ...networkPageFields
  }
}
    ${wu}`;
function Nv(s) {
  const e = { ...M, ...s };
  return W(Da, e);
}
function Iv(s) {
  const e = { ...M, ...s };
  return N(Da, e);
}
const da = o`
    query GetNetworkPages($preview: Boolean, $limit: Int, $locale: String) {
  networkCollection(
    where: {networkPage: {networkName_exists: true}}
    limit: $limit
    preview: $preview
    locale: $locale
  ) {
    items {
      url
      inlineLogo {
        sys {
          id
        }
      }
      networkPage {
        ...networkPageFields
      }
    }
  }
}
    ${wu}`;
function Jv(s) {
  const e = { ...M, ...s };
  return W(da, e);
}
function Hv(s) {
  const e = { ...M, ...s };
  return N(da, e);
}
const pa = o`
    query GetNetworkPageByUrl($url: String, $preview: Boolean, $limit: Int, $locale: String) {
  networkCollection(
    where: {networkPage: {networkName_exists: true}, url: $url}
    limit: $limit
    preview: $preview
    locale: $locale
  ) {
    items {
      url
      inlineLogo {
        sys {
          id
        }
      }
      networkPage {
        ...networkPageFields
      }
    }
  }
}
    ${wu}`;
function Yv(s) {
  const e = { ...M, ...s };
  return W(pa, e);
}
function Kv(s) {
  const e = { ...M, ...s };
  return N(pa, e);
}
const ba = o`
    query GetNetworks($preview: Boolean, $limit: Int, $locale: String) {
  networkCollection(limit: $limit, preview: $preview, locale: $locale) {
    items {
      ...networkFields
    }
  }
}
    ${mb}`;
function Xv(s) {
  const e = { ...M, ...s };
  return W(ba, e);
}
function Zv(s) {
  const e = { ...M, ...s };
  return N(ba, e);
}
const Ea = o`
    query GetNetworksNavigation($preview: Boolean, $limit: Int, $locale: String) {
  networkCollection(
    where: {showInNavigation: true}
    limit: $limit
    preview: $preview
    locale: $locale
  ) {
    items {
      ...networkNavigationFields
    }
  }
}
    ${Vb}`;
function Cv(s) {
  const e = { ...M, ...s };
  return W(Ea, e);
}
function gv(s) {
  const e = { ...M, ...s };
  return N(Ea, e);
}
const va = o`
    query GetHomepageNetworkCards($preview: Boolean, $limit: Int, $locale: String) {
  networkCollection(
    where: {showInHomepageNetworkCards: true}
    limit: $limit
    preview: $preview
    locale: $locale
  ) {
    items {
      ...homepageNetworkCardFields
    }
  }
}
    ${lb}`;
function kv(s) {
  const e = { ...M, ...s };
  return W(va, e);
}
function Ov(s) {
  const e = { ...M, ...s };
  return N(va, e);
}
const ma = o`
    query GetNetworkPreviewCards($preview: Boolean, $limit: Int, $locale: String) {
  networkCollection(
    where: {showInNetworkPreviewCards: true}
    limit: $limit
    preview: $preview
    locale: $locale
  ) {
    items {
      ...networkPreviewCardFields
    }
  }
}
    ${wb}`;
function Lv(s) {
  const e = { ...M, ...s };
  return W(ma, e);
}
function sm(s) {
  const e = { ...M, ...s };
  return N(ma, e);
}
const Va = o`
    query GetGasAPICarouselNetworks($preview: Boolean, $limit: Int, $locale: String) {
  networkCollection(
    where: {showInGasApiCarousel: true}
    limit: $limit
    preview: $preview
    locale: $locale
  ) {
    items {
      ...networkGasAPICarouselFields
    }
  }
}
    ${Fb}`;
function em(s) {
  const e = { ...M, ...s };
  return W(Va, e);
}
function tm(s) {
  const e = { ...M, ...s };
  return N(Va, e);
}
const la = o`
    query GetPricingPlanInfo($id: String!, $preview: Boolean = false, $locale: String) {
  pricingPlanInfo(id: $id, preview: $preview, locale: $locale) {
    ...pricingPlanInfoFields
  }
}
    ${gf}`;
function rm(s) {
  const e = { ...M, ...s };
  return W(la, e);
}
function um(s) {
  const e = { ...M, ...s };
  return N(la, e);
}
const wa = o`
    query GetPricingPlansComparison($id: String!, $preview: Boolean = false, $locale: String) {
  pricingPlansComparison(id: $id, preview: $preview, locale: $locale) {
    ...pricingPlansComparisonFields
  }
}
    ${ob}`;
function am(s) {
  const e = { ...M, ...s };
  return W(wa, e);
}
function im(s) {
  const e = { ...M, ...s };
  return N(wa, e);
}
function _m(s) {
  return process.env.CONTENTFUL_PREVIEW_MODE_SECRET === s;
}
function kf(s) {
  return new Is(function(e, t) {
    var r = Gs(e, []);
    return new rs(function(u) {
      var a, i = !1;
      return Promise.resolve(r).then(function(_) {
        return s(_, e.getContext());
      }).then(e.setContext).then(function() {
        i || (a = t(e).subscribe({
          next: u.next.bind(u),
          error: u.error.bind(u),
          complete: u.complete.bind(u)
        }));
      }).catch(u.error.bind(u)), function() {
        i = !0, a && a.unsubscribe();
      };
    });
  });
}
function Of(s) {
  return new Is(function(e, t) {
    return new rs(function(r) {
      var u, a, i;
      try {
        u = t(e).subscribe({
          next: function(_) {
            if (_.errors && (i = s({
              graphQLErrors: _.errors,
              response: _,
              operation: e,
              forward: t
            }), i)) {
              a = i.subscribe({
                next: r.next.bind(r),
                error: r.error.bind(r),
                complete: r.complete.bind(r)
              });
              return;
            }
            r.next(_);
          },
          error: function(_) {
            if (i = s({
              operation: e,
              networkError: _,
              //Network errors can return GraphQL errors on for example a 403
              graphQLErrors: _ && _.result && _.result.errors || void 0,
              forward: t
            }), i) {
              a = i.subscribe({
                next: r.next.bind(r),
                error: r.error.bind(r),
                complete: r.complete.bind(r)
              });
              return;
            }
            r.error(_);
          },
          complete: function() {
            i || r.complete.bind(r)();
          }
        });
      } catch (_) {
        s({ networkError: _, operation: e, forward: t }), r.error(_);
      }
      return function() {
        u && u.unsubscribe(), a && u.unsubscribe();
      };
    });
  });
}
(function(s) {
  zs(e, s);
  function e(t) {
    var r = s.call(this) || this;
    return r.link = Of(t), r;
  }
  return e.prototype.request = function(t, r) {
    return this.link.request(t, r);
  }, e;
})(Is);
function Tb(s) {
  var e = s || {}, t = e.initial, r = t === void 0 ? 300 : t, u = e.jitter, a = u === void 0 ? !0 : u, i = e.max, _ = i === void 0 ? 1 / 0 : i, h = a ? r : r / 2;
  return function(A) {
    var y = Math.min(_, h * Math.pow(2, A));
    return a && (y = Math.random() * y), y;
  };
}
function Pb(s) {
  var e = s || {}, t = e.retryIf, r = e.max, u = r === void 0 ? 5 : r;
  return function(i, _, h) {
    return i >= u ? !1 : t ? t(h, _) : !!h;
  };
}
var Bb = (
  /** @class */
  function() {
    function s(e, t, r, u, a) {
      var i = this;
      this.observer = e, this.operation = t, this.forward = r, this.delayFor = u, this.retryIf = a, this.retryCount = 0, this.currentSubscription = null, this.onError = function(_) {
        return Js(i, void 0, void 0, function() {
          var h;
          return Hs(this, function(f) {
            switch (f.label) {
              case 0:
                return this.retryCount += 1, [4, this.retryIf(this.retryCount, this.operation, _)];
              case 1:
                return h = f.sent(), h ? (this.scheduleRetry(this.delayFor(this.retryCount, this.operation, _)), [
                  2
                  /*return*/
                ]) : (this.observer.error(_), [
                  2
                  /*return*/
                ]);
            }
          });
        });
      }, this.try();
    }
    return s.prototype.cancel = function() {
      this.currentSubscription && this.currentSubscription.unsubscribe(), clearTimeout(this.timerId), this.timerId = void 0, this.currentSubscription = null;
    }, s.prototype.try = function() {
      this.currentSubscription = this.forward(this.operation).subscribe({
        next: this.observer.next.bind(this.observer),
        error: this.onError,
        complete: this.observer.complete.bind(this.observer)
      });
    }, s.prototype.scheduleRetry = function(e) {
      var t = this;
      if (this.timerId)
        throw new Error("RetryLink BUG! Encountered overlapping retries");
      this.timerId = setTimeout(function() {
        t.timerId = void 0, t.try();
      }, e);
    }, s;
  }()
), qb = (
  /** @class */
  function(s) {
    zs(e, s);
    function e(t) {
      var r = s.call(this) || this, u = t || {}, a = u.attempts, i = u.delay;
      return r.delayFor = typeof i == "function" ? i : Tb(i), r.retryIf = typeof a == "function" ? a : Pb(a), r;
    }
    return e.prototype.request = function(t, r) {
      var u = this;
      return new rs(function(a) {
        var i = new Bb(a, t, r, u.delayFor, u.retryIf);
        return function() {
          i.cancel();
        };
      });
    }, e;
  }(Is)
);
const Lf = nu([
  // From: https://github.com/vercel/next.js/discussions/18550#discussioncomment-968094
  new qb({
    attempts: (s, e, t) => {
      var u, a;
      return s < 5 && t.statusCode === 429 && ((a = (u = t.response) == null ? void 0 : u.headers) == null ? void 0 : a.get("X-Contentful-RateLimit-Reset"));
    },
    delay: (s, e, t) => {
      var u, a;
      const r = Number((a = (u = t.response) == null ? void 0 : u.headers) == null ? void 0 : a.get("X-Contentful-RateLimit-Reset")) * 1e3;
      return console.info("CONTENTFUL-RATELIMIT: retry in ", r, "ms"), r;
    }
  }),
  nf({
    fetch: (s, e) => fetch(s, e),
    uri: `https://graphql.contentful.com/content/v1/spaces/${process.env.CONTENTFUL_SPACE_ID}`
  })
]), sh = Of(({ graphQLErrors: s, networkError: e }) => {
  s && s.forEach(({ message: t, path: r }) => {
    console.error(JSON.stringify({ message: t, path: r }));
  }), e && console.error(JSON.stringify({ message: e.message, name: e.name }));
}), Gb = kf((s, { headers: e }) => ({
  headers: {
    ...e,
    authorization: `Bearer ${process.env.CONTENTFUL_DELIVERY_TOKEN}`
  }
})), It = new mu({
  cache: new vu(),
  defaultOptions: {
    query: {
      fetchPolicy: "cache-first"
      // Specifies the FetchPolicy to be used for this query https://www.apollographql.com/docs/react/api/core/ApolloClient/#FetchPolicy
    }
  },
  link: nu([Gb, sh, Lf]),
  ssrMode: !0
}), Rb = kf((s, { headers: e }) => ({
  headers: {
    ...e,
    authorization: `Bearer ${process.env.CONTENTFUL_PREVIEW_TOKEN}`
  }
})), jb = new mu({
  cache: new vu(),
  defaultOptions: {
    query: {
      fetchPolicy: "no-cache"
    }
  },
  link: nu([Rb, sh, Lf]),
  ssrMode: !0
});
async function I(s = !1) {
  return s ? jb : It;
}
async function K(s, e, t, r, u) {
  const a = await s(e, t, r);
  return {
    ...u,
    ...a
  };
}
async function fm() {
  var t;
  const { data: s, errors: e } = await It.query({
    query: Fu
  });
  return e ? (console.error(e), []) : (t = s == null ? void 0 : s.faqCategoryCollection) == null ? void 0 : t.items;
}
async function hm(s, e = !1) {
  var a, i, _;
  const t = await I(e), { data: r, errors: u } = await t.query({
    query: xu,
    variables: {
      path: s,
      preview: e
    }
  });
  return u ? (console.error(u), null) : (a = r == null ? void 0 : r.leadCapturePageCollection) != null && a.items && ((i = r == null ? void 0 : r.leadCapturePageCollection) == null ? void 0 : i.items.length) > 0 ? (_ = r == null ? void 0 : r.leadCapturePageCollection) == null ? void 0 : _.items[0] : null;
}
async function Sm() {
  var t;
  const { data: s, errors: e } = await It.query({
    query: ou
  });
  return e ? (console.error(e), []) : (t = s == null ? void 0 : s.leadCapturePageCollection) == null ? void 0 : t.items;
}
async function Am() {
  var t;
  const { data: s, errors: e } = await It.query({
    query: $u
  });
  return e ? (console.error(e), []) : (t = s == null ? void 0 : s.pageCollection) == null ? void 0 : t.items.filter((r) => !r.path.includes("/networks/"));
}
async function ym({
  path: s,
  locale: e,
  preview: t = !1
}) {
  var i, _;
  const r = await I(t), { data: u, errors: a } = await r.query({
    query: Mu,
    variables: {
      path: s,
      preview: t,
      locale: e
    }
  });
  if (a)
    return console.error(a), null;
  if (u && u.pageCollection && u.pageCollection.items) {
    const h = (_ = (i = u.pageCollection) == null ? void 0 : i.items) == null ? void 0 : _[0];
    if (h) {
      const { hero: f, seo: A } = h, y = {
        ...h,
        hero: f ? await Cb(f.sys.id, t, e) : null,
        seo: A ? await oa(A.sys.id, t, e) : null,
        sectionsCollection: {
          items: h ? await Ub(h, t, e) : null
        }
      };
      return y || null;
    }
  }
  return null;
}
async function Ub(s, e = !1, t) {
  var r;
  return s != null && s.sectionsCollection ? await Promise.all(
    (r = s.sectionsCollection) == null ? void 0 : r.items.map(async (u) => {
      if (!u) return [];
      const a = await Qb(u.sys.id, e, t);
      return {
        ...u,
        ...a
      };
    })
  ) : [];
}
async function Qb(s, e = !1, t) {
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: Tu,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  }), i = {
    ...u.pageSection,
    backgroundImage: u.pageSection.backgroundImage ? await _s(u.pageSection.backgroundImage.sys.id, e, t) : null,
    backgroundImageForTablet: u.pageSection.backgroundImageForTablet ? await _s(u.pageSection.backgroundImageForTablet.sys.id, e, t) : null,
    backgroundImageForMobile: u.pageSection.backgroundImageForMobile ? await _s(u.pageSection.backgroundImageForMobile.sys.id, e, t) : null,
    padding: u.pageSection.padding ? await Ht(u.pageSection.padding.sys.id, e, t) : null,
    contentCollection: {
      items: await gb(u.pageSection, e, t)
    }
  };
  return a ? (console.error(a), null) : i || null;
}
async function zb(s, e = !1, t) {
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: Bu,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  });
  return u ? u.cardItemsLayout : (a && console.error(a), null);
}
async function eh(s, e = !1, t) {
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: qu,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  });
  return u ? u.titleAndDescription : (a && console.error(a), null);
}
async function Jt(s, e = !1, t) {
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: Gu,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  });
  return u ? u.contentTypeRichText : (a && console.error(a), null);
}
async function _s(s, e = !1, t) {
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: ju,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  });
  return u ? u.asset : (a && console.error(a), null);
}
async function Fa(s, e = !1, t) {
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: Ru,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  });
  return u ? u.image : (a && console.error(a), null);
}
async function Wb(s, e = !1, t) {
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: Uu,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  });
  return u ? u.threeImageLayout : (a && console.error(a), null);
}
async function th(s, e = !1, t) {
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: Qu,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  });
  return u ? u.youTubePlayer : (a && console.error(a), null);
}
async function Nb(s, e = !1, t) {
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: zu,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  });
  return u ? u.linkTabs : (a && console.error(a), null);
}
async function Ib(s, e = !1, t) {
  var i, _, h;
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: Wu,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  });
  return a ? (console.error(a), null) : ((h = (_ = (i = u == null ? void 0 : u.networkComparisonTable) == null ? void 0 : i.networksCollection) == null ? void 0 : _.items) == null ? void 0 : h.length) > 0 ? u.networkComparisonTable : [];
}
async function rh(s, e = !1, t) {
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: Nu,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  });
  return u ? u.staticComponent : (a && console.error(a), null);
}
async function uh(s, e = !1, t) {
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: Iu,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  });
  return u ? u.customDropdown : (a && console.error(a), null);
}
async function Jb(s, e = !1, t) {
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: Ju,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  });
  return u ? u.providersList : (a && console.error(a), null);
}
async function Hb(s, e = !1, t) {
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: Hu,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  });
  return u ? u.pricingQuiz : (a && console.error(a), null);
}
async function ah(s, e = !1, t) {
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: Yu,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  });
  return u ? u.collapseItem : (a && console.error(a), null);
}
async function ih(s, e = !1, t) {
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: Ku,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  });
  return u ? u.textWithNavigation : (a && console.error(a), null);
}
async function Ht(s, e = !1, t) {
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: Xu,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  });
  return u ? u.padding : (a && console.error(a), null);
}
async function Yb(s, e = !1, t) {
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: ta,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  });
  return u ? u.labelWithIcon : (a && console.error(a), null);
}
async function _h(s, e = !1, t) {
  var i;
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: Pu,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  });
  if (u && u.column) {
    const { column: _ } = u;
    if (!(_ != null && _.contentCollection)) return [];
    const h = await Promise.all(
      (i = _.contentCollection) == null ? void 0 : i.items.map(async (f) => f ? f.__typename === "Image" ? await K(Fa, f.sys.id, e, t, f) : f.__typename === "ContentTypeRichText" ? await K(Jt, f.sys.id, e, t, f) : f.__typename === "Button" ? await K($t, f.sys.id, e, t, f) : f.__typename === "CollapseItem" ? await K(ah, f.sys.id, e, t, f) : f.__typename === "LabelWithIcon" ? await K(Yb, f.sys.id, e, t, f) : f.__typename === "YouTubePlayer" ? await K(th, f.sys.id, e, t, f) : f.__typename === "CardWithIcon" ? await K(fh, f.sys.id, e, t, f) : f : [])
    );
    return {
      ..._,
      contentCollection: {
        items: h
      },
      columnPadding: _.columnPadding ? await Ht(_.columnPadding.sys.id, e, t) : null
    };
  }
  return a && console.error(a), null;
}
async function fh(s, e = !1, t) {
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: Zu,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  });
  return u ? u.cardWithIcon : (a && console.error(a), null);
}
async function Kb(s, e = !1, t) {
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: Cu,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  });
  return u ? u.imageWithFooter : (a && console.error(a), null);
}
async function xa(s, e = !1, t) {
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: gu,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  });
  return u ? u.iconList : (a && console.error(a), null);
}
async function $t(s, e = !1, t) {
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: ku,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  });
  return u ? u.button : (a && console.error(a), null);
}
async function Xb(s, e = !1, t) {
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: Ou,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  });
  return u ? u.logoRow : (a && console.error(a), null);
}
async function oa(s, e = !1, t) {
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: Lu,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  });
  return u ? u.pageSeo : (a && console.error(a), null);
}
async function Zb(s, e = !1, t) {
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: ea,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  });
  return u ? u.linkAction : (a && console.error(a), null);
}
async function Cb(s, e = !1, t) {
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: sa,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  }), {
    iconList: i,
    button: _,
    backgroundImage: h,
    backgroundImageForTablet: f,
    backgroundImageForMobile: A,
    secondaryButton: y,
    image: c,
    imageOnMobile: n,
    logo: d,
    padding: E,
    additionalLinkLogo: V
  } = u.hero, b = {
    iconList: i ? await xa(i.sys.id, e, t) : null,
    button: _ ? await $t(_.sys.id, e, t) : null,
    secondaryButton: y ? await $t(y.sys.id, e, t) : null,
    backgroundImage: h ? await _s(h.sys.id, e, t) : null,
    backgroundImageForTablet: f ? await _s(f.sys.id, e, t) : null,
    backgroundImageForMobile: A ? await _s(A.sys.id, e, t) : null,
    image: c ? await _s(c.sys.id, e, t) : null,
    imageOnMobile: n ? await _s(n.sys.id, e, t) : null,
    logo: d ? await _s(d.sys.id, e, t) : null,
    padding: E ? await Ht(E.sys.id, e, t) : null,
    additionalLinkLogo: V ? await Zb(V.sys.id, e, t) : null
  };
  return u ? {
    ...u.hero,
    ...b
  } : (a && console.error(a), null);
}
async function gb(s, e = !1, t) {
  var r;
  return s != null && s.contentCollection ? await Promise.all(
    (r = s.contentCollection) == null ? void 0 : r.items.map(async (u) => u ? u.__typename === "MultiItemLayout" ? await K(kb, u.sys.id, e, t, u) : u.__typename === "Column" ? await K(_h, u.sys.id, e, t, u) : u.__typename === "CardItemsLayout" ? await K(zb, u.sys.id, e, t, u) : u.__typename === "TitleAndDescription" ? await K(eh, u.sys.id, e, t, u) : u.__typename === "ContentTypeRichText" ? await K(Jt, u.sys.id, e, t, u) : u.__typename === "Image" ? await K(Fa, u.sys.id, e, t, u) : u.__typename === "ThreeImageLayout" ? await K(Wb, u.sys.id, e, t, u) : u.__typename === "YouTubePlayer" ? await K(th, u.sys.id, e, t, u) : u.__typename === "LinkTabs" ? await K(Nb, u.sys.id, e, t, u) : u.__typename === "NetworkComparisonTable" ? await K(Ib, u.sys.id, e, t, u) : u.__typename === "StaticComponent" ? await K(rh, u.sys.id, e, t, u) : u.__typename === "CustomDropdown" ? await K(uh, u.sys.id, e, t, u) : u.__typename === "ProvidersList" ? await K(Jb, u.sys.id, e, t, u) : u.__typename === "PricingQuiz" ? await K(Hb, u.sys.id, e, t, u) : u.__typename === "CollapseItem" ? await K(ah, u.sys.id, e, t, u) : u.__typename === "TextWithNavigation" ? await K(ih, u.sys.id, e, t, u) : u.__typename === "PricingPlansComparison" ? await K(uE, u.sys.id, e, t, u) : u : [])
  ) : [];
}
async function kb(s, e = !1, t) {
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: ra,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  });
  if (a)
    return console.error(a), null;
  const i = (_) => JSON.parse(JSON.stringify(_));
  if (u) {
    let _ = i(u.multiItemLayout);
    const h = await Promise.all(_.itemsCollection.items.map(async (f) => f.__typename === "Column" ? await K(_h, f.sys.id, e, t, f) : f.__typename === "CardWithIcon" ? await K(fh, f.sys.id, e, t, f) : f.__typename === "CustomDropdown" ? await K(uh, f.sys.id, e, t, f) : f.__typename === "TitleAndDescription" ? await K(eh, f.sys.id, e, t, f) : f.__typename === "ImageWithFooter" ? await K(Kb, f.sys.id, e, t, f) : f.__typename === "IconList" ? await K(xa, f.sys.id, e, t, f) : f.__typename === "Image" ? await K(Fa, f.sys.id, e, t, f) : f.__typename === "Button" ? await K($t, f.sys.id, e, t, f) : f.__typename === "ContentTypeRichText" ? await K(Jt, f.sys.id, e, t, f) : f.__typename === "LogoRow" ? await K(Xb, f.sys.id, e, t, f) : f.__typename === "StaticComponent" ? await K(rh, f.sys.id, e, t, f) : f.__typename === "PricingPlanInfo" ? await K(rE, f.sys.id, e, t, f) : f));
    return _.itemsCollection.items = [...h], _.layoutPadding = _.layoutPadding ? await Ht(_.layoutPadding.sys.id, e, t) : null, _;
  }
  return null;
}
async function cm(s = !1) {
  const e = await I(s), { data: t, errors: r } = await e.query({
    query: ua,
    variables: {
      preview: s
    }
  });
  return r ? null : t != null && t.projectDashboardCardCollection ? t.projectDashboardCardCollection : null;
}
async function Ob(s, e = !1, t) {
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: aa,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  });
  if (a)
    return console.error(a), null;
  if (u && u.navigationSection) {
    const i = await Promise.all(u.navigationSection.itemsCollection.items.map(async (_) => _.title === "Networks" ? {
      ..._,
      networksCollection: {
        items: await tE(e, 15, t)
      }
    } : _));
    return {
      ...u.navigationSection,
      itemsCollection: {
        items: i
      }
    };
  }
  return null;
}
async function Lb(s, e = !1, t) {
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: ia,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  });
  return a ? (console.error(a), null) : u && u.navigationSectionRow ? u.navigationSectionRow : null;
}
async function sE(s, e = !1, t) {
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: _a,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  });
  if (a)
    return console.error(a), null;
  if (u != null && u.navigationParent) {
    const i = await Promise.all(
      u.navigationParent.sectionsCollection.items.map(async (_) => _.__typename === "NavigationSection" ? await K(Ob, _.sys.id, e, t, _) : _.__typename === "NavigationSectionRow" ? await K(Lb, _.sys.id, e, t, _) : _)
    );
    return {
      ...u.navigationParent,
      sectionsCollection: {
        ...u.navigationParent.sectionsCollection,
        items: i
      }
    };
  }
  return null;
}
async function nm(s = !1, e) {
  const t = await I(s), { data: r, errors: u } = await t.query({
    query: fa,
    variables: {
      preview: s,
      locale: e
    }
  });
  if (u)
    return null;
  if (!r.navigationParentCollection) return [];
  if (r != null && r.navigationParentCollection) {
    const a = await Promise.all(
      r.navigationParentCollection.items.map(async (i) => await K(sE, i.sys.id, s, e, i))
    );
    return {
      ...r.navigationParentCollection,
      items: a
    };
  }
  return null;
}
async function Dm(s = !1, e) {
  const t = await I(s), { data: r, errors: u } = await t.query({
    query: Aa,
    variables: {
      preview: s,
      locale: e
    }
  });
  return u ? null : r != null && r.pageBannerCollection ? r.pageBannerCollection : null;
}
async function dm(s = !1, e, t, r) {
  const u = await I(s), { data: a, errors: i } = await u.query({
    query: ha,
    variables: {
      preview: s,
      limit: e,
      skip: t,
      locale: r
    }
  });
  if (i)
    return null;
  if (a != null && a.caseStudyCollection) {
    const _ = await Promise.all(a.caseStudyCollection.items.map(async (h) => ({
      ...h,
      logo: await K(_s, h.logo.sys.id, s, r, h),
      heroImage: await K(_s, h.heroImage.sys.id, s, r, h),
      listImage: await K(_s, h.listImage.sys.id, s, r, h),
      body: await K(Jt, h.body.sys.id, s, r, h),
      textWithNavigation: await K(ih, h.textWithNavigation.sys.id, s, r, h),
      seo: await K(oa, h.seo.sys.id, s, r, h)
    })));
    return {
      ...a.caseStudyCollection,
      items: _
    };
  } else
    return null;
}
async function pm(s, e = !1, t, r, u) {
  var h, f, A;
  const a = await I(e), { data: i, errors: _ } = await a.query({
    query: Sa,
    variables: {
      url: s,
      preview: e,
      limit: t,
      skip: r,
      locale: u
    }
  });
  return _ ? null : (h = i == null ? void 0 : i.caseStudyCollection) != null && h.items && ((f = i == null ? void 0 : i.caseStudyCollection) == null ? void 0 : f.items.length) > 0 ? (A = i == null ? void 0 : i.caseStudyCollection) == null ? void 0 : A.items[0] : null;
}
async function hh(s, e = !1, t) {
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: ya,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  });
  return u ? u.networkBox : (a && console.error(a), null);
}
async function bm(s = !1, e = 20, t) {
  const r = await I(s), { data: u, errors: a } = await r.query({
    query: ca,
    variables: {
      limit: e,
      preview: s,
      locale: t
    }
  });
  return a ? (console.error(a), []) : u.networkCollection ? u && u.networkCollection ? await Promise.all(u.networkCollection.items.map(async (i) => {
    const { dinNetworkBox: _, orderInDinNetworkCarousel: h } = i;
    return _ ? {
      orderInDinNetworkCarousel: h,
      ...await hh(_.sys.id, s, t)
    } : null;
  })) : null : [];
}
async function eE(s, e = !1, t) {
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: na,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  });
  return u ? u.cardWithInfo : (a && console.error(a), null);
}
async function p_(s, e = !1, t = 3, r) {
  return s ? await Promise.all(s.items.map(async (u) => ({
    ...u,
    ...await eE(u.sys.id, e, r)
  }))) : [];
}
async function Ma(s, e = !1, t) {
  var i, _;
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: Da,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  });
  if (u && u.networkPage) {
    const { networkPage: h } = u, {
      seo: f,
      advantageAdvantagesList: A,
      advantageImage: y,
      aboutImage: c,
      gettingStartedImage: n,
      heroImage: d,
      heroImageOnMobile: E,
      quoteCompanyLogo: V,
      featuresCardsCollection: b,
      wantToLearnCardsCollection: F
    } = h;
    return {
      ...h,
      seo: f ? await K(oa, f.sys.id, e, t, h) : null,
      advantageAdvantagesList: A ? await xa(A.sys.id, e, t) : null,
      advantageImage: y ? await _s(y.sys.id, e, t) : null,
      aboutImage: c ? await _s(c.sys.id, e, t) : null,
      gettingStartedImage: n ? await _s(n.sys.id, e, t) : null,
      heroImage: d ? await _s(d.sys.id, e, t) : null,
      heroImageOnMobile: E ? await _s(E.sys.id, e, t) : null,
      quoteCompanyLogo: V ? await _s(V.sys.id, e, t) : null,
      featuresCardsCollection: {
        items: ((i = b == null ? void 0 : b.items) == null ? void 0 : i.length) > 0 ? await p_(b, e, 3, t) : []
      },
      wantToLearnCardsCollection: {
        items: ((_ = F == null ? void 0 : F.items) == null ? void 0 : _.length) > 0 ? await p_(F, e, 3, t) : []
      }
    };
  }
  return a && console.error(a), null;
}
async function Em(s = !1, e = 20, t) {
  const r = await I(s), { data: u, errors: a } = await r.query({
    query: da,
    variables: {
      limit: e,
      preview: s,
      locale: t
    }
  });
  return a ? (console.error(a), []) : u.networkCollection ? u && u.networkCollection ? await Promise.all(u.networkCollection.items.map(async (i) => {
    const {
      inlineLogo: _,
      url: h,
      networkPage: f
    } = i;
    return {
      url: h,
      inlineLogo: _ ? await _s(_.sys.id, s, t) : null,
      networkPage: f ? await Ma(f.sys.id, s, t) : null
    };
  })) : null : [];
}
async function vm(s, e = !1, t = 20, r) {
  var _, h;
  const u = await I(e), { data: a, errors: i } = await u.query({
    query: pa,
    variables: {
      url: s,
      limit: t,
      preview: e,
      locale: r
    }
  });
  return i ? (console.error(i), null) : ((h = (_ = a == null ? void 0 : a.networkCollection) == null ? void 0 : _.items) == null ? void 0 : h.length) > 0 ? (await Promise.all(a.networkCollection.items.map(async (A) => {
    const {
      inlineLogo: y,
      url: c,
      networkPage: n
    } = A;
    return {
      url: c,
      inlineLogo: y ? await _s(y.sys.id, e, r) : null,
      networkPage: n ? await Ma(n.sys.id, e, r) : null
    };
  })))[0] : null;
}
async function mm(s = !1, e = 15, t) {
  const r = await I(s), { data: u, errors: a } = await r.query({
    query: ba,
    variables: {
      limit: e,
      preview: s,
      locale: t
    }
  });
  return a ? (console.error(a), []) : u.networkCollection ? u && u.networkCollection ? await Promise.all(u.networkCollection.items.map(async (i) => {
    const {
      dinNetworkBox: _,
      inlineLogo: h,
      logo: f,
      networkPage: A
    } = i;
    return {
      ...i,
      dinNetworkBox: _ ? await hh(_.sys.id, s, t) : null,
      inlineLogo: h ? await _s(h.sys.id, s, t) : null,
      logo: f ? await _s(f.sys.id, s, t) : null,
      networkPage: A ? await Ma(A.sys.id, s, t) : null
    };
  })) : null : [];
}
async function tE(s = !1, e = 15, t) {
  const r = await I(s), { data: u, errors: a } = await r.query({
    query: Ea,
    variables: {
      limit: e,
      preview: s,
      locale: t
    }
  });
  return a ? (console.error(a), []) : u.networkCollection ? u && u.networkCollection ? await Promise.all(u.networkCollection.items.map(async (i) => {
    const { logo: _ } = i;
    return {
      ...i,
      logo: _ ? await _s(_.sys.id, s, t) : null
    };
  })) : null : [];
}
async function Vm(s = !1, e = 15, t) {
  const r = await I(s), { data: u, errors: a } = await r.query({
    query: va,
    variables: {
      limit: e,
      preview: s,
      locale: t
    }
  });
  return a ? (console.error(a), []) : u.networkCollection ? u && u.networkCollection ? await Promise.all(u.networkCollection.items.map(async (i) => {
    const { logo: _ } = i;
    return {
      ...i,
      logo: _ ? await _s(_.sys.id, s, t) : null
    };
  })) : null : [];
}
async function lm(s = !1, e = 20, t) {
  const r = await I(s), { data: u, errors: a } = await r.query({
    query: ma,
    variables: {
      limit: e,
      preview: s,
      locale: t
    }
  });
  return a ? (console.error(a), []) : u.networkCollection ? u && u.networkCollection ? await Promise.all(u.networkCollection.items.map(async (i) => {
    const { logo: _ } = i;
    return {
      ...i,
      logo: _ ? await _s(_.sys.id, s, t) : null
    };
  })) : null : [];
}
async function wm(s = !1, e = 20, t) {
  const r = await I(s), { data: u, errors: a } = await r.query({
    query: Va,
    variables: {
      limit: e,
      preview: s,
      locale: t
    }
  });
  return a ? (console.error(a), []) : u.networkCollection ? u && u.networkCollection ? await Promise.all(u.networkCollection.items.map(async (i) => {
    const { logo: _ } = i;
    return {
      ...i,
      logo: _ ? await _s(_.sys.id, s, t) : null
    };
  })) : null : [];
}
async function rE(s, e = !1, t) {
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: la,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  });
  return u ? u.pricingPlanInfo : (a && console.error(a), null);
}
async function uE(s, e = !1, t) {
  const r = await I(e), { data: u, errors: a } = await r.query({
    query: wa,
    variables: {
      id: s,
      preview: e,
      locale: t
    }
  });
  return u ? u.pricingPlansComparison : (a && console.error(a), null);
}
function Fm(s) {
  return s === "zh" ? "zh-CN" : "en-US";
}
export {
  yn as AnnouncementBannerOrder,
  cn as ApplicationActionOrder,
  nn as AssetOrder,
  Le as ButtonFieldsFragmentDoc,
  Dn as ButtonLinkingCollectionsCardWithIconCollectionOrder,
  dn as ButtonLinkingCollectionsColumnCollectionOrder,
  pn as ButtonLinkingCollectionsHeroCollectionOrder,
  bn as ButtonLinkingCollectionsIconListItemCollectionOrder,
  En as ButtonLinkingCollectionsMultiItemLayoutCollectionOrder,
  vn as ButtonLinkingCollectionsPricingCardCollectionOrder,
  mn as ButtonLinkingCollectionsPricingPlanInfoCollectionOrder,
  Vn as ButtonOrder,
  rb as CardItemsLayoutFieldsFragmentDoc,
  ln as CardItemsLayoutLinkingCollectionsPageSectionCollectionOrder,
  wn as CardItemsLayoutOrder,
  Hf as CardWithIconFieldsFragmentDoc,
  Fn as CardWithIconLinkingCollectionsCardItemsLayoutCollectionOrder,
  xn as CardWithIconLinkingCollectionsColumnCollectionOrder,
  on as CardWithIconLinkingCollectionsMultiItemLayoutCollectionOrder,
  Mn as CardWithIconOrder,
  vb as CardWithInfoFieldsFragmentDoc,
  $n as CardWithInfoLinkingCollectionsNetworkPageCollectionOrder,
  Tn as CardWithInfoOrder,
  Jf as CaseStudyFieldsFragmentDoc,
  Pn as CaseStudyOrder,
  Db as CollapseItemFieldsFragmentDoc,
  Bn as CollapseItemLinkingCollectionsColumnCollectionOrder,
  qn as CollapseItemLinkingCollectionsPageSectionCollectionOrder,
  Gn as CollapseItemOrder,
  sb as ColumnFieldsFragmentDoc,
  Rn as ColumnLinkingCollectionsMultiItemLayoutCollectionOrder,
  jn as ColumnLinkingCollectionsPageSectionCollectionOrder,
  Un as ColumnOrder,
  Qn as ContentTypeRichTextLinkingCollectionsCaseStudyCollectionOrder,
  zn as ContentTypeRichTextLinkingCollectionsColumnCollectionOrder,
  Wn as ContentTypeRichTextLinkingCollectionsLogoRowCollectionOrder,
  Nn as ContentTypeRichTextLinkingCollectionsMultiItemLayoutCollectionOrder,
  In as ContentTypeRichTextLinkingCollectionsPageSectionCollectionOrder,
  Jn as ContentTypeRichTextLinkingCollectionsTabbedPageSectionCollectionOrder,
  Hn as ContentTypeRichTextLinkingCollectionsThreeImageLayoutCollectionOrder,
  Yn as ContentTypeRichTextLinkingCollectionsTitleAndDescriptionCollectionOrder,
  Kn as ContentTypeRichTextLinkingCollectionsTitleAndRichTextCollectionOrder,
  Xn as ContentTypeRichTextOrder,
  fb as CustomDropdownFragmentDoc,
  Zn as CustomDropdownLinkingCollectionsMultiItemLayoutCollectionOrder,
  Cn as CustomDropdownLinkingCollectionsPageSectionCollectionOrder,
  gn as CustomDropdownOrder,
  kn as CustomDropdownSectionsCollectionOrder,
  lu as DefaultNetworkFieldsFragmentDoc,
  On as EntryOrder,
  Ln as FaqCategoryOrder,
  sD as FaqCategoryQuestionsCollectionOrder,
  Sb as FaqFieldsFragmentDoc,
  eD as FaqLinkingCollectionsFaqCategoryCollectionOrder,
  tD as FaqOrder,
  Sm as GetAllLeadCapturePages,
  ou as GetAllLeadCapturePagesDocument,
  $u as GetAllPagesDocument,
  ku as GetButtonDocument,
  Bu as GetCardItemsLayoutDocument,
  Zu as GetCardWithIconDocument,
  na as GetCardWithInfoDocument,
  ha as GetCaseStudiesDocument,
  Sa as GetCaseStudyByUrlDocument,
  Yu as GetCollapseItemDocument,
  Pu as GetColumnDocument,
  Ru as GetContentTypeImageDocument,
  Gu as GetContentTypeRichTextDocument,
  ju as GetContentfulImageDocument,
  Iu as GetCustomDropdownDocument,
  Fu as GetFaqCategoriesDocument,
  Va as GetGasApiCarouselNetworksDocument,
  sa as GetHeroDocument,
  va as GetHomepageNetworkCardsDocument,
  gu as GetIconListDocument,
  Cu as GetImageWithFooterDocument,
  ta as GetLabelWithIconDocument,
  xu as GetLeadCapturePageDocument,
  ea as GetLinkActionDocument,
  zu as GetLinkTabsDocument,
  Ou as GetLogoRowDocument,
  fa as GetMarketingNavigationDocument,
  _a as GetMarketingNavigationParentDocument,
  aa as GetMarketingNavigationSectionDocument,
  ia as GetMarketingNavigationSectionRowDocument,
  ra as GetMultiItemLayoutDocument,
  ya as GetNetworkBoxDocument,
  ca as GetNetworkBoxesDocument,
  Wu as GetNetworkComparisonTableDocument,
  pa as GetNetworkPageByUrlDocument,
  Da as GetNetworkPageDocument,
  da as GetNetworkPagesDocument,
  ma as GetNetworkPreviewCardsDocument,
  ba as GetNetworksDocument,
  Ea as GetNetworksNavigationDocument,
  Xu as GetPaddingDocument,
  Aa as GetPageBannersDocument,
  Mu as GetPageByPathDocument,
  Tu as GetPageSectionDocument,
  Lu as GetPageSeoDocument,
  la as GetPricingPlanInfoDocument,
  wa as GetPricingPlansComparisonDocument,
  Hu as GetPricingQuizDocument,
  ua as GetProjectDashboardCardsDocument,
  Ju as GetProvidersListDocument,
  Nu as GetStaticComponentDocument,
  Ku as GetTextWithNavigationDocument,
  Uu as GetThreeImageLayoutDocument,
  qu as GetTitleAndDescriptionDocument,
  Qu as GetYouTubePlayerDocument,
  Ab as HeroFieldsFragmentDoc,
  rD as HeroLinkingCollectionsLayerOneLandingPageCollectionOrder,
  uD as HeroLinkingCollectionsLayerTwoLandingPageCollectionOrder,
  aD as HeroLinkingCollectionsPageCollectionOrder,
  iD as HeroLinkingCollectionsPageSectionCollectionOrder,
  _D as HeroLinkingCollectionsTabbedPageSectionCollectionOrder,
  fD as HeroOrder,
  lb as HomepageNetworkCardFieldsFragmentDoc,
  hD as HubspotFormLinkingCollectionsLeadCapturePageCollectionOrder,
  SD as HubspotFormLinkingCollectionsResourcePageCollectionOrder,
  AD as HubspotFormOrder,
  kp as IconListItemFieldsFragmentDoc,
  yD as IconListItemLinkingCollectionsIconListCollectionOrder,
  cD as IconListItemOrder,
  nD as IconListItemsCollectionOrder,
  DD as IconListLinkingCollectionsHeroCollectionOrder,
  dD as IconListLinkingCollectionsMultiItemLayoutCollectionOrder,
  pD as IconListLinkingCollectionsNetworkPageCollectionOrder,
  bD as IconListOrder,
  Vs as ImageFieldsFragmentDoc,
  ED as ImageFormat,
  vD as ImageLinkingCollectionsColumnCollectionOrder,
  mD as ImageLinkingCollectionsLogoRowCollectionOrder,
  VD as ImageLinkingCollectionsMultiItemLayoutCollectionOrder,
  lD as ImageLinkingCollectionsPageSectionCollectionOrder,
  wD as ImageOrder,
  FD as ImageResizeFocus,
  xD as ImageResizeStrategy,
  If as ImageWithFooterFieldsFragmentDoc,
  oD as ImageWithFooterLinkingCollectionsMultiItemLayoutCollectionOrder,
  MD as ImageWithFooterLinkingCollectionsThreeImageLayoutCollectionOrder,
  $D as ImageWithFooterOrder,
  _b as LabelWithIconFieldsFragmentDoc,
  TD as LabelWithIconLinkingCollectionsColumnCollectionOrder,
  PD as LabelWithIconOrder,
  BD as LayerOneLandingPageOrder,
  qD as LayerOneLandingPageSectionsCollectionOrder,
  GD as LayerTwoLandingPageOrder,
  RD as LayerTwoLandingPageSectionsCollectionOrder,
  Mb as LeadCapturePageBodyFieldsFragmentDoc,
  $b as LeadCapturePageFieldsFragmentDoc,
  jD as LeadCapturePageOrder,
  UD as LeadCapturePageSpeakersCollectionOrder,
  Cf as LinkActionFieldsFragmentDoc,
  QD as LinkActionLinkingCollectionsCardWithInfoCollectionOrder,
  zD as LinkActionLinkingCollectionsHeroCollectionOrder,
  WD as LinkActionLinkingCollectionsPricingPlanCollectionOrder,
  ND as LinkActionLinkingCollectionsPricingQuizCollectionOrder,
  ID as LinkActionOrder,
  ab as LinkTabsFieldsFragmentDoc,
  JD as LinkTabsLinkingCollectionsPageSectionCollectionOrder,
  HD as LinkTabsOrder,
  YD as LinkTabsTabsCollectionOrder,
  gp as LogoRowFieldsFragmentDoc,
  KD as LogoRowLinkingCollectionsMultiItemLayoutCollectionOrder,
  XD as LogoRowLogosCollectionOrder,
  ZD as LogoRowOrder,
  eb as MultiItemLayoutFieldsFragmentDoc,
  CD as MultiItemLayoutLinkingCollectionsPageSectionCollectionOrder,
  gD as MultiItemLayoutLinkingCollectionsTabbedPageSectionCollectionOrder,
  kD as MultiItemLayoutOrder,
  Kf as NavigationItemFieldsFragmentDoc,
  OD as NavigationItemLinkingCollectionsNavigationSectionCollectionOrder,
  LD as NavigationItemLinkingCollectionsNavigationSectionColumnCollectionOrder,
  sd as NavigationItemOrder,
  ed as NavigationItemSectionsCollectionOrder,
  td as NavigationParentAppOrder,
  rd as NavigationParentAppSectionsCollectionOrder,
  Xf as NavigationParentFieldsFragmentDoc,
  ud as NavigationParentOrder,
  ad as NavigationSectionColumnItemsCollectionOrder,
  id as NavigationSectionColumnLinkingCollectionsNavigationSectionRowCollectionOrder,
  _d as NavigationSectionColumnOrder,
  Eb as NavigationSectionFieldsFragmentDoc,
  fd as NavigationSectionItemsCollectionOrder,
  hd as NavigationSectionLinkingCollectionsCustomDropdownCollectionOrder,
  Sd as NavigationSectionLinkingCollectionsNavigationItemCollectionOrder,
  Ad as NavigationSectionLinkingCollectionsNavigationParentAppCollectionOrder,
  yd as NavigationSectionLinkingCollectionsNavigationParentCollectionOrder,
  cd as NavigationSectionOrder,
  bb as NavigationSectionRowFieldsFragmentDoc,
  nd as NavigationSectionRowItemsCollectionOrder,
  Dd as NavigationSectionRowLinkingCollectionsNavigationParentCollectionOrder,
  dd as NavigationSectionRowOrder,
  Zf as NetworkBoxFieldsFragmentDoc,
  pd as NetworkBoxLinkingCollectionsNetworkCollectionOrder,
  bd as NetworkBoxOrder,
  Lp as NetworkComparisonTableFieldsFragmentDoc,
  Ed as NetworkComparisonTableLinkingCollectionsPageSectionCollectionOrder,
  vd as NetworkComparisonTableLinkingCollectionsTabbedPageSectionCollectionOrder,
  md as NetworkComparisonTableNetworksCollectionOrder,
  Vd as NetworkComparisonTableOrder,
  Op as NetworkDetailsFieldsFragmentDoc,
  ld as NetworkDetailsLinkingCollectionsNetworkComparisonTableCollectionOrder,
  wd as NetworkDetailsOrder,
  mb as NetworkFieldsFragmentDoc,
  Fb as NetworkGasApiCarouselFieldsFragmentDoc,
  Vb as NetworkNavigationFieldsFragmentDoc,
  Fd as NetworkOrder,
  xd as NetworkPageFeaturesCardsCollectionOrder,
  wu as NetworkPageFieldsFragmentDoc,
  od as NetworkPageLinkingCollectionsNetworkCollectionOrder,
  Md as NetworkPageOrder,
  $d as NetworkPageWantToLearnCardsCollectionOrder,
  wb as NetworkPreviewCardFieldsFragmentDoc,
  Nt as PaddingFieldsFragmentDoc,
  Td as PaddingLinkingCollectionsCardItemsLayoutCollectionOrder,
  Pd as PaddingLinkingCollectionsColumnCollectionOrder,
  Bd as PaddingLinkingCollectionsContentTypeRichTextCollectionOrder,
  qd as PaddingLinkingCollectionsHeroCollectionOrder,
  Gd as PaddingLinkingCollectionsMultiItemLayoutCollectionOrder,
  Rd as PaddingLinkingCollectionsPageSectionCollectionOrder,
  jd as PaddingLinkingCollectionsPricingPlansComparisonCollectionOrder,
  Ud as PaddingOrder,
  Qd as PageBannerOrder,
  zd as PageOrder,
  hb as PageSectionFieldsFragmentDoc,
  Wd as PageSectionLinkingCollectionsLayerOneLandingPageCollectionOrder,
  Nd as PageSectionLinkingCollectionsLayerTwoLandingPageCollectionOrder,
  Id as PageSectionLinkingCollectionsPageCollectionOrder,
  Jd as PageSectionOrder,
  Hd as PageSectionTitleOrder,
  Yd as PageSectionsCollectionOrder,
  Kd as PageSeoLinkingCollectionsCaseStudyCollectionOrder,
  Xd as PageSeoLinkingCollectionsLayerOneLandingPageCollectionOrder,
  Zd as PageSeoLinkingCollectionsLayerTwoLandingPageCollectionOrder,
  Cd as PageSeoLinkingCollectionsNetworkPageCollectionOrder,
  gd as PageSeoLinkingCollectionsPageCollectionOrder,
  kd as PageSeoOrder,
  tb as PricingCardFieldsFragmentDoc,
  Od as PricingCardLinkingCollectionsCardItemsLayoutCollectionOrder,
  Ld as PricingCardLinkingCollectionsMultiItemLayoutCollectionOrder,
  sp as PricingCardOrder,
  cb as PricingPlanFieldsFragmentDoc,
  gf as PricingPlanInfoFieldsFragmentDoc,
  ep as PricingPlanInfoLinkingCollectionsMultiItemLayoutCollectionOrder,
  tp as PricingPlanInfoLinkingCollectionsPricingPlansComparisonCollectionOrder,
  rp as PricingPlanInfoOrder,
  up as PricingPlanLinkingCollectionsPricingQuizCollectionOrder,
  ap as PricingPlanOrder,
  ip as PricingPlansComparisonFeaturesCollectionOrder,
  ob as PricingPlansComparisonFieldsFragmentDoc,
  _p as PricingPlansComparisonLinkingCollectionsPageSectionCollectionOrder,
  fp as PricingPlansComparisonOrder,
  hp as PricingPlansComparisonPricingPlansInfoCollectionOrder,
  xb as PricingPlansFeatureFieldsFragmentDoc,
  Sp as PricingPlansFeatureLinkingCollectionsPricingPlansComparisonCollectionOrder,
  Ap as PricingPlansFeatureOrder,
  nb as PricingQuizFieldsFragmentDoc,
  yp as PricingQuizLinkingCollectionsPageSectionCollectionOrder,
  cp as PricingQuizOrder,
  np as PricingQuizPricingPlansCollectionOrder,
  Dp as ProjectDashboardCardOrder,
  yb as ProvidersListFragmentDoc,
  dp as ProvidersListLinkingCollectionsPageSectionCollectionOrder,
  pp as ProvidersListOrder,
  bp as ResourcePageOrder,
  Oe as RichTextFieldsFragmentDoc,
  iE as SeoFieldsFragmentDoc,
  Ep as SpeakerLinkingCollectionsLeadCapturePageCollectionOrder,
  vp as SpeakerOrder,
  ib as StaticComponentFieldsFragmentDoc,
  mp as StaticComponentLinkingCollectionsMultiItemLayoutCollectionOrder,
  Vp as StaticComponentLinkingCollectionsPageSectionCollectionOrder,
  lp as StaticComponentOrder,
  ub as TabItemFieldsFragmentDoc,
  wp as TabItemLinkingCollectionsLinkTabsCollectionOrder,
  Fp as TabItemLinkingCollectionsTabbedPageSectionCollectionOrder,
  xp as TabItemOrder,
  op as TabbedPageSectionOrder,
  Mp as TabbedPageSectionTabsCollectionOrder,
  pb as TextWithNavigationFieldsFragmentDoc,
  $p as TextWithNavigationLinkingCollectionsCaseStudyCollectionOrder,
  Tp as TextWithNavigationLinkingCollectionsColumnCollectionOrder,
  Pp as TextWithNavigationLinkingCollectionsPageSectionCollectionOrder,
  Bp as TextWithNavigationOrder,
  qp as TextWithNavigationTitleAndRichTextCollectionOrder,
  Gp as ThreeImageLayoutImagesCollectionOrder,
  Rp as ThreeImageLayoutLinkingCollectionsPageSectionCollectionOrder,
  jp as ThreeImageLayoutLinkingCollectionsTabbedPageSectionCollectionOrder,
  Up as ThreeImageLayoutOrder,
  Yf as TitleAndDescriptionFieldsFragmentDoc,
  Qp as TitleAndDescriptionLinkingCollectionsMultiItemLayoutCollectionOrder,
  zp as TitleAndDescriptionLinkingCollectionsPageSectionCollectionOrder,
  Wp as TitleAndDescriptionLinkingCollectionsStaticComponentCollectionOrder,
  Np as TitleAndDescriptionLinkingCollectionsTabbedPageSectionCollectionOrder,
  Ip as TitleAndDescriptionOrder,
  db as TitleAndRichTextFieldsFragmentDoc,
  Jp as TitleAndRichTextLinkingCollectionsMultiItemLayoutCollectionOrder,
  Hp as TitleAndRichTextLinkingCollectionsTextWithNavigationCollectionOrder,
  Yp as TitleAndRichTextOrder,
  Kp as YouTubePlayerLinkingCollectionsColumnCollectionOrder,
  Xp as YouTubePlayerLinkingCollectionsPageSectionCollectionOrder,
  Zp as YouTubePlayerLinkingCollectionsTabbedPageSectionCollectionOrder,
  Cp as YouTubePlayerOrder,
  _m as authenticatePreviewToken,
  It as contentfulClient,
  jb as contentfulPreviewClient,
  Am as getAllPages,
  $t as getButton,
  zb as getCardItemsLayout,
  fh as getCardWithIcon,
  eE as getCardWithInfo,
  p_ as getCardsWithInfo,
  dm as getCaseStudies,
  pm as getCaseStudyByUrl,
  I as getClient,
  ah as getCollapseItem,
  _h as getColumn,
  _s as getContentfulImage,
  uh as getCustomDropdown,
  fm as getFAQCategories,
  wm as getGasAPICarouselNetworks,
  Cb as getHero,
  Vm as getHomepageNetworkCards,
  xa as getIconList,
  Fa as getImage,
  Kb as getImageWithFooter,
  Yb as getLabelWithIcon,
  hm as getLeadCapturePage,
  Zb as getLinkAction,
  Nb as getLinkTabs,
  Xb as getLogoRow,
  nm as getMarketingNavigation,
  sE as getMarketingNavigationParent,
  Ob as getMarketingNavigationSection,
  Lb as getMarketingNavigationSectionRow,
  kb as getMultiItemLayout,
  hh as getNetworkBox,
  bm as getNetworkBoxes,
  Ib as getNetworkComparisonTable,
  Ma as getNetworkPage,
  vm as getNetworkPageByUrl,
  Em as getNetworkPages,
  lm as getNetworkPreviewCards,
  mm as getNetworks,
  tE as getNetworksNavigation,
  Ht as getPadding,
  Dm as getPageBanners,
  ym as getPageByPath,
  oa as getPageSEO,
  Qb as getPageSection,
  rE as getPricingPlanInfo,
  uE as getPricingPlansComparison,
  Hb as getPricingQuiz,
  cm as getProjectDashboardCards,
  Jb as getProvidersList,
  Jt as getRichText,
  rh as getStaticComponent,
  ih as getTextWithNavigation,
  Wb as getThreeImageLayout,
  eh as getTitleAndDescription,
  th as getYouTubePlayer,
  Fm as mapLocale,
  yE as useGetAllLeadCapturePagesLazyQuery,
  AE as useGetAllLeadCapturePagesQuery,
  dE as useGetAllPagesLazyQuery,
  DE as useGetAllPagesQuery,
  iv as useGetButtonLazyQuery,
  av as useGetButtonQuery,
  VE as useGetCardItemsLayoutLazyQuery,
  mE as useGetCardItemsLayoutQuery,
  sv as useGetCardWithIconLazyQuery,
  LE as useGetCardWithIconQuery,
  Wv as useGetCardWithInfoLazyQuery,
  zv as useGetCardWithInfoQuery,
  Tv as useGetCaseStudiesLazyQuery,
  $v as useGetCaseStudiesQuery,
  Bv as useGetCaseStudyByUrlLazyQuery,
  Pv as useGetCaseStudyByUrlQuery,
  ZE as useGetCollapseItemLazyQuery,
  XE as useGetCollapseItemQuery,
  vE as useGetColumnLazyQuery,
  EE as useGetColumnQuery,
  ME as useGetContentTypeImageLazyQuery,
  oE as useGetContentTypeImageQuery,
  xE as useGetContentTypeRichTextLazyQuery,
  FE as useGetContentTypeRichTextQuery,
  TE as useGetContentfulImageLazyQuery,
  $E as useGetContentfulImageQuery,
  IE as useGetCustomDropdownLazyQuery,
  NE as useGetCustomDropdownQuery,
  fE as useGetFaqCategoriesLazyQuery,
  _E as useGetFaqCategoriesQuery,
  tm as useGetGasApiCarouselNetworksLazyQuery,
  em as useGetGasApiCarouselNetworksQuery,
  yv as useGetHeroLazyQuery,
  Av as useGetHeroQuery,
  Ov as useGetHomepageNetworkCardsLazyQuery,
  kv as useGetHomepageNetworkCardsQuery,
  uv as useGetIconListLazyQuery,
  rv as useGetIconListQuery,
  tv as useGetImageWithFooterLazyQuery,
  ev as useGetImageWithFooterQuery,
  dv as useGetLabelWithIconLazyQuery,
  Dv as useGetLabelWithIconQuery,
  SE as useGetLeadCapturePageLazyQuery,
  hE as useGetLeadCapturePageQuery,
  nv as useGetLinkActionLazyQuery,
  cv as useGetLinkActionQuery,
  jE as useGetLinkTabsLazyQuery,
  RE as useGetLinkTabsQuery,
  fv as useGetLogoRowLazyQuery,
  _v as useGetLogoRowQuery,
  Mv as useGetMarketingNavigationLazyQuery,
  xv as useGetMarketingNavigationParentLazyQuery,
  Fv as useGetMarketingNavigationParentQuery,
  ov as useGetMarketingNavigationQuery,
  Vv as useGetMarketingNavigationSectionLazyQuery,
  mv as useGetMarketingNavigationSectionQuery,
  wv as useGetMarketingNavigationSectionRowLazyQuery,
  lv as useGetMarketingNavigationSectionRowQuery,
  bv as useGetMultiItemLayoutLazyQuery,
  pv as useGetMultiItemLayoutQuery,
  jv as useGetNetworkBoxLazyQuery,
  Rv as useGetNetworkBoxQuery,
  Qv as useGetNetworkBoxesLazyQuery,
  Uv as useGetNetworkBoxesQuery,
  QE as useGetNetworkComparisonTableLazyQuery,
  UE as useGetNetworkComparisonTableQuery,
  Kv as useGetNetworkPageByUrlLazyQuery,
  Yv as useGetNetworkPageByUrlQuery,
  Iv as useGetNetworkPageLazyQuery,
  Nv as useGetNetworkPageQuery,
  Hv as useGetNetworkPagesLazyQuery,
  Jv as useGetNetworkPagesQuery,
  sm as useGetNetworkPreviewCardsLazyQuery,
  Lv as useGetNetworkPreviewCardsQuery,
  Zv as useGetNetworksLazyQuery,
  gv as useGetNetworksNavigationLazyQuery,
  Cv as useGetNetworksNavigationQuery,
  Xv as useGetNetworksQuery,
  OE as useGetPaddingLazyQuery,
  kE as useGetPaddingQuery,
  Gv as useGetPageBannersLazyQuery,
  qv as useGetPageBannersQuery,
  nE as useGetPageByPathLazyQuery,
  cE as useGetPageByPathQuery,
  bE as useGetPageSectionLazyQuery,
  pE as useGetPageSectionQuery,
  Sv as useGetPageSeoLazyQuery,
  hv as useGetPageSeoQuery,
  um as useGetPricingPlanInfoLazyQuery,
  rm as useGetPricingPlanInfoQuery,
  im as useGetPricingPlansComparisonLazyQuery,
  am as useGetPricingPlansComparisonQuery,
  KE as useGetPricingQuizLazyQuery,
  YE as useGetPricingQuizQuery,
  vv as useGetProjectDashboardCardsLazyQuery,
  Ev as useGetProjectDashboardCardsQuery,
  HE as useGetProvidersListLazyQuery,
  JE as useGetProvidersListQuery,
  WE as useGetStaticComponentLazyQuery,
  zE as useGetStaticComponentQuery,
  gE as useGetTextWithNavigationLazyQuery,
  CE as useGetTextWithNavigationQuery,
  BE as useGetThreeImageLayoutLazyQuery,
  PE as useGetThreeImageLayoutQuery,
  wE as useGetTitleAndDescriptionLazyQuery,
  lE as useGetTitleAndDescriptionQuery,
  GE as useGetYouTubePlayerLazyQuery,
  qE as useGetYouTubePlayerQuery
};
